//************************ Start Window Functions ********************************
var SERVER_HIT = 3660, SERVER_TIMER = 0;
var Flag_Prevent_ExpCol = true;
var PrintQueueBtnConfiguration = -1;
var TatMsgTimeOutValue = 10000;
var afterNextQuestionView = false;
var lastSelectedOptionByQuestion = {};
function ConsentFormAdd() {
    loader(1);
    //$("#popUpDialog1").css({ 'width': '1200px' });
    //$(".portletHead").css({ 'width': '1195px' });
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/ConsentForm/ConsentFormAdd/",
        popLevel: 1,
        onLoad: function () {
            if (enableDomLogs) {
                DomUtils.logDomData("Config >> Consent Forms >> Add");
            }
        },
        popUpHeader: "Consent Forms",
        closeButton: '#closebutton'
    });
    loader(0);
}

function ConsentFormEdit(Id) {
    loader(1);
    var consentID = Id;
    if (typeof consentID != 'undefined') {
        $("#hdnCnsentID").val(Id);
        fnPopDialog("/ConsentForm/ConsentFormAdd/" + consentID, "CONSENT FORMS");
        $("#popUpDialog1").css({ 'width': '1000px' });
        $('iframe:not(#iframeSmartCOMMSSo)').contents().contents().find(".gvCnsntMaster_N").show();
        $('iframe:not(#iframeSmartCOMMSSo)').contents().contents().find("#gridrefreshClear").click();
    }
    //else {
    //    AlertOnActionSingle('gvCnsntMaster', 'ItemChkOpportunity', 'Please select a record to be edited.', 'Please select only one record to edit.');
    //}

    loader(0);

}
function CPAAdd() {
    loader(1);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CPA/CPAAdd/",
        popLevel: 1,
        onLoad: function () {
            if (enableDomLogs) {
                DomUtils.logDomData("Add Care Plan Automation");
            }
        },
        popUpHeader: "Care Plan Automation",
        closeButton: '#btnCancel'
    });
    loader(0);
}

function CPAEdit(oggiId, OggiLobId) {
    loader(1);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CPA/CPAAdd?oggiId=" + oggiId + "&OggiLobId=" + OggiLobId,
        popLevel: 1,
        onLoad: function () {
            if (enableDomLogs) {
                DomUtils.logDomData("Edit Care Plan Automation");
            }
        },
        onClose: function () { $('#btnExportCFGCPA').show(); },
        popUpHeader: "Care Plan Automation",
        closeButton: '#btnCancel'
    });
    loader(0);
}

function fnPopDialog(fnuri, fnHeader) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + fnuri,
        popLevel: 0,
        onLoad: function () {
            $("#divHeader #closebutton").show();
            $('#div_health').animate({ scrollTop: 0 }, 100);
            if (enableDomLogs) {
                DomUtils.logDomData(fnHeader);
            }
        },
        popUpHeader: fnHeader,
        closeButton: '#closebutton'
    });
}


function CallMeBeforeSubmit() {
    if ($("#MainApp").is("visible") == false) {
        $("#MainBre").hide(); $("#MainApp").show();
    }
}
function SetContextKey(CurrObj) {
    var IcdVar = "DAIG," + $('#ddlIcdVersion').val();
    var ParentDiv = $(CurrObj).closest('td');
    if ($('.AutoExtender', ParentDiv).length > 0) {
        var ExtId = $('.AutoExtender', ParentDiv)[0].id;
        var ExtIds = ExtId.split('autoCompleteDefaultData');
        var FinalExtId = "autoCompleteDefaultData" + ExtIds[1].replace('_completionListElem', '');
        $find(FinalExtId)._contextKey = IcdVar;
    }
}

function DDDiagClientItemSelected(sender, e) {
    $('#hfDefaultDataCode').val(e.get_value());
    var textboxControl = $(sender.get_element());
    var txtAutoDaignosisCode = $(textboxControl).closest('.DaignosisAuto').closest('tr').find('[id*=txtAutoDaignosisCode]');
    txtAutoDaignosisCode.val(e.get_value());

}

function DDServClientItemSelected(sender, e) {
    $('#hfDefaultDataCode').val(e.get_value());
    var textboxControl = $(sender.get_element());
    var txtAutoDaignosisCode = $(textboxControl).closest('.DDServiceAuto').closest('tr').find('[id*=TextBox2]');
    txtAutoDaignosisCode.val(e.get_value());

}


$(document).ready(function () {
    $(document).keypress(function () { window.top.Set_Idle_Time = 0; });
    $(document).mousemove(function (e) { window.top.Set_Idle_Time = 0; });
    $(document).mouseup(function (e) { window.top.Set_Idle_Time = 0; });
    //$(this).keypress(function () { debugger; Set_Idle_Time = 0; });
    //$(this).mousemove(function (e) { debugger; Set_Idle_Time = 0; });

    //function ServerIdleTimer() {
    //    SERVER_TIMER++;
    //    if (SERVER_TIMER > SERVER_HIT) {
    //        SERVER_TIMER = 0;
    //        $.ajax({ type: "POST", data: { DATA_KEY: "GET_SERVER_IDLE" }, url: "cssLoader.ashx", dataType: "html", success: function (Result) { } });
    //    }
    //}
    //$(this).keypress(function () { SERVER_TIMER = 0; });
    //$(this).mousemove(function (e) { SERVER_TIMER = 0; });
    //var ServerIntervalId = setInterval(function () { ServerIdleTimer() }, 1000);

    //$(document).keypress(function () { debugger; Set_Idle_Time = 0; });
    //$(document).mousemove(function (e) { debugger;Set_Idle_Time = 0; });
    //$(document).mouseup(function (e) { debugger; Set_Idle_Time = 0; });
    //setInterval(function () { IdleTime() }, 1000);

    $('.scriptNextQueBtn').click(function (e) {
        var methodToCall = $(this).data('value');
        eval(methodToCall);
        e.preventDefault();
    });
})
function OpenUMActivityWindow(URL, HEIGHT, WIDTH) {
    var PTID = GetCookie("PT_ID"); var ACTTY = GetCookie("ACT_TY"); var ACTID = GetCookie("ACT_ID");
    if (PTID == "null") { CustomAlert("Select Activity Log"); return; }
    if (ACTTY == "null") { CustomAlert("Select Activity Log"); return; }
    if (ACTID == "null") { CustomAlert("Select Activity Log"); return; }
    URL += "?PATIENT_ID=" + PTID + "&ACT_TY=" + ACTTY + "&ACT_ID=" + ACTID + "&ACT_RF=1";
    OpenWindow(URL, HEIGHT, WIDTH);
}
function OpenCMActivityWindow(URL, HEIGHT, WIDTH, PATIENTID) {
    if (PATIENTID == "") { CustomAlert("Please select a member."); return; }
    //    URL += "?PATIENT_ID=" + PTID + "&ACT_TY=" + ACTTY + "&ACT_ID=" + ACTID + "&ACT_RF=1";
    OpenWindow(URL, HEIGHT, WIDTH);
}
function OpenWindow(URL, HEIGHT, WIDTH) {

    var Cen = (screen.width / 2) - (parseInt(WIDTH) / 2);
    var Top = (screen.height / 2) - (parseInt(HEIGHT) / 2);
    window.open(URL, (window.browserPopUpName || window.top.browserPopUpName), "height=" + HEIGHT + ",width=" + WIDTH + ",top=" + Top + ",left=" + Cen + ",status=yes,toolbar=no,menubar=no,location=no,scrollbars=yes");
}
function SmallWindow(URL, PATIENTID) {
    if (PATIENTID == "") { CustomAlert("Please select a member."); return; }
    OpenWindow(URL, 400, 400);
}
function MediumWindow(URL, PATIENTID) {

    if (PATIENTID == "") { CustomAlert("Please select a member."); return; }
    OpenWindow(URL, 600, 600);

}
function LargeWindow(URL, PATIENTID) {

    if (PATIENTID == "") { CustomAlert("Please select a member."); return; }
    OpenWindow(URL, 750, 1080);

}
function CloseWindow() {
    window.close();
}
//************************ End Window Functions ***********************************************
//************************ ContextMenu Functions Start ****************************************
function AutoTopOne(SourObj, DivHeight, Event, Container) {
    var WinHeight = $(window).height() - $(document).scrollTop(), ObjOffSet = $(SourObj).offset(), ContainerTop = $(Container).offset().top - $(document).scrollTop(), ContainerHeight = $(Container).height();
    var ObjTop = ObjOffSet.top, ObjYpos = Event.clientY > 0 ? Event.clientY : ObjTop;
    var ObjCTop = ObjOffSet.top, ObjYpos = Event.clientY > 0 ? Event.clientY : ObjTop;
    ObjTop = ObjTop - DivHeight;
    ObjTop = ObjTop - 50;
    var test = $(Container).offset().top + $(Container).height() - DivHeight;
    if ((ObjTop + DivHeight) > test) { ObjTop = test - DivHeight; }
    return ObjTop;
}
function AutoTopNew(SourObj, DivHeight, Event, Container) {

    var WinHeight = $(window).height() - $(document).scrollTop(), ObjOffSet = $(SourObj).offset(), ContainerTop = $(Container).offset().top - $(document).scrollTop(), ContainerHeight = $(Container).height();
    var ObjTop = ObjOffSet.top, ObjYpos = Event.clientY > 0 ? Event.clientY : ObjTop;
    ObjTop = ObjTop - DivHeight;
    var test = $(Container).offset().top + $(Container).height() - DivHeight;
    if ((ObjTop + DivHeight) > test) {
        ObjTop = ObjTop - DivHeight;
    }
    if (ObjTop < ContainerTop) {
        ObjTop = Event.clientY;
    }
    if (ObjTop < 40) { ObjTop = 60; }
    return ObjTop;
}
//ContextMenu(this,event,'',true,'',true);
//function ContextMenuNew(TargetObj, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container, NotDB) {
//    if ($("#ConMenu").length > 0) { $("#ConMenu").remove(); }
//    var DoTran = false; var DestObj = TargetObj;
//    var DivHeight = $(SourceDiv).height();
//    var DivTop;
//    if (NotDB || false) { DivTop = AutoTopOne(TargetObj, DivHeight, Event, Container); }
//    else { DivTop = AutoTopNew(TargetObj, DivHeight, Event, Container); }
//    if (IsCheckBox) {
//        if (ParentId != "") {
//            if (ClearAll) {
//                $(DestObj).closest(ParentId).find("input:checked").not(DestObj).removeAttr("checked");
//                //$(DestObj).closest($("." + ParentId)).find("input:checked").not(DestObj).removeAttr("checked");
//            }
//            var ChkAll = $(DestObj).closest(ParentId).find("input:checked");
//            // if (ChkAll.length <= 0) { ChkAll = $(DestObj).closest($("." + ParentId)).find("input:checked"); }
//            if (ChkAll.length == 1) {
//                var str = ChkAll[0].id; if (str.match("Header")) { if ($(DestObj).is(":checked")) { DoTran = true; } } else {
//                    DestObj = ChkAll[0]; DoTran = true; if (NotDB || false) { DivTop = AutoTopOne(TargetObj, DivHeight, Event, Container); }
//                    else { DivTop = AutoTopNew(TargetObj, DivHeight, Event, Container); }
//                }
//            }
//        }
//        else { if ($(DestObj).is(":checked")) { DoTran = true; } }
//    }
//    else { DoTran = true; }
//    if (DoTran) {
//        var DivPos = "left: " + ($(DestObj).offset().left + 15) + "px;top: " + DivTop + "px;";
//        var DivHtml = "<div style='" + DivPos + "' id=\"ConMenu\" class=\"ConMenu\">" + $(SourceDiv).html() + "</div>";
//        $(DestObj).after(DivHtml);
//    }
//}
function ContextMenuNew(TargetObj, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container, NotDB) {
    //if ($("#ConMenu").length > 0) { $("#ConMenu").remove(); }
    var ChkAll = $(ParentId).find("input:checked");
    if (ChkAll.length == 1) {
        var chkbox = ChkAll[0].id;
        //if (chkbox == $(TargetObj).attr('Id')) {
        //}
        //else {
        //    TargetObj = chkbox;
        //}
        //var mentop = $(TargetObj).offset().top;
        //var menleft = $(TargetObj).offset().left;
        var mentop = $("#" + chkbox).offset().top;
        mentop = mentop - $(document).scrollTop();
        var menleft = $("#" + chkbox).offset().left;
        var menheight = $(SourceDiv).height();
        var gtop = $(Container).offset().top;
        gtop = gtop - $(document).scrollTop();
        var gheight = $(Container).height();

        var toppos = 0, leftpos = 0;
        if ((mentop + menheight) > (gtop + gheight)) {
            //if ((mentop - menheight) < gtop) {
            //    toppos = mentop;
            //}
            //else {
            toppos = (mentop + 11) - menheight;
            //}
        }
        else {
            toppos = mentop;
        }
        leftpos = menleft + 13;
        $(SourceDiv).css("top", toppos + "px");
        $(SourceDiv).css("left", leftpos + "px");
        $(SourceDiv).show();
    }
    else {
        $(SourceDiv).hide();
    }

    //var DoTran = false; var DestObj = TargetObj;
    //var DivHeight = $(SourceDiv).height();
    //var DivTop;
    //if (NotDB || false) { DivTop = AutoTopOne(TargetObj, DivHeight, Event, Container); }
    //else { DivTop = AutoTopNew(TargetObj, DivHeight, Event, Container); }
    //if (IsCheckBox) {
    //    if (ParentId != "") {
    //        if (ClearAll) {
    //            $(DestObj).closest(ParentId).find("input:checked").not(DestObj).removeAttr("checked");
    //            //$(DestObj).closest($("." + ParentId)).find("input:checked").not(DestObj).removeAttr("checked");
    //        }
    //        var ChkAll = $(DestObj).closest(ParentId).find("input:checked");
    //        // if (ChkAll.length <= 0) { ChkAll = $(DestObj).closest($("." + ParentId)).find("input:checked"); }
    //        if (ChkAll.length == 1) {
    //            var str = ChkAll[0].id; if (str.match("Header")) { if ($(DestObj).is(":checked")) { DoTran = true; } } else {
    //                DestObj = ChkAll[0]; DoTran = true; if (NotDB || false) { DivTop = AutoTopOne(TargetObj, DivHeight, Event, Container); }
    //                else { DivTop = AutoTopNew(TargetObj, DivHeight, Event, Container); }
    //            }
    //        }
    //    }
    //    else { if ($(DestObj).is(":checked")) { DoTran = true; } }
    //}
    //else { DoTran = true; }
    //if (DoTran) {
    //    var DivPos = "left: " + ($(DestObj).offset().left + 15) + "px;top: " + DivTop + "px;";
    //    var DivHtml = "<div style='" + DivPos + "' id=\"ConMenu\" class=\"ConMenu\">" + $(SourceDiv).html() + "</div>";
    //    $(DestObj).after(DivHtml);
    //}
}
////************************ ContextMenu Functions Start ****************************************

//function AutoTop(SourObj,DivHeight, Event) {
//	var WinHeight = $(window).height(),ObjOffSet = $(SourObj).offset();
//	var ObjTop = ObjOffSet.top, ObjYpos = Event.clientY > 0 ? Event.clientY : ObjTop;
//	if ((ObjYpos + DivHeight) > WinHeight) { ObjTop = (ObjTop - DivHeight)+12; }
//	return ObjTop;
//}
////ContextMenu(this,event,'',true,'',true);
//function ContextMenu(TargetObj, Event, SourceDiv, IsCheckBox, ParentId, ClearAll) {
//	if ($("#ConMenu").length > 0) { $("#ConMenu").remove(); }
//	var DoTran = false; var DestObj = TargetObj;
//	var DivHeight = $(SourceDiv).height();var DivTop = AutoTop(TargetObj, DivHeight, Event);
//	if (IsCheckBox) {
//		if (ParentId != "") {
//			if (ClearAll) {$(DestObj).closest(ParentId).find("input:checked").not(DestObj).removeAttr("checked");}
//			var ChkAll = $(DestObj).closest(ParentId).find("input:checked");
//			if (ChkAll.length == 1) {DestObj = ChkAll[0];DoTran = true;DivTop = AutoTop(ChkAll[0], DivHeight, Event);}
//		}
//		else {if ($(DestObj).is(":checked")) { DoTran = true; } }
//	}
//	else {DoTran = true;}
//	if (DoTran) {
//		var DivPos = "left: " + ($(DestObj).offset().left + 15) + "px;top: " + DivTop + "px;";
//		var DivHtml = "<div style='" + DivPos + "' id=\"ConMenu\" class=\"ConMenu\">" + $(SourceDiv).html() + "</div>";
//		$(DestObj).after(DivHtml);
//	}
//	//$(document).mousedown(function (e) {
//		//if ($("#ConMenu").has(e.target).length === 0) { if ($("#ConMenu").length > 0) { $("#ConMenu").remove(); } }
//	//});
//}
////************************ ContextMenu Functions End ******************************************
//************************ Check Box Functions ***********************************************
function ToggleCheckBoxs(GvId, ChkHeadId, ChkItemId, ChkSource, ChkHeader, ChkAct) {
    var $CheckBoxsAll;

    var gridview = $("#" + GvId);

    if (gridview.length == 0) //If ClientIDMode is not static                   
    {
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
        $HCheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkHeadId + "]");
    }
    else {
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
        $HCheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkHeadId + "]");
    }
    if (ChkHeader == true) {
        $($CheckBoxsAll).each(function () {
            if (GvId == "gvDBRequest") {
                if ($(this)[0].disabled == false) {
                    $(this)[0].checked = ChkSource.checked;
                }
            }
            else {
                if ($(this)[0].disabled == false)
                    $(this)[0].checked = ChkSource.checked;
                if (GvId == "gvLinkView" && (ChkHeadId == "HeadChkEdit" || ChkHeadId == "HeadChkDelete")) {
                    var linkName = $(this).closest('tr').find("#lblMenuName").text();
                    linkName = linkName != null && linkName != undefined ? linkName.toLocaleLowerCase() : linkName;
                    if (linkName != null && linkName != undefined && (linkName == 'activity record >> documents' || linkName == 'activity record >> notes' || linkName == 'um authorizations >> notes' || linkName == 'um authorizations >> documents' || linkName == 'ag complaints >> notes' || linkName == 'ag complaints >> letters and documents')) {
                        if (!(linkName == 'activity record >> documents' && ChkHeadId == "HeadChkEdit")) {
                            $(this).closest('tr').find(".txt" + (ChkHeadId == "HeadChkEdit" ? "Edit" : "Delete")).css("display", ChkSource.checked ? "block" : "none");
                            $(this).closest('tr').find(".txt" + (ChkHeadId == "HeadChkEdit" ? "Edit" : "Delete")).val("");
                        }
                    }
                }
            }
        });
    }
    else {
        var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
        if ($CheckBoxsAll.length == $CheckBoxsChecked.length) {
            $($HCheckBoxsAll).each(function () {
                $(this)[0].checked = true;
            });
        }
        else {
            $($HCheckBoxsAll).each(function () {
                $(this)[0].checked = false;
            });
        }
    }

    if (GvId === "gvUmPendingActivity" || GvId === "gvPendingActions") {
        var hasPendingAddInfo = false;
        $($CheckBoxsAll.filter(":checked")).each(function () {
            if ($(this)[0].checked) {
                if ($(this).closest('tr').find('input[id$="hasAdditional"]').val() === "True") {
                    hasPendingAddInfo = true;
                    return false;
                }
            }
        });

        if (hasPendingAddInfo) {
            $('.gvUmPendingActivity_M').attr('disabled', true);
            $('.gvPendingActions_M').attr('disabled', true);
            $('#umPendingActivityAddInfoCheck').show();
            A11yAlerts.createWarningAlert('#umPendingActivityAddInfoCheck', 'This activity cannot be referred as Additional Information has already been requested.');
        }
        else {
            if (!$('.gvUmPendingActivity_M').hasClass("aspNetDisabled")) {
            $('.gvUmPendingActivity_M').attr('disabled', false);
            }
            $('.gvPendingActions_M').attr('disabled', false);
            $('#umPendingActivityAddInfoCheck').hide();
        }
    }

    if (ChkAct == true) {
        var SI = "." + GvId + "_S", MI = "." + GvId + "_M", NI = "." + GvId + "_N";
        $(SI).show(); $(MI).show(); $(NI).show();
        var $CheckBoxsCheckedAll = $CheckBoxsAll.filter(":checked");
        if ($CheckBoxsCheckedAll.length > 1) {
            $(SI).hide(); $(NI).hide();
            if (GvId == 'gvManageRiskType') { $(MI).hide(); }//to hide delete button in manage risk type if more than one record is selected
        }
        if ($CheckBoxsCheckedAll.length == 1) {
            $(NI).hide();
        }
        if (GvId == 'gvManageRole' && $CheckBoxsCheckedAll.length >= 1) {
            $CheckBoxsCheckedAll.each(function () {
                //if ($(this).parent().data('name').toString().toUpperCase() == 'PROVIDER_USER' || $(this).parent().data('name').toString().toUpperCase() == 'PROVIDER_ADMIN') {
                if ($(this).parent().data('isdefault').toString().toUpperCase() == 'YES') {
                    $(MI).hide();
                    return;
                }
            });
        }
    }

    $CheckBoxsAllD = $("#" + GvId + " input:checkbox[id*='ItemChkDelete_']");
    $CheckBoxsAllE = $("#" + GvId + " input:checkbox[id*='ItemChkEdit_']");
    $CheckBoxsAllA = $("#" + GvId + " input:checkbox[id*='ItemChkAdd_']");
    $HCheckBoxsAllD = $("#" + GvId + " input:checkbox[id*='HeadChkDelete']");
    $HCheckBoxsAllE = $("#" + GvId + " input:checkbox[id*='HeadChkEdit']");
    $HCheckBoxsAllA = $("#" + GvId + " input:checkbox[id*='HeadChkAdd']");
    $CheckBoxsAllCheckD = $("#" + GvId + " input:checkbox[id*='ItemChkDelete_']:checked");
    $CheckBoxsAllCheckE = $("#" + GvId + " input:checkbox[id*='ItemChkEdit_']:checked");
    $CheckBoxsAllCheckA = $("#" + GvId + " input:checkbox[id*='ItemChkAdd_']:checked");

    if (GvId == 'gvPageActions' && ChkHeadId == 'HeadChkView' && ChkAct == true && ChkHeader == true) {

        if (!ChkSource.checked) {

            $($CheckBoxsAllD).attr('checked', false);
            $($CheckBoxsAllE).attr('checked', false);
            $($CheckBoxsAllA).attr('checked', false);
            $($HCheckBoxsAllD).attr('checked', false);
            $($HCheckBoxsAllE).attr('checked', false);
            $($HCheckBoxsAllA).attr('checked', false);

        }


    }
    else if (GvId == 'gvPageActions' && ChkItemId == 'ItemChkView_' && ChkAct == true && ChkHeader == false) {
        if (!ChkSource.checked) {
            var CheckBoxDelete = "#" + $(ChkSource).attr('id').replace('ItemChkView_', 'ItemChkDelete_');
            $(CheckBoxDelete).attr('checked', false);
            var CheckBoxEdit = "#" + $(ChkSource).attr('id').replace('ItemChkView_', 'ItemChkEdit_');
            $(CheckBoxEdit).attr('checked', false);
            var CheckBoxAdd = "#" + $(ChkSource).attr('id').replace('ItemChkView_', 'ItemChkAdd_');
            $(CheckBoxAdd).attr('checked', false);

            if ($CheckBoxsAllCheckD.length != $CheckBoxsAllD.length) {
                $HCheckBoxsAllD.attr('checked', false);
            }
            if ($CheckBoxsAllCheckE.length != $CheckBoxsAllE.length) {
                $HCheckBoxsAllE.attr('checked', false);
            }
            if ($CheckBoxsAllCheckA.length != $CheckBoxsAllA.length) {
                $HCheckBoxsAllA.attr('checked', false);

            }

        }

    }

    if (GvId == 'gvPageActions') {  //uhc-3967
        var sourceId = $(ChkSource).attr('id');
        var pageActionName = $('#gvPageActions').find('#' + sourceId).closest('tr').find('td').html();
        // ChkItemId ItemChkEdit : for Edit click. ItemChkView_: for View Click
        switch (pageActionName.toUpperCase()) {
            case "DATE OF DEATH":
                if ($('.clsDateofDeath').find('.ItemChkView').children().is(':checked') == false) {
                    $('.clsCauseDeathInfo').find('.ItemChkView').children().prop('checked', false);
                    $('.clsCauseDeathInfo').find('.ItemChkEdit').children().prop('checked', false);
                    $('.clsPlaceDeathInfo').find('.ItemChkView').children().prop('checked', false);
                    $('.clsPlaceDeathInfo').find('.ItemChkEdit').children().prop('checked', false);
                }
                break;
            case "CAUSE OF DEATH":
                if ($('.clsCauseDeathInfo').find('.ItemChkView').children().is(':checked') == true) {
                    $('.clsDateofDeath').find('.ItemChkView').children().prop('checked', true);
                }
                if ($('.clsCauseDeathInfo').find('.ItemChkEdit').children().is(':checked') == true) {
                    $('.clsDateofDeath').find('.ItemChkView').children().prop('checked', true);
                    $('.clsDateofDeath').find('.ItemChkEdit').children().prop('checked', true);
                    $('.clsCauseDeathInfo').find('.ItemChkView').children().prop('checked', true);
                }
                break;
            case "ACTUAL PLACE OF DEATH":
                if ($('.clsPlaceDeathInfo').find('.ItemChkView').children().is(':checked') == true) {
                    $('.clsDateofDeath').find('.ItemChkView').children().prop('checked', true);
                }
                if ($('.clsPlaceDeathInfo').find('.ItemChkEdit').children().is(':checked') == true) {
                    $('.clsDateofDeath').find('.ItemChkView').children().prop('checked', true);
                    $('.clsDateofDeath').find('.ItemChkEdit').children().prop('checked', true);
                    $('.clsPlaceDeathInfo').find('.ItemChkView').children().prop('checked', true);
                }
                break;
        }
    } //uhc-3967
}
function ShowHideScriptExport(chkObj, headerChkObj, hdnId) {
    // var flag = ToggleCheckBoxs('gvAdminScript', 'HeaderChkScript', 'ItemChkScript_', this, true, true);
    var chkCount = 0;
    var chkObject = $(chkObj);
    if (chkObject.is(':checked')) {

        chkItems = chkObject.closest('table').find('input:checked').not('#HeaderChkScript');
        if (chkItems.length == 1) {
            var hdnObj = $('#' + chkItems.attr('id').replace('ItemChkScript', hdnId));
            if ($.trim(hdnObj.val()) === 'Form') {
                $('#imgbtnExport').hide();
            } else {
                $('#imgbtnExport').show();
            }
        }

    }
}

function ClearCheckBoxes(GvId, ChkItemId, HeaderChkItemId) {
    var $CheckBoxsAll;
    var $HeaderCheckBox;
    var gridview = $("#" + GvId);
    if (gridview.length == 0) //If ClientIDMode is not static                   
    {
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
        $HeaderCheckBox = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + HeaderChkItemId + "]");
    }
    else {
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
        $HeaderCheckBox = $("#" + GvId + " input:checkbox[id*=" + HeaderChkItemId + "]");
    }

    //    $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
    $($CheckBoxsAll).attr('checked', false);
    $('#' + (HeaderChkItemId || '')).attr('checked', false);
    $($HeaderCheckBox).attr('checked', false);
}
function AlertOnActionMulti(GvId, ChkItemId, NegMsg, PosMsg, IsExactMsg, MandatoryMsg) {
    var $CheckBoxsAll;
    var gridview = $("#" + GvId);
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
    if (MandatoryMsg != undefined && MandatoryMsg != null && MandatoryMsg.length > 0) {
        if ($CheckBoxsAll != null && $CheckBoxsChecked != null && $CheckBoxsAll.length == $CheckBoxsChecked.length) {
            if ($("#divErrorMsg_" + GvId).length === 0) {
                displayConsentFormValidationMessage(GvId);
            }
            DisplayFriendlyMessage($("#divErrorMsg_" + GvId), "Error", MandatoryMsg);
            return false;
        }
    }
    if ($CheckBoxsChecked.length > 0) {
        if ((PosMsg || '') === '') {
            return true;
        }
        var finalMsg = null;
        if (IsExactMsg == null) {
            var DisMes = "Selected Item"; PosMsg = PosMsg.replace("these", "");
            if ($CheckBoxsChecked.length > 1) { DisMes = $CheckBoxsChecked.length + " Item(s)"; PosMsg += "these"; }
            PosMsg = PosMsg.toLowerCase();
            if ($CheckBoxsChecked.length > 1) { finalMsg = PosMsg.substr(0, 1).toUpperCase() + PosMsg.substr(1) + " " + DisMes.toLowerCase(); }
            else { finalMsg = PosMsg.substr(0, 1).toUpperCase() + PosMsg.substr(1) + DisMes.toLowerCase(); }
        }
        else {
            if ($CheckBoxsChecked.length > 1)
                PosMsg = PosMsg.replace("this", "these");
            finalMsg = PosMsg;
        }
        var If = CustomConfirm(finalMsg.replace("?", "") + "?");
        return If;
    }
    else if ($CheckBoxsChecked.length == 0) {
        if ($("#divErrorMsg_" + GvId).length === 0) {
            displayConsentFormValidationMessage(GvId);
        }
        DisplayFriendlyMessage($("#divErrorMsg_" + GvId), "Error", NegMsg);
        return false;
    }

    return true;
}
function AlertOnActionMultiInternal(GvId, ChkItemId, NegMsg, PosMsg, IsExactMsg) {
    var $CheckBoxsAll;
    var gridview = $("#" + GvId);
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");

    if ($CheckBoxsChecked.length > 0) {
        if ((PosMsg || '') === '') {
            return true;
        }
        var finalMsg = null;
        if (IsExactMsg == null) {
            var DisMes = "Selected Item"; PosMsg = PosMsg.replace("these", "");
            if ($CheckBoxsChecked.length > 1) { DisMes = $CheckBoxsChecked.length + " Item(s)"; PosMsg += "these"; }
            PosMsg = PosMsg.toLowerCase();
            finalMsg = PosMsg.substr(0, 1).toUpperCase() + PosMsg.substr(1) + " " + DisMes.toLowerCase();
        }
        else {
            if ($CheckBoxsChecked.length > 1)
                PosMsg = PosMsg.replace("this", "these");
            finalMsg = PosMsg;
        }
        var If = CustomConfirm(finalMsg + ".");
        return If;
    }
    else if ($CheckBoxsChecked.length == 0) {
        CustomAlert(NegMsg);
        return false;
    }

    return true;
}
function AlertOnActionMultiBatchLetter(GvId, ChkItemId, NegMsg, PosMsg, IsExactMsg) {
    var $CheckBoxsAll;


    var gridview = $("#" + GvId);
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");

    var brakStaement = false;
    for (var i = 0; i < $CheckBoxsChecked.length; i++) {
        var curRow = $($CheckBoxsChecked[i]).closest("tr");
        var mName = $(".CHKMODULE", curRow).html();
        if (mName !== undefined) {
            if (mName.toUpperCase() === 'CM') { brakStaement = true; break; }
        }
    }
    if (brakStaement === true) { CustomAlert('Batch letter is eligible for UM and AG Modules only.'); return false; }
    if ($CheckBoxsChecked.length > 0) {
        if ((PosMsg || '') === '') {
            return true;
        }
        var finalMsg = null;
        if (IsExactMsg == null) {
            var DisMes = "Selected Item"; PosMsg = PosMsg.replace("these", "");
            if ($CheckBoxsChecked.length > 1) { DisMes = $CheckBoxsChecked.length + " Item(s)"; PosMsg += "these"; }
            PosMsg = PosMsg.toLowerCase();
            finalMsg = PosMsg.substr(0, 1).toUpperCase() + PosMsg.substr(1) + " " + DisMes.toLowerCase();
        }
        else {
            if ($CheckBoxsChecked.length > 1)
                PosMsg = PosMsg.replace("this", "these");
            finalMsg = PosMsg;
        }
        var If = CustomConfirm(finalMsg.replace("?", "") + "?");
        return If;
    }
    else if ($CheckBoxsChecked.length == 0) {
        CustomAlert(NegMsg);
        return false;
    }

    return true;
}
function IsCheckBoxChecked(checkListId, validationGroup) {

    var isValid = true;
    isValid = Page_ClientValidate(validationGroup);
    if (isValid) {
        var $CheckBoxsAll = $("input:checkbox[id*='" + checkListId + "']");
        var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
        if ($CheckBoxsChecked.length <= 0) {
            CustomAlert("Please select at least one behavioral condition.");
            isValid = false;
        }
    }
    return isValid;
}
function AlertOnActionSingle(GvId, ChkItemId, NegMsgDeflt, NegMsg) {
    var $CheckBoxsAll;
    var gridview = $("#" + GvId);

    if (gridview.length == 0) //If ClientIDMode is not static
    {
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
    }
    else {
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
    }
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");

    if ($CheckBoxsChecked.length == 0) {
        if ($("#divErrorMsg_" + GvId).length === 0) {
            displayConsentFormValidationMessage(GvId);
        }
        DisplayFriendlyMessage($("#divErrorMsg_" + GvId), "Error", NegMsgDeflt);
        return false;
    }
    else if ($CheckBoxsChecked.length > 1) {
        if ($("#divErrorMsg_" + GvId).length === 0) {
            displayConsentFormValidationMessage(GvId);
        }
        DisplayFriendlyMessage($("#divErrorMsg_" + GvId), "Error", NegMsg);
        return false;
    }

    return true;
}

function displayConsentFormValidationMessage(gridId) {
    if (gridId === 'gvCnsntMaster' || gridId === 'gvChecklist') {
        $("#editConsentFormAlert").append('<div id="divErrorMsg_' + gridId + '" style="text-align: center"></div>');
    } else {
        $("#" + gridId).before('<div id="divErrorMsg_' + gridId + '" style="text-align: center"></div>');
    }
}

function DisplayFriendlyMessage(element, msgType, msg) {    // NOSONAR (unconventional function name, but there are too many usages to fix)
    DevUtils.logDebug('msgType[' + msgType + '], msg[' + msg + '], element:', 'JS_CMN.DisplayFriendlyMessage()', element);
    let containerId = $(element).attr('id');

    DevUtils.logDebug('Making call to A11yAlerts with containerSelector[' + containerId + '], alertMessage[' + msg + '], alertType[' + msgType + ']', 'JS_CMN.DisplayFriendlyMessage()');

    switch (msgType) {
        case 'Success':
            A11yAlerts.createSuccessAlert('#' + containerId, msg);
            break;
        case 'Warning':
            A11yAlerts.createWarningAlert('#' + containerId, msg);
            break;
        default:
            A11yAlerts.createErrorAlert('#' + containerId, msg);
            break;
    }
}

//UHC-4143
$(document).off('click', '#btnAddCnstCheckList,#btnRemoveCnstCheckList').on('click', '#btnAddCnstCheckList,#btnRemoveCnstCheckList', function () {
    var ID = $(this).attr("Id");
    if (ID == "btnAddCnstCheckList") {
        var isTaggedItemExists = false;
        var isTaggedItemSelected = false;
        var selectedCount = 0;
        $("#lstCheckListItemMaster :selected").each(function (index, element) {
            if ($(this)[0].style.fontWeight == "bold") {
                isTaggedItemSelected = true;
                selectedCount++;
            }
        });
        $("#lstCheckListCnstItemMaster option").each(function (index, element) {
            if ($(this)[0].style.fontWeight == "bold")
                isTaggedItemExists = true;
        });
        if (isTaggedItemExists == true && isTaggedItemSelected == true) {
            alert("A checklist item with a consent tag is already selected for the consent form.");
            return false;
        }
        if (selectedCount > 1) {
            alert("Only one checklist item with a consent tag is allowed.");
            return false;
        }
    }
    var ChooseFrom = ID == "btnAddCnstCheckList" ? "#lstCheckListItemMaster" : "#lstCheckListCnstItemMaster";
    var moveTo = ID == "btnAddCnstCheckList" ? "#lstCheckListCnstItemMaster" : "#lstCheckListItemMaster";
    var SelectData = $(ChooseFrom + " :selected").toArray();
    $(moveTo).append(SelectData);
    SelectData.remove;
    return false;
});

function showCheckListAlert(sender) {
    var checkedStatus = $("#hdnCheckedStatus").val();
    if (checkedStatus == "True") {
        $("#lblCheckListAlert").html("This action shall disable the access to member's health information for providers and caregivers. Would you like to continue?");
        $find('behCheckListAlert').show();
    }
    else if (checkedStatus == "False") {
        $("#lblCheckListAlert").html("This action shall enable the access to member's health information for providers and caregivers. Would you like to continue?");
        $find('behCheckListAlert').show();
    }
}
function resetIsDisclosed() {
    var checkedStatus = $("#hdnCheckedStatus").val();
    if (checkedStatus == "True") {
        $("#chkIsDisclosed").attr('checked', true);
    }
    else {
        $("#chkIsDisclosed").removeAttr('checked');
    }
    $find('behCheckListAlert').hide();
    return false;
}
//UHC-4143
//PROD-8593
function OnCNSTFileSelected(sender, args) {
    var currentFileName = args.get_fileName();
    if ($.trim(currentFileName)) {
        $("#hdnIsFileUploaded").val("1");
    }
}
function OnCNSTFileRemoved(sender, args) {
    $("#hdnIsFileUploaded").val("0");
}
function ValidateExpiredDate(effctDate, expiryDate, isSave) {
    if (isSave == true) {
        var cnstCheckListIds = ''; //UHC-4143        
        $("#lstCheckListCnstItemMaster" + " option").each(function (ele, ind) {
            cnstCheckListIds += $(this).val() + ',';
        });
        cnstCheckListIds = cnstCheckListIds.substring(0, cnstCheckListIds.length - 1);
        $("#hdnSelectedCheckListIds").val(cnstCheckListIds);//UHC-4143
        var result = true;
        var varStartDate = $("#" + effctDate).val();
        var varEndDate = $("#" + expiryDate).val();
        if (varEndDate != 'undefined' && varEndDate != null && varEndDate != '') {
            var effectedDate = new Date(varStartDate);
            var expiredDate = new Date(varEndDate);
            var todaysDate = new Date();
            effectedDate.setHours(0, 0, 0, 0);
            expiredDate.setHours(0, 0, 0, 0);
            todaysDate.setHours(0, 0, 0, 0);
            if (expiredDate >= effectedDate) {//Checking weather start date is grater than end date or not
                $("#lblMessage").css('visibility', 'visible');
                if (expiredDate < todaysDate) {
                    //$("#lblCnstFrmExpDate").html("The Expiration Date should not be less than Current Date.").show();
                    //$("#lblMessage").css('visibility', 'hidden');
                    //result = false;
                }
                else {
                    $("#lblCnstFrmExpDate").hide();
                    $("#lblMessage").css('visibility', 'visible');
                }
                $("#lblCmpCnstFrmDates").hide();
            }
            else {
                $("#lblMessage").html("The Expiration Date should not be less than Effective Date.").show();
                result = false;
            }
        }
    }
    if (result == true) {
        var title = '', consentFormId = '', lobBenId = '';
        if ($("#hdnCnsentID").length > 0)
            consentFormId = $("#hdnCnsentID").val();
        else if ($('iframe:not(#iframeSmartCOMMSSo)').contents().find('#hdnCnsentID').length > 0)
            consentFormId = $('iframe:not(#iframeSmartCOMMSSo)').contents().find('#hdnCnsentID').val();
        if (consentFormId == '') {
            if ($("#hdnIsFileUploaded").val() == "0") {
                $("#lblUploaderror").show();
                $("#lblCmpCnstFrmDates").hide();
                $("#lblCnstFrmExpDate").hide();
                return false;
            }
            $("#lblUploaderror").hide();
            if ($("input[name = 'rdoHierarchyLevelGrid']").length > 0)
                lobBenId = $("input[name = 'rdoHierarchyLevelGrid']:checked").data('lobbenid');
            //$("#ddlLob").val();
            if ($("#txtConsentFormTitle").length > 0)
                title = $("#txtConsentFormTitle").val();
            else if ($('iframe:not(#iframeSmartCOMMSSo)').contents().find('#txtConsentFormTitle').length > 0)
                title = $('iframe:not(#iframeSmartCOMMSSo)').contents().find('#txtConsentFormTitle').val();
            var postData = { formTitle: title, EffectiveDate: varStartDate, ExpirationDate: varEndDate, lobBenId: lobBenId };
            $('iframe:not(#iframeSmartCOMMSSo)').contents().find('.loading').show();
            $.ajax({
                type: "POST",
                data: postData,
                url: baseURL + "/ActivityRecord/ValidateConsentForm",
                async: false,
                success: function (data) {
                    $('iframe:not(#iframeSmartCOMMSSo)').contents().find('.loading').hide();
                    $("#lblMessage").css('visibility', 'visible');
                    switch (data.data) {
                        case 0:
                            $("#lblMessage").html("The Effective Date should not overlap with the existing consent form's Expiration Date.");
                            $("#lblCmpCnstFrmDates").css('visibility', 'hidden');
                            result = false;
                            break;
                        case 2:
                            $("#lblMessage").html("There is an active form already exist.");
                            $("#lblCmpCnstFrmDates").css('visibility', 'hidden');
                            result = false;
                            break;
                        case 3:
                            $("#lblMessage").html("Consent form already exists for the higher eligibility level.");
                            $("#lblCmpCnstFrmDates").css('visibility', 'hidden');
                            result = false;
                            break;
                        case 1:
                            $("#lblMessage").css('visibility', 'hidden');
                            break;
                    }
                }
            });
        }
    }
    return result;
}
//PROD-8593
//************************ End Check Box Functions ***********************************************
function Valid_DropDown(DdlId, Mess) {
    var RetVal = true;
    var DdlVal = $(DdlId).val();
    if (DdlVal == "00" || DdlVal == "-1" || DdlVal == "0" || DdlVal == "") {
        CustomAlert(Mess);
        RetVal = false;
    }
    return RetVal;
}
//************************ Loader Start ***********************************************
// Don't Delete any code in this Block
//var prm = Sys.WebForms.PageRequestManager.getInstance();
//prm.add_initializeRequest(InitializeRequest);
////prm.add_endRequest(EndRequest);
//var postBackElement = null;
//function InitializeRequest(sender, args) {
//    //if (prm.get_isInAsyncPostBack()) {args.set_cancel(true);}
//    postBackElement = args.get_postBackElement();
//    var $Upp = $(postBackElement).closest(".UpdatePanelProgress");
//    var divid = "#div" + $Upp.attr("id") + "Progress";
//    $(divid).css("position", "absolute");
//    $(divid).css("width", $Upp.width() + "px");
//    $(divid).css("height", $Upp.height() + "px");
//}
//function EndRequest(sender, args) {

//}
//************************ Loader End *************************************************
//************************ Date Function Start ****************************************
function IsDate(TxtDate, SplitChar) {
    var AoDate, MS, MM, DD, YY;
    if (SplitChar === undefined) { SplitChar = '/'; }
    AoDate = TxtDate.split(SplitChar);
    if (AoDate.length !== 3) { return false; }
    MM = AoDate[0] - 1; DD = AoDate[1] - 0; YY = AoDate[2] - 0;
    MS = (new Date(YY, MM, DD)).getTime();
    AoDate = new Date(); AoDate.setTime(MS);
    if (AoDate.getFullYear() !== YY || AoDate.getMonth() !== MM || AoDate.getDate() !== DD) { return false; }
    return true;
}
function isValidCalendarDate(inputVal) {
    var isValid = true;
    let dateRegEx = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if (!dateRegEx.test(inputVal)) {
        isValid=false;
    }
    return isValid;
}
function IsDateTime(TxtDate) {
    let timeRegEx = IS_12HRS_FORMAT ? /^(0?[1-9]|1[012])(:[0-5]?\d)(:[0-5]?\d)? [APap][mM]$/ : /^([0?1][0-9]|2[0-3])(:[0-5]\d)$/;
    let dateRegEx = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    let dateTxt = TxtDate.split(' ')[0];
    if (!dateRegEx.test(dateTxt)) {
        return false;
    }

    let timeTxt = TxtDate.split(' ')[2] !== undefined ? TxtDate.split(' ')[1] + ' ' + TxtDate.split(' ')[2] : TxtDate.split(' ')[1];

    return timeRegEx.test(timeTxt);
}
function ValidateDate(Start_Date, End_Date) {
    var Retval = false;
    if (IsDate(Start_Date) && IsDate(End_Date)) {
        var StartDate = new Date(Start_Date);
        var EndDate = new Date(End_Date);
        if (StartDate > EndDate) { Retval = false; }
        else { Retval = true; }
    }
    else {
        Retval = false;
    }
    return Retval;
}
//************************ Date Function End ******************************************
//************************ Loader End *************************************************
function SyncTextBoxes(txt) {
    var t = $("#txtDtaStartDate").val();
    var d = $("#txtDtaDays").val();
    if (IsDate(t, '-')) {
        var dt = new Date(t);
        dt.setDate(dt.getDate() + d);
        $("#txtDtaEndDate").val(dt.toString('MM-dd-yyyy'));
    }

}
function GetMedicationCode(rdBtnID) {
    var rb = $(document.getElementById(rdBtnID));
    var medNameID = $("#" + rb[0].id.replace("rdoNdcCode", "lblDesc"));
    var ndcValue = $('label[for="' + $('#' + rdBtnID).attr('id') + '"]').html();
    $('#hdnMedCode').val(ndcValue);
    $('#hdnMedID').val('');
    $('#hdnMedID').val(rb[0].value);
    $('#hdnManualMedName').val('');
    $('#hdnManualMedName').val(medNameID[0].innerHTML);
    rb.checked = true;
    var list = rb.closest('table').find("INPUT[type='radio']").not(rb);
    list.attr('checked', false);
}
function limitChars(textBox, label, maxChars) {
    var text = $("#" + textBox).val();
    if (text.length <= maxChars) {
        var remainingChars = maxChars - text.length;
        $("#" + label).html('Characters remaining: ' + remainingChars);
        return true;
    }
    else {
        $("#" + textBox).val(text.substring(0, maxChars)); //UHC-4143
        $("#" + label).html('Characters remaining: ' + 0);
        return false;
    }
}
//****************************************Script Related Start***********************************************//       
function ShowSubOption(SelType, OptId) {

    $('.radiooptions').prop('checked', false);
    var OptAll = "", OptCur = "";
    OptAll = ".TR_Opts_";
    OptCur = ".TR_Opts_" + OptId;
    if (SelType == "RB") {
        //$("#Reb_Opt_Rb_" + OptId).attr('checked', true);
        //$("#Reb_Opt_Rb_" + OptId).focus();
        //if ($("#Reb_Opt_Rb_" + OptId).length > 0) {
        //    $("#Reb_Opt_Rb_" + OptId)[0].checked = true;
        //    $("#Reb_Opt_Rb_" + OptId)[0].focus();
        //}

        if ($("[id*=Reb_Opt_Rb_" + $.trim(OptId) + "€]").length > 0) {
            $("[id*=Reb_Opt_Rb_" + $.trim(OptId) + "€]")[0].checked = true;
            $("[id*=Reb_Opt_Rb_" + $.trim(OptId) + "€]").focus();
        }
        $(OptAll).find(".TR_SubOpt").each(function (index, el) {
            if ($(this).find("#hdnHasPh").length == 0) {
                $('input:checkbox', this).attr('checked', false);
                $('input:radio', this).attr('checked', false);
                $('select option:selected', this).removeAttr('selected');
                $('select', this).find('option:first').attr('selected', 'selected');
                $('input:text', this).val('');
                $('.txtboxfield', this).val(''); $('img.dynSignatureWF', this).attr('src', '');
                $(this).hide();
            }
        });
        var SubOpts = $(OptCur).find(".TR_SubOpt");
        $(OptCur).find(".TR_SubOpt").each(function (index, el) { $(this).show(); });
    }
    else if (SelType == "CHK") {
        var SubOpts = $(OptCur).find(".TR_SubOpt");
        if ($("#Reb_Opt_Ch_" + OptId).prop('checked') == true) {
            $("#hdnSelectedOption").val(OptId);//To Fix UHG- 491 - Vinod Borra
            $(OptCur).find(".TR_SubOpt").each(function (index, el) { $(this).show(); });
        }
        else {
            $(OptCur).find(".TR_SubOpt").each(function (index, el) {
                $('input:checkbox', this).attr('checked', false);
                $('input:radio', this).attr('checked', false);
                $('select option:selected', this).removeAttr('selected');
                $('select', this).find('option:first').attr('selected', 'selected');
                $('input:text', this).val(''); $('img.dynSignatureWF', this).attr('src', '');
                $(this).hide();
            });
        }
    }
    if (SubOpts != null) {
        if (SubOpts.length > 0) {
            $(OptCur).css('border', '1px');
        }
    }
}
function SelectThis(SelObj, evt, OptId, QueNextId) {
    var evt = (evt) ? evt : ((event) ? event : null);
    if (evt.keyCode == 13 || evt.keyCode == 9 || evt.keyCode == 32) {
        if (evt.keyCode == 13 || evt.keyCode == 32) {
            if (evt.keyCode == 13) { $(SelObj).attr('checked', true); }
            ShowSubOption('TB', OptId, QueNextId);
        }
        else {
            if ($(SelObj).is(':checked')) {
                ShowSubOption('TB', OptId, QueNextId);
            }
            else {
                var OptCur = ".TR_RadOpts_" + OptId;
                var SubOpts = $(OptCur).find(".TR_SubOpt");
            }
        }
    }
}
function SelectThisAndShowSubOption(SelObj, evt, QuestionId, OptId, QueNextId) {
    var evt = (evt) ? evt : ((event) ? event : null);
    if (evt.keyCode == 13 || evt.keyCode == 9 || evt.keyCode == 32) {
        if (evt.keyCode == 13 || evt.keyCode == 32) {
            if (evt.keyCode == 13) { $(SelObj).attr('checked', true); }
            ShowSubOptionAndGoToNext(SelObj, QuestionId, OptId, QueNextId, 1, '');
        }
        else {
            if ($(SelObj).is(':checked')) {
                ShowSubOptionAndGoToNext(SelObj, QuestionId, OptId, QueNextId, 1, '');
            }
            else {
                var OptCur = ".TR_RadOpts_" + OptId;
                var SubOpts = $(OptCur).find(".TR_SubOpt");
            }
        }
    }
}
function ValidateEndScript() {
    if ($("#hdnAllowEndScriptWF").val() == "false") {
        CustomAlert('You do not have authorization to perform this action'); return false;
    }
    var lblMessage = $("#lblRunScriptErrorMsg");
    lblMessage.css("color", 'Red');
    lblMessage.html('');
    if (ValidateWFQuestionOption()) {
        if (ValidateWFQuestionSubOption()) {
            var result = CustomConfirm('Are you sure you want to end the script?');
            if (result) {
                //Getting Response for the current question.
                var qusResult = GetCurrentQuestionData('false', '1');
                $("#lblRunScriptErrorMsg").html('');
                if (qusResult)
                    $("#hdnIsAnswered").val('true');
                else
                    $("#hdnIsAnswered").val('false');
                return true;
            }
            else
                return false;
        }
        else {
            lblMessage.html('Please select/enter required suboption(s)');
            return false;
        }
    }
    else {
        lblMessage.html('Please select/enter required option(s)');
        return false;
    }
}

function ValidateSaveForLaterScript() {
    //Getting Response for the current question.
    var lblMessage = $("#lblRunScriptErrorMsg");
    lblMessage.css("color", 'Red');
    lblMessage.html('');
    if (ValidateWFQuestionOption()) {
        if (ValidateWFQuestionSubOption()) {
            var qusResult = GetCurrentQuestionData('false', '1');
            if (qusResult) {
                $("#hdnIsAnswered").val('true');
                return true;
            }
            else {
                $("#hdnIsAnswered").val('false');
                //lblMessage.html('');
                return false;
            }
        }
        else {
            lblMessage.html('Please select/enter required suboption(s)');
            return false;
        }
    }
    else {
        lblMessage.html('Please select/enter required option(s)');
        return false;
    }
}

function calendarValidation(e) {
    var length = $(e).val().length;
    var code;
    var userAgent = navigator.userAgent;
    if (userAgent.search("Firefox") > -1) {
        code = ((e.which) ? e.which : e.keyCode);
    }
    else {
        code = window.event == undefined ? ((e.which) ? e.which : e.keyCode) : window.event.keyCode;
    }
    var digChar = [49, 50, 51, 52, 53, 54, 55, 56, 57, 48, 47];
    var isValid = false;
    for (var i = digChar.length - 1; i >= 0; i--) {
        if (digChar[i] == code) {
            isValid = true;
        }
    };
    $(e).blur(function () {
        isValidScriptDate(e); //VNSNYC-326
    });
    if (isValid === false || length > 10) {
        if (userAgent.search("Firefox") == -1) {
            event.preventDefault();
        }
        return;
    }
}

function isValidScriptDate(e) {
    //VNSNYC - 326
    $("#spanSPSInvalidDate").remove();
    //var regEx = /^(0[1-9]|1[0-2]|\d)[/]([0-2]\d|30|31|\d)[/](\d\d\d\d)$/;
    //if (regEx.test($(e).val()) == false) {
    if ($.trim($(e).val()) === '') {
        return true; //return true if the value is empty
    }

    var regEx = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/;

    if (!regEx.test($(e).val()) || !IsDate($(e).val().trim())) {
        $(e).val('');
        $(e).after("&nbsp;<span style='color:red;font-weight:bold;' id='spanSPSInvalidDate'>Invalid date.</span>");
        var elementID = $(e).data("ctrlinfo");
        var splittedValues = elementID.split('|');
        if (splittedValues.length > 0) {
            $("#TR_Que_Row_" + splittedValues[0]).removeClass("Answered").addClass("UnAnswered");
        }
        return false;
    }
    else
        return true;
}

function GetCurrentQuestionData(isFromHistory, isRestrict) {
    //Find the Message Label
    var lblMessage = $("#lblRunScriptErrorMsg");
    var requiredAnswer = $("#hdnRunScriptRequiredAnswer");
    $("#hdnCurrentQuestionData").val('');
    if (isFromHistory == "true")
        $("#hdnRunScriptCareNotes").val($("#txtCareNotes").val());
    var RetVal = "", subOptionsCount = 0; var chkSubOptionIds = new Array();
    var optionType = "", isInValidSubOptionDate = "";
    var lstSubOptionIds = new Array();
    var returnIfSubOptNotRequired = false;

    var SelOpts = $('input[name*="Reb_QueOpt_"]:radio:checked');
    if (SelOpts.length <= 0) {
        SelOpts = $('input[name*="Reb_QueOpt_"]:checkbox:checked');
        if (SelOpts.length <= 0) {
            SelOpts = $('input[id*="RebQueOptCalendar€"]:text');
            if (SelOpts.length <= 0) {
                SelOpts = $('input[id*="Reb_QueOpt_txt"]:text');
                if (SelOpts.length <= 0) {
                    SelOpts = $('textarea[id*="Reb_QueOpt_txt_area"]');
                    if (SelOpts.length <= 0) {
                        SelOpts = $('img[id*="RebQueOptSignature€"]');
                        if (SelOpts.length <= 0) {
                            SelOpts = $('span[id*="Reb_QueOpt_Label"]');
                            if (SelOpts.length <= 0) {
                                if (isFromHistory == "false") {
                                    lblMessage.html('Please select at least one option.');
                                    $("html, body").animate({ scrollTop: 0 }, 100);
                                    return false;
                                }
                                else {
                                    returnIfSubOptNotRequired = true;
                                }
                            }
                            else {
                                optionType = "label";
                                returnIfSubOptNotRequired = true;
                            }
                        }
                        else {
                            optionType = "signature";
                            if (SelOpts.attr("src") == "") {
                                if (isFromHistory == "false") {
                                    lblMessage.html("Please enter signature.");
                                    $("html, body").animate({ scrollTop: 0 }, 100);
                                    return false;
                                }
                            }
                            returnIfSubOptNotRequired = true;
                        }
                    }
                    else {
                        optionType = "textarea"; //CIH-1598 - To set the option type when click on show history
                        var TextAreaValue = $("#hdnTextAreaValue");
                        if (TextAreaValue.length > 0) {
                            TextAreaValue[0].value = SelOpts[0].value;
                        }
                        if (isFromHistory == "false") {
                            if (SelOpts.val().trim() == "") {
                                lblMessage.html('Please enter response');
                                return false;
                            }
                            else {
                                returnIfSubOptNotRequired = true;
                            }
                        }
                    }
                }
                else {
                    optionType = "text"
                    if (isFromHistory == "false") {
                        if (SelOpts.val().trim() == "") {
                            lblMessage.html('Please enter response');
                            return false;
                        }
                        else {
                            returnIfSubOptNotRequired = true;
                        }
                    }
                }
            }
            else {
                optionType = "calendar"
                if (SelOpts.val().trim() == "") {
                    if (isFromHistory == "false") {
                        lblMessage.html("Please enter date.");
                        $("html, body").animate({ scrollTop: 0 }, 100);
                        return false;
                    }
                    else {
                        returnIfSubOptNotRequired = true;
                    }
                }
                else {
                    if (IsDate(SelOpts.val().trim()) == false) {
                        lblMessage.html('Enter a valid date');
                        return false;
                    }
                    else {
                        returnIfSubOptNotRequired = true;
                    }
                }
            }

            if (optionType == "text" || optionType == "textarea") {
                var VariableType = $("#hdnRunScriptVariableType");
                if (VariableType.length > 0) {
                    if (VariableType[0].value == "1") {
                        if (isNaN(SelOpts.val().trim())) {
                            lblMessage.html('Enter numerics for script variable value');
                            return false;
                        }
                        else {
                            returnIfSubOptNotRequired = true;
                        }
                    }
                }
            }
        }
        else {
            returnIfSubOptNotRequired = true;
        }
    }
    else {
        returnIfSubOptNotRequired = true;
    }

    if (returnIfSubOptNotRequired) {
        for (var RI = 0; RI < SelOpts.length; RI++) {
            var OptScore = "0", SubOptScore = "0"; subOptionsCount = 0;
            var TempRdbName = ""; TempRdbName = $(SelOpts[RI]).attr("name");
            var TempRdbId = ""; TempRdbId = $(SelOpts[RI]).attr("id");
            var OptId = "";
            if (TempRdbName != null) {
                OptId = TempRdbName.replace("Reb_QueOpt_", "");
                if (OptId.indexOf("€") >= 0 && optionType != "calendar" && optionType != "signature")
                    OptId = OptId.slice(0, OptId.indexOf("€"));
                if (OptId.indexOf("€") >= 0 && (optionType == "calendar" || optionType == "signature"))
                    OptId = TempRdbId;
            }
            var OptionValue = "", SubOptionValues = "", PrevCheckedOptionID = "";
            var TempRdbRow = ""; TempRdbRow = "#TR_Opts_" + OptId;
            if (optionType != "calendar") {
                $(TempRdbRow).find("#hdnOptionScore").each(function (index, el) {
                    OptScore = $(this).val();
                });
            }
            if (optionType != "calendar" && $("#QueOptVal_" + OptId).html() != null) {
                OptionValue = $("#QueOptVal_" + OptId).html().trim();
            }
            else {
                if (SelOpts.length > 0) {
                    if (optionType == "calendar") {
                        OptionValue = SelOpts.val();
                        var splittedValues = OptId.split('€');
                        if (splittedValues.length > 1) {
                            OptId = splittedValues[1];
                            if (splittedValues.length > 2)
                                OptScore = splittedValues[2].replace("¶", ".");
                        }
                    }
                    if (optionType == "signature") {
                        OptionValue = SelOpts.attr('src');
                        var splittedValues = OptId.split('€');
                        if (splittedValues.length > 1) {
                            OptId = splittedValues[1];
                            if (splittedValues.length > 2)
                                OptScore = splittedValues[2].replace("¶", ".");
                        }
                    }
                    if (optionType == "text") {
                        OptionValue = SelOpts.val();
                        OptId = SelOpts.attr("id").replace("Reb_QueOpt_txt", "")
                        OptScore = SelOpts.attr("name").replace("Reb_QueOpt_txt_Score", "");
                    }
                    if (optionType == "textarea") {
                        OptionValue = htmlContentAlter(SelOpts.val(), true);
                        OptId = SelOpts.attr("id").replace("Reb_QueOpt_txt_area", "")
                        OptScore = SelOpts.attr("name").replace("Reb_QueOpt_txt_area_Score", "");
                    }
                    if (optionType == "label") {
                        OptionValue = SelOpts.html();
                        if (OptionValue != null)
                            OptionValue = OptionValue.trim();
                        OptId = SelOpts.attr("id").replace("Reb_QueOpt_Label", "")
                        OptScore = $("#hdnRunScriptScore").val();
                    }
                }
            }
            if (optionType != "calendar" && optionType != "text" && optionType != "textarea" && optionType != "signature") {
                var subOptionsPanel = $(TempRdbRow).find(".TR_SubOpt");
                subOptionsPanel.children().each(function (index, el) {
                    var outerDiv = $(this);
                    if (outerDiv != null) {
                        var innerHtml = null;
                        if (outerDiv.children().length > 0) {
                            outerDiv.children().each(function (index, el) {
                                var TempSubOptVal = "", TempSubOptID = "", TempSubOptScore = "0";
                                var SubOptType = "", IDandScore = "", SubOptionTypeId = "";
                                if ($(this).get(0).tagName.toLowerCase() == "input") {
                                    SubOptType = $(this).get(0).type.toLowerCase();
                                }
                                else if ($(this).get(0).tagName.toLowerCase() == "select") {
                                    if ($(this).get(0).multiple == true)
                                        SubOptType = "listbox";
                                    else
                                        SubOptType = "dropdownlist";
                                }
                                else
                                    SubOptType = $(this).get(0).tagName.toLowerCase();
                                if (SubOptType == "span" || SubOptType == "textarea" || SubOptType == "checkbox" || SubOptType == "radio" ||
                                    SubOptType == "text" || SubOptType == "dropdownlist" || SubOptType == "listbox" || SubOptType == "div" || SubOptType == "img") {
                                    subOptionsCount++;
                                    if (SubOptType == "radio") {
                                        if (this.checked == true) {
                                            TempSubOptVal = this.title;
                                            IDandScore = this.value;
                                            IDandScore = IDandScore.split('_');
                                            TempSubOptID = IDandScore[0];
                                            TempSubOptScore = IDandScore[1];
                                            SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal;
                                            if (TempSubOptID != "") {
                                                if (SubOptionValues != "")
                                                    SubOptionValues += "€";
                                            }
                                        }
                                    }
                                    else if (SubOptType == "text" || SubOptType == "textarea") {
                                        TempSubOptVal = $(this).val();
                                        IDandScore = $(this).attr("id");
                                        IDandScore = IDandScore.split('_');
                                        TempSubOptID = IDandScore[0];
                                        TempSubOptScore = (SubOptType === "text" ? IDandScore[1] : $(this).attr("data-score"));
                                        if (IDandScore.length > 2)
                                            SubOptionTypeId = IDandScore[2]
                                        if (TempSubOptVal.trim() != "") {
                                            if ($(this).get(0).CalendarBehavior != null) {
                                                if (IsDate(TempSubOptVal.trim()) == false) {
                                                    isInValidSubOptionDate = "true";
                                                }
                                            }
                                        }

                                        if (TempSubOptID != "" && TempSubOptVal != "") {
                                            if (SubOptType === "textarea") {
                                                TempSubOptVal = htmlContentAlter(TempSubOptVal, true);
                                            }
                                            SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal + "£" + SubOptionTypeId;
                                            if (SubOptionValues != "")
                                                SubOptionValues += "€";
                                        }
                                    }
                                    else if (SubOptType == "img") {
                                        if ($(this).hasClass('dynSignatureWF') && $(this).attr('src') != "") {
                                            TempSubOptVal = $(this).attr('src');
                                            IDandScore = $(this).attr("id");
                                            IDandScore = IDandScore.replace('RebQueSubOptSignature€', '').replace(/€/g, "_").trim();
                                            //IDandScore = IDandScore.replace('€', '_');
                                            IDandScore = IDandScore.split('_');
                                            TempSubOptID = IDandScore[0];
                                            TempSubOptScore = IDandScore[1].replace("¶", ".");
                                            var TempOptionID = IDandScore[2];
                                            if (IDandScore.length >= 2)
                                                //SubOptionType = IDandScore[3];
                                                SubOptionTypeId = 10;
                                            if (TempOptionID == OptId)
                                                subOptionsCount++;
                                            if (TempSubOptVal.trim() != "") { }
                                            if (TempSubOptID != "" && TempSubOptVal != "") {
                                                SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal + "£" + SubOptionTypeId;
                                                if (SubOptionValues != "")
                                                    SubOptionValues += "€";
                                            }
                                        }
                                    }
                                    else if (SubOptType == "span") {
                                        subOptionsCount--;
                                        isExists = "";
                                        var tempSpan = $('span[id*="Reb_QueSub_Opt_Label"]');
                                        var id = TempRdbName !== "" ? TempRdbName : tempSpan.attr("id");
                                        if (id != null && id.indexOf(OptId) >= 0) {
                                            if (tempSpan.length > 0) {
                                                let subOptionSpan = TempRdbRow !== "" ? $(TempRdbRow).find('span') : "";
                                                TempSubOptVal = subOptionSpan !== "" ? subOptionSpan.html() : tempSpan.html();
                                                IDandScore = subOptionSpan !== "" ? subOptionSpan.attr("id") :tempSpan.attr("id");
                                                IDandScore = (IDandScore != null) ? IDandScore.split('€') : [];
                                                if (IDandScore.length > 1) {
                                                    TempSubOptID = IDandScore[1];
                                                    if (IDandScore.length > 2)
                                                        TempSubOptScore = IDandScore[2];
                                                    if (IDandScore.length > 2)
                                                        SubOptionTypeId = IDandScore[3];

                                                    for (var i = 0; i < lstSubOptionIds.length; i++) {
                                                        if (TempSubOptID == lstSubOptionIds[i]) {
                                                            isExists = "true";
                                                            break;
                                                        }
                                                    }

                                                }
                                                if (TempSubOptID != "" && TempSubOptVal != "" && isExists == "") {
                                                    SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal + "£" + SubOptionTypeId;
                                                    lstSubOptionIds.push(TempSubOptID);
                                                    if (SubOptionValues != "")
                                                        SubOptionValues += "€";
                                                }
                                            }
                                        }
                                    }
                                    if (SubOptType == "checkbox" || SubOptType == "div") {
                                        $('input[name*=' + OptId + ']:checkbox:checked').each(function () {
                                            if ($(this).attr("id") == OptId) {
                                                var isExists = "";
                                                IDandScore = $(this).val();
                                                TempSubOptVal = $(this).attr("title");
                                                IDandScore = IDandScore.split('_');
                                                TempSubOptID = IDandScore[0];
                                                TempSubOptScore = IDandScore[1];
                                                for (var i = 0; i < chkSubOptionIds.length; i++) {
                                                    if (TempSubOptID == chkSubOptionIds[i]) {
                                                        isExists = "true";
                                                        break;
                                                    }
                                                }
                                                if (isExists == "") {
                                                    if (TempSubOptID != "") {
                                                        SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal;
                                                        chkSubOptionIds.push(TempSubOptID);
                                                        if (SubOptionValues != "")
                                                            SubOptionValues += "€";
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    if (SubOptType == "listbox") {
                                        $("option:selected").each(function () {
                                            if (this.className == OptId) {
                                                if (this.selected == true) {
                                                    var isExists = "";
                                                    TempSubOptVal = this.text;
                                                    IDandScore = this.value;
                                                    IDandScore = IDandScore.split('_');
                                                    TempSubOptID = IDandScore[0];
                                                    TempSubOptScore = IDandScore[1];
                                                    for (var i = 0; i < lstSubOptionIds.length; i++) {
                                                        if (TempSubOptID == lstSubOptionIds[i]) {
                                                            isExists = "true";
                                                            break;
                                                        }
                                                    }
                                                    if (isExists == "") {
                                                        if (TempSubOptID != "") {
                                                            SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal;
                                                            lstSubOptionIds.push(TempSubOptID);
                                                            if (SubOptionValues != "")
                                                                SubOptionValues += "€";
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                    else if (SubOptType == "dropdownlist") {
                                        TempSubOptVal = $('option:selected', this).text();
                                        if (TempSubOptVal != "Select" && TempSubOptVal != "") {
                                            IDandScore = $('option:selected', this).val();
                                            IDandScore = IDandScore.split('_');
                                            TempSubOptID = IDandScore[0];
                                            TempSubOptScore = IDandScore[1];
                                            SubOptionValues = SubOptionValues + TempSubOptID + "£" + TempSubOptScore + "£" + TempSubOptVal;
                                            if (TempSubOptID != "") {
                                                if (SubOptionValues != "")
                                                    SubOptionValues += "€";
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }
                });
            }
            if (RetVal != "") { RetVal += "§"; }
            if (SubOptionValues != "") { RetVal += OptId + "¦" + OptScore + "¦" + OptionValue + "¢" + SubOptionValues.slice(0, -1); }
            else {
                if (OptionValue != "") {
                    RetVal += OptId + "¦" + OptScore + "¦" + OptionValue;
                }
            }
        }
    }

    if (subOptionsCount > 0 && SubOptionValues === "" && isFromHistory === "false" && returnIfSubOptNotRequired === false) {
        lblMessage.html('Please select at least one sub option.');
        $("html, body").animate({ scrollTop: 0 }, 100);
        return false;
    }
    if (isInValidSubOptionDate == "true") {
        lblMessage.html('Enter valid date.');
        return false;
    }
    if (RetVal != "") {
        $("#hdnCurrentQuestionData").val(RetVal);
    }
    if (isFromHistory == "false" && isRestrict == "1") {
        if ($("#hdnNextQuestionIdWF").val() == "0") {
            if ($("#hdnAllowEndScriptWF").val() == "false") {
                CustomAlert('You do not have authorization to perform this action'); return false;
            }
        }
    }

    chkSubOptionIds = null;
    lstSubOptionIds = null;
    return true;
}


function ValidateOnNextClick() {
    var lblMessage = $("#lblRunScriptErrorMsg");
    lblMessage.css("color", 'Red');
    lblMessage.html('');
    if (ValidateWFQuestionOption()) {
        if (ValidateWFQuestionSubOption()) {
            return true;
        }
        else {
            lblMessage.html('Please select/enter required suboption(s)');
            return false;
        }
    }
    else {
        lblMessage.html('Please select/enter required option(s)');
        return false;
    }
}
function ValidateWFQuestionOption() {
    var QuesOpts = $("[class*=ReqQue_]");
    if (QuesOpts.length <= 0) {
        return true;
    }
    for (var index = 0; index < QuesOpts.length; index++) {
        var HasClass = $(QuesOpts[index]).hasClass("ReqQue_True");
        if (HasClass) {
            var MandateOpt = $(QuesOpts[index]).find('input[name*="Reb_QueOpt_"]:checkbox:checked');
            if (MandateOpt.length == 0) {
                return false;
            }
        }
    }
    return true;
}

function ValidateWFQuestionSubOption() {
    var RetVal = false; var HasSubOpt = false; var SubOptVal = true;
    var SubOptTypeId = ""; var SubOptTypeText = "";

    var SelOpts = $("[class*=ReqQue_]").find('input[name*="Reb_QueOpt_"]:radio:checked');

    if (SelOpts.length == 0) {
        SelOpts = $("[class*=ReqQue_]").find('input[name*="Reb_QueOpt_"]:checkbox:checked');
        if (SelOpts.length == 0) {
            return true;
        }
    }
    for (var RI = 0; RI < SelOpts.length; RI++) {
        if (SubOptVal == false) { return false; }
        else { SubOptVal = true; }
        if (SelOpts.length > 0) {

            var TempRdbName = ""; TempRdbName = $(SelOpts[RI]).attr("name");
            var TempRdbId = ""; TempRdbId = $(SelOpts[RI]).attr("id");
            var OptId = "";
            if (TempRdbName != null) {
                OptId = TempRdbName.replace("Reb_QueOpt_", "");
                if (OptId.indexOf("€") >= 0)
                    OptId = OptId.slice(0, OptId.indexOf("€"));
            }
            var OptionValue = "", SubOptionValues = "", PrevCheckedOptionID = "";
            var TempRdbRow = ""; TempRdbRow = "#TR_Opts_" + OptId;
            var subOptionsPanel = $(TempRdbRow).find(".TR_SubOpt");

            subOptionsPanel.children().each(function (i, el) {
                var outerDiv = $(this);
                if (outerDiv != null) {
                    if (SubOptVal == false) { return false; }
                    var IsSubOptMandatory = $('#Hdn_CurQueOptSubOptReq', outerDiv).val();
                    var innerHtml = null;
                    if (outerDiv.children().length > 0) {
                        outerDiv.children().each(function (idx, el) {
                            if (IsSubOptMandatory == "True" || ($(this).attr('id') == "divCurQueOptMultiSubOpt" && $("#Hdn_CurQueOptMultiSubOptReq", this).val() == "True") || $(this).get(0).tagName.toLowerCase() == "tbody") {
                                var SubOptType = "";
                                if ($(this).get(0).tagName.toLowerCase() == "input") {
                                    SubOptType = $(this).get(0).type.toLowerCase();
                                }
                                else if ($(this).get(0).tagName.toLowerCase() == "select") {
                                    if ($(this).get(0).multiple == true)
                                        SubOptType = "listbox";
                                    else
                                        SubOptType = "dropdownlist";
                                }
                                else
                                    SubOptType = $(this).get(0).tagName.toLowerCase();
                                if (SubOptType == "tbody") {
                                    $(this).find('.dynItem').each(function () {
                                        $(this).find('td').each(function () {
                                            var cellReq = $('#Hdn_CurQueOptSubOptReq', this).val();
                                            if (cellReq == "True") {
                                                var dynstatus = 0; var hasCheckbox = false; var anyChecked = false; var hasRadio = false; var anyRadioChecked = false;
                                                $('input:text, textarea, input:radio, input:checkbox, select', this).each(function () {
                                                    var dynval = $(this).val(); var tagName = $(this).prop("tagName").toLowerCase();
                                                    if (tagName == "input") { tagName = $(this).attr("type").toLowerCase(); }
                                                    if (tagName == "text" || tagName == "textarea") {
                                                        if (dynval === null || dynval.trim() === '') { dynstatus++; }
                                                    } else if (tagName == "radio") {
                                                        hasRadio = true;
                                                        if ($(this).is(":checked")) { anyRadioChecked = true; }
                                                    } else if (tagName == "checkbox") {
                                                        hasCheckbox = true;
                                                        if ($(this).is(":checked")) { anyChecked = true; }
                                                    } else if (tagName == "select") {
                                                        if (dynval === null || dynval === '' || dynval === '0') { dynstatus++; }
                                                    }
                                                });
                                                if (hasRadio && !anyRadioChecked) { dynstatus++; }
                                                if (hasCheckbox && !anyChecked) { dynstatus++; }
                                                $('img.dynsignature', this).each(function () {
                                                    if (!$(this).attr('src') || $(this).attr('src') === '') { dynstatus++; }
                                                });
                                                if (dynstatus > 0) { SubOptVal = false; }
                                            } else {
                                                $('input[id="Hdn_CurQueOptMultiSubOptReq"]', this).each(function () {
                                                    if ($(this).val() === "True") {
                                                        var cb = $(this).nextAll('input[type="checkbox"]:first');
                                                        if (cb.length > 0 && !cb.is(':checked')) { SubOptVal = false; }
                                                    }
                                                });
                                            }
                                        });
                                    });
                                }
                                if (SubOptType == "textarea" || SubOptType == "checkbox" || SubOptType == "radio" || SubOptType == "input" ||
                                    SubOptType == "text" || SubOptType == "dropdownlist" || SubOptType == "listbox" || SubOptType == "div" || SubOptType == "span" || SubOptType == "img") { // Mantis ID# 7808                     
                                    if (SubOptType == "radio") {
                                        var name = $(this).attr('name');
                                        if ($("input[name='" + name + "']:checked").length <= 0) {
                                            SubOptVal = false;
                                        }
                                        else {
                                            return false;
                                        }
                                    }
                                    else if (SubOptType == "text" || SubOptType == "textarea") {
                                        if ($(this).val().trim() == "") { SubOptVal = false; }
                                    }
                                    else if (SubOptType == "img") {
                                        if ($(this).attr('src') == "") { SubOptVal = false; }
                                    }
                                    if (SubOptType == "checkbox") {
                                        if ($(this)[0].children.length > 0) {
                                            if ($(this)[0].children[0].checked == false) { SubOptVal = false; }
                                        }
                                    }
                                    else if (SubOptType == "dropdownlist") {
                                        if ($(this).val() == "0") { SubOptVal = false; }
                                    }
                                    else if (SubOptType == "span") { // Mantis ID# 7808
                                        //SubOptVal = true;
                                    }
                                    else if (SubOptType == "div") {
                                        if ($(this).attr('id') == "divCurQueOptMultiSubOpt") {
                                            SubOptVal = fnIsSubOptCheckBoxMandatory(this, outerDiv);
                                        }
                                        else {
                                            if ($(this)[0].children.length > 0) {
                                                if ($(this)[0].children[0].checked == false) { SubOptVal = false; }
                                            }
                                        }
                                    }
                                    if (SubOptType == "input") {
                                        //SubOptVal = true;
                                    }
                                }
                            }
                            if (SubOptVal == false) { return false; }
                        });
                    }
                }
            });

            RetVal = SubOptVal;
            if (SubOptVal != false) {
                RetVal = true;
            }
        }
    }

    return RetVal;
}
//Checbox sub-option validation
function fnIsSubOptCheckBoxMandatory(curElement, outerDiv) {
    var returnVal = true;
    if ($('#Hdn_CurQueOptSubOptReq', outerDiv).val() === "True") {
        returnVal = $("input[type=checkbox]:checked", outerDiv).length > 0;
    } else {
        if ($("#Hdn_CurQueOptMultiSubOptReq", curElement).val() === "True") {
            var checkBoxItem = $(curElement).find('input:checkbox');
            if (checkBoxItem.length > 0) {
                returnVal = $(checkBoxItem).get(0).checked;
            }
        }
    }
    return returnVal;
}

function populateOptionsData() {

    //Find the Option related controls
    var optionType = "";
    var SelOpts = $('input[name*="Reb_QueOpt_"]:radio');
    if (SelOpts.length <= 0) {
        SelOpts = $('input[name*="Reb_QueOpt_"]:checkbox');
        if (SelOpts.length <= 0) {
            SelOpts = $('input[id*="RebQueOptCalendar€"]:text');
            if (SelOpts.length <= 0) {
                SelOpts = $('input[id*="Reb_QueOpt_txt"]:text');
                if (SelOpts.length <= 0) {
                    SelOpts = $('img[id*="RebQueOptSignature€"]');
                    if (SelOpts.length <= 0) {
                        SelOpts = $('textarea[id*="Reb_QueOpt_txt_area"]');
                        if (SelOpts.length <= 0) {
                            SelOpts = $('span[id*="Reb_QueOpt_Label"]');
                            if (SelOpts.length > 0)
                                optionType = "label"
                        }
                        else {
                            optionType = "textarea"
                            var TextAreaValue = $("#hdnTextAreaValue");
                            if (TextAreaValue.length > 0) {
                                SelOpts[0].value = TextAreaValue[0].value;
                            }
                        }
                    }
                    else
                        optionType = "signature";
                }
                else
                    optionType = "text"
            }
            else
                optionType = "calendar"
        }
        else
            optionType = "CHK"
    }
    else
        optionType = "RB"


    var options = $("#hdnCurrentQuestionData").val().split('§');

    //loop through each option
    for (var count = 0; count < options.length; count++) {
        var optionRelated = options[count].split('¦');

        var currentOptionId = optionRelated[0];
        var currentOptionValue = "";

        var subOptionRelated = "";

        if (optionRelated.length > 2)
            subOptionRelated = optionRelated[2];

        if (subOptionRelated != "") {
            var splittedSubOptions = subOptionRelated.split('¢');
            if (splittedSubOptions.length > 0)
                currentOptionValue = splittedSubOptions[0];


            for (var RI = 0; RI < SelOpts.length; RI++) {
                var TempRdbName = ""; TempRdbName = $(SelOpts[RI]).attr("name");
                var TempRdbId = ""; TempRdbId = $(SelOpts[RI]).attr("id");
                var OptId = "";

                if (TempRdbName != null) {
                    OptId = TempRdbName.replace("Reb_QueOpt_", "");
                    if (OptId.indexOf("€") >= 0 && optionType != "calendar" && optionType != "signature")
                        OptId = OptId.slice(0, OptId.indexOf("€"));
                    if (OptId.indexOf("€") >= 0 && (optionType == "calendar" || optionType == "signature"))
                        OptId = TempRdbId;

                    if (OptId == currentOptionId) {
                        SelOpts[RI].checked = true;
                        ShowSubOption(optionType, OptId);
                    }
                }
                var OptionValue = "";
                var TempRdbRow = ""; TempRdbRow = "#TR_Opts_" + OptId;
                if (SelOpts.length > 0) {
                    if (optionType == "calendar") {
                        var splittedValues = OptId.split('€');
                        if (splittedValues.length > 1)
                            OptId = splittedValues[1];
                        if (OptId == currentOptionId)
                            OptionValue = SelOpts.val(currentOptionValue);
                    }
                    if (optionType == "signature") {
                        var splittedValues = OptId.split('€');
                        if (splittedValues.length > 1)
                            OptId = splittedValues[1];
                        if (OptId == currentOptionId)
                            OptionValue = SelOpts.attr('src', currentOptionValue);
                    }
                    if (optionType == "text") {
                        OptId = SelOpts.attr("id").replace("Reb_QueOpt_txt", "")
                        if (OptId == currentOptionId) {
                            OptionValue = SelOpts.val(currentOptionValue);
                            showDiagSummDiv(currentOptionValue, SelOpts);//CIH-1598 - To render the HTML string for the placeholder
                        }
                    }
                    if (optionType == "textarea") {
                        OptId = SelOpts.attr("id").replace("Reb_QueOpt_txt_area", "")
                        if (OptId == currentOptionId) {
                            OptionValue = SelOpts.val(currentOptionValue);
                            showDiagSummDiv(currentOptionValue, SelOpts);//CIH-1598 - To render the HTML string for the placeholder
                        }
                    }
                    if (optionType == "label") {
                        OptId = SelOpts.attr("id").replace("Reb_QueOpt_Label", "")
                        if (OptId == currentOptionId && $("#hdnIsOutputVariableExists").val() == "")
                            OptionValue = SelOpts.html(currentOptionValue.trim());
                    }
                }

                if (optionType != "calendar" && optionType != "text" && optionType != "textarea" || optionType != "signature") {
                    var subOptionsPanel = $(TempRdbRow).find(".TR_SubOpt");
                    var splittedOptions = "";
                    if (splittedSubOptions.length > 1)
                        splittedOptions = splittedSubOptions[1].split('€');

                    for (var i = 0; i < splittedOptions.length; i++) {

                        var innerValues = splittedOptions[i].split('£');

                        var id = "", value = "";
                        if (innerValues.length > 0)
                            id = innerValues[0];
                        if (innerValues.length > 2)
                            value = innerValues[2];

                        subOptionsPanel.children().each(function (index, el) {
                            if ($(this)[0].className != "sphd")
                                populateSubOptionsData($(this), id, value, currentOptionId);
                        });
                    }
                }
            }
        }
    }
}
function populateSubOptionsData(control, id, value, OptId) {
    var currentId = "";
    if (control.children().length > 0) {
        control.children().each(function (index, el) {
            var SubOptType = "";
            if ($(this).get(0).tagName.toLowerCase() == "input") {
                SubOptType = $(this).get(0).type.toLowerCase();
            }
            else if ($(this).get(0).tagName.toLowerCase() == "select") {
                if ($(this).get(0).multiple == true) {
                    SubOptType = "listbox";
                }
                else
                    SubOptType = "dropdownlist";
            }
            else {
                SubOptType = $(this).get(0).tagName.toLowerCase();
            }

            if (SubOptType == "radio") {
                currentId = $(this)[0].value;
                currentId = currentId.split('_');
                if (currentId[0] == id) {
                    $(this)[0].checked = true;
                }
            }

            if (SubOptType == "checkbox") {
                if ($(this)[0].children.length > 0) {
                    currentId = $(this)[0].children[0].value;
                    currentId = currentId.split('_');
                    if (currentId[0] == id) {
                        $(this)[0].children[0].checked = true;
                    }
                }
            }
            else if (SubOptType == "text" || SubOptType == "textarea") {
                currentId = $(this)[0].id;
                currentId = currentId.split('_');
                if (currentId[0] == id) {
                    $(this).val(value);
                }
            }
            else if (SubOptType == "img") {
                currentId = $(this)[0].id;
                currentId = currentId.split('€');
                if (currentId.length > 1) {
                    if (currentId[1] == id) {
                        $(this).attr('src', value);
                    }
                }
            }
            else if (SubOptType == "span") {
                var tempSpan = $('span[id*="Reb_QueSub_Opt_Label"]');
                currentId = tempSpan.attr("id");
                if (currentId != null && currentId == id) {
                    tempSpan.html(value);
                }
            }
            else if (SubOptType == "div") {
                if ($(this).attr('id') == "divCurQueOptMultiSubOpt") {
                    currentId = $(this).find('input:checkbox')[0].value;
                    currentId = currentId.split('_');
                    if (currentId[0] == id) {
                        $(this).find('input:checkbox')[0].checked = true;
                    }
                }
                else {
                    if ($(this)[0].children.length > 0) {
                        currentId = $(this)[0].children[0].value;
                        currentId = currentId.split('_');
                        if (currentId[0] == id) {
                            $(this)[0].children[0].checked = true;
                        }
                    }
                }
            }
            if (SubOptType == "listbox" || SubOptType == "dropdownlist") {
                for (var i = 0; i < $(this)[0].length; i++) {
                    currentId = $(this)[0][i].value;
                    currentId = currentId.split('_');
                    if (currentId[0] == id) {
                        $(this)[0][i].selected = true;
                        break;
                    }
                }
            }
        });
    }
}
function validateQuickFields(hdnFieldUniqueName, hdnLoggedInUserDate) {
    var fieldUniqueName = $("#" + hdnFieldUniqueName).val();
    var currentUserDate = $("#" + hdnLoggedInUserDate).val();
    var lblMessage = $("#lblQuickUpdateMessage");
    if (fieldUniqueName === "COMMUNICATION_IMPAIRMENT" || fieldUniqueName === "ADVANCED_DIRECTIVE") {
        var chkOptions = $('input[id*="chkQuickUpdateImpairment"]:checkbox:checked');
        if (chkOptions.length === 0) {
            lblMessage.html('Select at least one option');
            return false;
        }
    }
    return validateScriptCommonFields(fieldUniqueName, lblMessage, currentUserDate);
}
////////  Single Screen Script Start   ///////////
function CheckReqQuestions() {
    var Retval = "";
    if ($("#CallScreenContent").children().find("#ImgRequired").length == 0 &&
        $("#CallScreenContent").children().find(".spanSubOptionRequired").length == 0 &&
        $("#CallScreenContent").children().find("#spnRequired").length == 0)
        return Retval;
    $('tr[id*="TR_Que_Row_"]').each(function (index, el) {
        var HasClass = $(this).hasClass("ReqQue_True");
        var QuestionId = $(this).prop("id");
        QuestionId = QuestionId.replace("TR_Que_Row_", "");
        var isMandatorySubOpt = $("#TR_Questions_" + QuestionId).find(".spanSubOptionRequired").length > 0;
        if (HasClass) {
            if (!IsAnswered(QuestionId)) {
                Retval = "Questions||" + QuestionId;
                ShowRequiredQueOrOpt(QuestionId, true);
                return false;
            }
            else if (!IsOptAnswered(QuestionId)) {
                Retval = "Options||" + QuestionId;
                ShowRequiredQueOrOpt(QuestionId, false);
                return false;
            }
            else if (isMandatorySubOpt && !IsSubOptAnswered(QuestionId)) {
                Retval = "SubOptions||" + QuestionId;
                ShowRequiredQueOrOpt(QuestionId, false);
                return false;
            }
            else {
                $("#TR_Questions_" + QuestionId).hide();
            }
        }
        else if (!IsOptAnswered(QuestionId)) {
            Retval = "Options||" + QuestionId;
            ShowRequiredQueOrOpt(QuestionId, false);
            return false;
        }
        else if (isMandatorySubOpt && !IsSubOptAnswered(QuestionId)) {
            Retval = "SubOptions||" + QuestionId;
            ShowRequiredQueOrOpt(QuestionId, false);
            return false;
        }
    });
    return Retval;
}

function ShowRequiredQueOrOpt(QuestionId, IsQuestion) {
    $("#TR_Questions_" + QuestionId).show();
    if (IsQuestion)
        $("#CallScreenContent").animate({ scrollLeft: 0, scrollTop: $("#TR_Que_Row_" + QuestionId)[0].offsetTop }, 500);
}

function IsOptAnswered(QuestionId) {
    if (QuestionId == "" || QuestionId == "0") { return false; }
    var QuesOpts = $("[class*=TR_Opts_" + QuestionId + "]");
    if (QuesOpts.length <= 0) {
        return true;
    }
    for (var index = 0; index < QuesOpts.length; index++) {
        var HasClass = $(QuesOpts[index]).hasClass("ReqQue_True");
        if (HasClass) {
            var OptId = $(QuesOpts[index]).prop("id"); OptId = OptId.replace("TR_Opts_", "");
            OptId = OptId.split('_'); OptId = OptId[1];
            var MandateOpt = $(QuesOpts[index]).find('input[name*="Reb_QueOpt_"]:checkbox:checked');
            if (MandateOpt.length == 0) {
                return false;
            }
        }
    }
    return true;
}
function IsSubOptAnswered(QuestionId) {
    var RetVal = false; var HasSubOpt = false; var SubOptVal = true;
    var SubOptTypeId = ""; var SubOptTypeText = "";

    if (QuestionId == "" || QuestionId == "0") { return false; }
    var SelOpts = $("[class*=TR_Opts_" + QuestionId + "]").find('input[name*="Reb_QueOpt_"]:radio:checked');

    if (SelOpts.length == 0) {
        SelOpts = $("[class*=TR_Opts_" + QuestionId + "]").find('input[name*="Reb_QueOpt_"]:checkbox:checked');
        if (SelOpts.length == 0) {
            return true;
        }
    }

    for (var count = 0; count < SelOpts.length; count++) {
        if (SubOptVal == false) { return false; }
        else { SubOptVal = true; }
        if (SelOpts.length > 0) {
            var OptId = $(SelOpts[count]).prop("id");
            OptId = OptId.replace("Reb_Opt_", "");
            OptId = OptId.split('€'); OptId = OptId[0];
            if (QuestionId != "" && OptId != "") {
                var TempRdbRow = ""; TempRdbRow = "#TR_Opts_" + QuestionId + "_" + OptId;
                TempRdbRow = TempRdbRow.replace("Ch_", "");
                var SubOptonsOuterDiv = $($(TempRdbRow).find('[class*=TR_SubOpt]'));
                if (SubOptonsOuterDiv.length > 0 && SubOptonsOuterDiv[0].children.length == 0) {
                    RetVal = true
                    continue;
                }


                SubOptonsOuterDiv.children().each(function (index, el) {
                    var outerDiv = $(this);
                    if (outerDiv != null) {
                        if (SubOptVal == false) { return false; }
                        var IsSubOptMandatory = $('#Hdn_CurQueOptSubOptReq', outerDiv).val();
                        var innerHtml = null;
                        if (outerDiv.children().length > 0) {
                            outerDiv.children().each(function (index, el) {
                                if (IsSubOptMandatory == "True" || ($(this).attr('id') == "divCurQueOptMultiSubOpt" && $("#Hdn_CurQueOptMultiSubOptReq", this).val() == "True") || $(this).get(0).tagName.toLowerCase() == "tbody") {
                                    var SubOptType = "";

                                    if ($(this).get(0).tagName.toLowerCase() == "input") {
                                        SubOptType = $(this).get(0).type.toLowerCase();
                                    }
                                    else if ($(this).get(0).tagName.toLowerCase() == "select") {
                                        if ($(this).get(0).multiple == true)
                                            SubOptType = "listbox";
                                        else
                                            SubOptType = "dropdownlist";
                                    }
                                    else
                                        SubOptType = $(this).get(0).tagName.toLowerCase();
                                    if (SubOptType == "tbody") {
                                        $(this).find('.dynItem').each(function () {
                                            $(this).find('td').each(function () {
                                                var cellReq = $('#Hdn_CurQueOptSubOptReq', this).val();
                                                if (cellReq == "True") {
                                                    var dynstatus = 0; var hasCheckbox = false; var anyChecked = false; var hasRadio = false; var anyRadioChecked = false;
                                                    $('input:text, textarea, input:radio, input:checkbox, select', this).each(function () {
                                                        var dynval = $(this).val(); var tagName = $(this).prop("tagName").toLowerCase();
                                                        if (tagName == "input") { tagName = $(this).attr("type").toLowerCase(); }
                                                        if (tagName == "text" || tagName == "textarea") {
                                                            if (dynval === null || dynval.trim() === '') { dynstatus++; }
                                                        } else if (tagName == "radio") {
                                                            hasRadio = true;
                                                            if ($(this).is(":checked")) { anyRadioChecked = true; }
                                                        } else if (tagName == "checkbox") {
                                                            hasCheckbox = true;
                                                            if ($(this).is(":checked")) { anyChecked = true; }
                                                        } else if (tagName == "select") {
                                                            if (dynval === null || dynval === '' || dynval === '0') { dynstatus++; }
                                                        }
                                                    });
                                                    if (hasRadio && !anyRadioChecked) { dynstatus++; }
                                                    if (hasCheckbox && !anyChecked) { dynstatus++; }
                                                    $('img.dynsignature', this).each(function () {
                                                        if (!$(this).attr('src') || $(this).attr('src') === '') { dynstatus++; }
                                                    });
                                                    if (dynstatus > 0) { SubOptVal = false; }
                                                } else {
                                                    $('input[id="Hdn_CurQueOptMultiSubOptReq"]', this).each(function () {
                                                        if ($(this).val() === "True") {
                                                            var cb = $(this).nextAll('input[type="checkbox"]:first');
                                                            if (cb.length > 0 && !cb.is(':checked')) { SubOptVal = false; }
                                                        }
                                                    });
                                                }
                                            });
                                        });
                                    }
                                    if (SubOptType == "textarea" || SubOptType == "checkbox" || SubOptType == "radio" || SubOptType == "input" ||
                                        SubOptType == "text" || SubOptType == "dropdownlist" || SubOptType == "listbox" || SubOptType == "div" || SubOptType == "span" || SubOptType == "img") { // Mantis ID# 7808                     
                                        if (SubOptType == "radio") {
                                            var name = $(this).attr('name');
                                            if ($("input[name='" + name + "']:checked").length <= 0) {
                                                SubOptVal = false;
                                            }
                                            else {
                                                return false;
                                            }
                                        }
                                        else if (SubOptType == "text" || SubOptType == "textarea") {
                                            if ($(this).val().trim() == "") { SubOptVal = false; }
                                        }
                                        if (SubOptType == "checkbox") {
                                            if ($(this)[0].children.length > 0) {
                                                if ($(this)[0].children[0].checked == false) { SubOptVal = false; }
                                            }
                                        }
                                        else if (SubOptType == "dropdownlist") {
                                            if ($(this).val() == "0") { SubOptVal = false; }
                                        }
                                        else if (SubOptType == "span") { // Mantis ID# 7808
                                            //SubOptVal = true;
                                        }
                                        else if (SubOptType == "img") {
                                            if ($(this).hasClass('imgsignaturefield') && $(this).attr('src') == '') {
                                                SubOptVal = false;
                                            }
                                        }
                                        else if (SubOptType == "div") {
                                            if ($(this).attr('id') == "divCurQueOptMultiSubOpt") {
                                                SubOptVal = fnIsSubOptCheckBoxMandatory(this, outerDiv);
                                            }
                                            else {
                                                if ($(this)[0].children.length > 0) {
                                                    if ($(this)[0].children[0].checked == false) { SubOptVal = false; }
                                                }
                                            }
                                        }
                                        if (SubOptType == "input") {
                                            //SubOptVal = true;
                                        }
                                    }
                                }
                                if (SubOptVal == false) { return false; }
                            });
                        }
                    }
                });
            }
            RetVal = SubOptVal;
            if (SubOptVal != false) {
                RetVal = true;
            }
        }
    }

    return RetVal;
}

function enableScriptButtons() {
    $("[id*=btnSaveAndContinue]").removeAttr("readonly").val('Save & Continue');
    $("[id*=btnSaveForLater]").removeAttr("readonly").val('Save For Later');
    $("[id*=btnSaveAndEnd]").removeAttr("readonly").val('Save & End Script');
    window.top.loader(0);
}
var IsSubOptionsSelected = true;
function GetCurrentCallData(IsEndScript, IsFromSave, IsFromReview) {
    try {
        window.top.loader(1);
        $("[id*=btnSaveAndContinue]").attr("readonly", "readonly").val('Please wait...');
        $("[id*=btnSaveForLater]").attr("readonly", "readonly").val('Please wait...');
        $("[id*=btnSaveAndEnd]").attr("readonly", "readonly").val('Please wait...');
        var UnansweredOptionsCount = 0;
        var UnAnsweredSubOptQusId = "";
        if (IsEndScript != "3" && IsFromSave != "") {
            if (CheckAttestationClicked()) {
                if (IsFromSave == "1" && IsEndScript == "1") {
                    var RetVal = CheckReqQuestions();
                    var RetValArrey = RetVal.split('||');
                    var QusNo = $("#TR_QueNo_" + RetValArrey[1]).html();
                    if (RetValArrey[0] == "Questions") {
                        //  alert("Please answer all required questions.");
                        window.top.AlertShow("Question no " + QusNo + " is required, please answer to proceed further.");
                        enableScriptButtons();
                        return false;
                    }
                    else if (RetValArrey[0] == "Options") {
                        window.top.AlertShow("Please select/enter required option(s) for question no " + QusNo);
                        enableScriptButtons();
                        return false;
                    }
                    else if (RetValArrey[0] == "SubOptions") {
                        //  alert("Please answer the sub option for required questions.");
                        window.top.AlertShow("Please select/enter suboption(s) for required question no " + QusNo);
                        enableScriptButtons();
                        return false;
                    }
                }
            }
            else {
                enableScriptButtons();
                return false;
            }
        }

        var ResponseValues = "", OptionResponse = "", SubOptionValues = "", OptionId = "", OptionScore = "", OptionValue = "", Values = "", SelectedOptions = 0, IsLabelExists = false;
        var QuestionRows = $('[class*=TR_Questions_]');
        for (var questionCount = 0; questionCount < QuestionRows.length; questionCount++) {
            var QuestionID = "", CareNotes = "";
            QuestionID = $(QuestionRows[questionCount]).attr("id").replace("TR_Questions_", "");
            CareNotes = $("#TaCare_" + QuestionID).val();
            var OptonsRow = $(QuestionRows[questionCount]).find('[class*=TR_Opts_]');
            var isSubOptDyn = false; var subDynStr = "";
            //RADIO OPTIONS
            var SelectedRadOptions = $(OptonsRow.find('input[name*="Reb_QueOpt_"]:radio:checked'));
            if (SelectedRadOptions.length > 0) {
                for (var radCount = 0; radCount < SelectedRadOptions.length; radCount++) {
                    OptionId = "", OptionScore = "", OptionValue = "", SubOptionValues = "";
                    Values = $(SelectedRadOptions[radCount]).attr("id").replace("Reb_Opt_", "").split('€');
                    if (Values.length > 0)
                        OptionId = Values[0];
                    if (Values.length > 1)
                        OptionScore = Values[1];
                    if (Values.length > 2)
                        OptionValue = Values[2];
                    OptionResponse = OptionId + "€" + OptionScore + "€" + OptionValue + "€" + "6";
                    var SubOptionsRow = null, SubOptonsOuterDiv = null;
                    //if ($(OptonsRow).find('#hdnIsDySubOpt').length > 0) { isSubOptDyn = $($(OptonsRow).find('#hdnIsDySubOpt')[radCount]).val(); }
                    if ($("#TR_Opts_" + QuestionID + "_" + OptionId).find('#hdnIsDySubOpt').length == 1) { isSubOptDyn = $("#TR_Opts_" + QuestionID + "_" + OptionId).find('#hdnIsDySubOpt').val(); }
                    if (isSubOptDyn == "True") {
                        subDynStr = GetDynamicSubOptionRow(OptionId);
                    }
                    else {
                        SubOptionsRow = $(OptonsRow.find('[id*=trSubOptions_' + OptionId + ']'));
                        SubOptonsOuterDiv = $(SubOptionsRow.find('[class*=TR_SubOpt]'));
                        SubOptionValues = GetSubOptionsData(SubOptonsOuterDiv, OptionId);
                    }
                    SelectedOptions++;
                    if (IsFromSave == "1") {
                        if (IsSubOptionsSelected == false) {
                            $("#TR_Questions_" + QuestionID).show();
                            {
                                UnansweredOptionsCount++;
                                if (UnAnsweredSubOptQusId == "") {
                                    UnAnsweredSubOptQusId = QuestionID;
                                }
                            }
                        }
                        else {
                            $("#TR_Questions_" + QuestionID).hide();
                        }
                    }
                    if (SubOptionValues != "" && isSubOptDyn == "False") {
                        OptionResponse += "ž1ƒ" + SubOptionValues.slice(0, -1);
                        SubOptionValues = "";
                    }
                    else if (isSubOptDyn == "True" && subDynStr != "") {
                        OptionResponse += "ž2ƒ" + subDynStr;
                    }
                    else if (isSubOptDyn == "True" && subDynStr == "") {
                        UnansweredOptionsCount = 1;
                        if (UnAnsweredSubOptQusId == "") {
                            UnAnsweredSubOptQusId = QuestionID;
                        }
                    }
                }
            }

            //CHECK BOX OPTONS
            var SelectedCheckBoxOptions = $(OptonsRow.find('input[name*="Reb_QueOpt_"]:checkbox:checked'));
            if (SelectedCheckBoxOptions.length > 0) {
                for (var chkCount = 0; chkCount < SelectedCheckBoxOptions.length; chkCount++) {
                    OptionId = "", OptionScore = "", OptionValue = "", TempOptionResponse = "";
                    Values = $(SelectedCheckBoxOptions[chkCount]).attr("name").replace("Reb_QueOpt_", "").split('€');
                    if (Values.length > 0)
                        OptionId = Values[0];
                    if (Values.length > 1)
                        OptionScore = Values[1];
                    if (Values.length > 2)
                        OptionValue = Values[2];
                    if ($("#TR_Opts_" + QuestionID + "_" + OptionId).find('#hdnIsDySubOpt').length == 1) { isSubOptDyn = $("#TR_Opts_" + QuestionID + "_" + OptionId).find('#hdnIsDySubOpt').val(); }
                    var SubOptionsRow = null, SubOptonsOuterDiv = null;
                    TempOptionResponse = OptionId + "€" + OptionScore + "€" + OptionValue + "€2";
                    if (isSubOptDyn == "True") {
                        subDynStr = GetDynamicSubOptionRow(OptionId);
                    }
                    else {
                        SubOptionsRow = $(OptonsRow.find('[id*=trSubOptions_' + OptionId + ']'));
                        SubOptonsOuterDiv = $(SubOptionsRow.find('[class*=TR_SubOpt]'));
                        SubOptionValues = GetSubOptionsData(SubOptonsOuterDiv, OptionId);
                    }
                    if (IsFromSave == "1") {
                        if (IsSubOptionsSelected == false) {
                            $("#TR_Questions_" + QuestionID).show();
                            {
                                UnansweredOptionsCount++;
                                if (UnAnsweredSubOptQusId == "") {
                                    UnAnsweredSubOptQusId = QuestionID;
                                }
                            }
                        }
                        else {
                            $("#TR_Questions_" + QuestionID).hide();
                        }
                    }

                    if (TempOptionResponse != "") {
                        OptionResponse += TempOptionResponse;
                        SelectedOptions++;
                        if (SubOptionValues != "" && isSubOptDyn == "False") {
                            OptionResponse += "ž1ƒ" + SubOptionValues.slice(0, -1);
                            SubOptionValues = "";
                        }
                        else if (isSubOptDyn == "True" && subDynStr != "") {
                            OptionResponse += "ž2ƒ" + subDynStr;
                        }
                        else if (isSubOptDyn == "True" && subDynStr == "") {
                            UnansweredOptionsCount = 1;
                            if (UnAnsweredSubOptQusId == "") {
                                UnAnsweredSubOptQusId = QuestionID;
                            }
                        }
                    }
                    OptionResponse += "¡";
                }
            }

            //TEXT BOX OPTION
            var TextBoxOption = $(OptonsRow.find('[id*="Reb_QueOpt_text"]'));
            if (TextBoxOption.length > 0) {
                for (var txtCount = 0; txtCount < TextBoxOption.length; txtCount++) {
                    OptionId = "", OptionScore = "", OptionValue = "";
                    OptionId = TextBoxOption[txtCount].id.replace("Reb_QueOpt_text", "");
                    OptionScore = TextBoxOption[txtCount].name.replace("Reb_QueOpt_text_Score", "");
                    OptionValue = TextBoxOption[txtCount].value;
                    if (OptionValue != "") {
                        SelectedOptions++;
                        OptionResponse += OptionId + "€" + OptionScore + "€" + OptionValue + "€" + "9";
                        OptionResponse += "¡";
                    }
                }
            }

            //TEXT AREA OPTION
            var TextAreaOption = $(OptonsRow.find('[id*="Reb_QueOpt_txt_area"]'));
            if (TextAreaOption.length > 0) {
                OptionId = "", OptionScore = "", OptionValue = "";
                OptionId = TextAreaOption.attr("id").replace("Reb_QueOpt_txt_area", "");
                OptionScore = TextAreaOption.attr("name").replace("Reb_QueOpt_txt_area_Score", "");
                OptionValue = TextAreaOption.val();
                if (OptionValue != "") {
                    SelectedOptions++;
                    OptionResponse += OptionId + "€" + OptionScore + "€" + OptionValue + "€" + "8";
                }
            }


            //CALENDAR OPTION
            var CalendarOption = $(OptonsRow.find('[id*="RebQueOptCalendar"]'));
            if (CalendarOption.length > 0) {
                OptionId = "", OptionScore = "", OptionValue = "";
                var IDAndScore = CalendarOption.attr("id").split("€");
                OptionId = IDAndScore[1];
                if (IDAndScore.length > 2)
                    OptionScore = IDAndScore[2].replace("¶", ".");
                OptionValue = CalendarOption.val();
                if (OptionValue != "") {
                    SelectedOptions++;
                    OptionResponse += OptionId + "€" + OptionScore + "€" + OptionValue + "€" + "1";
                }
            }
            // SIGNATURE OPTION
            var signatureOption = $(OptonsRow.find('[id*="RebQueOptSignature"]'));
            if (signatureOption.length > 0) {
                OptionId = "", OptionScore = "", OptionValue = "";
                var IDAndScore = signatureOption.attr("id").split("€");
                OptionId = IDAndScore[1];
                if (IDAndScore.length > 2)
                    OptionScore = IDAndScore[2].replace("¶", ".");
                OptionValue = signatureOption.attr('src');
                if (OptionValue != "") {
                    SelectedOptions++;
                    OptionResponse += OptionId + "€" + OptionScore + "€" + OptionValue + "€" + "1";
                }
            }

            //if (IsEndScript == "1") {
            var LabelOption = $(OptonsRow.find('[id*="Reb_QueOpt_Label"]'));
            if (LabelOption.length > 0) {
                OptionId = "", OptionScore = "", OptionValue = "";
                var IDAndScore = LabelOption.attr("id").split("|");
                OptionId = IDAndScore[1];
                OptionScore = IDAndScore[2];
                OptionValue = LabelOption.html();
                if (OptionValue != "") {
                    SelectedOptions++; IsLabelExists = true;
                    OptionResponse += OptionId + "€" + OptionScore + "€" + OptionValue.trim() + "€" + "4";
                }
            }
            //}

            if (OptionResponse != "") {
                ResponseValues += QuestionID + "¦" + CareNotes;
                ResponseValues += "¢" + OptionResponse;
            }

            if (ResponseValues != "" && OptionResponse != "") {
                ResponseValues += "§";
                OptionResponse = "";
            }
        }

        if (IsEndScript != "3") {
            if ((ResponseValues == "") || (IsLabelExists == true && SelectedOptions == 1)) {
                if (IsFromSave == "1") {
                    window.top.AlertShow('Please answer at least one question.');
                    enableScriptButtons();
                    return false;
                }
            }

            if ($("#hdnAllowEndScript").val() == "false" && IsEndScript == "1") {
                window.top.AlertShow('You do not have authorization to perform this action');
                enableScriptButtons();
                return false;
            }

            // if (UnansweredOptionsCount != 0 && IsFromSave == "1") {
            if (UnAnsweredSubOptQusId != "" && IsFromSave == "1") {
                // alert('Please select/enter values for sub option(s)');
                var UnAnsweredSubOptQusNo = $("#TR_QueNo_" + UnAnsweredSubOptQusId).html();
                window.top.AlertShow("Please select/enter values for sub option(s) of question no " + UnAnsweredSubOptQusNo);
                enableScriptButtons();
                return false;
            }

            if (IsFromReview != null) {
                if (CustomConfirm('Are you sure you want to send to your Manager for review?')) {
                    $("#hdnSendForReview").val('true');
                }
            }
        }

        $("#hdnCurrentCallData").val('');
        if (ResponseValues != "") {
            $("#hdnCurrentCallData").val(ResponseValues.slice(0, -1))
        }
        window.top.loader(0);
    } catch (err) {
        var stringErro = err.message + '\n' + err.stack + '\n' + new Date().toString() + '\n';

        var errorMsg = stringErro;
        window.top.logError(errorMsg, JSON.stringify(ResponseValues), '200');
        enableScriptButtons();
        window.top.AlertShow('An error has occurred. Please contact your administrator.' + '\n Additional Details:' + stringErro);
        return false;
    }
    return true;
}
function GetSubOptionsData(SubOptonsOuterDiv, OptId) {
    var SubOptionValues = "", subOptionsCount = 0; var chkSubOptionIds = new Array(); var lstSubOptionIds = new Array();
    IsSubOptionsSelected = true;
    SubOptonsOuterDiv.children().each(function (index, el) {
        var outerDiv = $(this);
        if (outerDiv != null) {
            var innerHtml = null;
            if (outerDiv.children().length > 0) {
                outerDiv.children().each(function (index, el) {
                    var TempSubOptVal = "", TempSubOptID = "", TempSubOptScore = "0";
                    var SubOptType = "", IDandScore = "", SubOptionType = "";
                    if ($(this).get(0).tagName.toLowerCase() == "input") {
                        SubOptType = $(this).get(0).type.toLowerCase();
                    }
                    else if ($(this).get(0).tagName.toLowerCase() == "select") {
                        if ($(this).get(0).multiple == true)
                            SubOptType = "listbox";
                        else
                            SubOptType = "dropdownlist";
                    }
                    else
                        SubOptType = $(this).get(0).tagName.toLowerCase();
                    if (SubOptType == "span" || SubOptType == "textarea" || SubOptType == "checkbox" || SubOptType == "radio" ||
                        SubOptType == "text" || SubOptType == "dropdownlist" || SubOptType == "listbox" || SubOptType == "div" || SubOptType == "img") {
                        if (SubOptType == "radio") {
                            TempSubOptVal = this.title;
                            IDandScore = this.value;
                            IDandScore = IDandScore.split('_');
                            TempSubOptID = IDandScore[0];
                            TempSubOptScore = IDandScore[1];
                            if (IDandScore[2] == OptId)
                                subOptionsCount++;
                            if (this.checked == true) {
                                SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal;
                                if (TempSubOptID != "") {
                                    if (SubOptionValues != "")
                                        SubOptionValues += "£";
                                }
                            }
                        }
                        else if (SubOptType == "text" || SubOptType == "textarea") {
                            TempSubOptVal = $(this).val();
                            IDandScore = $(this).attr("id");
                            IDandScore = IDandScore.split('_');
                            TempSubOptID = IDandScore[0];
                            TempSubOptScore = (SubOptType === "text" ? IDandScore[1] : $(this).attr("data-score")) ;
                            var TempOptionID = IDandScore[2];
                            if (IDandScore.length > 3)
                                SubOptionType = IDandScore[3];

                            if (TempOptionID == OptId)
                                subOptionsCount++;
                            if (TempSubOptVal.trim() != "") {
                                if ($(this).get(0).CalendarBehavior != null) {
                                    if (IsDate(TempSubOptVal.trim()) == false) {
                                        isInValidSubOptionDate = "true";
                                    }
                                }
                            }

                            if (TempSubOptID != "" && TempSubOptVal != "" && TempOptionID == OptId) {
                                if (SubOptType === "textarea") {
                                    TempSubOptVal = htmlContentAlter(TempSubOptVal, true);
                                }
                                SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal + "¶" + SubOptionType;
                                if (SubOptionValues != "")
                                    SubOptionValues += "£";
                            }
                        }
                        else if (SubOptType == "img") {
                            if ($(this).hasClass('imgsignaturefield')) {
                                TempSubOptVal = $(this).attr('src');
                                IDandScore = $(this).attr("id");
                                IDandScore = IDandScore.replace('RebQueSubOptSignature€', '').replace(/€/g, "_").trim();
                                IDandScore = IDandScore.split('_');
                                TempSubOptID = IDandScore[0];
                                TempSubOptScore = IDandScore[1].replace("¶", ".");
                                var TempOptionID = IDandScore[3];
                                if (IDandScore.length > 3)
                                    //SubOptionType = IDandScore[3];
                                    SubOptionType = 10;
                                if (TempOptionID == OptId)
                                    subOptionsCount++;
                                if (TempSubOptVal.trim() != "") { }
                                if (TempSubOptID != "" && TempSubOptVal != "" && TempOptionID == OptId) {
                                    SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal + "¶" + SubOptionType;
                                    if (SubOptionValues != "")
                                        SubOptionValues += "£";
                                }
                            }
                        }
                        else if (SubOptType == "span") {
                            isExists = "";
                            var tempSpan = $('span[id*=Reb_QueSub_Opt_Label' + OptId + '€]');
                            var id = tempSpan.attr("id");
                            if (id != null && id.indexOf(OptId) >= 0) {
                                if (tempSpan.length > 0) {
                                    TempSubOptVal = tempSpan.html();
                                    IDandScore = tempSpan.attr("id");
                                    IDandScore = IDandScore.split('€');
                                    if (IDandScore.length > 1) {
                                        TempSubOptID = IDandScore[1];
                                        if (IDandScore.length > 2)
                                            TempSubOptScore = IDandScore[2];
                                        if (IDandScore.length > 2)
                                            SubOptionType = IDandScore[3];
                                        for (var i = 0; i < lstSubOptionIds.length; i++) {
                                            if (TempSubOptID == lstSubOptionIds[i]) {
                                                isExists = "true";
                                                break;
                                            }
                                        }

                                    }
                                    if (TempSubOptID != "" && TempSubOptVal != "" && isExists == "") {
                                        SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal + "¶" + SubOptionType;
                                        lstSubOptionIds.push(TempSubOptID);
                                        if (SubOptionValues != "")
                                            SubOptionValues += "£";
                                    }
                                }
                            }
                        }
                        if (SubOptType == "checkbox" || SubOptType == "div") {
                            subOptionsCount++;
                            $('input[name*=' + OptId + ']:checkbox:checked').each(function () {
                                if ($(this).attr("id") == OptId) {
                                    var isExists = "";
                                    IDandScore = $(this).val();
                                    TempSubOptVal = $(this).attr("title");
                                    IDandScore = IDandScore.split('_');
                                    TempSubOptID = IDandScore[0];
                                    TempSubOptScore = IDandScore[1];
                                    for (var i = 0; i < chkSubOptionIds.length; i++) {
                                        if (TempSubOptID == chkSubOptionIds[i]) {
                                            isExists = "true";
                                            break;
                                        }
                                    }
                                    if (isExists == "") {
                                        if (TempSubOptID != "") {
                                            SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal;
                                            chkSubOptionIds.push(TempSubOptID);
                                            if (SubOptionValues != "")
                                                SubOptionValues += "£";
                                        }
                                    }
                                }
                            });

                        }
                        if (SubOptType == "listbox") {
                            subOptionsCount++;
                            $("option:selected").each(function () {
                                if (this.className == OptId) {
                                    if (this.selected == true) {
                                        var isExists = "";
                                        TempSubOptVal = this.text;
                                        IDandScore = this.value;
                                        IDandScore = IDandScore.split('_');
                                        TempSubOptID = IDandScore[0];
                                        TempSubOptScore = IDandScore[1];
                                        for (var i = 0; i < lstSubOptionIds.length; i++) {
                                            if (TempSubOptID == lstSubOptionIds[i]) {
                                                isExists = "true";
                                                break;
                                            }
                                        }
                                        if (isExists == "") {
                                            if (TempSubOptID != "") {
                                                SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal;
                                                lstSubOptionIds.push(TempSubOptID);
                                                if (SubOptionValues != "")
                                                    SubOptionValues += "£";
                                            }
                                        }
                                    }
                                }
                            });
                        }
                        else if (SubOptType == "dropdownlist") {
                            subOptionsCount++;
                            TempSubOptVal = $('option:selected', this).text();
                            if (TempSubOptVal != "Select" && TempSubOptVal != "") {
                                IDandScore = $('option:selected', this).val();
                                IDandScore = IDandScore.split('_');
                                TempSubOptID = IDandScore[0];
                                TempSubOptScore = IDandScore[1];
                                SubOptionValues = SubOptionValues + TempSubOptID + "¶" + TempSubOptScore + "¶" + TempSubOptVal;
                                if (TempSubOptID != "") {
                                    if (SubOptionValues != "")
                                        SubOptionValues += "£";
                                }
                            }
                        }
                    }
                });
            }
        }
    });
    if (subOptionsCount != 0 && SubOptionValues == "")
        IsSubOptionsSelected = false;
    return SubOptionValues;
}
function ExpColSelQue(QueId) {
    QueId = $.trim(QueId);

    // Capture saved radio BEFORE user changes it
    if (lastSelectedOptionByQuestion[QueId] === undefined) {

        var $checkedRadio = $("#TR_Questions_" + QueId)
            .find("input[type='radio']:checked");

        if ($checkedRadio.length > 0) {
            var id = $checkedRadio.attr("id");
            if (id) {
                var optId = id.split("€")[0].replace("Reb_Opt_", "");
                lastSelectedOptionByQuestion[QueId] = optId;
            }
        }
    }

    if (Flag_Prevent_ExpCol === true && afterNextQuestionView === false) {
        var SelRow = "#TR_Questions_" + QueId;
        var isVisible = $(SelRow).is(':visible');
        $(SelRow).toggle();

        DisplayCareNotes(QueId, '0');
    }
    else {
        Flag_Prevent_ExpCol = true;
        afterNextQuestionView = false;
    }

}
function DisplayCareNotes(CnId, DisTy) {
    if (DisTy == "0") {
        $("#TR_CN_" + CnId).hide();
    }
    else if (DisTy == "1") {
        $("#TR_CN_" + CnId).show();
    }
    else if (DisTy == "2") {
        $("#TR_CN_" + CnId).toggle();
    }
}
function ExpColRunScr(Expand) {
    if (Expand == true) {
        $('tr[id*="TR_Questions_"]').show();
    }
    else {
        $('tr[id*="TR_CN_"]').hide();
        $('tr[id*="TR_Questions_"]').hide();
    }
}
function ExpandCareNotes() {
    var UnAns = $("#hdnCareNotes").val();
    if (UnAns == "0") {
        $("#hdnCareNotes").val("1");
        $('tr[id*="TR_CN_"]').show();
    }
    else {
        $("#hdnCareNotes").val("0");
        $('tr[id*="TR_CN_"]').hide();
    }
}
function ExpUnAnswered(SelClass) {
    var QueId = "0";
    var UnAns = $("#hdnUnAnswer").val();
    if ($("#btnUnAnswerdGrid").attr('title') == "Expand UnAnswerd Questions") {
        $("#btnUnAnswerdGrid").attr('title', "Collapse UnAnswerd Questions");
    }
    else {
        $("#btnUnAnswerdGrid").attr('title', "Expand UnAnswerd Questions");
    }
    $('tr[id*="TR_Questions_"]').hide(); $('tr[id*="TR_CN_"]').hide();
    ResetWorkFlow();
    $(SelClass).each(function (index, el) {
        var SelId = $(this).prop("id");
        SelId = SelId.replace("TR_Que_Row_", "");
        if (SelId != "") {
            if (index == 1) { QueId = SelId; }
            if (UnAns == "0") {
                $("#TR_Questions_" + SelId).show();
            }
            else {
                $("#TR_Questions_" + SelId).hide();
            }
        }
    });
    $("#hdnUnAnswer").val("0");
    if (UnAns == "0") { $("#hdnUnAnswer").val("1"); }
}
function ResetNext() {
    $('img[id*="BtnNext_"]').hide(); $('input:hidden[id*="HdnNext_"]').val("0");
}
function ResetWorkFlow() {
    $('.WorkFlow').each(function (index, el) {
        var SelId = $(this).prop("id");
        SelId = SelId.replace("TR_Que_Row_", "");
        if (SelId != "") {
            $("#TR_Que_Row_" + SelId).removeClass("WorkFlow");
            if (IsAnswered(SelId)) {
                $("#TR_Que_Row_" + SelId).addClass("Answered");
            }
            else {
                $("#TR_Que_Row_" + SelId).addClass("UnAnswered");
            }
        }
    });
}
function IsAnswered(QuestionId) {
    var RetVal = false;
    if (QuestionId == "" || QuestionId == "0") { return false; }
    var SelOpts = $("#TR_Questions_" + QuestionId).find('input[name*="Reb_QueOpt_"]:radio:checked');
    if (SelOpts.length > 0) {
        RetVal = true; return RetVal;
    }
    else {
        SelOpts = $("#TR_Questions_" + QuestionId).find('input[name*="Reb_QueOpt_"]:checkbox:checked');
        if (SelOpts.length > 0) {
            RetVal = true; return RetVal;
        }
        else {
            SelOpts = $("#TR_Questions_" + QuestionId).find('[id*="Reb_QueOpt_text"]');
            if (SelOpts.length > 0 && SelOpts.val().trim() != "") {
                RetVal = true; return RetVal;
            }
            else {
                SelOpts = $("#TR_Questions_" + QuestionId).find('[id*="Reb_QueOpt_txt_area"]');
                if (SelOpts.length > 0 && SelOpts.val().trim() != "") {
                    RetVal = true; return RetVal;
                }
                else {
                    SelOpts = $("#TR_Questions_" + QuestionId).find('[id*="RebQueOptCalendar"]');
                    if (SelOpts.length > 0 && SelOpts.val().trim() != "") {
                        RetVal = true; return RetVal;
                    }
                    else {

                        SelOpts = $("#TR_Questions_" + QuestionId).find('[id*=Reb_QueOpt_Label]');
                        if (SelOpts.length > 0 && SelOpts[0].outerText != "") {
                            RetVal = true; return RetVal;
                        }
                        else {
                            SelOpts = $("#TR_Questions_" + QuestionId).find('[id*="RebQueOptSignature"]');
                            if (SelOpts.length > 0 && SelOpts.attr('src') != "") {
                                RetVal = true; return RetVal;
                            }
                        }
                    }
                }
            }
        }
    }
    return RetVal;
}
function GoToNext(Act, QueId) {
    var SelQueId = QueId;
    if (Act == "NB") {
        SelQueId = "0";
        $("#BtnNext_" + QueId).parent().find("input:hidden").each(function (index, el) { SelQueId = $(this).val(); return false; });
        $("#HdnNext_" + QueId).val("0"); $("#BtnNext_" + QueId).hide();
    }
    if (SelQueId != "" && SelQueId != "0") {
        SetQuestion(SelQueId, "WorkFlow");
        GoToQuestion(SelQueId, 1);
    }
}
function SetQuestion(QueId, ClassName) {
    ResetWorkFlow();
    $("#TR_Que_Row_" + QueId).removeClass("WorkFlow");
    $("#TR_Que_Row_" + QueId).removeClass("UnAnswered");
    $("#TR_Que_Row_" + QueId).removeClass("Answered");
    $("#TR_Que_Row_" + QueId).addClass(ClassName);
}

function savedRadioForQuestion(QueId) {
    QueId = $.trim(QueId);

    if (lastSelectedOptionByQuestion[QueId] !== undefined) return;

    var $checkedRadio = $("#TR_Questions_" + QueId)
        .find("input.RebQueSel[type='radio'][name='Reb_QueOpt_" + QueId + "']:checked");

    if ($checkedRadio.length > 0) {
        var checkedId = $checkedRadio.attr("id"); // Reb_Opt_<OptId>€...
        if (checkedId) {
            lastSelectedOptionByQuestion[QueId] =
                checkedId.split("€")[0].replace("Reb_Opt_", "");
        }
    }
}
function GoToQuestion(QueId, Next, isInitialLoad) {
    //if ($(".ImgPopOut")[0].style.display == "none") {
    //    if ($("#TR_Que_Row_" + QueId)[0] != null)
    //        $("#MainScriptDiv").animate({ scrollTop: $("#TR_Que_Row_" + QueId)[0].offsetTop + 40 }, 500);
    //}
    //else {
    if ($("#TR_Que_Row_" + QueId)[0] != null) {
        if (isInitialLoad) {
            setTimeout(function () {
                $("#CallScreenContent").animate({ scrollLeft: 0, scrollTop: $("#TR_Que_Row_" + QueId)[0].offsetTop }, 500);
                savedRadioForQuestion(QueId);}, 500);
        }
        else {
            $("#CallScreenContent").animate({ scrollLeft: 0, scrollTop: $("#TR_Que_Row_" + QueId)[0].offsetTop }, 500);
        }
    }
    //}
  $("#TR_Questions_" + QueId).show();
    afterNextQuestionView = true;
    if (Next == true) {
        var TrStr = "#TR_Questions_" + QueId + " input:visible:first";
        if (QueId != "0" && QueId != "") {
            $(TrStr).focus();
            var textareaOption = $("#TR_Questions_" + QueId + " textarea:visible:first");
            var labelOption = $("#TR_Questions_" + QueId + " span:visible:first");
            if ((($(TrStr).length > 0 && $(TrStr)[0].type == "text")) || textareaOption.length > 0 || labelOption.length > 0) {
                var nextQuesionID = $("#TR_Questions_" + QueId).find("#hdnQuestionNext")[0].value;
                if (nextQuesionID.length > 0 && nextQuesionID != "0") {
                    $("#TR_Questions_" + QueId).find("#HdnNext_" + QueId).val(nextQuesionID);
                    $("#TR_Questions_" + QueId).find("#BtnNext_" + QueId).show();
                }
            }
        }
    }
}
function PrintScript() {
    var DataPrint = $("#hdnPrintText").val();
    var moduleID = "", patientID = "", sectionName = "", AuthID = "", ComplaintID = "";
    if (window.top.$(".InAuthPage").is(":visible")) {
        var PI = window.top.UmPatient_AuthInfo("", "");
        moduleID = 3;
        patientID = PI.PatientId;
        sectionName = "Scripts";
        AuthID = PI.AuthNo;
    }
    else if (window.top.$(".InComplaintPage").is(":visible")) {
        var PI = window.top.AgPatient_ComplaintInfo("", "");
        moduleID = 5;
        patientID = PI.PatientId;
        sectionName = "Scripts";
        ComplaintID = PI.ComplaintId;
    }
    else {
        moduleID = 1;//cm
        patientID = $('#selectPatientAccessed', window.parent.document).val();
        sectionName = "Member Record >> Run Script >> Print";
    }
    var disp_setting = "toolbar=yes,location=no,directories=yes,menubar=yes,";
    disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";

    var docprint = window.open("", (window.browserPopUpName || window.top.browserPopUpName), disp_setting);
    docprint.document.open();
    docprint.document.write('<html><head></head>');
    docprint.document.write('<body onLoad="self.print()"><center>');
    docprint.document.write(DataPrint);
    docprint.document.write('</center></body></html>');
    docprint.document.close();
    docprint.focus();
    window.top.AuditLog(moduleID, 'Print', sectionName, patientID, window.top.memberidval, '', AuthID, ComplaintID, '');
}
function unescapeHtml(text) {
    if (text != null) {
        return text.replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&#39;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&#10;/g, "\n")
            .replace(/&amp;/g, '&');
    }
    else return "";
}
function PrePopulateQuestionResponses(sbQuestionResponses) {
    var SplittedData = "";
    var SplittedFrmtdData = "";
    if ($("#hdnCurrentCallData").val() != undefined) {
        SplittedFrmtdData = unescapeHtml($("#hdnCurrentCallData").val()).split('§');
    }

    //if ($("#hdnCurrentCallData").val() === 'undefined') {//balank page display case uhg-1899       
    //SplittedData = (typeof sbQuestionResponses === 'undefined') ? $("#hdnCurrentCallData").val().split('§') : sbQuestionResponses.split('§');//commentted by  venkatesh
    SplittedData = (typeof sbQuestionResponses === 'undefined') ? SplittedFrmtdData : unescapeHtml(sbQuestionResponses).split('§')
    //SplittedData = unescapeHtml(sbQuestionResponses).split('§'); //SplittedDataWtOtSpcSyb;
    //}
    //else {
    //    SplittedData = $("#hdnCurrentCallData").val().split('§');
    //}
    var TempOptionID = "";
    var questionIDs = []; //AutoSave
    for (var DataCount = 0; DataCount < SplittedData.length; DataCount++) {
        var QuestionID = "", CareNotes = "", OptionID = "", OptionValue = "", OptionTypeID = "", SubOptionID = "", SubOptionValue = "", subOptDynVal = "";
        var QuestionWiseData = SplittedData[DataCount].split('¦');
        QuestionID = QuestionWiseData[0];
        CareNotes = (QuestionWiseData.length >= 2) ? QuestionWiseData[1].replace(new RegExp('&#39;', 'g'), '\'') : QuestionWiseData[1];
        OptionID = QuestionWiseData[2];
        OptionValue = (QuestionWiseData.length >= 4) ? QuestionWiseData[3].replace(new RegExp('&#39;', 'g'), '\'') : QuestionWiseData[3];
        OptionTypeID = QuestionWiseData[4];
        SubOptionID = QuestionWiseData[5];
        SubOptionValue = (QuestionWiseData.length >= 7) ? QuestionWiseData[6].replace(new RegExp('&#39;', 'g'), '\'') : QuestionWiseData[6];
        subOptDynVal = (QuestionWiseData.length >= 8) ? QuestionWiseData[7].replace(new RegExp('&#177;', 'g'), '±') : QuestionWiseData[7];

        $("#TR_Que_Row_" + QuestionID).removeClass("UnAnswered");
        if (OptionTypeID == "4" && CareNotes != "")
            $("#TR_Que_Row_" + QuestionID).addClass("Answered");
        else if (OptionTypeID != "4")
            $("#TR_Que_Row_" + QuestionID).addClass("Answered");

        if (CareNotes != "") {
            var NotesRow = $("#TR_CN_" + QuestionID);
            var NotesTextArea = $(NotesRow.find("#TaCare_" + QuestionID));
            NotesTextArea.val(ReplacespecialCharcs(CareNotes));
        }

        var OptionsRow = $("#TR_Opts_" + QuestionID + "_" + OptionID);
        var subOptionsPanel = $(OptionsRow).find(".TR_SubOpt");
        if (OptionID != TempOptionID) {
            // OptionTypeID "4" (Label) is intentionally not pre-populated - last saved value may have stale text (GCCST-166329)
            switch (OptionTypeID) {
                case "6":
                    var RadioButton = $(OptionsRow.find("[id*=Reb_Opt_" + OptionID + "]"));
                    if (RadioButton.length > 0) {
                        RadioButton.attr('checked', true);
                        RadioButton[0].checked = true;
                    }
                    break;
                case "2":
                    var CheckBoxList = $(OptionsRow.find("[id*=Reb_Opt_Ch_" + OptionID + "]"));
                    if (CheckBoxList.length > 0) {
                        CheckBoxList[0].checked = true;
                        CheckBoxList.addClass("isprevanswered")
                    }
                    break;
                case "8":
                    var TextArea = $(OptionsRow.find("[id*=Reb_QueOpt_txt_area" + OptionID + "]"));
                    TextArea.val(ReplacespecialCharcs(OptionValue));
                    break;
                case "9":
                    var TextBox = $(OptionsRow.find("[id*=Reb_QueOpt_text" + OptionID + "]"));
                    TextBox.val(ReplacespecialCharcs(OptionValue));
                    break;
                case "1":
                    var Calendar = $(OptionsRow.find("[id*=RebQueOptCalendar€" + OptionID + "]"));
                    Calendar.val(OptionValue == "N/A" ? '' : OptionValue);
                    break;
                case "10":
                    var imageObj = $(OptionsRow.find("[id*=RebQueOptSignature€" + OptionID + "]"));
                    imageObj.attr('src', OptionValue);
                    break;
            }
        }

        if (OptionTypeID == "6" || OptionTypeID == "2") {
            if (subOptDynVal == "") {
                subOptionsPanel.children().each(function (index, el) {
                    if ($(this)[0].className != "sphd") {
                        populateSubOptionsData($(this), SubOptionID, ReplacespecialCharcs(SubOptionValue), OptionID);
                        subOptionsPanel[0].style.display = 'block';
                    }
                });
            }
            else { PoulateDynSubOpt(OptionID, subOptDynVal); }
        }
        TempOptionID = OptionID;
        questionIDs.push(QuestionID); //AutoSave
    }

    //AutoSave   Start
    if (($("#hdnAutoSaveScriptResponseMode").val() == "2" || $("#hdnAutoSaveScriptResponseMode").val() == "1") && questionIDs.length > 0) { AutoSave_ReadPrePopulatedResponses(questionIDs); $("#hdnAutoSaveScriptResponseMode").val("0"); }
    //AutoSave   End

}
////////////  Single Screen Script End  ////////////
//****************************************Script Related End*************************************************//
//--------------------------- Print Html ------------------//
function getTreePrint(table1) {
    var pp = window.open('', (window.browserPopUpName || window.top.browserPopUpName), 'left=200,top=150,width=935,height=750,toolbar=1,resizable=0,scrollbars=yes');
    pp.document.writeln('<HTML><HEAD><title>Print Preview</title>')
    pp.document.writeln("<style type='text/css'>a{color: #6666AA;font-size: 9pt;}a:link, a:visited, a:hover{color: black;background: white;text-decoration: none;cursor: default;}div[class='RadTreeView RadTreeView_Default'] ul li{list-style-type:none;}div[class='RadTreeView RadTreeView_Default'] ul li span[class='rtIn']{list-style-type:none;}div[class='RadTreeView RadTreeView_Default']  ul li ul li div div ul{list-style-type:none;padding-top:10px;padding-bottom:10px;}div[class='RadTreeView RadTreeView_Default']  ul li ul li div div ul li{list-style-type:none;}</style>")
    pp.document.writeln('<body MS_POSITIONING="GridLayout" bottomMargin="0" leftMargin="0" topMargin="0" rightMargin="0">');
    pp.document.writeln('<form  method="post">');
    pp.document.writeln(document.getElementById(table1).innerHTML);
    pp.document.writeln('</form></body></HTML>');
}
//------------------------ End Print Html -----------------------------//
//-------------------------validations---------------------------------//
function ddlClientValidate(source, fnarg) {
    if (fnarg.Value == "Select" || fnarg.Value == ' ') {
        fnarg.IsValid = false;
    } else {
        fnarg.IsValid = true;
    }
}
function ShowConfirmDialog() {
    var ddlBottomScript = $("#ddlScriptBottom").val();
    if (ddlBottomScript != "Select") {
        var runLogID = $("#hdnRunScriptRunLogID").val();
        if (runLogID != '') {
            var result = CustomConfirm("Are you sure you want to exit currenlty running script");
            if (result == true)
                return true;
            else
                return false;
        }
    }
    else {
        $("#lblRunScriptRequired").html('Select a Script');
        return false;
    }
}
function ValidateElectronicDocSave() {
    var ddlDocType = $("#ddlEDocDocumentType").val();

    var lblEDocMessage = $("#lblEDocMessage");
    if (ddlDocType == "-1") {
        lblEDocMessage.html('Select type');
        return false;
    }
    var txtDescription = $("#txtEDocDescription").val();
    if (txtDescription.trim() == '') {
        lblEDocMessage.html('Enter description');
        return false;
    }
    var fupElectronicDoc = $("#fupElectronicDoc").html();
    if (fupElectronicDoc.indexOf("title") == -1) {
        lblEDocMessage.html('Choose a file');
        return false;
    }
}
//----- Expand Collapse  Start------- //
function divexpandcollapse(divname) {
    var div = document.getElementById(divname);
    var img = document.getElementById('img' + divname);
    if (div.style.display == "none") {
        div.style.display = "inline";
        img.src = "imagehandler.ashx?img=Minus.png";
    } else {
        div.style.display = "none";
        img.src = "imagehandler.ashx?img=Plus.png";
    }
}
//----- Expand Collapse  End------- //
//------Start Select Single Radiobutton -----///
function SelectSingleRadiobutton(rdBtnID) {
    //process the radio button Being checked.
    var rduser = $(document.getElementById(rdBtnID));
    rduser.closest('TR').addClass('SelectedRowStyle');
    rduser.checked = true;
    // process all other radio buttons (excluding the the radio button Being checked).
    var list = rduser.closest('table').find("INPUT[type='radio']").not(rduser);
    list.attr('checked', false);
    list.closest('TR').removeClass('SelectedRowStyle');
}
//------End Select Single Radiobutton -----///
//---- Start Verify Radibutton Checked or not ----//
function AlertOnActionSingleRadioButton(grid, rbdId, errorMsg) {
    var bSelected = false;



    // $('#' + grid).find('input:radio').each(function (i) {

    if ($("#" + grid).length != 0) {
        $('#' + grid).find('input:radio').each(function (i) {

            // CHECK EACH ROW FOR THE SELECTED RADIO BUTTON.

            //if ($('input:radio[id=' + rbdId + '_' + i + ']:checked').length > 0) {
            //    alert('ok');
            //    bSelected = true;
            //}

            if (this.checked) {
                bSelected = true;
            }
        });
    }

    if ($("table." + grid).length > 0) {
        $("table." + grid).find('input:radio').each(function (i) {
            // CHECK EACH ROW FOR THE SELECTED RADIO BUTTON.
            // var name = $(this).attr('name');
            //if ($('input:radio[name=' + name + ']:checked').length == 0)
            // $('input:checkbox[id=' + ChkItemId + '_' + i + ']:checked').length > 0
            if (this.checked) {
                bSelected = true;
            }
        });
    }



    if (bSelected == false) {
        CustomAlert(errorMsg);
        return false;
    } else {
        return true;
    }
}
//---- End Verify Radibutton Checked or not ----//
function ClearMessage(labelControl) {
    $("#" + labelControl).html('');
}
//---- Start Verify Checked Items Status ----//
function ActiveAlertOnActionMulti(GvId, ChkItemId, NegMsg, PosMsg, Status) {
    var $CheckBoxsAll;
    var count = 0;
    var gridview = $("#" + GvId);
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");


    if ($CheckBoxsChecked.length > 0) {

        var RetVal = false;
        if ($("#" + GvId).length != 0) {
            $(".LabelStatusJQ", "#" + GvId).each(function (i) {
                if ($('input:checkbox[id="' + ChkItemId + '_' + i + '"]:checked').length > 0) {
                    if ($(this).html().trim() == Status.trim()) {
                    }
                    else {
                        RetVal = true;
                        count++;
                    }
                }
            });
        }
        else {
            $(".LabelStatusJQ", "." + GvId).each(function (i) {
                if ($('input:checkbox[id*=' + ChkItemId + '_' + i + ']:checked').length > 0) {
                    if ($(this).html().trim() == Status.trim()) {
                    }
                    else {
                        RetVal = true;
                        count++;
                    }
                }
            });
        }


        if (RetVal) {
            var DisMes = "Selected Item"; PosMsg = PosMsg.replace("these", "").trim();
            if ($CheckBoxsChecked.length > 1) {
                //DisMes = $CheckBoxsChecked.length + " Item(s)"; 
                DisMes = count + " Item(s)";
                PosMsg += " these";
            }
            //var If = confirm(PosMsg + " " + DisMes);
            PosMsg = PosMsg.toLowerCase();
            var finalMsg = PosMsg.substr(0, 1).toUpperCase() + PosMsg.substr(1).trim() + " " + DisMes.toLowerCase();
            var If = CustomConfirm(finalMsg.replace("?", "") + "?");
            return If;

        } else {
            CustomAlert('Please select at least one item with ' + (Status == "Active" ? "Inactive" : "Active") + " status");
            return false;
        }



    }
    else if ($CheckBoxsChecked.length == 0) {
        CustomAlert(NegMsg);
        return false;
    }

    return true;
}
//---- End Verify Checked Items Status ----//
function PrintPanel(obj, gethtml) {

    var jqueryDOM = "";
    if (gethtml !== undefined) {
        if (gethtml == true) { jqueryDOM = $(obj).html(); }
        else {
            jqueryDOM = $(obj).val();
        }
    }


    var windowUrl = 'Job Receipt';
    var uniqueName = new Date();
    var windowName = 'Print' + uniqueName.getTime();
    jqueryDOM = "<html><head><title>Print</title></head><body>" + jqueryDOM + "</body></html>";
    var printWindow = window.open(windowUrl, (window.browserPopUpName || window.top.browserPopUpName), 'height=400,width=800');
    printWindow.document.write(jqueryDOM);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    printWindow.onbeforeunload = ClearHealthNotesCheckBoxes;
    printWindow.onunload = ClearHealthNotesCheckBoxes;

    //setTimeout(function () {  }, 5000);
    return false;
}
function ClearHealthNotesCheckBoxes() {
    if ($("#gvCareNotes").length != 0)
        ClearCheckBoxes('gvCareNotes', 'ItemChk', 'HeaderChk');
}
function ValidateFileUploadControl(ctrl, lbl) {
    var fupctrl = $("#" + ctrl).html();
    if (fupctrl.indexOf("title") == -1) {
        $("#" + lbl).html('Choose a file');
        return false;
    }
}
function SetScrollPosition(ctrl, index) {
    var element = $("." + ctrl);
    var i = index * 14
    element[0].scrollTop += i;
}
function checkDays(sender, args) {
    var txtDtaStartDate = $('#txtDtaStartDate').val();
    var txtDtaEndDate = $('#txtDtaEndDate').val();
    var txtDtaDays = $('#ddlMedicationDays option:selected').text();

    if (txtDtaStartDate == '' || txtDtaEndDate == '' || txtDtaDays == 'Select')
        return false;

    var date1 = new Date(txtDtaStartDate);
    var date2 = new Date(txtDtaEndDate);

    var OneDay = 1000 * 60 * 60 * 24

    var date1ms = date1.getTime()
    var date2ms = date2.getTime()

    var differencems = Math.abs(date1ms - date2ms)
    var daysCount = Math.round(differencems / OneDay) + 1;

    // var sDate = new Date(txtDtaStartDate);
    // var eDate = new Date(txtDtaEndDate);
    // var daysCount = eDate.getDate() - sDate.getDate() + 1;

    if (txtDtaDays == daysCount) {
        args.IsValid = true;
    }
    else args.IsValid = false;
}
function validateDays(sender, args) {
    if (document.getElementById('ddlFldMEMType').value == 'DAY_SUPPLY') {
        if (isNaN(document.getElementById('txtDtaMEMMedName').value)) {
            args.IsValid = false;
        }
        else {
            args.IsValid = true;
        }
    }
    else {
        args.IsValid = true;
    }
}
//---- Start Verify selected file extension in radasync file upload ----//
function OnClientValidationFailed(sender, args) {
    var fileExtention = args.get_fileName().substring(args.get_fileName().lastIndexOf('.') + 1, args.get_fileName().length);
    if (args.get_fileName().lastIndexOf('.') != -1) {//this checks if the extension is correct
        if (sender.get_allowedFileExtensions().indexOf(fileExtention) == -1) {
            sender.deleteFileInputAt(0);
            CustomAlert("Invalid File Extension!");
        }
        else {
            CustomAlert("Wrong file size!");
        }
    }
    else {
        CustomAlert("not correct extension!");
    }
}
//---- End selected file extension in radasync file upload ----//
function ClearRadioButtons(GvId, RdbId) {
    var $CheckBoxsAll;
    var gridview = $("#" + GvId);
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:radio[id*=" + RdbId + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:radio[id*=" + RdbId + "]");

    $($CheckBoxsAll).attr('checked', false);
}
function UncheckCheckBox(inpObj) {
    var $CheckBoxsChecked = ($("#ddlPage option:selected").text() == "Referrals Column") ? ($(inpObj).find("input:checkbox:checked").not(':disabled')) : ($(inpObj).find("input:checkbox:checked"));
    $($CheckBoxsChecked).attr('checked', false);
    enOrDisDasDagsChkbox();
    return false;
}
function CheckView() {
    var $CheckBoxView = $(".ItemChkView").find("input:checkbox:checked");
    //$($CheckBoxView).attr('checked', false);
    var $CheckBoxViewsel = $(".HeadChkView").find("input:checkbox");
    $($CheckBoxViewsel).attr('checked', false);

    $(".ItemChkAdd").find("input:checkbox:checked").each(function (index, el) {
        var addChk = "#" + $(this).attr("id").replace("ItemChkAdd_", "ItemChkView_");
        $(addChk).attr('checked', true);
    });
    $(".ItemChkEdit").find("input:checkbox:checked").each(function (index, el) {
        var editChk = "#" + $(this).attr("id").replace("ItemChkEdit_", "ItemChkView_");
        $(editChk).attr('checked', true);
    });
    $(".ItemChkDelete").find("input:checkbox:checked").each(function (index, el) {
        var deleteChk = "#" + $(this).attr("id").replace("ItemChkDelete_", "ItemChkView_");
        $(deleteChk).attr('checked', true);
    });

    $(".ItemChkExport").find("input:checkbox:checked").each(function (index, el) {
        var exportChk = "#" + $(this).attr("id").replace("ItemChkExport_", "ItemChkView_");
        $(exportChk).attr('checked', true);
    });
    $(".ItemChkEmail").find("input:checkbox:checked").each(function (index, el) {
        var emailChk = "#" + $(this).attr("id").replace("ItemChkEmail_", "ItemChkView_");
        $(emailChk).attr('checked', true);
    });
    $(".ItemChkPrint").find("input:checkbox:checked").each(function (index, el) {
        var printChk = "#" + $(this).attr("id").replace("ItemChkPrint_", "ItemChkView_");
        $(printChk).attr('checked', true);
    });

    var $CheckBoxView1 = $(".ItemChkView").find("input:checkbox");
    var $CheckBoxView2 = $(".ItemChkView").find("input:checkbox:checked");
    if ($CheckBoxView1.length == $CheckBoxView2.length) {
        $($CheckBoxViewsel).attr('checked', true);
    }
}
function CaredateValidation(date1, date2) {

    var firstDate = $('#' + date1);  //'10-17-2013';
    var secondDate = $('#' + date2);

    if (firstDate.val() == '') {
        CustomAlert('Please Enter Start Date');
        secondDate.val('');
        return;
    }

    var date1 = new Date(firstDate.val());
    var date2 = new Date(secondDate.val());
    if (date2 < date1) {
        CustomAlert('Start Date Always Less than or Equal to End Date');
        secondDate.val('');
    }

}
function CheckText(e, text) {
    if (e.value == text) {
        e.value = '';
    }
}
function AddText(e, text) {
    if (e.value == '') {
        e.value = text;
    }
}
function displayKeyCode(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode == 32) {
        evt.returnValue = false;
        return false;
    }
}
function RistrictKeyBoard(event,isEnableT) {
    var charCode = (event.which) ? event.which : event.keyCode
    var retBoolVal = false;
    if (!retBoolVal) {
        if (charCode === 9) {
            retBoolVal = true;
        }
        else if (charCode === 8) {
            retBoolVal = true;
        }
        else if (charCode === 191) {
            retBoolVal = true;
        }
        else if (charCode > 44 && charCode < 58 && charCode !== 46) {
            retBoolVal = true;
        }
        else if (isEnableT && (charCode === 116 || charCode === 84 || charCode === 43)) {
            retBoolVal = true;
        }
        else { return retBoolVal; }
    }
    return retBoolVal;
}
function RistrictKeyBoardDateTime(event) {
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode == 9 || charCode == 8 || charCode == 65 || charCode == 77 || charCode == 80 || charCode == 191) { return true; }
    else if (charCode > 44 && charCode < 58) { return true; }
    else { return false; }
}
function RistrictKeyBoardCheck(dateCtrl,isValidT) {
    var dateVal = dateCtrl.value;
    var retval = true;
    var conVal = new Date(dateVal);
    if (conVal == 'Invalid Date') { retval = false; }
    if (retval) {
        if (dateVal.indexOf('-') >= 0) {
            dateVal = dateVal.replaceAll('-', '/');
        }
        var splitVal = dateVal.split('/');
        if (splitVal[0] > 12 || splitVal[0] < 1 || !splitVal[0])
            { retval = false; }
        if (splitVal[1] > 31 || splitVal[1] < 1 || !splitVal[1])
            { retval = false; }
        if (splitVal[2] > 2099 || splitVal[2] < 1900 || !splitVal[2])
            { retval = false; }//uhc-1408
        if (retval) {
            if (splitVal[0] == 2 && splitVal[1] > 28) { retval = false; }
            if (splitVal[2] % 4 == 0 && splitVal[0] == 2 && splitVal[1] <= 29) { retval = true; }
        }
    }
    if (!retval && isValidT) {
        retval = (dateVal.charAt(0).toLowerCase() === 't');
    }
    if (retval == false) {
        if (dateCtrl.value == "") {
        }
        else {
            dateCtrl.value = "";
            CustomAlert("Invalid date format! Please correct it.");
        }
    }
    return retval;
}
function ClientValidate(source, fnarguments) {
    var txt = document.getElementById('ctl00_UserControlPlaceHolder_app_pages_cm_operational_managecarestaff_ascx_txtKeyWord');
    var ddl = document.getElementById('ctl00_UserControlPlaceHolder_app_pages_cm_operational_managecarestaff_ascx_ddlCategory');
    var decision = ddl.options[ddl.selectedIndex].text;
    if (decision != 'Select') {
        fnarguments.IsValid = txt.value.length > 0;
    } else {
        fnarguments.IsValid = true;
    }
}
function ClientDdlValidate(source, fnarguments) {
    var ddl1 = document.getElementById('ctl00_UserControlPlaceHolder_app_pages_cm_operational_managecarestaff_ascx_ddlAddCareStaffType');
    var ddl2 = document.getElementById('ctl00_UserControlPlaceHolder_app_pages_cm_operational_managecarestaff_ascx_ddlAssignedTo');
    var decision = ddl1.options[ddl1.selectedIndex].value;
    var str = decision.split(":");
    if (str[1] == 0 && ddl2.options[ddl2.selectedIndex].text == 'Select') {
        fnarguments.IsValid = false;
    } else {
        fnarguments.IsValid = true;

    }
}
function ClientDdlEditValidate(source, fnarguments) {
    var ddl1 = document.getElementById('ctl00_UserControlPlaceHolder_app_pages_cm_operational_managecarestaff_ascx_ddlEditCareStaffType');
    var ddl2 = document.getElementById('ctl00_UserControlPlaceHolder_app_pages_cm_operational_managecarestaff_ascx_ddlEditAssignedTo');
    var decision = ddl1.options[ddl1.selectedIndex].value;
    var str = decision.split(":");
    if (str[1] == 0 && ddl2.options[ddl2.selectedIndex].text == 'Select') {
        fnarguments.IsValid = false;
    } else {
        fnarguments.IsValid = true;
    }
}
function SetTabCss(ApplyTab) {
    $("#HdnCurTabSel").val("");
    $("#HdnCurTabSel").val(ApplyTab);
    return true;
}
function ResetTabCss() {
    var CurTabSel = $("#HdnCurTabSel").val();
    $("#TabbedPanels1 .TabbedPanelsTabGroup").find("li").each(function (index, el) {
        $(this).removeClass();//.removeAttr("class");
        $(this).addClass("TabbedPanelsTab");//.attr("class", "TabbedPanelsTab");
    });
    if (CurTabSel == "") { CurTabSel = "#btnClickMemberInfo"; }
    $(CurTabSel).closest("li").addClass("TabbedPanelsTabSelected");//.attr("class", "TabbedPanelsTabSelected");
}
function MenuUpSetClient(InpVal) {
    $("#HdnMenuCollapse").val("");
    $("#HdnMenuCollapse").val(InpVal);
    MenuUpSet(1);
}
function MenuUpSet(clicked) {
    var InpVal = $("#HdnMenuCollapse").val();
    if (InpVal != "" && InpVal == "1") {
        $("#CollapsiblePanel1").removeClass("class");
        $("#CollapsiblePanel1").attr("class", "CollapsiblePanel CollapsiblePanelOpen");
        if (clicked != "" && clicked == "1") {
            $("#ShortSummary").hide('slow'); $("#CollapsiblePanelContent").show('slow');
        }
        else {
            $("#ShortSummary").hide(); $("#CollapsiblePanelContent").show();
        }
        $("#HdnMenuCollapse").val("1");
    }
    else {
        $("#CollapsiblePanel1").removeClass("class");
        $("#CollapsiblePanel1").attr("class", "CollapsiblePanel CollapsiblePanelClosed");
        if (clicked != "" && clicked == "1") {
            $("#ShortSummary").show('slow'); $("#CollapsiblePanelContent").hide('slow');
        }
        else {
            $("#ShortSummary").show(); $("#CollapsiblePanelContent").hide();
        }
        $("#HdnMenuCollapse").val("0");
    }
}
// Added 18-OCT-2013 11:59 AM ---!>
function ClientItemSelected(sender, e) {
    var textboxControl = $(sender.get_element());
    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        $('#hfEXTId').val('');
        clearExtControlValues(textboxControl, 'txtEXtNameAuto');

    } else {
        textboxControl.val(e._text);
        $('#hfEXTId').val(e.get_value());
        __doPostBack(textboxControl.attr('id'), "");
    }

}
function clearExtControlValues(object, txtCtl) {

    try {
        var ctlId = $(object).attr('id');

        // var fNameId = ctlId.replace(txtCtl, 'txtExtFirstName');
        $('#' + 'txtExtFirstName').val('');

        // var lNameId = ctlId.replace(txtCtl, 'txtExtLastName');
        $('#' + 'txtExtLastName').val('');

        var clinicId = ctlId.replace(txtCtl, 'txtClinic');
        $('#' + clinicId).val('');

        var phoneId = ctlId.replace(txtCtl, 'txtPhone');
        $('#' + phoneId).val('');

        var aPhoneId = ctlId.replace(txtCtl, 'txtAPhone');
        $('#' + aPhoneId).val('');

        var emailId = ctlId.replace(txtCtl, 'txtEmail');
        $('#' + emailId).val('');

        var faxId = ctlId.replace(txtCtl, 'txtFax');
        $('#' + faxId).val('');

        //var toDateId = ctlId.replace(txtCtl, 'txtToDate');
        $('#' + 'txtToDate').val('');

        var addressId = ctlId.replace(txtCtl, 'txtAddress');
        $('#' + addressId).val('');

        var stateId = ctlId.replace(txtCtl, 'txtState');
        $('#' + stateId).val('');

        var cityId = ctlId.replace(txtCtl, 'txtCity');
        $('#' + cityId).val('');

        var zipId = ctlId.replace(txtCtl, 'txtZip');
        $('#' + zipId).val('');

        //var fromDateId = ctlId.replace(txtCtl, 'txtFromDate');
        $('#' + 'txtFromDate').val('');

        var careNotesId = ctlId.replace(txtCtl, 'txtCareNotes');
        $('#' + careNotesId).val('');


        var lobId = ctlId.replace(txtCtl, 'ddECTlLOB');
        var items = $find(lobId).get_items();
        for (var i = 0; i <= items.get_count() - 1; i++) {
            var item = items.getItem(i);
            item.set_checked(false);
        }

        var genderId = ctlId.replace(txtCtl, 'ddlEXTGender');
        setDropDownDefaultValue($find(genderId));

        var roleId = ctlId.replace(txtCtl, 'ddlRole');
        setDropDownDefaultValue($find(roleId));

        var enthncityId = ctlId.replace(txtCtl, 'ddlEthnicity');
        setDropDownDefaultValue($find(enthncityId));

        var languageId = ctlId.replace(txtCtl, 'ddlLanguage');
        setDropDownDefaultValue($find(languageId));

        var borroughId = ctlId.replace(txtCtl, 'ddlEXTBorough');
        setDropDownDefaultValue($find(borroughId));
    } catch (e) {
        //alert(e.message);
        console.log(e.message);
    }
}
function setDropDownDefaultValue(dropDown, index) {


    if (dropDown._value != '-1') {
        dropDown.trackChanges();
        dropDown.get_items().getItem(index || 0).select();
        dropDown.updateClientState();
        dropDown.commitChanges();

    }
}
function CGClientItemSelected(sender, e) {
    //$('#hfCareGiverId').val(e.get_value());

    var textboxControl = $(sender.get_element());
    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        $('#hfCareGiverId').val('');
        clearCGControlValues(textboxControl, 'txtCGNameAuto');

    } else {
        textboxControl.val(e._text);
        $('#hfCareGiverId').val(e.get_value());
        __doPostBack(textboxControl.attr('id'), "");
    }
}
function clearCGControlValues(object, txtCtl) {

    try {
        var ctlId = $(object).attr('id');

        // var fNameId = ctlId.replace(txtCtl, 'txtCGFirstName');
        $('#' + 'txtCGFirstName').val('');

        // var lNameId = ctlId.replace(txtCtl, 'txtExtLastName');
        $('#' + 'txtCGMiddleName').val('');

        var cellPhoneId = ctlId.replace(txtCtl, 'txtCGCellPhone');
        $('#' + cellPhoneId).val('');

        var homePhoneId = ctlId.replace(txtCtl, 'txtCGHomePhone');
        $('#' + homePhoneId).val('');

        var aPhoneId = ctlId.replace(txtCtl, 'txtCGAlterNatePhone');
        $('#' + aPhoneId).val('');

        var addressId = ctlId.replace(txtCtl, 'txtCGAddress');
        $('#' + addressId).val('');

        //var fromDateId = ctlId.replace(txtCtl, 'txtCGFromDate');
        $('#' + 'txtCGFromDate').val('');

        var cateNotesId = ctlId.replace(txtCtl, 'txtCareNotes');
        $('#' + cateNotesId).val('');

        // var addressId = ctlId.replace(txtCtl, 'txtCGLastName');
        $('#' + 'txtCGLastName').val('');

        var DOBId = ctlId.replace(txtCtl, 'txtCGDateOfBirth');
        $('#' + DOBId).val('');

        var pEmailId = ctlId.replace(txtCtl, 'txtCGPrimaryEmail');
        $('#' + pEmailId).val('');

        //var zipId = ctlId.replace(txtCtl, 'txtCGOtherRelation');
        if ($('#' + 'txtCGOtherRelation') || '' != '')
            $('#' + 'txtCGOtherRelation').val('');

        var aEmailId = ctlId.replace(txtCtl, 'txtCGAlternateEmail');
        $('#' + aEmailId).val('');

        var cityId = ctlId.replace(txtCtl, 'txtCGCity');
        $('#' + cityId).val('');

        var zipId = ctlId.replace(txtCtl, 'txtCGZip');
        $('#' + zipId).val('');

        var countryId = ctlId.replace(txtCtl, 'txtCGCountry');
        $('#' + countryId).val('');

        // var toDateId = ctlId.replace(txtCtl, 'txtCGToDate');
        $('#' + 'txtCGToDate').val('');

        //var toDateId = ctlId.replace(txtCtl, 'chkPrimary');
        if ($('#' + 'chkPrimary') || '' != '')
            $('#' + 'chkPrimary').attr('checked', false);

        var hProxyId = ctlId.replace(txtCtl, 'chkCTHealthProxy');
        $('#' + hProxyId).attr('checked', false);


        //var lobId = ctlId.replace(txtCtl, 'ddECTlLOB');
        //var items = $find(lobId).get_items();
        //for (var i = 0; i <= items.get_count() - 1; i++) {
        //    var item = items.getItem(i);
        //    item.set_checked(false);
        //}

        var genderId = ctlId.replace(txtCtl, 'ddlCGGender');
        setDropDownDefaultValue($find(genderId));

        var stateId = ctlId.replace(txtCtl, 'ddlCGState');
        setDropDownDefaultValue($find(stateId));

        var enthncityId = ctlId.replace(txtCtl, 'ddlCGEthenicity');
        setDropDownDefaultValue($find(enthncityId));

        var languageId = ctlId.replace(txtCtl, 'ddlCGPrimaryLanguage');
        setDropDownDefaultValue($find(languageId));

        //var relationId = ctlId.replace(txtCtl, 'ddlCGRelationShip');
        //setDropDownDefaultValue($find(relationId));


    } catch (e) {
        //alert(e.message);
        console.log(e.message);
    }

}
function DDClientItemSelected(sender, e) {
    $('#hfDefaultDataCode').val(e.get_value());

}
function MDPClientItemSelected(sender, e) {
    //$('#hfMDEXTId').val(e.get_value());

    var textboxControl = $(sender.get_element());
    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        $('#hfMDEXTId').val('');
        //clearCGControlValues(textboxControl, 'txtCGNameAuto');

    } else {
        textboxControl.val(e._text);
        $('#hfMDEXTId').val(e.get_value());


        //__doPostBack(textboxControl.attr('id'), "");
    }
}
//PROD-10965
function AssignedToClientItemSelected(sender, e) {
    var textboxControl = $(sender.get_element());
    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        $('#hdnManageCareStaffAssignTo').val('');

    } else {
        textboxControl.val(e._text);
        $('#hdnManageCareStaffAssignTo').val(e.get_value());
    }
}
function onAssignToChange() {
    if ($.trim($("#txtAssignedTo").val()) == "")
        $('#hdnManageCareStaffAssignTo').val('');
}
function onAssignToEditChange() {
    if ($.trim($("#txtAssignedToEdit").val()) == "")
        $('#hdnManageCareStaffAssignTo').val('');
}
//PROD-10965

// PROD-13420 START
// for LOBBenfitPlan start
function OnLobBenefitPlanAutoCleared() {
    $('#hdnLobBenefitPlanId').val('');
}

function LobBenefitPlanClientItemSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hdnLobBenefitPlanId').val(e.get_value());
        $("#txtLobBenefitPlanAC").val(e.get_text());
    }
    else {
        return false;
    }
}
function validateLobBenfitPlan() {
    var isPlanACValid;
    var isValid = Page_ClientValidate('LOBBenefitPlan');
    if ($("#hdnLobBenefitPlanId").val() == "" || $("#hdnLobBenefitPlanId").val() == undefined) {
        $("#benefitPlanMandatory").show();
        var isPlanACValid = false;
    }
    else {
        $("#benefitPlanMandatory").hide();
        isPlanACValid = true;
    }

    return (isPlanACValid && isValid);
}
// LOBBenfitPlan end

// BenfitPlanProgram Start
function OnBenefitPlanAutoCleared() {
    $("#hdnBenefitPlanProgramId").val('');
}

function BenefitPlanProgramClientItemSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hdnBenefitPlanProgramId').val(e.get_value());
        $("#txtBenefitPlanProgramAC").val(e.get_text());
    }
    else {
        return false;
    }
}

function validateBenfitPlanProgram() {
    var isPlanACValid;
    var isValid = Page_ClientValidate('BenefitPlanProgram');
    if ($("#hdnBenefitPlanProgramId").val() == "" || $("#hdnBenefitPlanProgramId").val() == undefined) {
        $("#benefitPlanProgramMandatory").show();
        var isPlanACValid = false;
    }
    else {
        $("#benefitPlanProgramMandatory").hide();
        isPlanACValid = true;
    }

    return (isPlanACValid && isValid);
}

// BenfitPlanProgram End

//REQUIRED ACTIVITIES START

function OnPACBenefitPlanAutoCleared() {
    $('#hdnPACBenefitPlanId').val('');
}

function PACBenefitPlanClientItemSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hdnPACBenefitPlanId').val(e.get_value());
        $("#txtPACBenefitPlanAC").val(e.get_text());
        // server cal for programs dropdown binding
        $("#btnPACLoadPrograms").click();
    }
    else {
        return false;
    }
}

//REQUIRED ACTIVITIES END

//PROD-13420 END

function IcdClientItemSelected(sender, e) {
    // $('#hfIcdAutoId').val(e.get_value());
    var textboxControl = $(sender.get_element());
    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        textboxControl.attr('title', '');
    } else {
        textboxControl.val(e.get_value());
        textboxControl.attr('title', e._text);
    }
}
function ExceptionRaised() {
    $("#DivException").show();
}
function ScriptPopup(ImgObj, ImgAct) {
    $(".ImgPopOut, .ImgPopIn").hide();
    var topAreaHeight = $('#MainDiv', parent.document).height(); // Calculates Menu, Member summary and Logo size
    var totAvailableHeight = $('#mainTblForVisibleScreenSize', parent.document).height(); // Gives the total height of the visible screen area
    var heightToSet = (totAvailableHeight - topAreaHeight - 110);
    $("#CallScreenContent").height(heightToSet > 0 ? ((heightToSet > 150) ? heightToSet : 150) : 300 + "px");  //Setting minimum height 150/300
    if (ImgAct == 1) {
        $(".ImgPopIn").show();
        $("#lblSPSMemName").show();
        $(".FooterPopIn").addClass("scriptFooter");
        $("#CallScreenFooter").removeClass("FooterPopIn").addClass("FooterPopOut");
        $("#MainScriptDiv").removeClass("PopIn").addClass("PopOut");
        //$('body').css('overflow', 'hidden');        
    }
    else {
        $(".ImgPopOut").show();
        $(".FooterPopIn").removeClass("scriptFooter");
        $("#lblSPSMemName").hide();
        //$("#CallScreenContent").height("300px");
        $("#CallScreenFooter").removeClass("FooterPopOut").addClass("FooterPopIn");
        $("#MainScriptDiv").removeClass("PopOut").addClass("PopIn");
        //$('body').css('overflow', 'auto');
    }
}
//function RemoveBodyScroll() {
//    $('body').css('overflow', 'hidden');
//}
//function AddBodyScroll() {
//    $('body').css('overflow', 'auto');
//}
function SetQuickUpdate(show) {
    var hdnQuick = $("#hdnQuickUpdate").val();
    ShowOrHideQuickUpdate(hdnQuick, show);
    if ($(".classDdlDays").val() === "Do Not Call") {
        $('.classDdlTime').hide();
    }
}
function ShowOrHideQuickUpdate(inpVal, show) {
    $("#hdnQuickUpdate").val('');
    $("#hdnQuickUpdate").val(inpVal);
    if (show == "") {
        $("#divQuickLinks").toggle();
        $("#divQuickUpdate").toggle();
    }
    else {
        if (show == "QuickUpdate") {
            $("#divQuickUpdate").show();
            $("#divQuickLinks").hide();
        }
        else if (show == "QuickLinks") {
            $("#divQuickLinks").show();
            $("#divQuickUpdate").hide();
        }
    }
}
function DivMenuShow(MenuId, OffTop, OffLeft) {
    $(MenuId).show();
    $(MenuId).css("left", OffLeft + "px");
    var WinHeight = $(window).height();
    if ((OffTop + $(MenuId).height) > WinHeight) { OffTop = (OffTop - $(MenuId).height); }
    $(MenuId).css("top", (OffTop) + "px");
    //$(MenuId).css("position", "relative");
}
//$(window).scroll(function () {
//    DbMenuApp(DivObj, MenuId, Hilight);
//});
function OnScrollHide(DivObj, MenuId, Hilight, event) {
    DbMenuApp(DivObj, MenuId, Hilight, event);
}
function DbMenuApp(DivObj, MenuId, Hilight, event, HeaderChk) {
    var mousePosition = {};
    var menuPostion = {};
    var menuDimension = {};

    var contextMenu = $(MenuId);
    menuDimension.x = contextMenu.outerWidth();
    menuDimension.y = contextMenu.outerHeight();
    mousePosition.x = event.pageX;
    mousePosition.y = event.pageY;

    if (mousePosition.x + menuDimension.x > $(window).width() + $(window).scrollLeft()) {
        menuPostion.x = mousePosition.x - menuDimension.x;
    } else {
        menuPostion.x = mousePosition.x;
    }

    if (mousePosition.y + menuDimension.y > $(window).height() + $(window).scrollTop()) {
        menuPostion.y = mousePosition.y - menuDimension.y;
    } else {
        menuPostion.y = mousePosition.y;
    }
    vScrollPosition = $(document).scrollTop();
    hScrollPosition = $(document).scrollLeft();

    if (menuPostion.y > document.body.clientHeight / 2) {
        menuPostion.y = menuPostion.y - vScrollPosition;
    }
    else
        menuPostion.y = menuPostion.y + vScrollPosition;

    if (menuPostion.x > document.body.clientWidth / 2) {
        menuPostion.x = menuPostion.x - 2;
    }
    else
        menuPostion.x = menuPostion.x + 5;

    //$('body').css('overflow', 'auto');
    $(MenuId).hide();
    if (Hilight) {
        var $ChkAll = $(DivObj).find("input:checkbox");
        if ($ChkAll.length > 0) { $ChkAll.closest('TR').removeClass('SelectedChkRowStyle'); }
    }
    var $ChkedAll = $(DivObj).find("input:checkbox:checked"); //Get Checked Check box list from grid

    var $GridChkBoxAll = $(DivObj).find("input:checkbox"); //Get all Check box's list from grid

    if ($GridChkBoxAll.length == 2 && $ChkedAll.length == 1) {
        if ($ChkedAll[0].id.indexOf("_0") == -1 && $GridChkBoxAll[0].id.indexOf("_0") == -1) {
            if ((HeaderChk || false) == false) {
                $(MenuId).hide();
                return;
            }
        } else {
            if ((HeaderChk || false) == true) {
                $(MenuId).hide();
                return;
            }
        }
        //} 
        //else if ($ChkedAll.length == 1 && $ChkedAll[0].id.indexOf("_0") == -1) {
        //    $(MenuId).hide();
        //    return;
    }
    if ($ChkedAll.length > 0) {
        if (Hilight) { $ChkedAll.closest('TR').addClass('SelectedChkRowStyle'); }
        var posleft;
        var postop;
        if ($ChkedAll.length == 1) {
            try {
                if (event.target.id == $ChkedAll.attr('id')) {
                    posleft = menuPostion.x;
                    postop = menuPostion.y;
                }
                else {
                    postop = $($ChkedAll[0]).offset().top;
                    posleft = $($ChkedAll[0]).offset().left + 13;
                }
            }
            catch (e) {
                postop = $($ChkedAll[0]).offset().top;
                posleft = $($ChkedAll[0]).offset().left + 13;
            }
            if ((HeaderChk || false) == true) {
                if ($GridChkBoxAll.length > 2) {
                    $(MenuId).hide();
                } else {
                    DivMenuShow(MenuId, postop + 40, posleft, event);

                }
            } else {
                DivMenuShow(MenuId, $('#' + event.target.id).offset().top, posleft + 1, event);
            }
            //$('body').css('overflow', 'hidden');
        }
    }
}
function DBMemPopupOpened() {
    var value = $('#hdnmempopstate').val();
    if (value != '') {
        DBMemPopup(value);
    }
}
//<!----Dashboard Related Script.
function DBMemPopup(ImgAct) {
    $("#btndmpopout, #btndmpopin").hide();
    if (ImgAct == 1) {
        $("#btndmpopin").show();
        $("#hddmdtlset").height("99.5%");
        $("#divMemdtlpop").removeClass("PopIn").addClass("PopOut");
        $("#dmemhset").css("height", (parseInt($(window).height()) - 76) + "px");
        $("#dmemhsetOA").css("height", (parseInt($(window).height()) - 95) + "px");
        $("#dmemhsetPA").css("height", (parseInt($(window).height()) - 53) + "px");
        $('#hdnmempopstate').val('1');
        $('#hdnmempopstate0').val('1');
        $('#hdnmempopstate1').val('1');
        $('#hdnmempopstate2').val('1');
    }
    else {
        $("#btndmpopout").show();
        $("#hddmdtlset").height("300px");
        $("#divMemdtlpop").removeClass("PopOut").addClass("PopIn");
        $('#hdnmempopstate').val('0');
        $('#hdnmempopstate0').val('0');
        $('#hdnmempopstate1').val('0');
        $('#hdnmempopstate2').val('0');
        DbMemSet();
        // $('body').css('overflow', 'auto');
    }
}
function DBAlPopup(ImgAct) {
    $("#btndapopout, #btndapopin").hide();
    if (ImgAct == 1) {
        $("#btndapopin").show();
        $("#hddAdtlset").height("99.5%");
        $("#divAldtlpop").removeClass("PopIn").addClass("PopOut");
        $("#dbalthst").css("height", (parseInt($(window).height()) - 53) + "px");
        $("#dbdpset").css("height", (parseInt($(window).height()) - 53) + "px");
        $("#dbqiset").css("height", (parseInt($(window).height()) - 53) + "px");
        $("#dbasumset").css("height", (parseInt($(window).height()) - 53) + "px");
        $('#hdnaltpopstate').val('1');
        $('#hdnaltpopstate0').val('1');
        $('#hdnaltpopstate1').val('1');
        $('#hdnaltpopstate2').val('1');
        $('#hdnaltpopstate3').val('1');
        $('#hdnaltpopstate4').val('1');
        // $('body').css('overflow', 'hidden');
    }
    else {
        $("#btndapopout").show();
        $("#hddAdtlset").height("300px");
        $("#divAldtlpop").removeClass("PopOut").addClass("PopIn");
        $('#hdnaltpopstate').val('0');
        $('#hdnaltpopstate0').val('0');
        $('#hdnaltpopstate1').val('0');
        $('#hdnaltpopstate2').val('0');
        $('#hdnaltpopstate3').val('0');
        $('#hdnaltpopstate4').val('0');
        DbAltSet();
        // $('body').css('overflow', 'auto');
    }
}
function DBClPopup(ImgAct) {
    $("#btndcpopout, #btndcpopin").hide();
    if (ImgAct == 1) {
        $("#btndcpopin").show();
        $("#hddCdtlset").height("99.5%");
        $("#divCldtlpop").removeClass("PopIn").addClass("PopOut");
        $("#rsAppointments").css("height", (parseInt($(window).height()) - 53) + "px");
        $('#hdncalpopstate').val('1');
        // $('body').css('overflow', 'hidden');
    }
    else {
        $("#btndcpopout").show();
        $("#hddCdtlset").height("240px");
        $("#divCldtlpop").removeClass("PopOut").addClass("PopIn");
        $('#hdncalpopstate').val('0');
        DbCalSet();
        // $('body').css('overflow', 'auto');
    }
}
function DBRlPopup(ImgAct) {
    $("#btndrpopout, #btndrpopin").hide();
    if (ImgAct == 1) {
        $("#btndrpopin").show();
        $("#hddRdtlset").height("99.5%");
        $("#divRldtlpop").removeClass("PopIn").addClass("PopOut");
        $("#rrecghset").css("height", (parseInt($(window).height()) - 53) + "px");
        $("#rrejghset").css("height", (parseInt($(window).height()) - 53) + "px");
        $('#hdnrecpopstate').val('1');
        $('#hdnrecpopstate0').val('1');
        $('#hdnrecpopstate1').val('1');
        //$('body').css('overflow', 'hidden');
    }
    else {
        $("#btndrpopout").show();
        $("#hddRdtlset").height("300px");
        $("#divRldtlpop").removeClass("PopOut").addClass("PopIn");
        $('#hdnrecpopstate').val('0');
        $('#hdnrecpopstate0').val('0');
        $('#hdnrecpopstate1').val('0');
        DbGridSet();
        //$('body').css('overflow', 'auto');
    }
}
function SetAllDb() {
    $(document).ready(function () {
        DbGridSet();
        DbMemSet();
        DbAltSet();
        DbCalSet();
        DBClPopup($('#hdncalpopstate').val());
    });
}
function DbGridSet() {
    var RBRadPaneID = $("#RBRadPaneClientID").val();
    if (RBRadPaneID == "") { return; }
    if ($("#hdnrecpopstate").val() != "1") {
        $("#rrecghset").css("height", (parseInt($("#" + RBRadPaneID).height()) - 83) + "px");
        $("#rrejghset").css("height", (parseInt($("#" + RBRadPaneID).height()) - 83) + "px");
    }
}
function DbMemSet() {
    var LTRadPaneid = $("#LTRadPaneClientID").val();
    if (LTRadPaneid == "") { return; }
    if ($("#hdnmempopstate").val() != "1") {
        $("#dmemhset").css("height", (parseInt($("#" + LTRadPaneid).height()) - 76) + "px");
        $("#dmemhsetOA").css("height", (parseInt($("#" + LTRadPaneid).height()) - 88) + "px");
        $("#dmemhsetPA").css("height", (parseInt($("#" + LTRadPaneid).height()) - 51) + "px");
    }
}
function DbAltSet() {
    var LBRadPaneid = $("#LBRadPaneClientID").val();
    if (LBRadPaneid == "") { return; }
    if ($("#hdnaltpopstate").val() != "1") {
        $("#dbalthst").css("height", (parseInt($("#" + LBRadPaneid).height()) - 51) + "px");
        $("#dbdpset").css("height", (parseInt($("#" + LBRadPaneid).height()) - 30) + "px");
        //$("#dbrgset").css("height", (parseInt($("#" + LBRadPaneid).height()) - 53) + "px");
        $("#dbqiset").css("height", (parseInt($("#" + LBRadPaneid).height()) - 30) + "px");
        $("#dbasumset").css("height", (parseInt($("#" + LBRadPaneid).height()) - 51) + "px");

        if ($('#hdnQualityGraphData').val() == "1") {
            setDashChartScrollPos('#dbqiset.qualityGraph');
        } else {
            $('#dbqiset.qualityGraph').scrollTop = 0;
        }

        if ($('#hdnDeseaseGraphData').val() == '1') {
            setDashChartScrollPos('#dbdpset.diseaseGraph');
        } else {
            $('#dbdpset.diseaseGraph').scrollTop = 0;
        }
    }
}
function DbCalSet() {
    var CalHeight = parseInt($("#CalCtrlID").height()) - 29;
    if ($("#hdncalpopstate").val() != "1") {
        $("#rsAppointments").css("height", CalHeight + "px");
        $("#hddCdtlset").height("240px");
    }
}
//Dashboard Related Script.-----!>
function validateUpload(sender, args) {
    var upload = $find("flUpload");
    var link = document.getElementById('lnkContent');// $find("lnkContent");
    if (link != null) {
        args.IsValid = true;
        return;
    }
    else {
        if (upload.getUploadedFiles().length != 0 || $('#lblImage').html() != '') {
            args.IsValid = true;
            return;
        }
    }
    //args.IsValid = upload.getUploadedFiles().length != 0;
}
function OnClientFileUploaded(sender, args) {
    var contentType = args.get_fileName();
    $('#lblImage').html(contentType);
    $('#hdnImage').val(contentType);
}
function OnClientFileUploadRemoving(sender, args) {
    if (args.get_rowIndex() == 0) {
        $('#lblImage').html('');
        $('#hdnImage').val('');
    }
}
function validateUpload1(sender, args) {
    if ($("#hdnIsFileUploaded").val() == "0") {
        $("#lblUploaderror").show();
    } else {
        $("#lblUploaderror").hide();
    }
    var upload = $find("flUploadMng");
    var link = document.getElementById('lnkContent');// $find("lnkContent");
    if (link != null) {
        args.IsValid = true;
        return;
    }
    else {
        if (upload.getUploadedFiles().length != 0 || $('#lblImage').html() != '') {
            args.IsValid = true;
        }
    }
}
function ValidateAlpha(event) {
    var keyCode = (event.which) ? event.which : event.keyCode
    if ((keyCode > 64 && keyCode < 91) || (keyCode > 96 && keyCode < 123) || keyCode == 8 || keyCode == 9 || keyCode == 37 || keyCode == 39 || keyCode == 46) {
        return true;
    }
    else { return false; }
}
function DbMenuAppointment(DivObj, MenuId, Hilight, ChkBox, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container) {
    //function DbMenuAppointment(DivObj, MenuId, Hilight, ChkBox, Event) {    
    SelectAllCheckboxes(ChkBox);
    var $Trs = $(DivObj).find(".ConMenuBtn"); $($Trs).attr("disabled", false);
    var hdnChk = $(ChkBox).closest('td').find("input:hidden");
    var EnaClass = "." + $(hdnChk[0]).val();
    var $TrsEna = $(DivObj).find(EnaClass);
    if ($Trs.length > 0 && $TrsEna.length > 0) {
        $($TrsEna[0]).attr("disabled", false);
    }
    if ($(hdnChk[0]).val().toUpperCase() == "PENDING" || $(hdnChk[0]).val().toUpperCase() == "REQUESTED") {
        $($Trs[4]).attr("disabled", true);
    }
    else if ($(hdnChk[0]).val().toUpperCase() == "SCHEDULED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
    }
    else if ($(hdnChk[0]).val().toUpperCase() == "CONFIRMED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
    }
    else if ($(hdnChk[0]).val().toUpperCase() == "COMPLETED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[3]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
        $($Trs[5]).attr("disabled", true);
        $($Trs[6]).attr("disabled", true);
    }
    else if ($(hdnChk[0]).val().toUpperCase() == "RESCHEDULED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
    }
    else if ($(hdnChk[0]).val().toUpperCase() == "CANCELLED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[3]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
        $($Trs[5]).attr("disabled", true);
        $($Trs[6]).attr("disabled", true);
    }
    //DbMenuApp(DivObj, MenuId, Hilight, Event);
    ContextMenuNew(ChkBox, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container);
}
function SelectAllCheckboxes(ChkBox) {
    var IsChecked = ChkBox.checked;
    var cbxAll = ChkBox;
    var Parent = document.getElementById('gvVisit');
    var items = Parent.getElementsByTagName('input');
    for (i = 0; i < items.length; i++) {
        if (items[i].id != cbxAll.id && items[i].type == "checkbox") {
            items[i].checked = false;
        }
        else {
            items[i].checked = IsChecked;
        }
    }
}
function PerformActionOnTextBox(ChkItemId, ConditionalCallback) {
    var CurRow = $(ChkItemId).closest("tr");
    $(".TxtVM", CurRow).val('');
    var IsChecked = $(ChkItemId).is(":checked");//ChkItemId.checked;
    var IsGCChecked = $(".clsIsMandatoryChk", CurRow).is(":checked");
    var IsSPChecked = $(".clsIsSPMandatoryChk", CurRow).is(":checked");
    if (IsChecked || IsGCChecked || IsSPChecked) {
        $(".TxtVM", CurRow).prop("disabled", false);
        $(".TxtVM", CurRow).removeClass("aspNetDisabled ");
    }
    else {
        $(".TxtVM", CurRow).prop("disabled", true);
        $(".TxtVM", CurRow).addClass("aspNetDisabled ");
    }
    if (ConditionalCallback != undefined)
        ConditionalCallback($(ChkItemId));
}

function PerformActionOnTextBoxATDiagCode(ChkItemId) {
    var DiagCodeAccField = [];
    var DiagCodeDescAccField = [];
    var countle = [];
    if ($('#hdnDiagCodeAccField').val() != "") { DiagCodeAccField = $('#hdnDiagCodeAccField').val().split(','); }
    if ($('#hdnDiagCodeDescAccField').val() != "") { DiagCodeDescAccField = $('#hdnDiagCodeDescAccField').val().split(','); }
    var combo = $find('ddlDiagnosisAndServiceCodes');
    var CurRow = $(ChkItemId).closest("li");
    var CurRow1 = $(".rcbCheckBox", CurRow).attr("data-Child");
    var OptonalFind = $(".rcbCheckBox", CurRow).attr("ChkEnabled");
    if (OptonalFind != null && OptonalFind == "1") {
        countle = $("li .rcbCheckBox[data-Child=" + CurRow1 + "]").closest("li");
    }
    else {
        countle = $("li .rcbCheckBox[data-Child*=" + CurRow1 + "]").closest("li");
    }
    var valChecked = $(".rcbCheckBox" + ' input[type=checkbox]', CurRow).is(":checked");
    var result = $('#ddlDiagnosisAndServiceCodes_Input').val();
    combo.trackChanges();
    for (i = 0; i < countle.length; i++) {
        var prevVal = '', currVal = '';

        // For optional and Parent control this will false i>0
        if (i > 0) {
            $(".rcbCheckBox" + ' input[type=checkbox]', countle[i]).prop("disabled", false);
            //When you click master control all control need to enable and default checked child control except "Optional Control"
            //and when you uncheck parent it need to uncheck all child control including "Optional Control".
            if ($(".rcbCheckBox", countle[i]).attr("ChkEnabled") == "1") {
                $(".rcbCheckBox" + ' input[type=checkbox]', countle[i]).prop("checked", false)
            }
            else {
                $(".rcbCheckBox" + ' input[type=checkbox]', countle[i]).prop("checked", valChecked)
            }

            // If for "Optional Control" and else for parent and child control.
            if ($(".rcbCheckBox", countle[i]).attr("ChkEnabled") == "1" && valChecked) {
            }
            else { $(".rcbCheckBox" + ' input[type=checkbox]', countle[i]).prop("disabled", true); }
        }

        //this for check all control 
        if (valChecked) {

            if ($(".rcbCheckBox", countle[i]).attr("ChkEnabled") == "1" && i > 0) {
                $(".txtVT", countle[i]).prop("disabled", true);
            }
            else {
                $(".txtVT", countle[i]).prop("disabled", false);
                $(".txtVT", countle[i]).removeClass("aspNetDisabled");
            }
            prevVal = $(".txtIT", countle[i]).val(); currVal = $(".txtVT", countle[i]).val();
            if (currVal != prevVal && currVal == "" && ($(".rcbCheckBox", countle[i]).attr("ChkEnabled") != "1" || i == 0)) {
                $(".txtVT", countle[i]).val($(".txtIT", countle[i]).val());
                if (DiagCodeDescAccField.indexOf($(".lblVT", countle[i]).text()) == -1) {
                    DiagCodeDescAccField.push($(".lblVT", countle[i]).text());
                }
            }

            if (DiagCodeAccField.indexOf($("#hdnAccField", countle[i]).val()) == -1 && ($(".rcbCheckBox", countle[i]).attr("ChkEnabled") != "1" || i == 0)) { DiagCodeAccField.push($("#hdnAccField", countle[i]).val()); }
        }
        //this for uncheck all control 
        else {
            var DiagCodeDescSeach = DiagCodeDescAccField.indexOf($(".lblVT", countle[i]).text());
            if (DiagCodeDescSeach > -1) { DiagCodeDescAccField.splice(DiagCodeDescSeach, 1); }
            $(".txtVT", countle[i]).val('');
            $(".txtVT", countle[i]).prop("disabled", true);
            var DiagCodeAccSeach = DiagCodeAccField.indexOf($("#hdnAccField", countle[i]).val());
            if (DiagCodeAccSeach > -1) { DiagCodeAccField.splice(DiagCodeAccSeach, 1); }
        }
    }
    $('#hdnDiagCodeAccField').val(DiagCodeAccField.join(','));
    $('#hdnDiagCodeDescAccField').val(DiagCodeDescAccField.join(','));
    $('#ddlDiagnosisAndServiceCodes_Input').val(DiagCodeDescAccField.join(','));
    combo.updateClientState();
    combo.commitChanges();
}
function DiagCode(e) {
    e.stopPropagation();
}

function RadComboboxStopPropagation(e) {
    e.stopPropagation();
}
function PerformActionOnInsideTextBoxATDiagCode(TextId, strLblValue) {
    var CurRow = $(TextId).closest("li");
    var CurrVal = $(TextId).val();
    var IsChecked = $(".rcbCheckBox" + ' input[type=checkbox]', CurRow).is(":checked");
    if (IsChecked && CurrVal == "") { $(".txtVT", CurRow).val(strLblValue); }
    var dataVal = $('#ddlDiagnosisAndServiceCodes_Input').val();
    var DiagCodeDescAccField = [];
    if ($('#hdnDiagCodeDescAccField').val() != "") {
        DiagCodeDescAccField = $('#hdnDiagCodeDescAccField').val().split(',');
    }

    DiagCodeDescAccField.push(strLblValue);
    $('#ddlDiagnosisAndServiceCodes_Input').val(DiagCodeDescAccField.join(","));
}

function PerformActionOnTextBoxAT(ChkItemId) {
    var CurRow = $(ChkItemId).closest("li");
    var prevVal = '', currVal = '';
    var IsChecked = $(".rcbCheckBox", CurRow).is(":checked");
    if (IsChecked) {
        $(".txtVT", CurRow).prop("disabled", false);
        $(".txtVT", CurRow).removeClass("aspNetDisabled");
        prevVal = $(".txtIT", CurRow).val(); currVal = $.trim($(".txtVT", CurRow).val());
        if (currVal != prevVal && currVal == "") { $(".txtVT", CurRow).val($(".txtIT", CurRow).val()); }
    }
    else {
        $(".txtVT", CurRow).val('');
        $(".txtVT", CurRow).prop("disabled", true);
        $(".SelectRbtn" + ' input[type=radio]', CurRow).prop('checked', false);
        $(".SelectRbtn" + ' input[type=radio]', CurRow).removeClass('DefaultChecked');
    }
}
function PerformActionOnInsideTextBoxAT(TextId, strLblValue) {
    var CurRow = $(TextId).closest("li");
    var CurrVal = $.trim($(TextId).val());
    var IsChecked = $(".rcbCheckBox", CurRow).is(":checked");
    if (IsChecked && CurrVal == "") { $(".txtVT", CurRow).val(strLblValue); }
}

function PerformActionOnRadioButtonClick(RbId, IsDefaultChecked, isNotUnitType) {
    var CurRow = $(RbId).closest("li");
    var CurList = $(RbId).closest("ul");
    if (IsDefaultChecked == undefined)
        IsDefaultChecked = "false";
    if (!$(".SelectRbtn" + ' input[type=radio]', CurRow).hasClass('DefaultChecked') && IsDefaultChecked.toLowerCase() == "false") {
        var IsChecked = $(".rcbCheckBox", CurRow).is(":checked");
        if (IsChecked || (isNotUnitType != undefined && isNotUnitType.toLowerCase() == "true")) {
            $(".SelectRbtn" + ' input[type=radio]', CurList).removeAttr("onclick");
            if (isNotUnitType != undefined && isNotUnitType.toLowerCase() == "true") {
                $(".SelectRbtn" + ' input[type=radio]', CurList).attr("onclick", "javascript:PerformActionOnRadioButtonClick(this,'" + false + "','" + true + "');");
                var val = $(".lblVT", CurList).text();
                $('#ddlAccordian_Input').val($(".lblVT", CurRow).text());
                $('#hdnAccordianValue').val($(".lblVT", CurRow).text());
            }
            else
                $(".SelectRbtn" + ' input[type=radio]', CurList).attr("onclick", "javascript:PerformActionOnRadioButtonClick(this);");
            $(".SelectRbtn" + ' input[type=radio]', CurList).prop('checked', false);
            $(".SelectRbtn" + ' input[type=radio]', CurList).removeClass('DefaultChecked');
            $(".SelectRbtn" + ' input[type=radio]', CurRow).addClass('DefaultChecked');
            $(".SelectRbtn" + ' input[type=radio]', CurRow).prop('checked', true);
            $('#BtnCloseAccordian').trigger('click');
        }
        else if (isNotUnitType == undefined || isNotUnitType.toLowerCase != "true") {
            $(".SelectRbtn" + ' input[type=radio]', CurRow).prop('checked', false);
            CustomAlert('Please select unit type');
        }
    }
    else {
        $(".SelectRbtn" + ' input[type=radio]', CurList).removeAttr("onclick");
        if (isNotUnitType != undefined && isNotUnitType.toLowerCase() == "true") {
            $('#ddlAccordian_Input').val('');
            $(".SelectRbtn" + ' input[type=radio]', CurList).attr("onclick", "javascript:PerformActionOnRadioButtonClick(this,'" + false + "','" + true + "');");
        }
        else
            $(".SelectRbtn" + ' input[type=radio]', CurList).attr("onclick", "javascript:PerformActionOnRadioButtonClick(this);");
        $(".SelectRbtn" + ' input[type=radio]', CurList).prop('checked', false);
        $(".SelectRbtn" + ' input[type=radio]', CurList).removeClass('DefaultChecked');
    }

}


function Redirect(ChkItemId) {
    var CurRow = $(ChkItemId).closest("td");
    var Val = $(".RedirectPage", CurRow).val();

    //PROD-19169 KP
    var AuthData = Val.split('|');

    if (window.top.IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed', window.parent.document).val() != AuthData[0]) {
        window.top.GetPatientAlertsAndAcknowledge(AuthData[0], 0, 0, 'bulkreferral', Val);
        return false;
    }
    else {
        SetAuthPatientData(Val);
        return false;
    }
}
function ValidateMessagesForMandatoryFields() {
    var RetVal = true;
    $("#gvAuthValidationConfiguration, #gvComplaintValidationConfiguration").find(".ChkVM").each(function (index, el) {
        var CurRow = $(this).closest("tr");
        var IsChecked = $("input:checkbox", CurRow).is(":checked");
        if (IsChecked) {
            if ($(".TxtVM", CurRow).val().trim() == '') {
                RetVal = false; return false;
            }
        }
    });
    if (RetVal != true) {
        $("#lblStatus").text('');
        DisplayFriendlyMessage($("#LabelErrorMsg"), "Error", "Please select validation message for the mandatory fields");
    }
    return RetVal;
}
function AppointmentProviderSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hfAppID').val(e.get_value());
        $("#txtProvName").val(e.get_text());
        __doPostBack('<%# txtProvName.ClientID %>', 'OnTextChanged');
    }
    else {
        return false;
    }
}
function AppointmentCodSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hfProvCode').val(e.get_value());
        $("#txtProviderCode").val(e.get_text());
        __doPostBack('<%# txtProviderCode.ClientID %>', 'OnTextChanged');
    }
    else {
        return false;
    }
}
function OnProviderCodeCleared() {
    $("#hfProvCode").val('');
    ClearAppointmentProviderData();
}
function ClearAppointmentProviderData() {
    $("#txtProvName").val('');
    $("#txtProviderCode").val('');
    $("#txtContactNo").val('');
    $("#txtProvType").val('');
    $("#txtProvAddress").val('');
    $("#hdnProvEmail").val('');
}
function OnProviderNameCleared() {
    $("#hfAppID").val('');
    ClearAppointmentProviderData();
}
function AddReminder() {
    var confirmMsg = "Do you want to add an Appointment Reminder?";
    if (CustomConfirm(confirmMsg) == true) {
        $find("bidAddActivity").show();
        return true;
    }
    else {
        return false;
    }
}
function ValidateRoleCategory() {
    var lblRoleCatCount = $('#lblRoleCatCount');
    var lblRoleCategory = $('#lblRoleCategory');
    if (lblRoleCatCount[0].value == "") {
        lblRoleCategory[0].innerHTML = '*';
        return false;
    }
    else {
        lblRoleCategory[0].innerHTML = '';
        return true;
    }
}
function SetRoleCategoryCount(sender, eventArgs) {
    var lblRoleCatCount = $('#lblRoleCatCount');
    if (sender._checkedIndices.length == 0) {
        lblRoleCatCount[0].value = "";
    }
    else {
        lblRoleCatCount[0].value = "exists";
    }
}
function ChildCheck(GvId, chkObj, ChkAct) {
    var CurrTr = $(chkObj).closest('tr');
    var CurrId = $(CurrTr).find("#hdnAdd").val().split("_");
    var parentTable = $(CurrTr).closest(GvId);
    var dataresult = $(CurrTr).find("#lblMenuName").html();
    if (CurrId[1] == 0) {
        $(".pnlLinksView " + GvId).find("tr").each(function (index, el) {
            if ($(this).find("#hdnAdd").length > 0) {
                var CheckVal = $(this).find("#hdnAdd").val().split("_")[0];
                if (CheckVal == CurrId[0]) {
                    $(this).find(ChkAct).find("input:checkbox").prop("checked", chkObj.checked);
                    if (chkObj.checked) { $(this).find(".ItemChkView").find("input:checkbox").prop("checked", true); }
                    else if (ChkAct == ".ItemChkView") {
                        $(this).find(".ItemChkAdd").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkEdit").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkDelete").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkView").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkExport").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkEmail").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkPrint").find("input:checkbox").prop("checked", false);
                    }
                    if (ChkAct == ".ItemChkEdit" || ChkAct == ".ItemChkDelete") {
                        var linkName = $(this).find("#lblMenuName").text();
                        linkName = linkName != null && linkName != undefined ? linkName.toLocaleLowerCase() : linkName;
                        if (linkName != null && linkName != undefined && (linkName == 'activity record >> documents' || linkName == 'activity record >> notes' || linkName == 'um authorizations >> notes' || linkName == 'um authorizations >> documents' || linkName == 'ag complaints >> notes' || linkName == 'ag complaints >> letters and documents')) {
                            if (!(linkName == 'activity record >> documents' && ChkAct == ".ItemChkEdit")) {
                                $(this).find(".txt" + (ChkAct == ".ItemChkEdit" ? "Edit" : "Delete")).css("display", chkObj.checked ? "block" : "none");
                                $(this).find(".txt" + (ChkAct == ".ItemChkEdit" ? "Edit" : "Delete")).val("");
                            }
                        }
                    }
                }
            }
        });
    }
    else {
        if (chkObj.checked) { $(CurrTr).find(".ItemChkView").find("input:checkbox").prop("checked", true); }
        else if (ChkAct == ".ItemChkView") {
            $(CurrTr).find(".ItemChkAdd").find("input:checkbox").prop("checked", false);
            $(CurrTr).find(".ItemChkEdit").find("input:checkbox").prop("checked", false);
            $(CurrTr).find(".ItemChkDelete").find("input:checkbox").prop("checked", false);
            $(CurrTr).find(".ItemChkExport").find("input:checkbox").prop("checked", false);
            $(CurrTr).find(".ItemChkEmail").find("input:checkbox").prop("checked", false);
            $(CurrTr).find(".ItemChkPrint").find("input:checkbox").prop("checked", false);
        }
        if (ChkAct == ".ItemChkEdit" || ChkAct == ".ItemChkDelete") {
            var linkName = $(CurrTr).find("#lblMenuName").text();
            linkName = linkName != null && linkName != undefined ? linkName.toLocaleLowerCase() : linkName;
            if (linkName != null && linkName != undefined && (linkName == 'activity record >> documents' || linkName == 'activity record >> notes' || linkName == 'um authorizations >> notes' || linkName == 'um authorizations >> documents' || linkName == 'ag complaints >> notes' || linkName == 'ag complaints >> letters and documents')) {
                if (!(linkName == 'activity record >> documents' && ChkAct == ".ItemChkEdit")) {
                    $(CurrTr).find(".txt" + (ChkAct == ".ItemChkEdit" ? "Edit" : "Delete")).css("display", chkObj.checked ? "block" : "none");
                    $(CurrTr).find(".txt" + (ChkAct == ".ItemChkEdit" ? "Edit" : "Delete")).val("");
                }
            }
        }
    }
}
//Start Show or Hide GridView Columns According to selection
function MycareMemberColumnShowHideNew(sender, eventArgs) {

    var item = eventArgs.get_item();
    var selecValue = item.get_value();
    var check = item.get_checked();
    var hidden = $("#hdnSelectedColumn");
    if (hidden.val() != '') {
        var arr = hidden.val().split(",");
        if (arr.length > 0) {
            if (check) {
                hidden.val(hidden.val() + "," + selecValue);
            } else {
                arr.splice($.inArray(selecValue, arr), 1);
                hidden.val(arr.join(","));
            }
        }
    } else {
        hidden.val(selecValue);
    }
    var checkedElements = sender.get_checkedItems().length;
    if (checkedElements <= 7) {
        GridColumnShowHide(selecValue, check, 'gvCareMember1');
    } else {
        CustomAlert('You cannot select more than 7 columns');
        item.set_checked(false);
        //eventArgs._item._checkBoxElement.checked = false;
    }
}
function GridColumnShowHide(col_no, do_show, grid_id) {

    //Show or Hide columns in rows
    $("#" + grid_id + " tr").each(function (i) {
        $(this).find('td').each(function (j) {
            if (j == col_no) {
                if (do_show) {
                    $(this).show();

                } else {
                    $(this).hide();
                }

            }
        });

        //Show or Hide header in rows
        $(this).find('th').each(function (k) {
            if (k == col_no) {
                if (do_show) {
                    $(this).show();

                } else {
                    $(this).hide();
                }

            }
        });
    });

}
//End Show or Hide GridView Columns According to selection
function DocForm_ClearData() {
    $('#htmlDocForm  input:text[value!=""], #htmlDocForm  textarea[value!=""], #htmlDocForm  input:radio:checked, #htmlDocForm  input:checkbox:checked').each(function () {
        var ObjId = ""; ObjId = $(this).attr("id");
        if (ObjId.indexOf("_CB_") != -1 || ObjId.indexOf("_RB_") != -1) { $(this).attr('checked', false); }
        else if (ObjId.indexOf("_TB_") != -1 || ObjId.indexOf("_TA_") != -1) { $(this).val(''); }
    });
    return false;
}
function DocForm_GetData() {
    var RetVal = ""; var SplitRow = "|", SplitCol = "~"; var RetBool = false;
    $("#hdnFormHTMLData").val('');
    $('#htmlDocForm input:text[value!=""], #htmlDocForm  textarea[value!=""], #htmlDocForm  input:radio:checked, #htmlDocForm  input:checkbox:checked').each(function () {
        var ObjId = "", ObjVal = ""; ObjId = $(this).attr("id");
        if (ObjId.indexOf("_CB_") != -1 || ObjId.indexOf("_RB_") != -1) { ObjVal = $(this).attr("title"); }
        else if (ObjId.indexOf("_TB_") != -1 || ObjId.indexOf("_TA_") != -1) { ObjVal = $(this).val().trim(); }
        if (RetVal != "") { RetVal += SplitRow; }
        RetVal += ObjId + SplitCol + ObjVal.replace(SplitRow, "").replace(SplitCol, "");
    });
    if (RetVal != "") {
        RetVal = RetVal.replace(/[\r\n]/g, "");
        $("#hdnFormHTMLData").val(RetVal); RetBool = true;
    }
    if (RetBool != true) { CustomAlert("Please Enter Data."); }
    return RetBool;
}
function DocForm_GetPrintData() {
    var RetVal = ""; var SplitRow = "|", SplitCol = "~"; var RetBool = false;
    $("#hdnFormHTMLData").val('');
    $('#htmlDocForm input:text[value!=""], #htmlDocForm  textarea[value!=""], #htmlDocForm  input:radio:checked, #htmlDocForm  input:checkbox:checked').each(function () {
        var ObjId = "", ObjVal = ""; ObjId = $(this).attr("id");
        if (ObjId.indexOf("_CB_") != -1 || ObjId.indexOf("_RB_") != -1) { ObjVal = $(this).attr("title"); }
        else if (ObjId.indexOf("_TB_") != -1 || ObjId.indexOf("_TA_") != -1) { ObjVal = $(this).val(); }
        if (RetVal != "") { RetVal += SplitRow; }
        RetVal += ObjId + SplitCol + ObjVal.replace(SplitRow, "").replace(SplitCol, "");
    });
    return RetVal;
}
function DocForm_SetData(ResData) {
    var SplitRow = "|", SplitCol = "~";
    var RowSplit = ResData.split(SplitRow);
    for (var RI = 0; RI < RowSplit.length; RI++) {
        var ObjId = "", ObjVal = "";
        var ColSplit = null; ColSplit = RowSplit[RI].split(SplitCol);
        if (ColSplit.length > 0) { ObjId = "#" + ColSplit[0]; }
        if (ColSplit.length > 1) { ObjVal = ColSplit[1]; }
        if (ObjId.indexOf("_CB_") != -1 || ObjId.indexOf("_RB_") != -1) { $(ObjId).attr('checked', true); }
        else if (ObjId.indexOf("_TB_") != -1 || ObjId.indexOf("_TA_") != -1) { $(ObjId).val(ObjVal); }
    }
}
function DocForm_Enable() {
    $(document).ready(function () {
        $(".ObjInp").keyup(function () {
            var ObjId = "", BaseId = ""; var BaseObj = null, BaseSp = null, ObjRow = null;
            var ObjHdVa = "", ObjHdOp = "", ObjInpVal = "", ObjOutVal = "", ObjEval = "";
            var ObjTot = "", ObjAvg = "", ObjAvgVal = "", ObjResetVal = "0";
            ObjId = $(this).attr("id"); ObjRow = $(this).closest('tr');
            BaseSp = ObjId.split("_");
            if (BaseSp.length == 4) {
                BaseId = BaseSp[0] + "_" + BaseSp[1] + "_" + BaseSp[2];
                BaseObj = "[id^=" + BaseId + "]";
                ObjHdVa = $(".ObjHdVa:first", ObjRow).val(); ObjHdOp = $(".ObjHdOp:first", ObjRow).val(); ObjInpVal = $(this).val();

                if (isNaN(ObjInpVal) == true) { ObjInpVal = ""; $(this).val(''); }
                if (ObjHdOp == "!") {
                    ObjHdOp = "+";
                    if (ObjInpVal == "0" || ObjInpVal == "8") { ObjInpVal = ObjInpVal; }
                    else { ObjInpVal = "0"; $(this).val(''); }
                }
                else if (parseInt(ObjInpVal) > 4) {
                    if (ObjHdOp == "-") { ObjResetVal = "4"; }
                    if (ObjHdOp == "+") { ObjResetVal = "0"; }
                    ObjInpVal = ObjResetVal; $(this).val(''); ObjInpVal = "";
                }
                if (ObjInpVal == "") { ObjInpVal = ObjHdVa; }
                if (ObjHdVa != undefined) { ObjHdVa = parseInt(ObjHdVa); }

                ObjEval = ObjHdVa + ObjHdOp + ObjInpVal;
                ObjOutVal = eval(ObjEval);
                $(".ObjOut:first", ObjRow).val(ObjOutVal);

                var ObjSecTotVal = 0; var ObjQueNo = 0; var ObjQueRes = 0;
                $(BaseObj).filter(".ObjOut").each(function () {
                    if ($(this).val() != "") {
                        ObjQueRes = ObjQueRes + 1;
                        ObjSecTotVal = ObjSecTotVal + parseInt($(this).val());
                    }
                });
                ObjQueNo = $(BaseObj).filter(".ObjOut").length;

                if ($(BaseObj).filter(".ObjTot").length > 0) { $(BaseObj).filter(".ObjTot:first").val(ObjSecTotVal); }
                if ($(BaseObj).filter(".ObjMul").length > 0) { $(BaseObj).filter(".ObjMul:first").val(ObjSecTotVal * ObjQueNo); }

                if ($(BaseObj).filter(".ObjAvg").length > 0) {
                    //ObjAvgVal = (ObjSecTotVal * ObjQueNo) / ObjQueNo;
                    ObjAvgVal = ObjSecTotVal / ObjQueRes;
                    $(BaseObj).filter(".ObjAvg:first").val(ObjAvgVal);
                    var ObjTotBot = $(BaseObj).filter(".ObjAvg:first").attr("class").split(/\s+/);
                    var ObjBotTot = "." + ObjTotBot[1];
                    $(ObjBotTot, "#ObjBotCtrl").each(function () {
                        $(this).val(ObjAvgVal);
                    });
                }
                var ObjBotTotVal = 0; var ObjFinHH = 0; var ObjMaxTot = 0;
                $(".ObjInp", "#ObjBotCtrl").each(function () {
                    if ($(this).val() != "") { ObjBotTotVal = ObjBotTotVal + parseInt($(this).val()); }
                });
                if ($("#ObjBotCtrl").find(".ObjOut").length > 0) { $("#ObjBotCtrl").find(".ObjOut:first").val(ObjBotTotVal); }

                if ($(".ObjTotHH:first").length == 1) { ObjFinHH = $(".ObjTotHH:first").val(); }
                if ($(".ObjFinHH:first").length == 1) {
                    $(".ObjFinHH:first").val('0');
                    if (ObjFinHH > 0) { $(".ObjFinHH:first").val(ObjFinHH); }
                }
                if ($(".ObjFinTot:first").length == 1) {
                    $(".ObjFinTot:first").val('0');
                    if (ObjBotTotVal > 0) { $(".ObjFinTot:first").val(ObjBotTotVal); }
                }
                ObjMaxTot = parseInt(ObjBotTotVal) + parseInt(ObjFinHH);
                if ($(".ObjMaxTot:first").length == 1) {
                    $(".ObjMaxTot:first").val('0');
                    if (ObjMaxTot > 0) { $(".ObjMaxTot:first").val(ObjMaxTot); }
                    else { $(".ObjMaxTot:first").val(ObjBotTotVal); }
                }
            }
        });
    });
}
function DocForm_Print(inpVal) {
    if (inpVal == true) {
        var MyData = DocForm_GetPrintData();

        var printContents = $("#htmlDocForm").clone();
        var disp_setting = "toolbar=yes,location=no,directories=yes,menubar=yes,";
        disp_setting += "scrollbars=yes,width=930, height=600, left=100, top=25";

        var PrintStyle = "<style>";
        PrintStyle += ".htmlDocForm {padding:10px;font-size:14px;border:1px solid #000;}";
        PrintStyle += ".htmlDocForm tr{padding:2px;}";
        PrintStyle += ".htmlDocForm td{padding:2px;}";
        PrintStyle += ".htmlDocForm ul li {list-style-type:disc;}";
        PrintStyle += "</style>";

        var docprint = window.open("url", (window.browserPopUpName || window.top.browserPopUpName), disp_setting);
        docprint.document.writeln("<html><head>" + PrintStyle + "</head><body onfocus='window.close();'><div id='htmlDocForm'>");
        docprint.document.writeln(document.getElementById("htmlDocForm").innerHTML);
        docprint.document.writeln("</div></body></html>");
        var $pdoc = docprint.document.body;
        DocForm_PrintData($pdoc, MyData);
        docprint.print();
        docprint.document.close();
        docprint.focus();
    }
    return false;
}
function DocForm_PrintData(pdoc, ResData) {
    var SplitRow = "|", SplitCol = "~";
    var RowSplit = ResData.split(SplitRow);
    for (var RI = 0; RI < RowSplit.length; RI++) {
        var ObjId = "", ObjVal = "";
        var ColSplit = null; ColSplit = RowSplit[RI].split(SplitCol);
        if (ColSplit.length > 0) { ObjId = "#" + ColSplit[0]; }
        if (ColSplit.length > 1) { ObjVal = ColSplit[1]; }
        if (ObjId.indexOf("_CB_") != -1 || ObjId.indexOf("_RB_") != -1) {
            $(pdoc).find(ObjId).prop("checked", true);
        }
        else if (ObjId.indexOf("_TB_") != -1 || ObjId.indexOf("_TA_") != -1) {
            $(pdoc).find(ObjId).val(ObjVal);
        }
    }
}
function AddDouble(Before, AfterStr, AfterVal) {
    var RV = "";
    RV += Before; RV += '\"';
    RV += AfterStr; RV += AfterVal;
    RV += '\"';
    return RV;
}
function CreateArray(ArrayData, Unique) {
    var RetArrayData = new Array();
    var ArrayDataSplit = ArrayData.split(',');
    if (ArrayDataSplit.length > 0) {
        for (var XI = 0; XI < ArrayDataSplit.length; XI++) {
            if ($.trim(ArrayDataSplit[XI]) != "") {
                AddArrayItem(RetArrayData, $.trim(ArrayDataSplit[XI]), Unique);
            }
        }
    }
    return RetArrayData;
}
function AddArrayItem(MyArray, ItemVal, Unique) {
    var ItemHave = false;
    for (var XI = 0; XI < MyArray.length; XI++) {
        if (MyArray[XI] == ItemVal) { ItemHave = true; break; }
    }
    if (ItemHave == false) {
        MyArray.push(ItemVal);
    }
    else if (ItemHave == true && Unique == false) {
        MyArray.push(ItemVal);
    }
    return MyArray;
}
function ClassSubOption(SubOptionVal) {
    var SubOption = new Object();
    SubOption.QuestionId = ""; SubOption.OptionId = "";
    SubOption.SuboptionId = ""; SubOption.SuboptionText = "";
    SubOption.SubOptOpportunityId = ""; SubOption.SubOptScore = "0.00";
    if (SubOptionVal != null) {
        SubOptionData = SubOptionVal.split('~');
        if (SubOptionData.length > 0) {
            if (SubOptionData.length > 0) { SubOption.QuestionId = SubOptionData[0]; }
            if (SubOptionData.length > 1) { SubOption.OptionId = SubOptionData[1]; }
            if (SubOptionData.length > 2) { SubOption.SuboptionId = SubOptionData[2]; }
            if (SubOptionData.length > 3) { SubOption.SuboptionText = SubOptionData[3]; }
            if (SubOptionData.length > 4) { SubOption.SubOptOpportunityId = SubOptionData[4]; }
            if (SubOptionData.length > 5) { SubOption.SubOptScore = SubOptionData[5]; }
        }
    }
    return SubOption;
}
function GetSubOptionRows(SubOptionValues) {
    var SubOptionRows = []; var SubOptionData = null;
    SubOptionDataRows = SubOptionValues.split('§');
    for (var SR = 0; SR < SubOptionDataRows.length; SR++) {
        SubOptionData = null; SubOptionData = ClassSubOption(SubOptionDataRows[SR]);
        SubOptionRows.push(SubOptionData);
    }
    return SubOptionRows;
}
function SetSubOption(SubOptTitle, SubOptType, SubOptionData) {
    var SubOptionDataRows = null;
    var XData = new Array(); var YData = new Array();
    if (SubOptTitle == "") { SubOptTitle = null; }
    DisplaySubOption(null, SubOptTitle);
    if (SubOptType == "1" || SubOptType == "2" || SubOptType == "3" || SubOptType == "4") {
        DisplaySubOption(SubOptType, SubOptTitle);
    }
    if (SubOptionData == "") { return; }
    SubOptionDataRows = GetSubOptionRows(SubOptionData);
    DisplaySubOption(SubOptType, SubOptTitle);

    if (SubOptType == "5" || SubOptType == "6" || SubOptType == "7" || SubOptType == "8") {
        SubOptionItems(SubOptionDataRows);
    }
    else if (SubOptType == "9") {
        for (var SR = 0; SR < SubOptionDataRows.length; SR++) {
            XYDataVal = null;
            XYDataVal = SubOptionDataRows[SR].SuboptionText.split('|');
            if (XYDataVal.length == 2) {
                YData = AddArrayItem(YData, XYDataVal[0], true);
                XData = AddArrayItem(XData, XYDataVal[1], true);
            }
        }
        if (XData.length > 0 && YData.length > 0) {
            $("#Txt_RankXData").val(XData);
            $("#Txt_RankYData").val(YData);
            GenrateRanking(XData, YData, SubOptionDataRows);
        }
    }
}
function ButAttr(ValId, ValEna) {
    if (ValEna == 1) { $(ValId).removeAttr("disabled"); return; }
    $(ValId).attr("disabled", "disabled");
}
function DisplaySubOption(SubOptType, SubOptTitle) {
    if (SubOptType == "5" || SubOptType == "6" || SubOptType == "7" || SubOptType == "8" || SubOptType == "9") {
        //$("#Ddl_Opportunity").val('00');
        ButAttr("#BtnAqSave", 0);
    }
    else { ButAttr("#BtnAqSave", 1); }
    var $SubOptTitle = "", $SubOptXData = "", $SubOptYData = "", $SubOptHeader = "";
    $SubOptTitle += "<li style=\"padding:5px;\"><span><b>Sub Option Title</b> &nbsp; &nbsp;";
    $SubOptTitle += "<span id=\"Valid_11\" class=\"Valid\" style=\"display:none;\">*</span> <input type=\"text\" id=\"Txt_SubOptTitle\" style=\"width:335px;\" /></span></li>";

    $SubOptXData += "<li style=\"padding:5px;\">";
    $SubOptXData += "<span><b>Ranking - X Data</b> &nbsp; <span id=\"Valid_12\" class=\"Valid\" style=\"display:none;\">*</span> <input type=\"text\" id=\"Txt_RankXData\" onkeyup=\"ButAttr('#BtnAqSave', 0);\" style=\"width:335px\" /></span>";
    $SubOptXData += "</li>";

    $SubOptYData += "<li style=\"padding:5px;\">";
    $SubOptYData += "<span><b>Ranking - Y Data</b> &nbsp; <span id=\"Valid_13\" class=\"Valid\" style=\"display:none;\">*</span> <input type=\"text\" id=\"Txt_RankYData\" onkeyup=\"ButAttr('#BtnAqSave', 0);\" style=\"width:335px\" /> &nbsp; ";
    $SubOptYData += "<input type=\"button\" value=\"Generate\" onclick=\"CreateRanking();\" /></span>";
    $SubOptYData += "</li>";

    $SubOptHeader += "<li style=\"background-color:#EAEAEA;color:Black;font-weight:bold;padding:5px;\">";
    $SubOptHeader += "<span>Sub Option Text</span>";
    $SubOptHeader += "<span style=\"width:250px;float:right;\">";
    $SubOptHeader += "<span style=\"width:70px;\">Scores</span>";
    $SubOptHeader += "<span style=\"float:right;\">Opportunity <img src=\"imagehandler.ashx?img=spacer.gif\" width=\"20\" height=\"2\"/></span>";
    $SubOptHeader += "</span>";
    $SubOptHeader += "</li>";

    $("#SubOption_Row1").hide(); $("#SubOption_Head").hide(); $("#SubOption_Row2").hide();
    $(".SubOptionHead_Col").hide(); $("#SubOption_Data").hide();
    $("#UL_SubOptionsView").html('');


    $("#UL_SubOptionsView").append($SubOptTitle);
    if (SubOptType != null) {
        if (SubOptType == "00" || SubOptType == "0") { SubOptType = null; }
    }
    if (SubOptType != null) {
        $("#Txt_SubOptTitle").val('');
        $("#SubOption_Row1").show(); $("#SubOption_Head").show(); $("#SubOption_Row2").show(); $("#SubOption_Data").show();
    }
    if (SubOptTitle != null) { $("#Txt_SubOptTitle").val(SubOptTitle); }

    if (SubOptType == null) { return; }
    if (SubOptType == "00") { $("#Txt_SubOptTitle").val(''); return; }

    $("#SubOption_Row1").show(); $("#SubOption_Head").show(); $("#SubOption_Row2").show();
    $("#SubOption_Data").show();

    $("#UL_SubOptionsView #LiSubOpt_Title").show();

    if (SubOptType == "5" || SubOptType == "6" || SubOptType == "7" || SubOptType == "8") {
        $(".SubOptionHead_Col").show();
        $("#UL_SubOptionsView").append($SubOptHeader);
    }
    else if (SubOptType == "9") {
        $("#UL_SubOptionsView").append($SubOptXData);
        $("#UL_SubOptionsView").append($SubOptYData);

        $("#Txt_RankXData").val(''); $("#Txt_RankYData").val('');
    }
}
function CreateRanking() {
    var RankXData = $("#Txt_RankXData").val();
    var RankYData = $("#Txt_RankYData").val();
    var XDataArray = new Array(); var YDataArray = new Array();
    XDataArray = CreateArray(RankXData, true);
    YDataArray = CreateArray(RankYData, true);
    $("#Txt_RankXData").val(XDataArray); $("#Txt_RankYData").val(YDataArray);
    GenrateRanking(XDataArray, YDataArray, null);
    ButAttr('#BtnAqSave', 1);
}
function GetRankData(YData, XData, SubOptData) {
    var SuboptionText = ""; var SuboptionXYData = YData + "|" + XData;
    var SubId = ""; var SubScore = ""; var SubScore = "";
    for (var SR = 0; SR < SubOptData.length; SR++) {
        SuboptionText = ""; SuboptionText = SubOptData[SR].SuboptionText;
        if (SuboptionText == SuboptionXYData) {
            SubId = SubOptData[SR].SuboptionId;
            SubOptOpp = SubOptData[SR].SubOptOpportunityId;
            SubScore = SubOptData[SR].SubOptScore;
            break;
        }
    }
    return { SubOptId: SubId, SubOptOppId: SubOptOpp, SubOptScore: SubScore };
}
function GenrateRanking(RankXData, RankYData, SubOptData) {
    if (RankXData == null || RankYData == null) { return; }
    var $DataHtml = ""; $XDataHtml = ""; var $YDataHtml = "";
    var SubOptVal = null; var SubOptIdVal = new Array();
    if (RankXData.length > 0 && RankYData.length > 0) {
        ButAttr("#BtnAqSave", 1);
        var $OptOpportunity = $("#Ddl_Opportunity").html();
        var SelId = ""; var Selval = AddDouble(" selected=", "", "selected");
        $OptOpportunity = $OptOpportunity.replace(Selval, "");

        $($("#UL_SubOptionsView li").get(2)).nextAll("li").remove();
        $XDataHtml += "<li style=\"padding:5px;clear:both;\" class=\"DataLi\">";
        $XDataHtml += "<table border=\"0\" cellpadding=\"2\" cellspacing=\"2\" width=\"100%\">";
        $XDataHtml += "<tr class=\"DataRow\"><td style=\"width:150px;align:left;\"></td>";
        for (var XI = 0; XI < RankXData.length; XI++) {
            $XDataHtml += "<td" + AddDouble(" id=", "TD_", XI + 1) + " style=\"width:100px;align:left;\"><b>" + RankXData[XI] + "</b></td>";
        }
        $XDataHtml += "</tr>";
        for (var YI = 0; YI < RankYData.length; YI++) {
            $YDataHtml += "<tr><td colspan=\"100%\"><img src=\"imagehandler.ashx?img=spacer.gif\" width=\"5\" height=\"10\"/></td></tr>";
            $YDataHtml += "<tr class=\"DataRow\"><td" + AddDouble(" id=", "TR_", YI + 1) + " style=\"width:100px;align:left;\"><b>" + RankYData[YI] + "</b></td>";
            for (var XI = 0; XI < RankXData.length; XI++) {
                $YDataHtml += "<td" + AddDouble(" id=", "TRTD_", (YI + 1) + "_" + (XI + 1)) + " style=\"width:100px;align:left;\">";
                $YDataHtml += "<span class=\"Edit\" style=\"display:none;\">";

                if (SubOptData != null) {

                    SubOptVal = null; SubOptVal = GetRankData(RankYData[YI], RankXData[XI], SubOptData);
                    $YDataHtml += "<input type='hidden' id='Hdn_SubOptId'";
                    if (SubOptVal.SubOptId != "") { $YDataHtml += AddDouble(" value=", "", SubOptVal.SubOptId); }
                    $YDataHtml += "/>";

                    $YDataHtml += "<b>Opportunity</b><br>";
                    $YDataHtml += "<select class='Width150'";
                    if (SubOptVal.SubOptOppId != "") { $YDataHtml += AddDouble(" id=", "DDL_SubOptOppr_", SubOptVal.SubOptId); SubOptIdVal.push(SubOptVal.SubOptId + "|" + SubOptVal.SubOptOppId); }
                    else { $YDataHtml += " id='DDL_SubOptOppr'"; }
                    $YDataHtml += ">";
                    $YDataHtml += $OptOpportunity;
                    $YDataHtml += "</select>";

                    $YDataHtml += "<br><b>Scores</b><img src=\"imagehandler.ashx?img=spacer.gif\" title=\"Edit\" width=\"20px\"/>";
                    $YDataHtml += "<input type='text' id='Txt_SubOptScores' class='Width50'";
                    if (SubOptVal.SubOptScore != "") { $YDataHtml += AddDouble(" value=", "", SubOptVal.SubOptScore); }
                    $YDataHtml += "/>";

                }
                else {
                    $YDataHtml += "<input type='hidden' id='Hdn_SubOptId'/>";
                    $YDataHtml += "<b>Opportunity</b><br><select class=\"Width150\" id=\"DDL_SubOptOppr\">" + $OptOpportunity + "</select>";
                    $YDataHtml += "<br><b>Scores</b><img src=\"imagehandler.ashx?img=spacer.gif\" title=\"Edit\" width=\"20px\"/><input value='0.00' type=\"text\" id=\"Txt_SubOptScores\" class=\"Width50\" />";
                }

                $YDataHtml += " <img id='Save' src=\"imagehandler.ashx?img=ItemOk.png\" onclick=\"DisplaySubOptionHide(this);\" alt=''/>";
                $YDataHtml += "</span>";
                $YDataHtml += "<span class=\"Show\">";
                $YDataHtml += "<img id='Edit' src=\"imagehandler.ashx?img=btnGridEdit.png\" title=\"Edit\" onclick=\"DisplaySubOptionShow(this," + (YI + 1) + "," + (XI + 1) + ");\" alt=''/>";
                $YDataHtml += "</span>";
                $YDataHtml += "</td>";
            }
            $YDataHtml += "</tr>";
        }
        $YDataHtml += "</table></li>";
        $DataHtml = $XDataHtml + $YDataHtml;
        $($DataHtml).insertAfter($("#UL_SubOptionsView li").get(2));
    }
    if (SubOptData != null) {
        var ValSplit = null; var SelDdlId = ""; var SelDdlVal = "";
        for (var SD = 0; SD < SubOptIdVal.length; SD++) {
            ValSplit = ""; SelDdlId = ""; SelDdlVal = "";
            ValSplit = SubOptIdVal[SD].split('|');
            if (ValSplit.length == 2) {
                SelDdlId = "#DDL_SubOptOppr_" + ValSplit[0]; SelDdlVal = ValSplit[1];
                $("#UL_SubOptionsView").find(SelDdlId).val(SelDdlVal);
            }
        }
    }
}
function DisplaySubOptionShow(ImgObj, R, C) {
    var ColId = "#TD_" + C; var RowId = "#TR_" + R; var RowColId = "#TRTD_" + R + "_" + C;
    $(ImgObj).parents("table").find(".Edit").hide();
    $(ImgObj).parents("table").find(".Show").hide();

    $($(ImgObj).parents("table").find('td[id*="TD_"]')).each(function (i) {
        $(this).attr('style', 'color:black;text-decoration:none;width:100px;align:left;');
    });
    $($(ImgObj).parents("table").find('td[id*="TR_"]')).each(function (i) {
        $(this).attr('style', 'color:black;text-decoration:none;width:100px;align:left;');
    });
    $($(ImgObj).parents("table").find('td[id*="TRTD_"]')).each(function (i) {
        $(this).attr('style', 'color:black;text-decoration:none;width:100px;align:left;');
    });

    $($(ImgObj).parents("table").find(ColId)).attr('style', 'color:blue;text-decoration:underline;width:200px;align:left;');
    $($(ImgObj).parents("table").find(RowId)).attr('style', 'color:blue;text-decoration:underline;align:left;');
    $($(ImgObj).parents("table").find(RowColId)).attr('style', 'width:200px;align:left;');

    $(ImgObj).parent().parent().find(".Edit").show();

}
function DisplaySubOptionHide(ImgObj) {
    $($(ImgObj).parents("table").find('td[id*="TD_"]')).each(function (i) {
        $(this).attr('style', 'color:black;text-decoration:none;width:100px;align:left;');
    });
    $($(ImgObj).parents("table").find('td[id*="TR_"]')).each(function (i) {
        $(this).attr('style', 'color:black;text-decoration:none;width:100px;align:left;');
    });
    $($(ImgObj).parents("table").find('td[id*="TRTD_"]')).each(function (i) {
        $(this).attr('style', 'color:black;text-decoration:none;width:100px;align:left;');
    });

    $(ImgObj).parents("table").find(".Edit").hide();
    $(ImgObj).parents("table").find(".Show").show();
}
function DeleteSubOption(ImgObj, ImgTitle) {
    var CV = CustomConfirm(ImgTitle);
    if (CV == true) {
        $(ImgObj).parent().parent().parent().remove().fadeOut(500);
    }
}
function AddMoreSubItems() {
    var SubOptCount = $("#Txt_SubOptCount").val();
    $("#Txt_SubOptCount").val('');
    if (isNaN(SubOptCount) == true) { return; }
    ButAttr("#BtnAqSave", 1);
    var SubOptionRows = []; var SubOptionData = null;
    for (var SR = 0; SR < SubOptCount; SR++) {
        SubOptionData = null; SubOptionData = ClassSubOption(null);
        SubOptionRows.push(SubOptionData);
    }
    SubOptionItems(SubOptionRows);
}
function SubOptionItems(SubOptData) {
    var $OptOpportunity = $("#Ddl_Opportunity").html();
    var SelId = ""; var Selval = AddDouble(" selected=", "", "selected");
    $OptOpportunity = $OptOpportunity.replace(Selval, "");
    for (var SV = 0; SV < SubOptData.length; SV++) {
        var $InsertHtml = ""; var SubOptText = ""; var SubOptOpportunity = ""; var SubOptScore = ""; SelId = "";
        if (SubOptData[SV].SuboptionText != "") { SubOptText = AddDouble(" value=", "", SubOptData[SV].SuboptionText); }
        $InsertHtml += "<li style=\"padding:5px;clear:both;\" class=\"DataLi\">";

        $InsertHtml += "<input type='hidden' id='Hdn_SubOptId'";
        if (SubOptData[SV].SuboptionId != "") { $InsertHtml += AddDouble(" value=", "", SubOptData[SV].SuboptionId); }
        $InsertHtml += "/>";

        $InsertHtml += "<span style='float:left;'><input type='text' id='Txt_SubOptText'" + SubOptText + " class='Width250'/></span>";
        $InsertHtml += "<span style=\"width:450px;float:right;\">";

        $InsertHtml += "<span style='width:60px;'>"
        $InsertHtml += "<input type='text' id='Txt_SubOptScores' class='Width50'";
        if (SubOptData[SV].SubOptScore != "") { $InsertHtml += AddDouble(" value=", "", SubOptData[SV].SubOptScore); }
        $InsertHtml += "/>";
        $InsertHtml += "</span>";

        $InsertHtml += "<span style=\"width:350px;float:right;\">";
        $InsertHtml += "<select class='Width300'";
        if (SubOptData[SV].SubOptOpportunityId != "") { $InsertHtml += AddDouble(" id=", "DDL_SubOptOppr_", SubOptData[SV].SuboptionId); SelId = "#DDL_SubOptOppr_" + SubOptData[SV].SuboptionId; }
        else { $InsertHtml += " id='DDL_SubOptOppr'"; }
        $InsertHtml += ">";
        $InsertHtml += $OptOpportunity;
        $InsertHtml += "</select>";
        $InsertHtml += " &nbsp; <img src=\"imagehandler.ashx?img=btnGridDelete.png\" title=\"Delete\" onclick=\"DeleteSubOption(this,'Are you sure you want to delete this SubOption?');\" alt=''/>";
        $InsertHtml += "</span>";
        $InsertHtml += "</span>";
        $InsertHtml += "</li>";
        $("#UL_SubOptionsView").append($InsertHtml);
        if (SubOptData[SV].SubOptOpportunityId != "" && SelId != "") { $("#UL_SubOptionsView").find(SelId).val(SubOptData[SV].SubOptOpportunityId); }
    }
}
function Valid_SaveQuestion() {
    var RetVal = true; var SubVal = true; var ValidAll = true;
    var hdnQuestionId = $("#Hdn_QuestionId").val();
    var hdnOptionId = $("#Hdn_OptId").val();
    var optValue = $("#Hdn_OptAct").val();
    if (optValue == "") { ValidAll = false; }
    if (ValidAll == false && $("#Txt_OptName").val() != "") { ValidAll = true; }

    var txtQuestionName = $("#Txt_QuestionName").val();
    var ddlQuestionNo = $("#DDL_QuestionNo").val();
    var txtOptName = $("#Txt_OptName").val();
    var txtOptScore = $("#Txt_OptScore").val();
    var SubOptType = $("#DDL_SubOptType").val();
    var AdminOptType = $("#ddlOptionType").val();
    var txtSubOptTitle = ""; var txtRankXData = ""; var txtRankYData = "";
    var txtSubOptTitle = $("#Txt_SubOptTitle").val();
    if (txtQuestionName == "") { CustomAlert("Please Enter Question"); return false; }
    if (ddlQuestionNo == "") { CustomAlert("Please Select Question No"); return false; }
    if (AdminOptType == "" || AdminOptType == "00" || AdminOptType == "0") { CustomAlert("Please Select Option Type"); return false; }
    if (SubOptType == "" || SubOptType == "00") { $("#Hdn_SubOptTitle").val(''); $("#Hdn_SubOptionData").val(''); }
    if (ValidAll == false) { return RetVal; }
    if (txtOptName == "") { CustomAlert("Please Enter Option"); return false; }
    if (txtOptScore != "") {
        if (isNaN(txtOptScore)) {
            CustomAlert("Please Enter Number for Suboption Score"); return false;
        }
    }
    if (SubOptType != "" && SubOptType != "00") {
        txtSubOptTitle = $("#Txt_SubOptTitle").val();
        if (txtSubOptTitle == "") { CustomAlert("Please Enter Suboption Title"); return false; }
        if (SubOptType == "9") {
            txtRankXData = $("#Txt_RankXData").val(); txtRankYData = $("#Txt_RankYData").val();
            if (txtRankXData == "") { CustomAlert("Please Enter XData For Ranking"); return false; }
            if (txtRankYData == "") { CustomAlert("Please Enter YData For Ranking"); return false; }
        }
    }
    if (RetVal == true) {
        if (SubOptType == "1" || SubOptType == "2" || SubOptType == "3" || SubOptType == "4") {
            SubVal = Validate_LbTbTaDp();
        }
        else if (SubOptType == "5" || SubOptType == "6" || SubOptType == "7" || SubOptType == "8") {
            SubVal = Validate_DdLbCbRb();
            if (SubVal == true) {
                var $DataLi = $("#UL_SubOptionsView").find(".DataLi");
                if ($DataLi.length <= 0) {
                    CustomAlert("Please Enter Suboption Values");
                    SubVal = false;
                }
            }
        }
        else if (SubOptType == "9") {
            SubVal = Validate_Ranking();
        }
        RetVal = SubVal;
    }
    return RetVal;
}
function Validate_LbTbTaDp() {
    var SelVal = true; var SelMess = "";
    var SubOptTitle = ""; SubOptTitle = $("#Txt_SubOptTitle").val();
    var SubQuestionId = ""; SubQuestionId = $("#Hdn_QuestionId").val();
    var SubOptionId = ""; SubOptionId = $("#Hdn_OptId").val();
    if (SubQuestionId == "") { SubQuestionId = "0"; }
    if (SubOptionId == "") { SubOptionId = "0"; }

    $("#Hdn_SubOptTitle").val(''); $("#Hdn_SubOptionData").val('');
    $("#Hdn_SubOptTitle").val(SubOptTitle);
    return SelVal;
}
function Validate_DdLbCbRb() {
    var SelVal = true; var SelMess = "";
    var SubOptTitle = ""; SubOptTitle = $("#Txt_SubOptTitle").val();
    var SubQuestionId = ""; SubQuestionId = $("#Hdn_QuestionId").val();
    var SubOptionId = ""; SubOptionId = $("#Hdn_OptId").val();
    if (SubQuestionId == "") { SubQuestionId = "0"; }
    if (SubOptionId == "") { SubOptionId = "0"; }
    var SubOptionQuestionId = SubQuestionId + "~" + SubOptionId;

    var SubOptionData = "";
    $("#Hdn_SubOptTitle").val(''); $("#Hdn_SubOptionData").val('');
    $("#Hdn_SubOptTitle").val(SubOptTitle);

    var $DataLi = $("#UL_SubOptionsView").find(".DataLi");
    for (var DL = 0; DL < $DataLi.length; DL++) {
        var $SubOptid = null; $SubOptid = $($DataLi[DL]).find("#Hdn_SubOptId");
        var $SubOptText = null; $SubOptText = $($DataLi[DL]).find("#Txt_SubOptText");
        var $SubOptScores = null; $SubOptScores = $($DataLi[DL]).find("#Txt_SubOptScores");
        var $SubOptOpportunity = null; $SubOptOpportunity = $($DataLi[DL]).find("select[id*='DDL_SubOptOppr']");
        var SelId1 = ""; var SelVal1 = ""; var SelVal2 = ""; var SelVal3 = ""; SelMess = "";
        SelId1 = $($SubOptid).val(); if (SelId1 == "") { SelId1 = "0"; }
        SelVal1 = $($SubOptText).val();
        SelVal2 = $($SubOptScores).val();
        SelVal3 = $($SubOptOpportunity).val();
        if (SelVal1 == "") { SelMess = "Please Enter Suboption Text"; SelVal = false; }
        else if (isNaN(SelVal2) == true) { SelMess = "Please Enter Number for Suboption Score"; SelVal = false; }
        if (SelVal == false) {
            if (SelMess != "") { CustomAlert(SelMess + " For Suboption ( " + (DL + 1) + " )"); }
            break;
        }
        if (SubOptionData != "") { SubOptionData += "§"; }
        SubOptionData += SubOptionQuestionId + "~" + SelId1 + "~" + SelVal1 + "~" + SelVal3 + "~" + SelVal2;
    }
    if (SelVal == true) { $("#Hdn_SubOptionData").val(SubOptionData); }
    return SelVal;
}
function Validate_Ranking() {
    var RankXData = $("#Txt_RankXData").val();
    var RankYData = $("#Txt_RankYData").val();
    var XDataArray = new Array(); var YDataArray = new Array();
    XDataArray = CreateArray(RankXData, true);
    YDataArray = CreateArray(RankYData, true);

    var SelVal = true; var SelMess = "";
    var SubOptTitle = ""; SubOptTitle = $("#Txt_SubOptTitle").val();
    var SubQuestionId = ""; SubQuestionId = $("#Hdn_QuestionId").val();
    var SubOptionId = ""; SubOptionId = $("#Hdn_OptId").val();
    if (SubQuestionId == "") { SubQuestionId = "0"; }
    if (SubOptionId == "") { SubOptionId = "0"; }
    var SubOptionQuestionId = SubQuestionId + "~" + SubOptionId;

    var SubOptionData = "";

    $("#Hdn_SubOptTitle").val(''); $("#Hdn_SubOptionData").val('');
    $("#Hdn_SubOptTitle").val(SubOptTitle);
    var $ImgObj = null;
    var $DataRow = $("#UL_SubOptionsView").find(".DataRow");
    if ($DataRow.length > 0) {
        for (var DR = 0; DR < $DataRow.length; DR++) {
            if (DR > 0) {
                var $DataCol = null; $DataCol = $($DataRow[DR]).find("td");
                for (var DC = 0; DC < $DataCol.length; DC++) {
                    if (DC > 0) {
                        $ImgObj = null; $ImgObj = $($DataCol[DC]).find("#Edit");
                        var $SubOptid = null; $SubOptid = $($DataCol[DC]).find("#Hdn_SubOptId");
                        var $SubOptScores = null; $SubOptScores = $($DataCol[DC]).find("#Txt_SubOptScores");
                        var $SubOptOpportunity = null; $SubOptOpportunity = $($DataCol[DC]).find("select[id*='DDL_SubOptOppr']");
                        var SelId1 = ""; var SelVal1 = ""; var SelVal2 = ""; SelMess = "";
                        SelId1 = $($SubOptid).val(); if (SelId1 == "") { SelId1 = "0"; }
                        SelVal1 = $($SubOptScores).val();
                        SelVal2 = $($SubOptOpportunity).val();
                        if (isNaN(SelVal1) == true) { SelMess = "Please Enter Number for Suboption Score"; SelVal = false; }
                        if (SelVal == false) {
                            //if (SelMess != "") { alert(SelMess + " For ( " + YDataArray[DR - 1] + " " + XDataArray[DC - 1] + " )"); }
                            if (SelMess != "") { SelMess += " For ( " + YDataArray[DR - 1] + " " + XDataArray[DC - 1] + " )"; }
                            DisplaySubOptionShow($ImgObj, DR, DC);
                            break;
                        }
                        if (SubOptionData != "") { SubOptionData += "§"; }
                        SubOptionData += SubOptionQuestionId + "~" + SelId1 + "~" + YDataArray[DR - 1] + "|" + XDataArray[DC - 1] + "~" + SelVal2 + "~" + SelVal1;
                    }
                }
                if (SelVal == false) { break; }
            }
        }
    }
    else {
        SelVal = false;
    }
    if (SelVal == true) { $("#Hdn_SubOptionData").val(SubOptionData); }
    if ($("#Hdn_SubOptionData").val() == "") { SelVal = false; }
    if (SelVal == false) {
        if (SelMess != "") { CustomAlert(SelMess); }
        else { CustomAlert("Please Check Ranking Data.."); }
    }
    return SelVal;
}
/*Validaions in adminquestion page*/
function scriptValidation(type) {


    var question = $('textarea#Txt_QuestionName').val();
    if (question == '') {
        CustomAlert('Please enter question');
        return false;
    }

    var ddlOptionType = $('#ddlOptionType :selected').text()
    //    var ddval = $('select[name*="ddlOptionType"] option:selected').val();
    //    var ddtext = $('select[name*="ddlOptionType"] option:selected').text();
    if (ddlOptionType == 'Select') {
        CustomAlert('Please select option type');
        return false;
    }
    if (type == '1') {
        return true;
    }

    var option = $('textarea#Txt_OptName').val();

    if (option == '') {
        CustomAlert('Please enter option');
        return false;
    }


    var subOption = '';
    var ddlSubOptionType = '';

    if (type = '2') {
        //$('textarea[name=message]').val();
        subOption = $('textarea#txtSubOptionText').val();
        ddlSubOptionType = $('#DDL_SubOptType  :selected').text();

        if (subOption != '' && ddlSubOptionType != 'Select' && ddlSubOptionType != '') {
            return gridvalidation(ddlSubOptionType);
        }
        if (subOption != '' && subOption != null) {
            if (ddlSubOptionType == 'Select' || ddlSubOptionType == '') {
                CustomAlert('Please select sub option type');
                return false;
            }
        }

        if (ddlSubOptionType != 'Select' && ddlSubOptionType != '') {
            if (subOption == '') {
                CustomAlert('Please enter sub option title');
                return false;
            }
        }

        return true;
    }

    if (type = '3') {

        subOption = $('textarea#txtSubOptionText').val();
        ddlSubOptionType = $('#DDL_SubOptType  :selected').text()
        if (subOption == '') {
            CustomAlert('Please enter sub option title');
            return false;
        }

        if (ddlSubOptionType == 'Select') {
            CustomAlert('Please select sub option type');
            return false;
        }
        return gridvalidation(ddlSubOptionType);
        return true;
    }
    return true;
}
function gridvalidation(type) {
    var RetVal = true;
    if (type.trim() == 'Calendar' || type.trim() == 'Label' || type.trim() == 'TextArea' || type.trim() == 'TextBox') {
        RetVal = true;
        return true;
    }
    else {

        if ($(".Text1Box", "#gvSubOptionValues").length <= 0) {
            CustomAlert("Please add value for sub option ");
            RetVal = false;
        }

        $(".Text1Box", "#gvSubOptionValues").each(function (i) {
            if ($(this).val() == "") {
                CustomAlert("Please Enter Value For Sub Option Value " + (i + 1));
                $(this).focus();
                RetVal = false; return false;
            };
        });
    }
    return RetVal;
}
/*Show or Hide textboxes in OGI add page*/
function showHide(textBox, anchor, ddlvalidator, textvalidator, div) {

    var dValidator = $('#' + ddlvalidator)[0];
    var tValidator = $('#' + textvalidator)[0];

    if ($('#' + anchor).text() == '--') {
        $('#' + textBox).css('display', 'none');
        $('#' + textBox).val('');
        $('#' + anchor).text('+');

        ValidatorEnable(dValidator, true);
        ValidatorEnable(tValidator, false);
        $('#' + div).css('display', 'none');
        dValidator.css('display', 'block ');
        tValidator.isvalid = true;
        //dValidator.isvalid = true;

    } else {
        $('#' + textBox).css('display', 'block');
        $('#' + anchor).text('--');

        ValidatorEnable(dValidator, false);
        ValidatorEnable(tValidator, true);
        $('#' + div).css('display', 'block');
        // tValidator.parent().css('display', 'block');
        dValidator.css('display', 'none ');
        //tValidator.isvalid = true;
        dValidator.isvalid = true;

    }
}
/*Show or hide suboption values according to sub option type*/
function hideSubOptionValue(textBox, grid) {
    var type = $('#DDL_SubOptType :selected').text();
    if (type.trim() == 'Calendar' || type.trim() == 'Label' || type.trim() == 'TextArea' || type.trim() == 'TextBox' || type.trim() == 'Ranking') {
        if ($(".Text1Box", "#gvSubOptionValues").length > 0) {
            CustomAlert("Please remove sub option values before change the sub option type");
            // $('#DDL_SubOptType :selected').text($('#hdn_SOPType').val())
            //           var index= $("#DDL_SubOptType").prop("selectedIndex");
            $("#DDL_SubOptType").prop("selectedIndex", $('#hdn_SOPType').val());
            return false;
        }

        $('#' + textBox).val('');

        $('#' + grid).css('display', 'none');
        $('#subValueTitleValue').css('display', 'none');

    } else {
        if ($(".Text1Box", "#gvSubOptionValues").length <= 0) {
            $('#subValueTitleValue').css('display', 'block');
        }

    }
    $('#hdn_SOPType').val($("#DDL_SubOptType").prop("selectedIndex"));

}

$(document).on("keypress keyup", ".AllowNumericsWithDecimal", function (event) {
    $(this).val($(this).val().replace(/[^0-9\.]/g, ''));
    if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
    }
    var length = $(this).val().trim().split('.').length - 1;
    if (length > 1) {
        $(this).val('');
    }
});



function isValidEstimatedCost(obj) {
    if (obj.value.trim() == '.') {
        CustomAlert('Please enter valid Estimated Cost');
        $(obj).val('');
    }
}

function isNumericKey(evt) {
    //getting key code of pressed key
    var keycode = (evt.which) ? evt.which : evt.keyCode;
    //comparing pressed keycodes
    if (keycode > 31 && (keycode < 48 || keycode > 57))
        return false;

    return true;
}

function restrictSpecialChars(evt, obj) {
    var reg = /^[A-Za-z0-9 ]*[A-Za-z0-9 ][A-Za-z0-9 ]*$/;
    var value = evt.key;
    if (!reg.test(value)) {
        return false;
    } else if (value === " " && $("#" + obj.id).val().trim() === "") {
        return false;
    } else {
        return true;
    }
}

function RestrictKeysForField(obj, evt, rType, rLength) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    var len = $(obj).val().length;
    if (len > rLength) {
        return false;
    }
    if (rType == 1) {
        if (charCode == 46 || (charCode >= 48 && charCode <= 57)) {
            return true;
        }
    }
    if (rType == 2) {
        if (charCode == 46 || (charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
            return true;
        }
    }
    if (rType == 3) {
        if (charCode == 46 || (charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
            return true;
        }
    }
    return false;
}
function RestrictPasteForField(obj, rType, rLength) {
    var Num0to9 = /^[1-9][0-9]*$/;
    var alNum = /^[a-zA-Z0-9]+$/;
    var alNumDot = /^[a-zA-Z0-9\.]+$/;
    var decimalUpto2 = /^[0-9]*\.?[0-9]*$/;
    var isValid = false;
    var eventdata = obj.value.trim();
    var len = $(obj).val().length;
    if (len > rLength) { $(obj).val(''); return false; }
    if (rType == 1) {
        isValid = Num0to9.test(eventdata);
    }
    if (rType == 2) {
        isValid = alNum.test(eventdata);
    }
    if (rType == 3) {
        isValid = alNumDot.test(eventdata);
    }
    if (rType === "DEC") {
        isValid = decimalUpto2.test(eventdata);
    }
    if (isValid) { return true; } else { $(obj).val(''); return false; }
}
function restrictpastefornonAlphaNumericfield(event) {
    var pastedText = (event.clipboardData || window.clipboardData).getData('text');
    var alphanumericOnly = /^[a-zA-Z0-9]*$/;
    if (!alphanumericOnly.test(pastedText)) {
        event.preventDefault();
    }
}

function restrictPasteForNonNumericDec(event) {
    var pastedText = (event.clipboardData || window.clipboardData).getData('text');
    var Pattern = /^[0-9]+(\.[0-9]+)?$/;
    if (!Pattern.test(pastedText)) {
        event.preventDefault();
        return false;
    }
    var target = event.target || event.srcElement;
    var currentVal = target.value || '';
    var selStart = typeof target.selectionStart === 'number' ? target.selectionStart : currentVal.length;
    var selEnd = typeof target.selectionEnd === 'number' ? target.selectionEnd : currentVal.length;
    var resultVal = currentVal.substring(0, selStart) + pastedText + currentVal.substring(selEnd);
    if (!Pattern.test(resultVal)) {
        event.preventDefault();
        return false;
    }
    return true;
}

function isNumericCopyPaste(obj) {
    if ($(obj).attr("id") === "TextDecAppr") {
        var columnIndex = 0;
        if (isNewMdrReview) {
            columnIndex = 1;
        }
        var activeRow = $(obj).closest('tr');
        var selectedDecStatus = $('#UmDdDecStatus').find('option:selected').text();
        var isAppealUpheld = !$.fn.isNullOrEmpty(selectedDecStatus) && selectedDecStatus.trim().toLowerCase() === "appeal upheld";
        var isDecisionContext = activeRow.find('#UmDdDecStatus').is(":visible") || activeRow.find('#chkGroupDecision').is(":checked");
        if (isAppealUpheld && isDecisionContext) {
            return;
        }
        var displayedDecStatus = $(obj).closest('tr').find('td').eq(4 + columnIndex).find('span').first().html();
        if (!$.fn.isNullOrEmpty(displayedDecStatus) && !activeRow.find('#chkGroupDecision').is(":checked") && displayedDecStatus.trim().toLowerCase() === "appeal upheld") {
            return;
        }
    }
    var Num0to9 = /^(0|[1-9][0-9\s]*)$/;
    var eventdata = obj.value.trim();
    isValid = Num0to9.test(eventdata);

    if (isValid) {
        return true;
    }
    else {
        $(obj).val('');
        return false;
    }
}

function ValidateNumericData(obj, noZero) {
    if ($(obj).val().length > 0) {
        if (isNaN($(obj).val()))
            $(obj).val('');
        else if (noZero == true && !parseInt($(obj).val()) > 0)
            $(obj).val('');
    }
}

function isNumericAllowDecimalKey(evt) {
    //getting key code of pressed key
    var keycode = (evt.which) ? evt.which : evt.keyCode;
    //comparing pressed keycodes
    if (keycode != 46 && keycode > 31
        && (keycode < 48 || keycode > 57))
        return false;

    return true;
}

function validateFloatKeyPress(el, evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    var number = el.value.split('.');
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    //just one dot
    if (number.length > 1 && charCode == 46) {
        return false;
    }
    //get the carat position
    var caratPos = getSelectionStart(el);
    var dotPos = el.value.indexOf(".");
    if (caratPos > dotPos && dotPos > -1 && (number[1].length > 1)) {
        return false;
    }
    return true;
}

function getSelectionStart(o) {
    if (o.createTextRange) {
        var r = document.selection.createRange().duplicate()
        r.moveEnd('character', o.value.length)
        if (r.text == '') return o.value.length
        return o.value.lastIndexOf(r.text)
    } else return o.selectionStart
}

/*Restrict Alphabets and special characters*/
function isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;

    return true;
}
//Function to allow only Decimal values to textbox
function validateDec(key) {
    //getting key code of pressed key
    var keycode = (key.which) ? key.which : key.keyCode;
    //comparing pressed keycodes
    if (!(keycode == 8 || keycode == 46) && (keycode < 48 || keycode > 57)) {
        return false;
    }
    else {
        var parts = key.srcElement.value.split('.');
        if (parts.length > 1 && keycode == 46)
            return false;
        return true;
    }
}
/*Allows only negative numbers and Zero only -- Added by Siva Krishna on 09/07/2014 15:30:00*/
function IsNegativeNumber(obj, evt) {
    var key1 = evt.which
    var len = $(obj).val().length;
    var txtdata = $(obj).val();
    if (len == 0) {

        if (!((key1 == 45) || (key1 == 48))) {

            evt.preventDefault()
        }
    }
    else if ((len == 1) && (txtdata == 0)) {
        if (!((key1 == 08) || (key1 == 0))) {
            evt.preventDefault()
        }
    }
    else {

        if (!((key1 == 08) || (key1 == 0) || (key1 >= 48 && key1 <= 57))) {
            evt.preventDefault()
        }
    }
}
/*Validate textbox control*/
function validateTextBox(control, message) {

    if ($('#' + control).val() == '') {
        CustomAlert(message);
        return false
    }

    return true;
}

//validating hrs,days,weeks for pcw
function isMaxNo(input, maxval) {
    var CurRow = $(input).closest(".DiagProcCode");
    var val;
    if (maxval == 7) {
        input = $("#ddlDaysval", CurRow).val() == 'W' ? 1 : $("#ddlDaysval", CurRow).val();
        val = parseInt($.trim(input));
        if (!isNaN(val) && val > 0 && val <= 7) {

            todatecalc(CurRow);
            isApprovUnits(CurRow);
            return true;
        }
        else {
            $("#TextDays,#TextReq,#TxtWeeklyHours", CurRow).val("");
            return false;
        }
    } else if (maxval == 24) {
        val = parseFloat($.trim($(input).val()));
        var unitType = $("#UmDdUnitType option:selected", CurRow).text().toLowerCase();

        var daysName = $('#ddlDaysval', CurRow).val();
        var valLimit = 24;
        if (unitType == "units" && daysName == 'W') { valLimit = 168; }
        else if (unitType == "15 minutes") {
            if (daysName == 'W') { valLimit = 672; }
            else { valLimit = 96; }
        }
        if (!isNaN(val) && val > 0 && val <= valLimit) {

            todatecalc(CurRow);
            isApprovUnits(CurRow);
            return true;
        }
        else {
            $("#TextHrs,#TextReq,#TxtWeeklyHours", CurRow).val("").trigger('change');
            return false;
        }
    }
    else if (maxval == 6) {
        val = parseInt($.trim($(input).val()));
        if (!isNaN(val) && val >= 0 && val <= 6) {

            todatecalc(CurRow);
            isApprovUnits(CurRow);
            return true;
        }
        else {
            $("#TextAdlDays", CurRow).val("");

            todatecalc(CurRow);
            isApprovUnits(CurRow);
            return false;
        }
    }
    else {
        val = parseInt($.trim($(input).val()));
        if (isNaN(val)) {
            var hrs = $.trim($("#TextHrs", CurRow).val());
            var additionalDays = $.trim($("#TextAdlDays", CurRow).val());
            additionalDays = (additionalDays === "" || typeof additionalDays === "undefined") ? 0 : parseInt(additionalDays);
            if (additionalDays > 0 && hrs > 0) {
                val = 0;
                $("#TextWeeks", CurRow).val('0');
            }
        }
        if (!isNaN(val) && val >= 0 && val <= parseInt(schedulerMaximumAllowedTimeframe)) {

            todatecalc(CurRow);
            isApprovUnits(CurRow);
            return true;
        }
        else if ($('#IsFromIAR').val() !== 'true' && $("#TextWeeks,#TextReq,#TextToDate", CurRow).val() !=="") {
            $("#TextWeeks,#TextReq,#TextToDate", CurRow).val("");
            CustomAlert('Weeks should not greater than ' + schedulerMaximumAllowedTimeframe);
            return false;
        } else {
            $("#TextWeeks,#TextReq", CurRow).val("");
            return false;
        }
    }

}
//todate calculation
function calctodate(obj) {
    var CurRow = $(obj).closest(".DiagProcCode");
    var isblurEvent = (event != undefined) ? (event.type == "blur") ? true : false : false;
    var unitType = $("#UmDdUnitType option:selected", CurRow).text().toLowerCase();
    var isFromDate = ($(obj).attr('class') != undefined) ? ($(obj).attr('class').indexOf('TextFromDate') >= 0) ? true : false : false;
    if ($("#ddlDaysval", CurRow).val() == 'W' && isFromDate && isblurEvent) {
        $("#TextWeeks", CurRow).val('0');
    }
    else if (unitType != "days" && $("#DIV_24_UF_CODES_SERVICE_DAYS", CurRow).is(":visible")) {
        todatecalc(CurRow);
    }
    calculateWeeks(obj);
}

// calculating approved units for pcw
function isApprovUnits(CurRow) {
    var days = $.trim($("#ddlDaysval", CurRow).val() == 'W' ? 1 : $("#ddlDaysval", CurRow).val());// $.trim($("#TextDays", CurRow).val());
    var hrs = $.trim($("#TextHrs", CurRow).val());
    var weeks = $.trim($("#TextWeeks", CurRow).val());
    var additionalDays = $.trim($("#TextAdlDays", CurRow).val());

    additionalDays = (additionalDays === "" || typeof additionalDays === "undefined") ? 0 : parseInt(additionalDays);
    var unitType = $("#UmDdUnitType option:selected", CurRow).text().toLowerCase();
    var CodeDesc = $('.TextSsCodeDesc', CurRow).val();
    var ddlDayNameshdn = (CurRow).find("#ddlDayNameshdn").val();
    var $fromdate = new Date($("#TextFromDate", CurRow).val());
    var $todate = new Date($("#TextToDate", CurRow).val());
    var daysName = $('#ddlDaysval', CurRow).val();
    var isHDCal = true;
    if (daysName != undefined) {
        if (daysName == 'W' && (unitType == "units" || unitType == "15 minutes")) { isHDCal = false; }
    }

    if (isHDCal) {
        if ((days != "" && typeof days != "undefined") && (hrs != "" && typeof hrs != "undefined")) {
            var num = parseInt(days) * parseFloat(hrs);
            $("#TxtWeeklyHours", CurRow).val(num);
            if (num.toString().split('.').length > 1)
                $("#TxtWeeklyHours", CurRow).val(num.toFixed(2));
        }
    }
    else
        $("#TxtWeeklyHours", CurRow).val('');
    if (unitType == "days") {
        var reqUnits = DateDiff($fromdate, $todate);
        if (!isNaN(reqUnits)) {
            $("#TextReq", CurRow).val(reqUnits + 1);
        }
    }
    else {
        if (ddlDayNameshdn != undefined && ddlDayNameshdn.length > 0 && $fromdate != 'Invalid Date' && $todate != 'Invalid Date') {

            var totalDays = 0;
            if (ddlDayNameshdn.substring(ddlDayNameshdn.length - 1) == ",")
                ddlDayNameshdn = ddlDayNameshdn.substring(0, ddlDayNameshdn.length - 1);

            if (ddlDayNameshdn == "Week") {
                weeks = GetTotalWeeks($fromdate, $todate);
                $("#TextAdlDays", CurRow).prop('disabled', 'disabled');
                $("#TextWeeks", CurRow).prop('disabled', 'disabled');
                totalDays = parseInt(weeks);
            }
            else {
                totalDays = getDaysBetweenDates($fromdate, $todate, ddlDayNameshdn);
                if ($('#IsFromIAR').val() !== "true") {
                    $("#TextAdlDays", CurRow).removeAttr('disabled');
                    $("#TextWeeks", CurRow).removeAttr('disabled');
                }
            }
            var reqUnits = (parseInt(totalDays) * parseFloat(hrs));
            reqUnits = parseFloat(reqUnits) + parseFloat(0.49);
            if (isNaN(reqUnits))
                $("#TextReq", CurRow).val('');
            else
                $("#TextReq", CurRow).val(Math.round(reqUnits));
            $("#TextReq", CurRow).attr("disabled", "disabled");
        }
        else if ((days != "" && typeof days != "undefined") && (hrs != "" && typeof hrs != "undefined") && (weeks != "" && typeof weeks != "undefined")) {
            var reqUnits = (parseInt(days) * parseFloat(hrs) * parseInt(weeks)) + (parseFloat(hrs) * additionalDays);
            reqUnits = parseFloat(reqUnits) + parseFloat(0.49);

            if (isNaN(reqUnits))
                $("#TextReq", CurRow).val('');
            else
                $("#TextReq", CurRow).val(Math.round(reqUnits));
            $("#TextReq", CurRow).attr("disabled", "disabled");
        }
        else {
            $("#TextReq", CurRow).val("");
            //$('.TextReq', CurRow).removeAttr('disabled');
        }
    }
    if (unitType != "days" && CodeDesc.toUpperCase() != "CDPAS" && CodeDesc.toUpperCase() != "PERSONAL CARE") {
        $('.TextReq', CurRow).removeAttr('disabled');
    }
    var reqUnits = $('.TextReq', CurRow).val();
    if (reqUnits == 0) $('.TextReq', CurRow).val('');
    $("#TxtWeeklyHours.ai-suggested", CurRow).removeClass("ai-suggested");
    $("#TextReq.ai-suggested", CurRow).removeClass("ai-suggested");
}

function getDaysBetweenDates(start, end, daysSelected) {

    var result = [];
    var dayNames = daysSelected.split(',');
    for (var i = 0, len = dayNames.length; i < len; i++) {

        var days = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
        var day = days[dayNames[i].toLowerCase().substr(0, 3)];
        // Copy start date
        var current = new Date(start);
        // Shift to next of required days
        current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
        // While less than end date, add dates to result array
        while (current <= end) {
            result.push(new Date(+current));
            current.setDate(current.getDate() + 7);
        }
    }

    return result.length;
}
//calculating todate for pcw
function todatecalc(CurRow) {
    var days = $("#ddlDaysval", CurRow).val() == 'W' ? 1 : $("#ddlDaysval", CurRow).val() == "" ? "0" : $("#ddlDaysval", CurRow).val();//$("#TextDays", CurRow).val();
    var hrs = $("#TextHrs", CurRow).val() == "" ? "0" : $("#TextHrs", CurRow).val();
    var weeks = $("#TextWeeks", CurRow).val();
    var adlDays = parseInt($("#TextAdlDays", CurRow).val());
    var date = $("#TextFromDate", CurRow).val();
    if ((days != "" && typeof days != "undefined") && (hrs != "" && typeof hrs != "undefined") && ((weeks != "" && typeof weeks != "undefined") || (adlDays != "" && typeof adlDays != "undefined")) && (date != "" && typeof date != "undefined")) {
        var interval = weeks || 0;
        var $date = new Date($("#TextFromDate", CurRow).val());
        var $result = $("#TextToDate", CurRow).val();
        var resultDate = new Date($date);
        var daysToAdd = 7 * interval;
        var daysToRemove = 1;
        var fromDateoffSet = new Date($("#TextFromDate", CurRow).val()).getTimezoneOffset();
        var toDateOffSet = new Date($("#TextToDate", CurRow).val()).getTimezoneOffset();
        //if (new Date($("#TextFromDate", CurRow).val()).ToMMDDYYYYString() == new Date($("#TextToDate", CurRow).val()).ToMMDDYYYYString()) {
        //    resultDate.setDate($date.getDate() + (daysToAdd - daysToRemove));
        //}
        //else
        resultDate.setDate($date.getDate() + (daysToAdd - daysToRemove) + (isNaN(adlDays) ? 0 : adlDays));
        var dateString = resultDate.ToMMDDYYYYString();
        if ($('#IsFromIAR').val() != "true") {
            if ((!isNaN(parseInt(weeks)) && parseInt(weeks) !== 0) || (!isNaN(adlDays) && adlDays !== 0)) {
                if ($("#ddlDaysval", CurRow).val() != 'W') {
                    $("#TextToDate", CurRow).val(dateString);
                }
            }
            else {
                $("#TextToDate", CurRow).val('');
            }
            $("#TextToDate", CurRow).trigger('change');
        }
        //$("#TextToDate", CurRow).attr("disabled", "disabled");     
    }
    //else {
    //    $("#TextToDate", CurRow).removeAttr("disabled");
    //}
}

function calculateWeeks(obj, todate) {
    var CurRow = $(obj).closest(".DiagProcCode");
    var $fromdate = new Date($("#TextFromDate", CurRow).val());
    var $todate = $("#TextToDate", CurRow).val().trim();
    if ($todate.toUpperCase().indexOf("T") >= 0) {
        validateTplusDateCondition(obj);
    }
    $todate = new Date($("#TextToDate", CurRow).val());
    var unitType = $("#UmDdUnitType option:selected", CurRow).text().toLowerCase();
    var reqUnits = $('.TextReq', CurRow).val();
    if (reqUnits == 0) $('.TextReq', CurRow).val('');
    var ddlDayNameshdn = (CurRow).find("#ddlDayNameshdn").val();
    if (unitType != "days" && $("#DIV_24_UF_CODES_SERVICE_DAYS", CurRow).is(":visible")) {
        if ($fromdate != "" && typeof $fromdate != "undefined" && !isNaN($fromdate) && $todate != "" && typeof $todate != "undefined" && !isNaN($todate)) {
            var diff = DateDiff($fromdate, $todate);
            if (diff >= 1 || diff == 0) {
                if (ddlDayNameshdn == "Week") {
                    var weeks = GetTotalWeeks($fromdate, $todate);
                    $("#TextWeeks", CurRow).val(weeks);
                }
                else {
                    var dateDiff = DateDiff($fromdate, $todate) + 1;
                    var weeks = parseInt(dateDiff / 7);
                    var addlDays = parseInt(dateDiff % 7);
                    $("#TextWeeks", CurRow).val(weeks);
                    $("#TextAdlDays", CurRow).val((weeks > 0 && addlDays > 0) ? addlDays : (dateDiff < 7) ? dateDiff == 0 ? 1 : dateDiff : 0);
                }
                $("#TextWeeks", CurRow).trigger("blur");
            }
            else {
                $("#TextToDate", CurRow).val('');
                $("#TextWeeks", CurRow).trigger("blur");
            }

        }
        else if ($fromdate != "" && typeof $fromdate != "undefined" && !isNaN($fromdate) && todate == undefined) {
            if (ddlDayNameshdn != "Week")
                $("#TextWeeks", CurRow).trigger("blur");
            else
                $("#TextWeeks", CurRow).val("");
        }
        if ($('#IsFromIAR').val() === "true") {
            $("#TextWeeks", CurRow).attr('disabled', true);
            $("#TextAdlDays", CurRow).attr('disabled', true);
        }
    }

    //else if ($fromdate != "" && typeof $fromdate != "undefined" && !isNaN($fromdate) && $todate != "" && typeof $todate != "undefined" && !isNaN($todate)) {
    //    var diff = DateDiff($fromdate, $todate);
    //    if (diff >= 1 || diff == 0) {
    //        var D1 = new Date($fromdate); var D2 = new Date($todate);
    //        var reqUnits = DateDiff($fromdate, $todate);
    //        if (EXCLUDE_TO_DATE) {
    //            if (D1.ToMMDDYYYYString() == D2.ToMMDDYYYYString()) {
    //                $(".TextReq", CurRow).val(1);
    //            }
    //            else {
    //                $(".TextReq", CurRow).val(reqUnits);
    //            }
    //        }
    //        else
    //            $(".TextReq", CurRow).val((reqUnits + 1));
    //    }
    //    else {
    //        $("#TextToDate", CurRow).val('');
    //        $(".TextReq", CurRow).val('');
    //    }
    //}

}


function validateExtCareTeam(parentTable, autotextBox, textBox1, textBox2) {
    var RetVal = true, RetMess = "", autotextBoxVal = "", textBox1Val = "", textBox2Val = "";
    var $ParentObj = $(parentTable); autotextBox = "[id$='" + autotextBox + "']";
    if ($ParentObj.find(autotextBox).length == 1) { autotextBoxVal = $($ParentObj.find(autotextBox)[0]).val(); }
    textBox1Val = $(textBox1).val(); textBox2Val = $(textBox2).val();
    if (autotextBoxVal == "" && textBox1Val == "" && textBox2Val == "") {
        RetVal = false; RetMess = "Please Enter Provider Name / Provider First Name and Last Name.";
    }
    else if (autotextBoxVal == "" && (textBox1Val == "" || textBox2Val == "")) {
        RetVal = false;
        if (textBox1Val == "") { RetMess = "Please Enter Provider First Name."; }
        else if (textBox2Val == "") { RetMess = "Please Enter Provider Last Name."; }
    }

    if (RetVal == false) { CustomAlert(RetMess); return RetVal; }
    else if (Page_ClientValidate('ExternalCareTeam')) {
        return true;
    } else {
        return false;
    }
}
function showHideDefault(ddl, checkBox) {
    var valueFind = $find(ddl).get_value();
    if (valueFind == '0') {
        $('#' + checkBox).hide();
    } else {
        $('#' + checkBox).show();
    }
}
function OnClientSelectedIndexChanged(sender, eventArgs) {
    var item = eventArgs.get_item();
    var valueFind = item.get_value();
    if (valueFind == '0') {
        //$('#chkdefault').prop('checked', false).hide();
        $('#chkdefault').hide();
        $('#lblDefault').hide();

    } else {
        $('#lblDefault').show();
        $('#chkdefault').show();
    }
}
function validateCareTeamProvider(textBox1, textBox2, textBox3) {
    if ($('#' + textBox3).val() == '' && ($('#' + textBox1).val() == '' || $('#' + textBox2).val() == '')) {
        CustomAlert('Please Enter Provider Name or First Name and Last Name');
        Page_ClientValidate('CTProvider');
        return false;
    } else {
        if (Page_ClientValidate('CTProvider') && Page_ClientValidate('PABAddress')) {
            return true;
        } else {
            return false;
        }
    }
}
function OnChanged(sender, eventArgs) {
    var item = eventArgs.get_item();
    var valueFind = item.get_value();
    if (valueFind == '-1') {
        //$('#chkPrimary').css('visibility', 'hidden').next('label').text('');
        $('#chkPrimary').css('display', 'block').next('label').text('');

    } else {
        $('#chkPrimary').css('display', 'list').next('label').text('Set as Primary');

        //$('#chkPrimary').css('visibility', 'visible')
    }
    CustomAlert(valueFind);
}
/*Show or Hide textboxes in careteam add page*/
function showHideRelation(sender, eventArgs) {

    var item = eventArgs.get_item();
    var valueFind = item.get_value();
    var tValidator = $('#ReqOtherRelation')[0];
    $('#txtCGOtherRelation').val('');
    if (valueFind != '8') {

        ValidatorEnable(tValidator, false);
        $('#rowRelation').hide();

        tValidator.isvalid = true;
        //dValidator.isvalid = true;

    } else {
        ValidatorEnable(tValidator, true);
        $('#rowRelation').show('slow');


    }



}
function setContextMenuPostion(event, contextMenu1) {

    var mousePosition = {};
    var menuPostion = {};
    var menuDimension = {};

    var contextMenu = $(contextMenu1);
    menuDimension.x = contextMenu.outerWidth();
    menuDimension.y = contextMenu.outerHeight();
    mousePosition.x = event.pageX;
    mousePosition.y = event.pageY;

    if (mousePosition.x + menuDimension.x > $(window).width() + $(window).scrollLeft()) {
        menuPostion.x = mousePosition.x - menuDimension.x;
    } else {
        menuPostion.x = mousePosition.x;
    }

    if (mousePosition.y + menuDimension.y > $(window).height() + $(window).scrollTop()) {
        menuPostion.y = mousePosition.y - menuDimension.y;
    } else {
        menuPostion.y = mousePosition.y;
    }

    vScrollPosition = $(document).scrollTop(); //retrieve the document scroll ToP position
    hScrollPosition = $(document).scrollLeft(); //retrieve the document scroll Left position
    var s = getScrollPosition(event);
    var hh = document.body.clientHeight;

    if (menuPostion.y > document.body.clientHeight / 2) {
        $(contextMenu1).css("top", menuPostion.y - vScrollPosition + "px");
    }
    else
        $(contextMenu1).css("bottom", menuPostion.y + vScrollPosition + "px");

    if (menuPostion.x > document.body.clientWidth / 2) {
        CustomAlert('ok');
        $(contextMenu1).css("right", (menuPostion.x - 2) + "px");
    }
    else
        $(contextMenu1).css("left", (menuPostion.x + 5) + "px");

    //if (menuPostion.y > $(document).height() / 2) {
    //    $(contextMenu1).css("top", menuPostion.y - vScrollPosition + "px");
    //}
    //else
    //    $(contextMenu1).css("bottom", menuPostion.y + "px");

    //if (menuPostion.x > $(document).width() / 2) {
    //    alert('ok');
    //    $(contextMenu1).css("right", menuPostion.x - hScrollPosition + "px");
    //}
    //else
    //    $(contextMenu1).css("left", menuPostion.x + "px");

    // $(contextMenu1).css("position", "fixed");
    $(contextMenu1).show();
    //ShowMenu(contextMenu1, event);
    //DivMenuShow(contextMenu1, menuPostion.y, menuPostion.x);
    return menuPostion;


}
function getMousePosition(e) {
    e = e || window.event;
    var position = {
        'x': e.clientX,
        'y': e.clientY
    }
    return position;
}
function getScrollPosition() {
    var x = 0;
    var y = 0;

    if (typeof (window.pageYOffset) == 'number') {
        x = window.pageXOffset;
        y = window.pageYOffset;
    } else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
        x = document.documentElement.scrollLeft;
        y = document.documentElement.scrollTop;
    } else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
        x = document.body.scrollLeft;
        y = document.body.scrollTop;
    }

    var position = {
        'x': x,
        'y': y
    }

    return position;
}
//************************ Start Tooltip Functions ********************************************
var JsToolTip = function () {
    var id = 'ToolTipDiv'; var Pos_Top = 5; var Pos_Left = 5;
    var Max_Width = 300; var Max_Speed = 10; var Timer = 20; var End_Alpha = 95; var Alpha = .95;
    var ToolTipDiv, ToolTip_Top, ToolTip_Con, ToolTip_Bot, Max_Height;
    var ie = document.all ? true : false;
    return {
        Show: function (v, w) {
            if (ToolTipDiv == null) {
                ToolTipDiv = document.createElement('div'); ToolTipDiv.setAttribute('id', id);
                ToolTip_Top = document.createElement('div'); ToolTip_Top.setAttribute('id', id + '_Top');
                ToolTip_Con = document.createElement('div'); ToolTip_Con.setAttribute('id', id + '_Con');
                ToolTip_Bot = document.createElement('div'); ToolTip_Bot.setAttribute('id', id + '_Bot');

                ToolTipDiv.appendChild(ToolTip_Top);
                ToolTipDiv.appendChild(ToolTip_Con);
                ToolTipDiv.appendChild(ToolTip_Bot);

                document.body.appendChild(ToolTipDiv);
                ToolTipDiv.style.opacity = 0;
                ToolTipDiv.style.filter = 'alpha(opacity=0)';

                document.onmousemove = this.Pos;

            }
            ToolTipDiv.style.display = 'block';
            ToolTip_Con.innerHTML = v;
            ToolTipDiv.style.width = w ? w + 'px' : 'auto';
            ToolTipDiv.style.zIndex = '1000000';
            if (!w && ie) {
                ToolTip_Top.style.display = 'none';
                ToolTip_Bot.style.display = 'none';
                ToolTipDiv.style.width = ToolTipDiv.offsetWidth;
                ToolTip_Top.style.display = 'block';
                ToolTip_Bot.style.display = 'block';
            }
            if (ToolTipDiv.offsetWidth > Max_Width) { ToolTipDiv.style.width = Max_Width + 'px' }
            Max_Height = parseInt(ToolTipDiv.offsetHeight) + Pos_Top;
            clearInterval(ToolTipDiv.Timer);
            ToolTipDiv.Timer = setInterval(function () { JsToolTip.Fade(1) }, Timer);
        },
        Pos: function (e) {
            var u = ie ? event.clientY + document.documentElement.scrollTop : e.pageY;
            var l = ie ? event.clientX + document.documentElement.scrollLeft : e.pageX;
            ToolTipDiv.style.top = (u - Max_Height) + 'px';
            ToolTipDiv.style.left = (l + Pos_Left) + 'px';

        },
        Fade: function (d) {
            var a = Alpha;
            if ((a != End_Alpha && d == 1) || (a != 0 && d == -1)) {
                var i = Max_Speed;
                if (End_Alpha - a < Max_Speed && d == 1) {
                    i = End_Alpha - a;
                } else if (Alpha < Max_Speed && d == -1) {
                    i = a;
                }
                Alpha = a + (i * d);
                ToolTipDiv.style.opacity = Alpha * .01;
                ToolTipDiv.style.filter = 'alpha(opacity=' + Alpha + ')';
            } else {
                clearInterval(ToolTipDiv.Timer);
                if (d == -1) { ToolTipDiv.style.display = 'none' }
            }
        },
        Hide: function () {
            clearInterval(ToolTipDiv.Timer);
            ToolTipDiv.Timer = setInterval(function () { JsToolTip.Fade(-1) }, Timer);
        }
    };
}();
//************************ End Tooltip Functions **********************************************
jQuery.expr[':'].Contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};
function ValidSearch() {
    var RetVal = false;
    VALIDATION_KEY = "CPA_MAT";
    ResetValidations();
    AddValidation(new Array("Required_Dropdown", "#DD_SearchType", "#Valid_01", "Please Select Search Type"));
    AddValidation(new Array("Required_Textbox", "#Txt_Search", "#Valid_02", "Please Enter Search Word"));
    RetVal = SetValidations();
    if (RetVal == true) {
        if ($("#Txt_Search").attr("title") == $("#Txt_Search").val()) {
            ShowValidMsg("#Valid_02", "*", "Please Enter Search Word", 1);
            RetVal = false;
        }
    }
    return RetVal;
}
function AddNewCpa() {
    var SE_GT = "", SE_GV = "", SE_OT = "", SE_OV = "";
    $("#ddlAddGoal option:selected").each(function () {
        SE_GT = $(this).text(); SE_GV = $(this).val();
    });
    $("#ddlAddOpp option:selected").each(function () {
        SE_OT = $(this).text(); SE_OV = $(this).val();
    });
    if (SE_GV == "-1" || SE_OV == "-1") { CustomAlert("Please Select Goal & Opportunity."); return; }
    var GoHdn = $("#AddNewApaTab").find("#Cpa_GV_OV");
    var CurVal = SE_GV + "|" + SE_OV; var AddNew = true;
    for (var HI = 0; HI < GoHdn.length; HI++) {
        var GOV = null; GOV = $(GoHdn[HI]).val();
        if (GOV == CurVal) {
            AddNew = false;
            break;
        }
    }
    if (AddNew == false) {
        ExpandCollapse_CpaData(false);
        $("#IntImg1_" + SE_GV + "_" + SE_OV).hide();
        $("#IntImg2_" + SE_GV + "_" + SE_OV).show();
        $("#CpaInt_" + SE_GV + "_" + SE_OV).show();
        $("#ddlAddGoal").val("-1"); $("#ddlAddOpp").val("-1");
        CustomAlert("Goal & Opportunity Combination Already Exists.");
        return;
    }
    //ExpandCollapse_CpaData(false);
    var $ListBoxInt = $("#LbAddInt").html();
    var $NewCpaHtmlText = $("#HtmlAddCpa").html();

    $NewCpaHtmlText = $NewCpaHtmlText.replace(/{GOAL_ID}/g, SE_GV);
    $NewCpaHtmlText = $NewCpaHtmlText.replace(/{GOAL_NAME}/g, SE_GT);
    $NewCpaHtmlText = $NewCpaHtmlText.replace(/{OPP_ID}/g, SE_OV);
    $NewCpaHtmlText = $NewCpaHtmlText.replace(/{OPP_NAME}/g, SE_OT);

    $NewCpaHtmlText = $NewCpaHtmlText.replace(/<tbody>/g, "");
    $NewCpaHtmlText = $NewCpaHtmlText.replace(/<\/tbody>/g, "");

    $("#AddNewApaTab tr:first").after($NewCpaHtmlText); //$("#AddNewApaTab").append($NewCpaHtmlText);
    var IntId = "#LB_Int1_" + SE_GV + "_" + SE_OV;
    $(IntId).html(''); $(IntId).html($ListBoxInt);
    DocumentReady();

    $("#IntImg1_" + SE_GV + "_" + SE_OV).hide();
    $("#IntImg2_" + SE_GV + "_" + SE_OV).show();
    $("#CpaInt_" + SE_GV + "_" + SE_OV).show();

    CheckExistMatrix(SE_OV, SE_GV);

    $("#ddlAddGoal").val("-1"); $("#ddlAddOpp").val("-1");
}
function CheckExistMatrix(OV, GV) {
    var MatVal = $("#HdnOgiMat").val();
    var Int1Id = "#LB_Int1_" + GV + "_" + OV;
    var Int2Id = "#LB_Int2_" + GV + "_" + OV;
    if (MatVal != "") {
        var MatRows = MatVal.split('|');
        for (var CI = 0; CI < MatRows.length; CI++) {
            if (MatRows[CI] != null) {
                var MatData = MatRows[CI].split('~');
                var OTV = 0; var GTV = 0; var ITV = 0;
                if (MatData.length == 3) {
                    OTV = MatData[0]; GTV = MatData[1]; ITV = MatData[2];
                    if (OTV == OV && GTV == GV) {
                        ExchangeOptionVal(Int1Id, Int2Id, ITV);
                    }
                }
            }
        }
    }
}
function SwapCpaData(ImgId1, ImgId2, DivId) {
    $(ImgId1).hide(); $(ImgId2).show();
    $(DivId).toggle();
}
function ExpandCollapse_CpaData(Expand) {
    if (Expand == true) { $(".CpaRow").show(); $(".CpaImg1").hide(); $(".CpaImg2").show(); }
    else { $(".CpaRow").hide(); $(".CpaImg1").show(); $(".CpaImg2").hide(); }
}
function DocumentReady() {
    $('.WaterMark').each(function () {
        $(this).addClass("WME");
        var default_value = $(this).attr("title");
        if (this.value == '') { this.value = default_value; }
        if (this.value != default_value) { $(this).removeClass("WME"); }
        $(this).focus(function () {
            if (this.value == default_value) {
                $(this).removeClass("WME");
                this.value = '';
            }
        });
        $(this).blur(function () {
            if (this.value == '') {
                this.value = default_value;
                $(this).addClass("WME");
            }
        });
    });
}
function ExchangeOptionVal(SourObj, DestObj, SelVal) {
    $(SourObj + " option[value='" + SelVal + "']").each(function () {
        var OptText = ""; var OptVal = "";
        OptText = $(this).text(); OptVal = $(this).val();
        $(DestObj).append("<option value='" + OptVal + "'>" + OptText + "</option>");
        $(this).remove();
    });
}
function ExchangeOption(SourObj, DestObj) {
    $(SourObj + " option:selected").each(function () {
        var OptText = ""; var OptVal = "";
        OptText = $(this).text(); OptVal = $(this).val();
        $(DestObj).append("<option value='" + OptVal + "'>" + OptText + "</option>");
        $(this).remove();
    });
}
function SearchOption(TextObj, SelObj) {
    //var St = $(TextObj).val();
    //if (St == "") { $(SelObj + " option").show(); return; }
    //$(SelObj + " option:not(:Contains('" + St + "'))").hide();
    //$(SelObj + " option:Contains('" + St + "')").show();

    var St = $(TextObj).val();
    if (St == "") {
        $(SelObj).find("option").each(function () {
            if ($(this).is('option') && (!$(this).parent().is('span'))) {
                $(this).show();
            }
            else if ($(this).is('option') && ($(this).parent().is('span'))) {
                var opt = $(this);
                var p = $(this).parent();
                $(p).replaceWith(opt);
                opt.show();
            }
        });
        return;
    }
    St = St.toLowerCase();
    $(SelObj + " option").each(function () {
        if ($(this).is('option') && (!$(this).parent().is('span'))) {
            $(this).wrap('<span>').hide();
        }
    });

    $(SelObj).find("option").each(function () {
        var OT = "";
        if ($(this).is('option') && (!$(this).parent().is('span'))) {
            OT = $(this).text().toLowerCase();
            if (OT.indexOf(St) >= 0) { $(this).show(); }
        }
        else if ($(this).is('option') && ($(this).parent().is('span'))) {
            OT = $(this).text().toLowerCase();
            if (OT.indexOf(St) >= 0) {
                var opt = $(this);
                var p = $(this).parent();
                $(p).replaceWith(opt);
                opt.show();
            }
        }
    });
}
function GetSelected() {
    var SelRows = $("#AddNewApaTab").find('tr[id*="CpaRowInt_"]');
    var RetVal = false; var SelVals = []; var SelMatrix = "";
    $("#Hdn_MatData").val('');
    for (var HI = 0; HI < SelRows.length; HI++) {
        var GV = null; var OV = null; var SelInt = [];
        GV = $(SelRows[HI]).find("#Cpa_GV:first").val();
        OV = $(SelRows[HI]).find("#Cpa_OV:first").val();
        var IntId = null; IntId = "#LB_Int2_" + GV + "_" + OV + " option";
        $(IntId).each(function () {
            if ($(this).val() != "") {
                if (SelMatrix != "") { SelMatrix += "|"; }
                SelMatrix += OV + "~" + GV + "~" + $(this).val();
            }
        });
    }
    if (SelMatrix != "") { $("#Hdn_MatData").val(SelMatrix); RetVal = true; }
    if (RetVal == false) { CustomAlert("Invalid Matrix Data"); }
    return RetVal;
}
function ValidateRunForm() {
    if ($(".ddlSelectForm").val() == 'Select') {
        $("#lblFormMandatory").html('*');
        return false;
    }
    else {
        $("#lblFormMandatory").html('');
        return true;
    }
}
//Start Loader functionality for autotextbox
function removeLoader(textBoxId, textLength) {

    if ($(textBoxId).val().length < textLength) {
        $(textBoxId).css('background-image', 'none');
    }
}
function suggestionListPopulating(source, e) {

    var textboxControl = $(source.get_element()); // Get the textbox control.

    //alert(textboxControl.val());

    textboxControl.css('background', '#FFF url(imagehandler.ashx?img=Auto_Loader.gif) no-repeat right'); // Put a background image for the textbox.
    //textboxControl.css('background', '#FFF url(StaticContents/images/loading-red.gif) no-repeat right');

}
function dd() {

    var comletionList = $find("AutoSpId").get_completionList();
    if (comletionList.childNodes.length > 0) {
        comletionList.childNodes[0].innerHTML = "<div class='cloumnspan' style='width:10%;float:left'>" + "Name" + "</div>"
            + "<div class='cloumnspan' style='width:70%;float:left'>" + "VALUE" + "</div>"
        for (i = 1; i < comletionList.childNodes.length; i++) {
            var itemobj = new Object();
            var _data = comletionList.childNodes[i]._value;
            itemobj.name = _data.substring(_data.lastIndexOf('|') + 1); // parse name as item value
            comletionList.childNodes[i]._value = itemobj.name;
            _data = _data.substring(0, _data.lastIndexOf('|'));
            itemobj.age = _data.substring(_data.lastIndexOf('|') + 1);
            _data = _data.substring(0, _data.lastIndexOf('|'));
            itemobj.id = _data.substring(_data.lastIndexOf('|') + 1);


            comletionList.childNodes[i].innerHTML = "<div class='cloumnspan' style='width:10%;float:left'>" + itemobj.id + "</div>"
                + "<div class='cloumnspan' style='width:70%;float:left'>" + itemobj.name + "</div>"
                + "<div class='cloumnspan' style='width:18%;'>" + itemobj.age + "</div>";

        }
    }

}
function suggestionListPopulated(source, e) {
    var textboxControl = $(source.get_element()); // Get the textbox control.
    textboxControl.css('background-image', 'none'); // Remove background image from the textbox.

    //End Loader functionality for autotextbox
    //dd();
}
function UASDbMenuCarePlan(DivObj, MenuId, Hilight, ChkBox, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container) {
    var $Trs = $(DivObj).find(".ConMenuCP"); $($Trs).attr("disabled", false);
    var hdnChk = $(ChkBox).closest('td').find("input:hidden");
    var EnaClass = "." + $(hdnChk[0]).val();
    var $TrsEna = $(DivObj).find(EnaClass);


    ContextMenuNew(ChkBox, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container, true);

    //DbMenuApp(DivObj, MenuId, Hilight, Event);
}
function DbMenuCarePlan(DivObj, MenuId, Hilight, ChkBox, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container) {
    var $Trs = $(DivObj).find(".ConMenuCP"); $($Trs).attr("disabled", false);
    var hdnChk = $(ChkBox).closest('td').find("input:hidden");
    var $span = $($Trs[5]).closest('td').find('span');
    var $spanText = '( 0% )';
    var hdnvalues = $(hdnChk[0]).val().split('$');
    $('#hdnCategoryType').val(hdnvalues[0].toUpperCase());
    //var isSignOff = true;
    var EnaClass = "." + hdnvalues[0];
    var $TrsEna = $(DivObj).find(EnaClass);
    if (hdnvalues.length >= 2) {
        $('#hdnSignOffStatus').val(hdnvalues[1]);
        //isSignOff = Boolean(hdnvalues[1].toLowerCase() == "true");
    }

    if ($span.length == 1) {
        $span[0].textContent = '';
    }

    if (hdnvalues.length >= 3) {
        $spanText = '( ' + hdnvalues[2] + '% )';
    }


    if (hdnvalues[0].toUpperCase() == "RECOMMENDED") {
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[3]).attr("disabled", true);
        //$($Trs[5]).attr("disabled", !isSignOff);
        if ($span.length == 1) {
            $span[0].textContent = $spanText;
        }

    }
    else if (hdnvalues[0].toUpperCase() == "CURRENT" || hdnvalues[0].toUpperCase() == "UAS") {
        //$($Trs[5]).attr("disabled", !isSignOff);
        //if ($span.length == 1) {
        //    $span[0].textContent = $spanText;
        //}
    }
    else if (hdnvalues[0].toUpperCase() == "COMPLETED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
        $($Trs[5]).attr("disabled", true);
        $($Trs[6]).attr("disabled", true);
        $($Trs[7]).attr("disabled", true);
        $($Trs[8]).attr("disabled", true);
    }
    else if (hdnvalues[0].toUpperCase() == "DELETED") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[3]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
        $($Trs[5]).attr("disabled", true);
        $($Trs[6]).attr("disabled", true);
        $($Trs[7]).attr("disabled", true);
        $($Trs[8]).attr("disabled", true);
    }

    ContextMenuNew(ChkBox, Event, SourceDiv, IsCheckBox, ParentId, ClearAll, Container, true);

    //DbMenuApp(DivObj, MenuId, Hilight, Event);
}
function CloseDiagnosis() {

    if ($find('behDignosis') != null)
        $find('behDignosis').hide();
}
function healthIndValuesTB(validationGroup, edit) {
    var RetVal = true;
    if (edit || false) {
        var txtBox = $(".EditHITextRecordValue");
        if (txtBox.val() == ".") {
            CustomAlert("Please enter valid value for parameter");
            txtBox.val('');
            txtBox.focus();
            RetVal = false;
        }

    } else {
        $(".HealthIndTB", "#gvParameterValues").each(function (i) {
            if ($(this).val() == ".") {
                CustomAlert("Please enter valid value for parameter " + (i + 1));
                $(this).val('');
                $(this).focus();
                RetVal = false;
                return false;
            };
        });
    }

    if (RetVal) {
        return Page_ClientValidate(validationGroup);
    } else {
        return RetVal;
    }

}
function checkDecimal(inputtext,isPercent,allowZero) {
    var re = new RegExp('^[0-9]*\.?[0-9]*$');
    if (inputtext.value.match(re)) {
        var parsedValue = parseFloat(inputtext.value);
        if (!allowZero && parsedValue === 0) {
            inputtext.value = '';
            return false;
        }
        if (isPercent && parsedValue > 100) {
            inputtext.value = '';
            return false;
        }
        return true;
    }
    else {
        inputtext.value = ''
        return false;
    }
}
function CheckNumeric(inputtext) {
    var re = new RegExp('^[0-9]+$');
    if (inputtext.value.match(re)) {
        return true;
    }
    else {
        inputtext.value = ''
        return false;
    }
}
function CheckNumericGreaterThanZero(inputtext) {
    var re = new RegExp('^0*[1-9][0-9]*$');
    if (inputtext.value.match(re)) {
        return true;
    }
    else {
        inputtext.value = ''
        return false;
    }
}
function ShowHideHIAlert(validator, control) {
    var vldt = $('#' + validator)[0];
    var cntrl = $('#' + control);
    var ddl = $('#ddlParameterType');
    if (ddl.val() == "3") {
        ValidatorEnable(vldt, false);
        cntrl.css('display', 'none');
        vldt.isvalid = true;
    } else {
        ValidatorEnable(vldt, true);
        cntrl.css('display', 'table');
        //vldt.isvalid = true;
    }
}
function OnClientValidationFailed(sender, args) {
    var fileExtention = args.get_fileName().substring(args.get_fileName().lastIndexOf('.') + 1, args.get_fileName().length);
    if (args.get_fileName().lastIndexOf('.') != -1) {//this checks if the extension is correct
        if (sender.get_allowedFileExtensions().indexOf(fileExtention) == -1) {
            Array.removeAt(sender._uploadedFiles, 0);
            sender.deleteFileInputAt(0);
            sender.updateClientState();
            CustomAlert("Wrong Extension!");
        }
    }
    else {
        CustomAlert("not correct extension!");
    }
}
function validateServiceUpload(sender, args) {
    var upload = $find("radServiceUpload");
    if (upload.getUploadedFiles().length != 0) {
        args.IsValid = true;
        return;
    } else {
        args.IsValid = false;
    }

    //args.IsValid = upload.getUploadedFiles().length != 0;
}
//************************ Auth Page Redirection from DashBoard Start *********************************************************
function SetAuthPatientDataCm(AuthClassId) {
    var PaId = $("#ddlPatientAccessed").val(); var PaName = $("#ddlPatientAccessed  option:selected").text();
    var TempVar = PaName.split(",");
    var PatientFName = "", PatientLName = "";
    if (TempVar.length > 0) {
        var PaNames = TempVar[0].split(",");
        PatientFName = PaNames[0]; PatientLName = PaNames[1];
    }
    if (PaId != "" && PatientFName != "" && PatientLName != "") {
        SetAuthData(PaId, '', AuthClassId, 0, PatientFName, PatientLName);
    }
}
function SetAuthPatientDataDbOpenAuth() {
    var GvRowData = "";
    $("#gvOpenAuths").find("input:checked").each(function () {
        if (GvRowData == "") { GvRowData = $(this).closest("tr").find("[id^=hdnAuthDetails]").val(); return false; }
    });
    if (GvRowData != "") { SetAuthPatientDatanew(GvRowData); }
    //if (GvRowData != "") { SetAuthPatientData(GvRowData); }
    return false;
}
function SetAuthDataPendingActivity(AuthNo) {
    if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
    if (localStorage.getItem("AUTH_DATA_AUTH_NO") != null) { localStorage.removeItem("AUTH_DATA_AUTH_NO"); }
    localStorage.setItem("AUTH_DATA_AUTH_NO", AuthNo);
    window.top.GotoAuth();
    return false;
}
function SetAuthDataPendingActivitynew(AuthNo) {
    if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
    if (localStorage.getItem("AUTH_DATA_AUTH_NO") != null) { localStorage.removeItem("AUTH_DATA_AUTH_NO"); }
    localStorage.setItem("AUTH_DATA_AUTH_NO", AuthNo);
    window.top.GotoAuth();
    return false;
}
function SetAuthPatientData(DataValues) {
    var AuthData = DataValues.split('|');
    if (AuthData.length >= 6) {
        SetAuthDatanew(AuthData[0], AuthData[1], AuthData[2], AuthData[3]);
    }
}
function SetAuthPatientDatanew(DataValues) {
    var AuthData = DataValues.split('|');
    if (AuthData.length >= 6) {
        SetAuthDatanew1(AuthData[0], AuthData[1], AuthData[2], AuthData[3]);
    }
}
function SetAuthData(PatientId, AuthId, AuthClassId, AuthNo) {
    var AuthData = AuthNo + "_" + PatientId + "_" + AuthClassId + "_" + AuthId;
    if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
    if (localStorage.getItem("AUTH_DATA_AUTH_NO") != null) { localStorage.removeItem("AUTH_DATA_AUTH_NO"); }
    localStorage.setItem("AUTH_DATA", AuthData);
    window.top.GotoAuth(AuthNo, AuthClassId, PatientId);
}


function SetAuthDatanewnew(PatientId, AuthId, AuthClassId, AuthNo) {
    var AuthData = AuthNo + "_" + PatientId + "_" + AuthClassId + "_" + AuthId;

    try { localStorage.removeItem("AUTH_DATA"); }
    catch (e) { }
    try { localStorage.setItem("AUTH_DATA", AuthData); window.top.GotoAuth(AuthNo, AuthClassId, PatientId); }
    catch (e) { }
}

function SetAuthDatanew(PatientId, AuthId, AuthClassId, AuthNo, ActivityLogId, isFromPreAuth = false) {
    ClearFaxLinkValues();
    ActivityLogId = isNaN(ActivityLogId) ? '' : ActivityLogId;
    isFromPreAuth = (typeof isFromPreAuth === 'boolean') ? isFromPreAuth : false;
    var AuthData = AuthNo + "_" + PatientId + "_" + AuthClassId + "_" + AuthId + "_" + ActivityLogId;
    if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
    if (!isFromPreAuth) {
        window.top.clearPreAuthCache();
    }
    localStorage.setItem("AUTH_DATA", AuthData);
    window.top.GotoAuth(AuthNo, AuthClassId, PatientId, ActivityLogId, isFromPreAuth);
}
/*Function to set the global variables values and navigate to UM Auth Entry page*/
function SetAuthDatanewForFaxLinking(PatientId, AuthId, AuthClassId, AuthNo, LinkFaxForNewAuth, MessageId, DocumentTypeId) {
    var AuthData = AuthNo + "_" + PatientId + "_" + AuthClassId + "_" + AuthId;
    if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
    localStorage.setItem("AUTH_DATA", AuthData);
    if (localStorage.getItem("LINK_FAX_NEW_AUTH") != null) { localStorage.removeItem("LINK_FAX_NEW_AUTH"); }
    localStorage.setItem("LINK_FAX_NEW_AUTH", LinkFaxForNewAuth);
    if (localStorage.getItem("MESSAGE_ID_NEW_AUTH") != null) { localStorage.removeItem("MESSAGE_ID_NEW_AUTH"); }
    localStorage.setItem("MESSAGE_ID_NEW_AUTH", MessageId);
    if (ToValue($("#HdnFaxDocumentTypeId").val(), "") !== "") {
        $("#HdnFaxDocumentTypeId").val('');
    }
    $("#HdnFaxDocumentTypeId").val(DocumentTypeId);
    $("#hdnFaxForAuth").val('true');
    window.top.GotoAuth(AuthNo, AuthClassId, PatientId);
}
function SetComplaintDatanewForFaxLinking(PatientId, ComplaintId, ComplaintTypeId, CompaintType, PatientFName, PatientLName, LinkFaxForNewComp, MessageId, DocumentTypeId) {
    var ComplaintData = { CompaintType: CompaintType, PatientId: PatientId, ComplaintTypeId: ComplaintTypeId, ComplaintNo: ComplaintId, PatientName: PatientFName + "_" + PatientLName };
    localStorage.removeItem("COMPLAINT_DATA");
    localStorage.setItem("COMPLAINT_DATA", JSON.stringify(ComplaintData));
    if (ToValue($("#HdnLinkFaxNewComplaint").val(), "") !== "") {
        $("#HdnLinkFaxNewComplaint").val('');
    }
    $("#HdnLinkFaxNewComplaint").val(LinkFaxForNewComp);

    if (ToValue($("#HdnMsgIdNewComplaint").val(), "") !== "") {
        $("#HdnMsgIdNewComplaint").val('');
    }
    $("#HdnMsgIdNewComplaint").val(MessageId);

    if (ToValue($("#HdnFaxDocumentTypeId").val(), "") !== "") {
        $("#HdnFaxDocumentTypeId").val('');
    }
    $("#HdnFaxDocumentTypeId").val(DocumentTypeId);
    GotoComplaint();
}
/*END*/
function SetAuthDatanew1(PatientId, AuthId, AuthClassId, AuthNo) {
    ClearFaxLinkValues();
    var AuthData = AuthNo + "_" + PatientId + "_" + AuthClassId + "_" + AuthId;
    if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
    localStorage.setItem("AUTH_DATA", AuthData);
    window.top.GotoAuth(AuthNo, AuthClassId, PatientId);
}
//************************ Auth Page Redirection from DashBoard End ***********************************************************
function validateSPRecommanded(validationGroup, isSavebtn) {

    //
    var $CheckBoxsAll;
    var appStatus = false;
    var authType = false;
    var gridview = $("#" + 'gvMembSPServiceCategory');
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + "gvMembSPServiceCategory").attr('ID') + " input:checkbox[id*=" + "ItemChkMembSPsc" + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + "ItemChkMembSPsc" + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
    var flag = true;

    ////Find out required fields
    //if (gridview.length == 0) //If ClientIDMode is not static                   
    //    $reqAll = $("#" + $("table." + "gvMembSPServiceCategory").attr('ID') + " span[id*=" + "NewSPCREQ" + "]");
    //else
    //    $reqAll = $("#" + GvId + " span[id*=" + "NewSPCREQ" + "]");

    ////Set display none
    //if ($reqAll.length > 0) {
    //    $($reqAll).each(function (i) {
    //        $(this).attr('style', 'display:none;color:Red;');
    //    });
    //}

    //Remove required lable text
    $($CheckBoxsAll).each(function (i) {
        var chk = $(this).attr('id');

        var reqLob = chk.replace('ItemChkMembSPsc', 'lblreqMsgMembLob');
        //$('#' + reqAunit).attr('style', 'display:none;color:Red;');
        $('#' + reqLob)[0].innerHTML = '';
        var reqProvider = chk.replace('ItemChkMembSPsc', 'lblreqMsgMembProvider');

        $('#' + reqProvider)[0].innerHTML = '';

        var reqAUnit = chk.replace('ItemChkMembSPsc', 'lblreqMsgMembAUnits');
        $('#' + reqAUnit)[0].innerHTML = '';
    });
    //End required lable text

    if ($CheckBoxsChecked.length > 0) {
        $($CheckBoxsChecked).each(function (i) {

            var chk = $(this).attr('id');
            var prov = chk.replace('ItemChkMembSPsc', 'ddlMembGProvider');
            var lob = chk.replace('ItemChkMembSPsc', 'ddlMembGLob');
            var rUnit = chk.replace('ItemChkMembSPsc', 'txtMembGRUnits');
            var aUnit = chk.replace('ItemChkMembSPsc', 'txtMembGAUnits');
            var status = chk.replace('ItemChkMembSPsc', 'ddlMembGStatus');
            var uUnit = chk.replace('ItemChkMembSPsc', 'txtMembGUUnits');
            var auth = chk.replace('ItemChkMembSPsc', 'lblNewAuth');

            var reqProv = chk.replace('ItemChkMembSPsc', 'lblreqMsgMembProvider');
            var reqLob = chk.replace('ItemChkMembSPsc', 'lblreqMsgMembLob');
            //var reqRUnit = chk.replace('ItemChkMembSPsc', 'reqtxtMembGRUnitsNewSPCREQ');
            var reqAUnit = chk.replace('ItemChkMembSPsc', 'lblreqMsgMembAUnits');
            var reqStatus = chk.replace('ItemChkMembSPsc', 'reqddlMembGStatusNewSPCREQ');

            //var dropProvider = $telerik.$("#ctl00_UserControlPlaceHolder_app_pages_cm_manage_manageserviceplan_ascx_MSplan_gvMembSPServiceCategory_ctl02_ddlMembGProvider_0");
            var dropProvider = $telerik.$("#" + prov + "");
            var dropLob = $telerik.$("#" + lob + "");
            var rUnits = $("#" + rUnit);
            var aUnits = $("#" + aUnit);
            var reqProvs = $("#" + reqProv);
            var reqLobs = $("#" + reqLob);
            // var reqRUnits = $("#" + reqRUnit);
            var reqAUnits = $("#" + reqAUnit);
            var uUnits = $("#" + uUnit);
            var auths = $("#" + auth)[0].innerHTML.split('|');
            var statuss = $("#" + status);
            var reqStatuss = $("#" + reqStatus);
            //console.log({ authType: authType, authsl: auths.length, auths: auths });
            if (authType == false && auths.length > 1 && auths[1] != '') {
                authType = true;
            }
            //var chkId = $(this).attr('id').split('_');
            //var rowIndex = chkId[chkId.length - 1];
            //var rUnits = $("input:text[id$=" + "txtMembGRUnits_" + rowIndex + "]");
            //var provider = $("span[id$=" + "lblGProviderCode_" + rowIndex + "]");

            /*Remove Requiredunits mandatory jiraid-VNSPAYOR-473*/
            if (dropProvider.val() == 'Select' || dropProvider.val() == '') {

                reqProvs[0].innerHTML = '*';
                flag = false;
            }
            if (dropLob.val() == 'Select' || dropLob.val() == '') {

                reqLobs[0].innerHTML = '*';
                flag = false;
            }

            if (ReqAndAppUnits(rUnits, aUnits, 1) == false) {
                reqAUnits[0].innerHTML = '*';
                flag = false;
                return;
            }

            //Used units Validation
            //if (ReqAndAppUnits(rUnits, aUnits, 4, uUnits) == false) {
            //    flag = false;
            //    return;
            //}

            if (statuss.val().trim() == 'Approved' && flag == true) {
                flag = ReqAndAppUnits(rUnits, aUnits, 2);
                if (flag == false) {
                    reqAUnits[0].innerHTML = '*';
                    //reqAUnits.attr('style', 'display:block;color:Red;');
                    return;
                }
                if (!appStatus) {
                    appStatus = true;
                }
            }

            if (statuss.val().trim() == 'Denied' && flag == true) {

                flag = ReqAndAppUnits(rUnits, aUnits, 3);
                if (flag == false) {
                    reqAUnits[0].innerHTML = '*';
                    //reqAUnits.attr('style', 'display:block;color:Red;');
                    return;
                }
            }

        });
    }
    if (authType && flag && (isSavebtn || false == true)) {
        flag = CustomConfirm('This service usually requires authorization. Click Save & Submit Auth to create an authorization, or click ok to proceed.');
    }
    //console.log({ flags: flag, appStatuss: appStatus, bb: (isSavebtn || false == true) });
    if (flag && appStatus && (isSavebtn || false == true)) {
        flag = CustomConfirm('Are you sure, you want to approve the selected service categories? Once approved service categories cannot be modified.');
    }
    return flag;
}
function GridCaredateValidation(date1, date2) {

    var secondDate = $(date2);
    //var secId = $(date2).attr('id').split('_');
    var secId = $(date2).attr('id');
    var fdate = secId.replace('txtTNewSPToDate', 'txtNewSPFromDate');
    var firstDate = $('#' + fdate + "");
    // var firstDate = $('#' + date1 + "_" + secId[secId.length - 1]);

    // var firstDate = $("input:text[id$=" + date1 + "_" + secId[secId.length - 1] + "]");

    if (firstDate.val() == '') {
        CustomAlert('Please Enter Start Date');
        secondDate.val('');
        return;
    }

    var date1 = new Date(firstDate.val());
    var date2 = new Date(secondDate.val());
    if (date2 < date1) {
        CustomAlert('Start Date Always Less than or Equal to End Date');
        secondDate.val('');
    }
}
function validateNewSP(validationGroup, isFromAuth, isSavebtn) {
    // 


    var $CheckBoxsAll;
    var gridview = $("#" + 'gvNewServicePlan');
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + "gvNewServicePlan").attr('ID') + " input:checkbox[id*=" + "ItemChkNewSPsc" + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + "ItemChkNewSPsc" + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");

    var appStatus = false;
    var authTypeStatus = false;

    var prevDate1 = new Date();
    var prevDate2 = new Date();
    var prevServiceId = 0;
    var flag = true;
    var index1 = 0;
    var index2 = 0;
    var reqCntrls = ["txtAutoSPDesc", "txtAutoSPProv", "ddlNewGLob", "txtNewSPFromDate", "txtTNewSPToDate", "ddlMembNewUnitType", "ddlMembNFrequency"]
    var reqLabels = ["lblreqMsgNewSPDescription", "lblreqMsgNewSPProv", "lblreqMsgNewGLob", "lblreqMsgNewGStartDate", "lblreqMsgNewGToDate", "lblreqMsgNewGNewUnitType", "lblreqMsgNewGNewFrequency", "lblreqMsgNewGNewDecisionStatus", "lblMsgAunit"];
    var reqCntrlsLength = reqCntrls.length;
    $($CheckBoxsAll).each(function (i) {
        var chk = $(this).attr('id');
        reqLabels.forEach(
            function (val, ind) {
                var reqLabel = chk.replace('ItemChkNewSPsc', val);
                var label = $('#' + reqLabel)[0];
                label.innerHTML = '';
                if (parseInt(ind, 10) < parseInt(reqCntrlsLength, 10)) {
                    var reqtext = chk.replace('ItemChkNewSPsc', reqCntrls[ind]);
                    var cntrl = $('#' + reqtext)[0];
                    var cntrl = $find(reqtext);
                    if (cntrl === null || (cntrl || '') === '') {
                        cntrl = $('#' + reqtext)[0];
                    }
                    if (cntrl.value == '' || cntrl._value == '-1') {
                        label.innerHTML = '*';
                        flag = false;
                    }
                }

            }
        );

    });

    if (!flag) {
        return false;
    }

    if ($CheckBoxsAll.length > 0) {

        $($CheckBoxsAll).each(function (i) {

            var chk = $(this).attr('id');
            //var service = chk.replace('ItemChkNewSPsc', 'ddlNewSPDescription');
            var service = chk.replace('ItemChkNewSPsc', 'hdGNewDescId');
            var fdate = chk.replace('ItemChkNewSPsc', 'txtNewSPFromDate');
            var tdate = chk.replace('ItemChkNewSPsc', 'txtTNewSPToDate');
            var status = chk.replace('ItemChkNewSPsc', 'ddlMembNewDecisionStatus');
            var reqAunit = chk.replace('ItemChkNewSPsc', 'lblMsgAunit');

            var rUnit = chk.replace('ItemChkNewSPsc', 'txtMembGNewRUnits');
            var aUnit = chk.replace('ItemChkNewSPsc', 'txtMembGNewAUnits');

            var authType = chk.replace('ItemChkNewSPsc', 'lblMsgAuthType');
            var acId = chk.replace('ItemChkNewSPsc', 'ddlMembNAuthClass');
            var atId = chk.replace('ItemChkNewSPsc', 'ddlMembNAuthType');
            var atypeId = chk.replace('ItemChkNewSPsc', 'hdGNewAuthTypeId');

            var acCombo = $find(acId);
            var atCombo = $find(atId);
            var authTypes = $("#" + authType);
            var atypeIds = $("#" + atypeId);



            if ((acCombo || atCombo || '') != '') {

                //console.log(atCombo);
                if (acCombo._value != '-1' && atCombo._value == '-1') {
                    authTypes[0].innerHTML = '*';
                    flag = false;
                    return false;
                }

                //console.log(atCombo._value);
                if (authTypeStatus == false && atCombo._value != '-1') {
                    authTypeStatus = true;
                }
            }

            if ((atCombo || '') == '' && (isSavebtn || false) == true && atypeIds.val() != '') {
                //console.log(atypeIds.val());
                authTypeStatus = true;
            }

            //var dropProvider = $telerik.$("#ctl00_UserControlPlaceHolder_app_pages_cm_manage_manageserviceplan_ascx_MSplan_gvMembSPServiceCategory_ctl02_ddlMembGProvider_0");
            //var serviceId = $telerik.$("#" + service + "");
            var serviceId = $("#" + service);
            var fromDate = $("#" + fdate);
            var toDate = $("#" + tdate);
            var statuss = $("#" + status);
            var reqAunits = $("#" + reqAunit);

            var rUnits = $("#" + rUnit);
            var aUnits = $("#" + aUnit);


            var date1 = new Date(fromDate.val());
            var date2 = new Date(toDate.val());

            if (ReqAndAppUnits(rUnits, aUnits, 1) == false) {
                reqAunits[0].innerHTML = '*';
                flag = false;
                return false;
            }

            if (statuss.val().trim() == 'Approved' && flag == true) {
                //if (aUnits.val() == '') {
                //    //Page_ClientValidate(validationGroup);
                //    flag = false;
                //} else {
                flag = ReqAndAppUnits(rUnits, aUnits, 2);
                //}

                if (flag == false) {
                    // reqAunits[0].style.display = 'block';
                    reqAunits[0].innerHTML = '*';
                    return false;
                }
                if (!appStatus) {
                    appStatus = true;
                }
            }

            if (statuss.val().trim() == 'Denied' && flag == true) {

                flag = ReqAndAppUnits(rUnits, aUnits, 3);
                if (flag == false) {
                    //reqAunits[0].style.display = 'block';
                    reqAunits[0].innerHTML = '*';
                    return false;
                }
            }

            $($CheckBoxsAll).each(function (j) {
                if (i != j) {
                    var cchk = $(this).attr('id');
                    //var cservice = cchk.replace('ItemChkNewSPsc', 'ddlNewSPDescription');
                    var cservice = cchk.replace('ItemChkNewSPsc', 'hdGNewDescId');
                    var cfdate = cchk.replace('ItemChkNewSPsc', 'txtNewSPFromDate');
                    var ctdate = cchk.replace('ItemChkNewSPsc', 'txtTNewSPToDate');

                    //var dropProvider = $telerik.$("#ctl00_UserControlPlaceHolder_app_pages_cm_manage_manageserviceplan_ascx_MSplan_gvMembSPServiceCategory_ctl02_ddlMembGProvider_0");
                    // var cserviceId = $telerik.$("#" + cservice + "");
                    var cserviceId = $("#" + cservice);
                    var cfromDate = $("#" + cfdate);
                    var ctoDate = $("#" + ctdate);

                    var cdate1 = new Date(cfromDate.val());
                    var cdate2 = new Date(ctoDate.val());
                    if (cserviceId.val() == serviceId.val() && ((date1 >= cdate1 && date1 <= cdate2) || (date2 >= cdate1 && date2 <= cdate2) || (date1 < cdate1 && date2 > cdate2))) {
                        CustomAlert('Service Category already exists for same time period. (Row ' + (i + 1) + ' and ' + (j + 1) + ' )');
                        flag = false;
                        return false;
                    }

                }

            });

            if (!flag) {
                return false;
            }

            //if (i == 0) {
            //    prevDate1 = date1;
            //    prevDate2 = date2;
            //    prevServiceId = serviceId;
            //} else {
            //    if (prevServiceId == serviceId && ((prevDate1 >= date1 && prevDate1 <= date2) || (prevDate2 >= date1 && prevDate2 <= date2) || (prevDate2 < date1 && prevDate2 > date2))) {
            //        alert('Service Category already exists for same time period.');
            //        return false;
            //    }
            //    prevDate1 = date1;
            //    prevDate2 = date2;
            //    prevServiceId = serviceId;
            //}

        });

        if (isFromAuth != null && flag) {
            if ($CheckBoxsChecked.length == 0) {
                CustomAlert('Please select at least one record to submit an authorization request.');
                return false;
            }
        }
    } else {

        flag = false;
    }
    //if (!flag) {
    //    return false;
    //} else {
    //    return true;
    //}

    //console.log({ authTypeStatus: authTypeStatus, flag: flag, isSavebtn: isSavebtn });
    if (authTypeStatus && flag && (isSavebtn || false) == true) {
        flag = CustomConfirm('This service usually requires authorization. Click Save & Submit Auth to create an authorization, or click ok to proceed.');
    }
    //console.log({ flags: flag, appStatuss: appStatus, bb: (isSavebtn || false == true) });
    if (flag && appStatus && (isSavebtn || false) == true) {
        flag = CustomConfirm('Are you sure, you want to approve the selected service categories? Once approved service categories cannot be modified.');
    }
    return flag;
}
function validateNewSP1(validationGroup, isFromAuth, isSavebtn) {



    var $CheckBoxsAll;
    var gridview = $("#" + 'gvNewServicePlan');
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + "gvNewServicePlan").attr('ID') + " input:checkbox[id*=" + "ItemChkNewSPsc" + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + "ItemChkNewSPsc" + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");

    var appStatus = false;
    var authTypeStatus = false;

    var prevDate1 = new Date();
    var prevDate2 = new Date();
    var prevServiceId = 0;
    var flag = true;
    var index1 = 0;
    var index2 = 0;


    $($CheckBoxsAll).each(function (i) {
        var chk = $(this).attr('id');

        var reqAunit = chk.replace('ItemChkNewSPsc', 'lblMsgAunit');
        //$('#' + reqAunit).attr('style', 'display:none;color:Red;');
        $('#' + reqAunit)[0].innerHTML = '';
        var authType = chk.replace('ItemChkNewSPsc', 'lblMsgAuthType');

        $('#' + authType)[0].innerHTML = '';
    });

    if ($CheckBoxsAll.length > 0 && Page_ClientValidate(validationGroup)) {

        $($CheckBoxsAll).each(function (i) {

            var chk = $(this).attr('id');
            //var service = chk.replace('ItemChkNewSPsc', 'ddlNewSPDescription');
            var service = chk.replace('ItemChkNewSPsc', 'hdGNewDescId');
            var fdate = chk.replace('ItemChkNewSPsc', 'txtNewSPFromDate');
            var tdate = chk.replace('ItemChkNewSPsc', 'txtTNewSPToDate');
            var status = chk.replace('ItemChkNewSPsc', 'ddlMembNewDecisionStatus');
            var reqAunit = chk.replace('ItemChkNewSPsc', 'lblMsgAunit');

            var rUnit = chk.replace('ItemChkNewSPsc', 'txtMembGNewRUnits');
            var aUnit = chk.replace('ItemChkNewSPsc', 'txtMembGNewAUnits');

            var authType = chk.replace('ItemChkNewSPsc', 'lblMsgAuthType');
            var acId = chk.replace('ItemChkNewSPsc', 'ddlMembNAuthClass');
            var atId = chk.replace('ItemChkNewSPsc', 'ddlMembNAuthType');
            var atypeId = chk.replace('ItemChkNewSPsc', 'hdGNewAuthTypeId');

            var acCombo = $find(acId);
            var atCombo = $find(atId);
            var authTypes = $("#" + authType);
            var atypeIds = $("#" + atypeId);



            if ((acCombo || atCombo || '') != '') {

                //console.log(atCombo);
                if (acCombo._value != '-1' && atCombo._value == '-1') {
                    authTypes[0].innerHTML = '*';
                    flag = false;
                    return false;
                }

                //console.log(atCombo._value);
                if (authTypeStatus == false && atCombo._value != '-1') {
                    authTypeStatus = true;
                }
            }

            if ((atCombo || '') == '' && (isSavebtn || false) == true && atypeIds.val() != '') {
                //console.log(atypeIds.val());
                authTypeStatus = true;
            }

            //var dropProvider = $telerik.$("#ctl00_UserControlPlaceHolder_app_pages_cm_manage_manageserviceplan_ascx_MSplan_gvMembSPServiceCategory_ctl02_ddlMembGProvider_0");
            //var serviceId = $telerik.$("#" + service + "");
            var serviceId = $("#" + service);
            var fromDate = $("#" + fdate);
            var toDate = $("#" + tdate);
            var statuss = $("#" + status);
            var reqAunits = $("#" + reqAunit);

            var rUnits = $("#" + rUnit);
            var aUnits = $("#" + aUnit);


            var date1 = new Date(fromDate.val());
            var date2 = new Date(toDate.val());

            if (ReqAndAppUnits(rUnits, aUnits, 1) == false) {
                flag = false;
                return false;
            }

            if (statuss.val().trim() == 'Approved' && flag == true) {
                //if (aUnits.val() == '') {
                //    //Page_ClientValidate(validationGroup);
                //    flag = false;
                //} else {
                flag = ReqAndAppUnits(rUnits, aUnits, 2);
                //}

                if (flag == false) {
                    // reqAunits[0].style.display = 'block';
                    reqAunits[0].innerHTML = '*';
                    return false;
                }
                if (!appStatus) {
                    appStatus = true;
                }
            }

            if (statuss.val().trim() == 'Denied' && flag == true) {

                flag = ReqAndAppUnits(rUnits, aUnits, 3);
                if (flag == false) {
                    //reqAunits[0].style.display = 'block';
                    reqAunits[0].innerHTML = '*';
                    return false;
                }
            }

            $($CheckBoxsAll).each(function (j) {
                if (i != j) {
                    var cchk = $(this).attr('id');
                    //var cservice = cchk.replace('ItemChkNewSPsc', 'ddlNewSPDescription');
                    var cservice = cchk.replace('ItemChkNewSPsc', 'hdGNewDescId');
                    var cfdate = cchk.replace('ItemChkNewSPsc', 'txtNewSPFromDate');
                    var ctdate = cchk.replace('ItemChkNewSPsc', 'txtTNewSPToDate');

                    //var dropProvider = $telerik.$("#ctl00_UserControlPlaceHolder_app_pages_cm_manage_manageserviceplan_ascx_MSplan_gvMembSPServiceCategory_ctl02_ddlMembGProvider_0");
                    // var cserviceId = $telerik.$("#" + cservice + "");
                    var cserviceId = $("#" + cservice);
                    var cfromDate = $("#" + cfdate);
                    var ctoDate = $("#" + ctdate);

                    var cdate1 = new Date(cfromDate.val());
                    var cdate2 = new Date(ctoDate.val());
                    if (cserviceId.val() == serviceId.val() && ((date1 >= cdate1 && date1 <= cdate2) || (date2 >= cdate1 && date2 <= cdate2) || (date1 < cdate1 && date2 > cdate2))) {
                        CustomAlert('Service Category already exists for same time period. (Row ' + (i + 1) + ' and ' + (j + 1) + ' )');
                        flag = false;
                        return false;
                    }

                }

            });

            if (!flag) {
                return false;
            }

            //if (i == 0) {
            //    prevDate1 = date1;
            //    prevDate2 = date2;
            //    prevServiceId = serviceId;
            //} else {
            //    if (prevServiceId == serviceId && ((prevDate1 >= date1 && prevDate1 <= date2) || (prevDate2 >= date1 && prevDate2 <= date2) || (prevDate2 < date1 && prevDate2 > date2))) {
            //        alert('Service Category already exists for same time period.');
            //        return false;
            //    }
            //    prevDate1 = date1;
            //    prevDate2 = date2;
            //    prevServiceId = serviceId;
            //}

        });

        if (isFromAuth != null && flag) {
            if ($CheckBoxsChecked.length == 0) {
                CustomAlert('Please select at least one record to submit an authorization request.');
                return false;
            }
        }
    } else {

        flag = false;
    }
    //if (!flag) {
    //    return false;
    //} else {
    //    return true;
    //}

    //console.log({ authTypeStatus: authTypeStatus, flag: flag, isSavebtn: isSavebtn });
    if (authTypeStatus && flag && (isSavebtn || false == true)) {
        CustomAlert('This service usually requires authorization. Click Save & Submit Auth to create an authorization, or click Save again to proceed.');
    }
    //console.log({ flags: flag, appStatuss: appStatus, bb: (isSavebtn || false == true) });
    if (flag && appStatus && (isSavebtn || false == true)) {
        flag = CustomConfirm('Are you sure, you want to approve the selected service categories? Once approved service categories cannot be modified.');
    }
    return flag;
}
function scriptOGGIValidation() {
    var dropGoalGroup = $telerik.$("#ddlSerGoalGroup");
    var dropOpportunity = $telerik.$("#ddlOpportunity");
    $("#RequiredFieldValidatorSCPT").attr('style', 'display:none;color:Red;');
    $("#RequiredFieldValidator1SCPT").attr('style', 'display:none;color:Red;');

    if (dropOpportunity.val() == '' || dropGoalGroup.val() == 'Select Goal Group') {
        $("#RequiredFieldValidatorSCPT").attr('style', 'display:block;color:Red;');
        $("#RequiredFieldValidator1SCPT").attr('style', 'display:block;color:Red;');
        Page_ClientValidate("OGIS");
        return false;

    } else {
        return true;
    }
}
function gridCareUnitsValidation(Textbox1, Textbox2, CTextbox) {

    var text1 = $(Textbox1);
    var text2 = $(Textbox2);
    if (text1.length > 0) {
        text2 = $("#" + text1.attr('id').replace(CTextbox, Textbox2));
    } else {

        text1 = $("#" + text2.attr('id').replace(CTextbox, Textbox1));
    }

    //var val1;
    //var val2;

    //if (text1.val() != '') {
    //    val1 = parseInt(text1.val());
    //} else {
    //    val1 = 0;
    //}

    //if (text2.val() != '') {
    //    val2 = parseInt(text2.val());
    //} else {
    //    val2 = 0;
    //}

    //if (val1 < val2)
    //{
    //    alert('Approved Units Always Less than or Equal to Requested Units');
    //    text2.val('');

    //}
    ReqAndAppUnits(text1, text2, 1);
    return;
}
function ReqAndAppUnits(text1, text2, funcNum, text3) {
    var val1;
    var val2;
    var val3;

    if (text1.val() != '') {
        val1 = parseInt(text1.val());
    } else {
        val1 = 0;
    }

    if (text2.val() != '') {
        val2 = parseInt(text2.val());
    } else {
        val2 = 0;
    }

    if (text3 || '' != '' && text3.val() != '') {
        val3 = parseInt(text3.val());
    } else {
        val3 = 0;
    }

    if (funcNum == 1) {
        if (val1 < val2) {
            CustomAlert('Approved units should be less than or equal to the Recommended units');
            if (val2 == '0') {
                text2.val('0');
            }
            return false;
        }
    } else if (funcNum == 2) {

        if (val1 != val2) {
            CustomAlert('Approved units should be equal to recommended units for approvals');
            if (val2 == '0') {
                text2.val('0');
            }
            return false;
        }
    }
    else if (funcNum == 3) {

        if (val2 != 0) {
            CustomAlert('Approved units should be zero for denials');
            return false;
        }
    }
    else if (funcNum == 4) {

        if (val2 < val3) {
            CustomAlert('Used units should be less than or equal to the Approved units');
            if (val3 == '0') {
                text3.val('0');
            }
            return false;
        }
    }

    return true;
}
function validateAddAppointment() {
    var isValid = true;
    var ddlTypeOfAppointment = $("#ddlTypeOfAppointment").val();
    var txtAppointmentReason = $("#txtReason").val();
    var txtProvName = $("#txtProvName").val();
    var ddlSaveStatus = $("#ddlSaveStatus").val();
    var txtProviderCode = $("#txtProviderCode").val();
    if (ddlTypeOfAppointment == "-1") {
        isValid = false;
        $("#lblAppointmentType").show();
    }
    else
        $("#lblAppointmentType").hide();
    //if (txtAppointmentReason == "") {
    //    $("#lblAppointmentReason").show();
    //    isValid = false;
    //}
    //else
    $("#lblAppointmentReason").hide();
    if (ddlSaveStatus == "-1") {
        isValid = false;
        $("#lblAppointmentStatus").show();
    }
    else
        $("#lblAppointmentStatus").hide();
    if (txtProviderCode == "") {
        $("#lblAppointmentProviderCode").show();
        isValid = false;
    }
    else
        $("#lblAppointmentProviderCode").hide();
    if (txtProvName == "") {
        $("#lblAppointmentProviderName").show();
        isValid = false;
    }
    else
        $("#lblAppointmentProviderName").hide();
    return isValid;

}
function SetAuthDataInFrame(PatientId, AuthId, AuthClassId, AuthNo, PatientFName, PatientLName, FrameId) {

    var AuthData = AuthNo + "_" + PatientId + "_" + AuthClassId + "_" + AuthId + "_" + PatientFName + "_" + PatientLName;
    localStorage.removeItem("AUTH_DATA");
    localStorage.setItem("AUTH_DATA", AuthData);
    CustomAlert(document.getElementById(FrameId).src);
    document.getElementById(FrameId).src = document.getElementById(FrameId).src.replace('~', '');
    CustomAlert(document.getElementById(FrameId).src);
}
function validateOGGIMatrix() {
    if (Page_ClientValidate("OGISAVE")) {
        CustomAlert('The guideline source will update the previous guideline source for a preexisting OGGI combination');
        return true;
    } else {
        return false;
    }
}
function DeleteInvalidFiles() {
    var upload = $find("flUpload");
    var inputs = upload.getUploadedFiles();
    for (i = inputs.length - 1; i >= 0; i--) {
        upload.deleteFileInputAt(i);
    }
}
function validateFlUpload(sender, args) {
    var upload = $find("flUpload");

    if (upload.getUploadedFiles().length != 0) {
        args.IsValid = true;
        return;
    }
    else {
        args.IsValid = false;
        return;
    }
}
function isNumberKeyToPhone(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    if (charCode != 45 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;

    return true;
}
function ValidateEmail(email) {
    var Result = true;
    if ($.trim(email) != "") {
        var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (!reg.test(email)) { Result = false; }
    }
    return Result;
}
function validateSPRecommandedDelete() {

    var $CheckBoxsAll;
    var gridview = $("#" + 'gvMembSPServiceCategory');
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + "gvMembSPServiceCategory").attr('ID') + " input:checkbox[id*=" + "ItemChkMembSPsc" + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + "ItemChkMembSPsc" + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
    var flag = true;

    if ($CheckBoxsChecked.length > 0) {
        $($CheckBoxsChecked).each(function (i) {

            var chk = $(this).attr('id');
            var authId = chk.replace('ItemChkMembSPsc', 'lblAuthID');
            var authIds = $("#" + authId);
            if (authIds.html() != 'N/A' && flag == true) {
                CustomAlert('You cannot delete selected records as authorizations are submitted');
                flag = false;
                return;
            }


        });
    }
    if (flag) {
        flag = CustomConfirm('Are you sure you want to delete this service plan?');
    }
    return flag;
}
function ServicePlanClientIertemSelected(sender, e) {

    Page_ValidationActive = false;
    // $('#hfIcdAutoId').val(e.get_value());
    // Page_ClientValidate('MembNewGSPS');
    var textboxControl = $(sender.get_element());
    var txtId = textboxControl.attr('id');
    var hdndesId = txtId.replace('txtAutoSPDesc', 'hdnAutoSP');
    var hdndesIds = $("#" + hdndesId);

    var hdnCtypeId = txtId.replace('txtAutoSPDesc', 'hdnNewCodeType');
    var hdnCtypeIds = $("#" + hdnCtypeId);
    var hdnNewCode = txtId.replace('txtAutoSPDesc', 'hdnNewCode');
    var hdnNewCodes = $("#" + hdnNewCode);
    var values = e.get_value().split(':');

    if (values.length >= 1)
        hdnCtypeIds.val(values[0]);
    if (values.length >= 2)
        hdndesIds.val(values[1]);
    if (values.length >= 3)
        hdnNewCodes.val(values[2]);

    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        textboxControl.attr('title', '');
        hdndesIds.val('');
        clearNewSPControlValues(textboxControl, 'txtAutoSPDesc');
        return false;

    } else {
        textboxControl.val(e._text.split(':')[1]);
        textboxControl.attr('title', e._text);
        __doPostBack(txtId, '');
    }



    //textboxControl.attr('title', e._text);


}
function clearNewSPControlValues(object, txtCtl) {
    try {
        var ctlId = $(object).attr('id');

        var provId = ctlId.replace(txtCtl, 'txtAutoSPProv');
        $('#' + provId).val('');

        var fromId = ctlId.replace(txtCtl, 'txtNewSPFromDate');
        $('#' + fromId).val('');

        var toId = ctlId.replace(txtCtl, 'txtTNewSPToDate');
        $('#' + toId).val('');

        var rUnitsId = ctlId.replace(txtCtl, 'txtMembGNewRUnits');
        $('#' + rUnitsId).val('');

        var aUnitsId = ctlId.replace(txtCtl, 'txtMembGNewAUnits');
        $('#' + aUnitsId).val('');

        var uUintsId = ctlId.replace(txtCtl, 'txtMembNewGUUnits');
        $('#' + uUintsId).val('');


        //var lobId = ctlId.replace(txtCtl, 'ddECTlLOB');
        //var items = $find(lobId).get_items();
        //for (var i = 0; i <= items.get_count() - 1; i++) {
        //    var item = items.getItem(i);
        //    item.set_checked(false);
        //}

        var lobId = ctlId.replace(txtCtl, 'ddlNewGLob');
        setDropDownDefaultValue($find(lobId));

        var unitTypeId = ctlId.replace(txtCtl, 'ddlMembNewUnitType');
        setDropDownDefaultValue($find(unitTypeId));

        var frequencyId = ctlId.replace(txtCtl, 'ddlMembNFrequency');
        setDropDownDefaultValue($find(frequencyId));

        var dStatusId = ctlId.replace(txtCtl, 'ddlMembNewDecisionStatus');
        setDropDownDefaultValue($find(dStatusId));

        var gUsedId = ctlId.replace(txtCtl, 'ddlMembNewGGUsed');
        setDropDownDefaultValue($find(gUsedId), 1);

        var aClassId = ctlId.replace(txtCtl, 'ddlMembNAuthClass');
        if ($find(aClassId) || '' != '')
            setDropDownDefaultValue($find(aClassId));

        var aTypeId = ctlId.replace(txtCtl, 'ddlMembNAuthType');
        if ($find(aTypeId) || '' != '')
            setDropDownDefaultValue($find(aTypeId));
    } catch (e) {
        //alert(e.message);
        console.log(e.message);

    }
}
function CptItemSelected(sender, e) {
    // $('#hfIcdAutoId').val(e.get_value());
    if ($('#hdnSelect').val() == "1" || $('#hdnSelect').val() == "") {
        return AlertOnActionMulti('gvCptCode', 'ItemCptCode', 'Please Select at least one record to Select CPT Code.', '');
    }
    else {
        return true;
    }

}
function validateNewSPC() {

    var $CheckBoxsAll;
    var gridview = $("#" + 'gvNewServicePlan');
    if (gridview.length == 0) //If ClientIDMode is not static                   
        $CheckBoxsAll = $("#" + $("table." + "gvNewServicePlan").attr('ID') + " input:checkbox[id*=" + "ItemChkNewSPsc" + "]");
    else
        $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + "ItemChkNewSPsc" + "]");
    var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");

    if ($CheckBoxsChecked.length > 1) {
        CustomAlert('Please select only one record for adding service plan');
        return false;
    } else {
        return true;
    }
}
function ServicePlanProvItemSelected(sender, e) {
    // $('#hfIcdAutoId').val(e.get_value());
    var textboxControl = $(sender.get_element());
    var provId = textboxControl.attr('id').replace('txtAutoSPProv', 'hdGNewProvId');
    var prov = $('#' + provId);
    if (e.get_value() == "0" || e.get_value() == "-1") {
        textboxControl.val('');
        textboxControl.attr('title', '');
        prov.val('');
    } else {
        textboxControl.val(e.get_value());
        textboxControl.val(e._text.split(':')[1]);
        //textboxControl.attr('title', e._text);
        prov.val(e.get_value());
    }
}
//uhc-176
function CareStaffItemSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hfCareStaffId').val(e.get_value());
        $("#txtCareStaffAuto").val(e.get_text());
    }
    else {
        return false;
    }
}

function OnCareStaffAutoCleared() {
    $("#hfCareStaffId").val('');
}


function ClearTextBoxVaule() {
    if ($("#hfCareStaffId").val() == '') {
        $("#txtCareStaffAuto").val('');
    }
}
//uhc-176

function OnLevelOfCareAutoCleared() {
    $("#hdnLocId").val('');
}

function LevelOfCareItemSelected(sender, e) {
    if (e.get_text() != "No Records Found") {
        $('#hdnLocId').val(e.get_value());
        $("#txtLevelOfCareAuto").val(e.get_text());
    }
    else {
        return false;
    }
}

function autoSearchTextBoxChange(object, textId, hiddenId) {

    var textboxControl = $(object);
    var prov = $('#' + textboxControl.attr('id').replace(textId, hiddenId));
    if (prov || '' != '') {
        if (textId == 'txtEXtNameAuto') {
            clearExtControlValues(object, textId);
        } else {
            switch (textId) {
                case "txtAutoSPDesc":
                    clearNewSPControlValues(object, textId);
                    break;
                case "txtCGNameAuto":
                    clearCGControlValues(object, textId);
                    break;
                default:
                    break;
            }
            textboxControl.val('');
        }
        textboxControl.attr('title', '');
        prov.val('');

    }
}
function membSpLobDropDownOpenedChange(sender, eventArgs) {


    var ddId = $(sender.get_element())[0].id;
    var acId = ddId.replace('ddlNewGLob', 'ddlMembNAuthClass');
    var atId = ddId.replace('ddlNewGLob', 'ddlMembNAuthType');

    var acCombo = $find(acId);
    var atCombo = $find(atId);

    if ((acCombo || atCombo || '') == '')
        return;

    if ($('#' + ddId)[0].value == 'Select') {

        if (acCombo._value != '-1') {
            acCombo.trackChanges();
            acCombo.get_items().getItem(0).select();
            acCombo.updateClientState();
            acCombo.commitChanges();
        }
        if (atCombo._value != '-1') {
            atCombo.trackChanges();
            atCombo.get_items().getItem(0).select();
            atCombo.updateClientState();
            atCombo.commitChanges();
        }


    }

}
function membSPLObSelectVerify(divId, divType) {
    var $divId = $(divId).attr('id');
    var atId = $divId.replace(divType, 'ddlMembNAuthType');
    var atCombo = $find(atId);

    if ((atCombo || '') == '')
        return;

    var lobId = $divId.replace(divType, 'ddlNewGLob');

    if ($('#' + lobId)[0].value == 'Select') {
        CustomAlert('Please choose LOB before selecting Auth Class');
    }

}
function MemberProgramValidations() {
    if (Page_ClientValidate('addProg')) {
        var ctoDate = $("#txtEndDate");
        var confirmValue = true;
        if (ctoDate.val() != '') {
            var cdate1 = new Date(ctoDate.val());
            var currentDate = new Date();

            if (cdate1 < currentDate) {

                var editType = $('#hdnMPEditType').val();
                if (editType == '1')
                    confirmValue = CustomConfirm('LOB inactivation will cause the inactivation of all associated Plans and Programs​. Are you sure, you want to inactivate the LOB?');
                else if (editType == '2')
                    confirmValue = CustomConfirm('Plan inactivation will cause the inactivation of all associated Programs​. Are you sure, you want to inactivate the PLAN?');
            }
        }

        return confirmValue;
    }
    else {
        return false;
    }
}
function DisableControls(pnlControl) {
    var parentControl = "#" + pnlControl;
    $(parentControl).find(".tdDtaEdit").each(function () {
        $(this).find(".aspNetDisabled").each(function () {
            if ($(this)[0].disabled = true) {
                if ($(this)[0].tagName.toLowerCase() == "input" || $(this)[0].tagName.toLowerCase() == "textarea") {
                    $(this)[0].className = "txtboxfieldDisabled";
                }
                else if ($(this)[0].tagName.toLowerCase() == "select") {
                    $(this)[0].className = "SelectBoxLDisabled";
                }
            }
        });
    });
}
function ValidateAuthPriority() {
    if ($(".txtUmMaAuthPriorityMinimumTAT").val().trim() != '') {
        if ($(".ddlUmMaPriorityTimeTypeMin").val() <= 0) { $(".ReqddlUmMaPriorityTimeTypeMin").show(); return false; }

    }

    $(".ReqddlUmMaPriorityTimeTypeMin").hide();
    $(".ReqddlAuthInfoReciptDate").hide();
    return true;
}
function ValidateReferance() {
    if ($(".txtUmMaAuthPriorityMinimumTAT").val().trim() != '') {
        if ($(".ddlAuthInfoReciptDate").val() <= 0) { $(".ReqddlAuthInfoReciptDate").show(); return false; }
    }
    $(".ReqddlAuthInfoReciptDate").hide();
    return true;
}
function ValidateExtentionTime() {
    if ($(".txtUmMaAuthPriorityET").val().trim() != '') {
        if ($(".ddlUmMaPriorityTimeTypeExt").val() <= 0) { $(".ReqddlUmMaPriorityTimeTypeExt").show(); return false; }
    }
    $(".ReqddlUmMaPriorityTimeTypeExt").hide();
    return true;
}
function validateWeightage(value) {
    var splittedValues = value.split(/\./);
    if (splittedValues.length > 0 && splittedValues[0].length > 3)
        return false;
    else if (splittedValues.length > 1 && (splittedValues[0].length > 3 || splittedValues[1].length > 2 || (splittedValues[0].length == 3 && splittedValues[1].length == 1)))
        return false;
    else if (splittedValues.length > 0 && splittedValues[0] > 100)
        return false;
    return true;
}
function validateEstimatedRisk(isLobOnly) {
    var lblMERMessage = $("#lblMERMessage");
    var lobs = $('#hdnMERLOBs').val();
    if ((lobs || "") == "") {
        lblMERMessage.html('Select ' + window.top.RiskLevel + '.');
        return false;
    }

    if (isLobOnly == null) {
        var scptWeightage = $("#txtMERScriptWeightage").val();
        var oppWeightage = $("#txtMEROppWeightage").val();
        var cdpsWeightage = $("#txtMERCDPSWeightage").val();
        var cdpsPercentage = $("#txtMERCDPSPercentage").val();
        var oppCount = $("#txtMEROppCount").val();
        var isOppWeightageValid = false;
        if (oppWeightage == "") {
            lblMERMessage.html('Enter opportunities weightage.');
            return false;
        }
        else {
            if (!validateWeightage(oppWeightage)) {
                lblMERMessage.html('Enter valid opportunities weightage.');
                return false;
            }
            else {
                if (!IsWeightageZeroOrEmpty(oppWeightage))
                    isOppWeightageValid = true;
            }
        }

        if ($('#ddlOpportunityType').val() == "") {
            lblMERMessage.html('Select Max. opportunity count value.');
            return false;
        }

        if (isOppWeightageValid) {
            if ((oppCount == "" || oppCount == "0") && $("#txtMaxOppCount").val() != "0") {//$("#lblMaxOppCount")[0].innerHTML != "0") {
                lblMERMessage.html('Enter opportunity count.');
                return false;
            }

            if (parseInt(oppCount) > parseInt($("#txtMaxOppCount").val())) {//parseInt($("#lblMaxOppCount")[0].innerHTML)) {
                lblMERMessage.html('Opportunity count can not be more than Max opp. count.');
                return false;
            }
        }

        if (cdpsWeightage == "") {
            lblMERMessage.html('Enter CDPS weightage.');
            return false;
        }
        else {
            if (!validateWeightage(cdpsWeightage)) {
                lblMERMessage.html('Enter valid CDPS weightage.');
                return false;
            }
        }

        if (scptWeightage == "") {
            lblMERMessage.html('Enter script weightage.');
            return false;
        }
        else {
            if (!validateWeightage(scptWeightage)) {
                lblMERMessage.html('Enter valid script weightage.');
                return false;
            }
        }

        if ((cdpsPercentage == "" || cdpsPercentage == "0") && !IsWeightageZeroOrEmpty(cdpsWeightage)) {
            lblMERMessage.html('Enter CDPS percentage.');
            return false;
        }
        else {
            if (parseFloat(cdpsPercentage) > 100 && !IsWeightageZeroOrEmpty(cdpsWeightage)) {
                lblMERMessage.html('CDPS percentage cannot be more than 100.');
                return false;
            }
        }

        //Prod-3653
        var gridview = $("#Gridview1");
        var hasValue = true;
        var sumOfWeightages = 0;
        if (gridview.length > 0) {
            $("#Gridview1 tr").each(function () {
                var ddEstimatedRiskType = $(this).find('.clsestimatedRiskTypes');
                var textBox = $(this).find('.clstxtRiskWeightage');
                var txtPercentage = $(this).find('.clstxtRiskPercentage');
                var lblRiskPercentage = $(this).find('.clslblRiskPercentage');
                if (ddEstimatedRiskType.val() != "-1") {
                    if (textBox.val() != "0" && textBox.val() != '') {
                        sumOfWeightages += parseFloat(textBox.val());
                        if (IsWeightageZeroOrEmpty(txtPercentage.val())) {
                            $(this).find('.clstxtRiskPercentage').append('<span class="validationMessage" style="color:red">*</span>');
                            lblMERMessage.html('Enter ' + lblRiskPercentage.html().replace(':', '') + '.');
                            hasValue = false;
                        }
                        else {
                            if (parseFloat(txtPercentage.val()) > 100 && !IsWeightageZeroOrEmpty(textBox.val())) {
                                lblMERMessage.html(lblRiskPercentage.html().replace(':', '') + ' cannot be more than 100.');
                                hasValue = false;
                            }
                        }
                    }
                }
            });
            // return hasValue;
        }
        //

        if (!hasValue)
            return hasValue;

        if (parseFloat(scptWeightage) + parseFloat(oppWeightage) + parseFloat(cdpsWeightage) + parseFloat(sumOfWeightages) != 100) {
            lblMERMessage.html('Sum of weightages should be equal to 100.');//opportunity, CDPS and script 
            return false;
        }

        if (parseInt(scptWeightage) != 0) {
            var $CheckBoxsAll;
            var gridview = $("#gvERScriptIRiskPercentage");

            if (gridview.length > 0) {
                $CheckBoxsChecked = $("#gvERScriptIRiskPercentage input:checkbox:checked[id*=" + "ItemChkERScriptScore" + "]");
                $CheckBoxsNotChecked = $("#gvERScriptIRiskPercentage input:checkbox[id*=" + "ItemChkERScriptScore" + "]");
                if ($CheckBoxsChecked.length == 0) {
                    lblMERMessage.html('Please select at least one record for individual script percentage.');
                    return false;
                }
                var scptPercentagesEntered = 0;
                var invalidWeightage = "";
                $($CheckBoxsChecked).each(function (i) {
                    var chk = $(this).attr('id');
                    var scptPercentageId = chk.replace('ItemChkERScriptScore', 'txtMERIScriptPercentage');
                    var scptPercentage = $("#" + scptPercentageId);
                    if (scptPercentage[0].value != "" && !IsWeightageZeroOrEmpty(scptPercentage[0].value)) {
                        if (validateWeightage(scptPercentage[0].value))
                            scptPercentagesEntered += parseFloat(scptPercentage[0].value);
                        else {
                            invalidWeightage = "1";
                            scptPercentage.focus();
                            return false;
                        }
                    }
                    else {
                        invalidWeightage = "1";
                        scptPercentage.focus();
                        return false;
                    }
                });
                var showchkMsg = "";
                $($CheckBoxsNotChecked).each(function (i) {
                    var chk = $(this).attr('id');
                    var scptPercentageIdE = chk.replace('ItemChkERScriptScore', 'txtMERIScriptPercentage');
                    var scptPercentageE = $("#" + scptPercentageIdE);
                    if (scptPercentageE[0].value != "" && scptPercentageE[0].value != "0" && $(this)[0].checked == false) {
                        showchkMsg = "1";
                        scptPercentageE.focus();
                        return false;
                    }
                });

                if (scptPercentagesEntered > 100) {
                    lblMERMessage.html('Sum of individual script percentages should be less than 100.');
                    return false;
                }
                if (showchkMsg == "1") {
                    lblMERMessage.html('Please select the record for which you have entered individual script percentage.');
                    return false;
                }
                if (invalidWeightage == "1") {
                    lblMERMessage.html('Enter valid individual script percentage.');
                    return false;
                }
            }
        }
    }
    return true;
}
function PreserveIndividualScriptWeightages() {
    $("#hdnPrevSelectedScriptWeightages").val('');
    var gridview = $("#gvERScriptIRiskPercentage");
    var $CheckBoxsChecked = $("#gvERScriptIRiskPercentage input:checkbox:checked[id*=" + "ItemChkERScriptScore" + "]");
    var prevValues = "";
    $($CheckBoxsChecked).each(function (i) {
        if ($(this)[0].checked == true) {
            var chk = $(this).attr('id');
            var scptId = chk.replace('ItemChkERScriptScore', 'hdnMERScriptId');
            var scptPercentageId = chk.replace('ItemChkERScriptScore', 'txtMERIScriptPercentage');
            var scptPercentage = $("#" + scptPercentageId);
            if (scptPercentage[0].value != "" && scptPercentage[0].value != "0") {
                var scriptIdAndScore = $("#" + scptId)[0].value + "$" + scptPercentage[0].value;
                prevValues += scriptIdAndScore;
                if (prevValues != "") { prevValues += "§"; }
            }
        }
    });
    if (prevValues != "")
        $("#hdnPrevSelectedScriptWeightages").val(prevValues.slice(0, -1));
}

function IsWeightageZeroOrEmpty(value) {
    var val = parseFloat(value);
    return (value == "" || val == 0 || isNaN(val));
}

function AutoCalculateWeightage(txtbox1, txtbox2, txtbox3, txtDynRiskType) {
    $("#lblMERMessage").html('');
    var gridview = $("#Gridview1");
    if (!validateWeightage(txtDynRiskType.value) || txtDynRiskType.value > 100) {
        $("#lblMERMessage").html('Enter valid weightage.');
        return;
    }
    var rowCount = $("#Gridview1 tr").length;
    var chkTextBoxEnable = false;
    $("#Gridview1 tr").each(function () {
        chkTextBoxEnable = $(this).find('.clstxtRiskWeightage').is(':disabled');
    });

    var flagTxtHasValue = false;
    var $textBox = $('.clstxtRiskWeightage:not([name="' + $(txtDynRiskType).attr("name") + '"],:disabled)');
    $textBox.each(function () {
        if (!IsWeightageZeroOrEmpty($(this).val()))
            flagTxtHasValue = true;
    });

    if (chkTextBoxEnable)
        rowCount = rowCount - 1;

    if (!flagTxtHasValue && !IsWeightageZeroOrEmpty($(txtDynRiskType).val())) {
        var dynvalue = txtDynRiskType.value;
        var dynVal = 0;
        if (rowCount > 1)
            dynVal = ((100 - (dynvalue)) / (3 + rowCount - 1)).toFixed(2);
        else
            dynVal = ((100 - (dynvalue)) / (3)).toFixed(2);


        dynVal = parseFloat(dynVal);
        $textBox.val(dynVal);

        RoundOfftoHundred($("#" + txtbox1).val(), $("#" + txtbox2).val(), $("#" + txtbox3).val(), txtbox2);
        return;
    }

    var remainingWeightage = (100 - parseFloat(txtDynRiskType.value)).toFixed(2);
    if (remainingWeightage == 0) {
        $textBox.val("0");
        return;
    }
}

function RoundOfftoHundred(weightage1, weightage2, weightage3, valueToModify) {
    var gridview = $("#Gridview1");
    var sumOfWeightages = 0;
    var cntrlToModify = $("#" + valueToModify);
    if (gridview.length > 0) {
        $("#Gridview1 tr").each(function () {
            var ddEstimatedRiskType = $(this).find('.clsestimatedRiskTypes');
            var textBox = $(this).find('.clstxtRiskWeightage');
            var isDisabled = textBox.is(':disabled');
            var val = parseFloat(textBox.val());
            if (ddEstimatedRiskType.val() != "-1") {
                if (!isDisabled && (val != 0 || val != '')) {
                    sumOfWeightages = sumOfWeightages + val;
                }
            }
        });
    }
    if (parseFloat(weightage1) + parseFloat(weightage2) + parseFloat(weightage3) + parseFloat(sumOfWeightages) != 100) {
        var diff = parseFloat(((parseFloat(weightage1) + parseFloat(weightage2) + parseFloat(weightage3) + parseFloat(sumOfWeightages)) - 100).toFixed(2));
        var cntrlValue = parseFloat(cntrlToModify.val());
        var res = (cntrlValue - diff).toFixed(2);
        if (diff > 0)//== 0.01)
            cntrlToModify.val(res);
        else if (diff < 0)// == -0.01)
            cntrlToModify.val(res);
    }
}

function CheckBoxClick(sourCheckBox) {
    var checkBox1 = sourCheckBox;
    if (checkBox1.checked == true) {
        var If = CustomConfirm("Are you sure, you want to mark this alert as read?");
        if (If) {
            var hdnChk = $(sourCheckBox).closest('td').find("input:hidden");
            var str = $(hdnChk[0]).val();
            $('#hdnPatientVisitEventId').val(str);
            $('#hdnIsOk').val("true");
            //return true;
        }
        else {
            $('#hdnIsOk').val("false");
            checkBox1.checked = false;
            return false;
        }
    }
    else {
        var If = CustomConfirm("Are you sure, you want to mark this alert as unread?");
        if (If) {
            var hdnChk = $(sourCheckBox).closest('td').find("input:hidden");
            var str = $(hdnChk[0]).val();
            $('#hdnPatientVisitEventId').val(str);
            $('#hdnIsOk').val("true");
            //return true;
        }
        else {
            $('#hdnIsOk').val("false");
            checkBox1.checked = true;
            return false;
        }
    }
}
function enableGroupActivity(isPost, ctrl_check) {
    if (isPost) {
        $('.trGroupActivityDepartment').show();
    }
    else {
        if (ctrl_check.checked == true) {
            $('.trGroupActivityDepartment').show();
        }
        else {
            $('#ddlCareStaff').show();
            $('#ddlCareTeamStaff').hide();
            $('.trGroupActivityDepartment').hide();
            $('.trGroupActivityDepartment').find("input:checkbox").each(function (index, el) {
                $(this).prop("checked", false);
            });
            $('.trGroupActivityDepartment').find("input").each(function (index, el) {
                if ($(this).attr("type") == "text" || $(this).attr("type") == "hidden") {
                    $(this).val("");
                    if ($(this).attr("type") == "text") { $(this).val("Select"); }
                }
            });
        }
    }
}
function ReadTemplateHTML() {
    var templateHTML = $("#divCNSTTemplateHRML");
    templateHTML.find(".replacethis").each(function () {
        var textBox = $(this);
        textBox.replaceWith("<span>" + " " + textBox[0].value + "</span>");
    });
    $("#hdnCNSTTemplateHTML").val(templateHTML[0].innerHTML.replace(/"/g, '\''));
    var images = templateHTML.find('img[id*="saveSignature"]');
    var imageData = "";
    images.each(function () {
        if ($(this)[0].src != null) {
            imageData += $(this)[0].src + "§";
        }
    });
    imageData = imageData.substring(0, imageData.length - 1);
    $("#hdnImageData").val(imageData);
}
function ChangeTextBoxDefaultValue(txtBox) {
    txtBox.defaultValue = txtBox.value;
}
//************************ Complaint Page Redirection from DashBoard Start *********************************************************
function SetComplaintData(PatientId, ComplaintId, ComplaintTypeId, CompaintType, PatientFName, PatientLName, ActivityLogId, ActivityTypeName) {
    window.top.AppContextManager.PatientContext.setPatientId(PatientId);
    ActivityLogId = isNaN(ActivityLogId) ? '' : ActivityLogId;
    if (ConfirmUserNavigationOnFaxLinking()) {
        ClearFaxLinkValues();
        var currentLevel = 0;
        if (window.top.isRedirectToComplaintActivity === 1) {
            currentLevel = getComplaintCurrentLevelByComplaintId(ComplaintId, PatientId);
        }
        var ComplaintData = { CompaintType: CompaintType, PatientId: PatientId, ComplaintTypeId: ComplaintTypeId, ComplaintNo: ComplaintId, PatientName: PatientFName + "_" + PatientLName, CurrentLevel: currentLevel, ActivityLogId: ActivityLogId, ActivityTypeName: ActivityTypeName };
        localStorage.removeItem("COMPLAINT_DATA");
        localStorage.setItem("COMPLAINT_DATA", JSON.stringify(ComplaintData));
        window.top.GotoComplaint(JSON.stringify(ComplaintData));
        if (window.top.enableDomLogs) {
            DomUtils.logDomData('Member Info >> Complaint >> AddorEdit');
        }
    }
    else {
        window.top.isFromOpenComplaintEdit = false;
    }
}
//************************ Complaint Page Redirection from DashBoard End ***********************************************************
// Complaint Summary Print Page
function PrintDivContent(divID) {

    var divElements = document.getElementById(divID).innerHTML;
    var oldPage = document.body.innerHTML;
    document.body.innerHTML = divElements;
    window.print();
    document.body.innerHTML = oldPage;
}
function HideProviderAddressControls() {
    $('#tblNewProviderAddress').hide();
    $('#tblProvAddressGrid').show();
    $('#btnAddProvAddress').show();
    $('#btnEditProvAddress').show();
    $('#btnDeleteProvAddress').show();
    return false;
}
function EnableManageConfiguration(link) {
    if (link.innerHTML == "Manage Configuration") {
        if ($("#hdnConfigValidation").val() == "0") { CustomAlert("Please contact your administrator to create / manage profiles"); return false; }


    }
}
function ClientStartDateValidate(source, fnarguments) {

    var radi = $('input[type=radio]:checked').val();
    if (radi == 'Pending') {

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        var today = mm + '/' + dd + '/' + yyyy;

        if (fnarguments.Value > today) {
            fnarguments.IsValid = true;
        } else {
            fnarguments.IsValid = false;
        }
    }
    else
        fnarguments.IsValid = true;
}
function enableOtherPrivilege(isPost, ctrl_check) {
    if (isPost) {
        $('.trOtherPrivilegeType').show();
    }
    else {
        if (ctrl_check.innerHtml != "Select") {
            $('.trOtherPrivilegeType').show();
        }
    }

}
function enableAdminRestriction(ddlObj, chkObj) {
    if (ddlObj == null) {
        $(chkObj).prop("disabled", true);
    }
    else {
        var SelText = $(ddlObj).find('option:selected').text();
        $(chkObj).prop("checked", false);
        $(chkObj).prop("disabled", true);
        if (SelText == "Admin")
            $(chkObj).prop("disabled", false);
        return false;
    }
    setTimeout(function () { $("#fakeuname,#fakepword").val(''); }, 1000);
}
function setDashChartScrollPos(id) {
    var divid = $(id);
    if (divid && divid.length > 0) {
        divid[0].scrollTop = parseInt(divid[0].scrollHeight - parseInt(divid[0].offsetHeight)) / 2;
    }
}
function Datevalidationfrmtdt(frmctrl, toctrl, ctrl) {
    if (ctrl == 1) {
        var fval = $('#' + frmctrl).val();
        var tval = $('#' + toctrl).val();
        if (fval != '' && fval != 'From Date') {
            var fdt = new Date(fval);
            var tdt = new Date(tval);
            if (fdt > tdt) {
                $('#' + toctrl).val('To Date');
                CustomAlert('From Date Must Be Less Then To Date.');
            }
        }
        else {
            $('#' + toctrl).val('To Date');
            CustomAlert('Please Select From Date');
        }
    }
    else if (ctrl == 0) {
        var fval = $('#' + frmctrl).val();
        var tval = $('#' + toctrl).val();
        if (fval != '' && fval != 'From Date') {
            var fdt = new Date(fval);
            if (tval != '' && tval != 'To Date') {
                var tdt = new Date(tval);
                if (fdt > tdt) {
                    $('#' + toctrl).val('To Date');
                    CustomAlert('From Date Must Be Less Then To Date.');
                }
            }
        }
        else {
            $('#' + toctrl).val('To Date');
            CustomAlert('Please Select From Date');
        }
    }
}
function DobDateValidation(evt) {
    var fneval = $(evt).val();
    if (fneval) {
        var ddt = new Date(fneval);
        var odt = new Date();
        if (ddt > odt) {
            $(evt).val('');
            CustomAlert('Date of Birth should not be greater than the current date');
        }
    }
}
function ShowSubOptionAndGoToNext(SelType, QueId, OptId, QueNextId, Next, IsSpan) {
    var OptAll = "", OptCur = "";
    var isSubOptDyn = "False";
    if (SelType.CalendarBehavior != null) {
        if (SelType.value != "") {
            ResetNext();
        }
    }
    else
        ResetNext();

    SetQuestion(QueId, "Answered");
    OptAll = ".TR_Questions_" + QueId;
    OptCur = ".TR_Opts_" + $.trim(QueId) + "_" + $.trim(OptId);

    if (SelType == "RB") {

        QueId = $.trim(QueId);
        var previousOptId = lastSelectedOptionByQuestion[QueId];

        // selection changed ONLY if option is different
        var isSelectionChanged = (previousOptId !== $.trim(OptId));

        $(OptAll).find("[id*='Reb_Opt_']").prop('checked', false);
        $("[id*=Reb_Opt_" + $.trim(OptId) + "€]").prop('checked', true);

        $("[id*=Reb_Opt_" + $.trim(OptId) + "€]").focus();

        if (IsSpan == "true") {
            if ($("[id*=Reb_Opt_" + $.trim(OptId) + "€]").length > 0) {
                $("[id*=Reb_Opt_" + $.trim(OptId) + "€]")[0].checked = true;
            }
        }

        if (isSelectionChanged) {

            var options = $(OptAll).find("[id*='TR_Opts_" + $.trim(QueId) + "']");
            for (var optCount = 0; optCount < options.length; optCount++) {
                isSubOptDyn == "False"
                var spVals = $(options[optCount]).attr("id").split('_');
                if (spVals.length > 3) {
                    var currId = spVals[3];
                    if (currId != $.trim(OptId)) {
                        if ($("#TR_Opts_" + $.trim(QueId) + "_" + currId).find('#hdnIsDySubOpt').length == 1) { isSubOptDyn = $("#TR_Opts_" + $.trim(QueId) + "_" + currId).find('#hdnIsDySubOpt').val(); }
                        if (isSubOptDyn == "True") {
                            if ($("#dynTable_" + currId).find('.dynItem').length >= 1) {
                                $("#dynTable_" + currId).find('.dynItem').remove();
                                AddDynamicSubOptionRow(currId);
                            }
                        }
                    }
                }
            }
            $(OptAll).find(".TR_SubOpt").each(function (index, el) {
                if ($(this).find("#hdnHasPh").length == 0) {
                    $('input:checkbox', this).attr('checked', false);
                    $('input:radio', this).attr('checked', false);
                    $('select option:selected', this).removeAttr('selected');
                    $('select', this).find('option:first').attr('selected', 'selected');
                    $('input:text', this).val(''); $('img.dynsignature', this).attr('src', ''); $('img.imgsignaturefield', this).attr('src', '');
                    $(this).hide();
                }
            });

        }
        var SubOpts = $(OptCur).find(".TR_SubOpt");
        $(OptCur).find(".TR_SubOpt").each(function (index, el) { $(this).show(); });

        // update last selected option
        lastSelectedOptionByQuestion[QueId] = $.trim(OptId);
    }
    else if (SelType == "CHK") {        
        var SubOpts = $(OptCur).find(".TR_SubOpt");
        var checkboxControl = $("#Reb_Opt_Ch_" + OptId);
        if (IsSpan == "true") {
            if (checkboxControl[0].checked == false)
                checkboxControl[0].checked = true;
            else
                checkboxControl[0].checked = false;
        }

        if ($($(OptAll).find('input:checkbox:checked')).length == 0)
            SetQuestion(QueId, "UnAnswered");

        if (checkboxControl[0].checked == true) {
            $(OptCur).find(".TR_SubOpt").each(function (index, el) { $(this).show(); });
        }
        else {
            if ($("#TR_Opts_" + $.trim(QueId) + "_" + $.trim(OptId)).find('#hdnIsDySubOpt').length == 1) { isSubOptDyn = $("#TR_Opts_" + $.trim(QueId) + "_" + $.trim(OptId)).find('#hdnIsDySubOpt').val(); }
            $(OptCur).find(".TR_SubOpt").each(function (index, el) {
                $('input:checkbox', this).attr('checked', false);
                $('input:radio', this).attr('checked', false);
                $('select option:selected', this).removeAttr('selected');
                $('select', this).find('option:first').attr('selected', 'selected');
                $('input:text', this).val('');
                $('textarea', this).val(''); $('img.dynsignature', this).attr('src', ''); $('img.imgsignaturefield', this).attr('src', '');
                $(this).hide();
            });
            if (isSubOptDyn == "True") {
                $("#dynTable_" + $.trim(OptId)).find('.dynItem').remove();
                AddDynamicSubOptionRow($.trim(OptId));
            }
        }
    }
    if (SelType.length > 0 && SelType[0].className != undefined) {
        if (SelType[0].className.indexOf("txtboxfield") >= 0) {
            if (SelType[0].value.trim() == "" || $(OptAll).find('[id*="Reb_QueOpt_text"]').length > 1) {
                SetQuestion(QueId, "UnAnswered");
                return;
            }
        }
    }
    if (SubOpts != null) {
        if (SubOpts.children().length > 0)
            $("#trSubOptions_" + OptId.trim()).css('border', '1px');
    }
    if ($('[id*="HdnNext_"]').val() == "0") {
        $('[id*="BtnNext_"]').hide();
    }
    if (QueNextId != "" && $.trim(QueNextId) != "0") {
        if ((SubOpts != null && SubOpts.children().length > 0) ||
            (SelType == "CHK" && $($(OptAll).find('input:checkbox')).length != $($(OptAll).find('input:checkbox:checked')).length)) {
            $("#HdnNext_" + QueId).val(QueNextId);
            $("#BtnNext_" + QueId).show();
        }
        else {
            SetQuestion(QueNextId, "WorkFlow");
            if (Next == true) { GoToQuestion(QueNextId, true); }
        }
    }

    var OptionId1 = $("#hdnSelectedOptionId1").val(); var OptionId2 = $("#hdnSelectedOptionId2").val();//G8CAL-240
    if (OptionId1 == "" && OptionId2 == "") {
        OptionId1 = $.trim(OptId); $("#hdnSelectedOptionId1").val(OptionId1);
    }
    else if (OptionId1 != "" && OptionId2 == "") {
        OptionId2 = $.trim(OptId); $("#hdnSelectedOptionId2").val(OptionId2);
    }
    else if (OptionId1 != "" && OptionId2 != "") {
        $("#hdnSelectedOptionId1").val($("#hdnSelectedOptionId2").val()); $("#hdnSelectedOptionId2").val($.trim(OptId));
    }//G8CAL-240
    return false;
}
function calculateScriptOutputVariableValue(objVarName, queId, optionId, controlID, HidnFldId) {
    Flag_Prevent_ExpCol = false; var questionIds = [];

    var cntValue = $(controlID).val().trim();
    // if (!$.isNumeric(cntValue)) { alert("Please enter the numeric value"); $(controlID).val(""); return; }

    if (cntValue == $('#' + HidnFldId).val()) { return; } //prevent the blur event if with out change the control value


    if ($('#' + HidnFldId).val() == null || $('#' + HidnFldId).val() == "" || ($('#' + HidnFldId).val() != cntValue))//stroring the control value into hidden field
    {
        $('#' + HidnFldId).val(cntValue);
    }

    if (objVarName == "" || objVarName == null) { return; }

    try {
        var baseAppURL = AutoSave_GetHiddenValues("#hdnBaseUrl");
        var serviceURL = baseAppURL + '/api/Route/GetUMResult';

        //if ($("#hdnUMScriptID").length > 0 && $("#hdnUMScriptID").val() != "") {
        //    serviceURL = "../UmData.ashx";
        //}
        var inputdata = ''; var isDataEntered = true; var hdnScriptVariables = '';

        $("#CallScreenContent").find(".clsHdnScriptVariables").each(function () {

            if ($(this).attr("id") == "hdnScriptVariables") {


                var TmpVal = ''; TmpVal = $(this).val(); var tmpSplit = TmpVal.split("|");
                var OptIdNo = '', OptVal = '', OptDomId = '', OptOutVar = '', OptOutTeDom = '', OptOutLblDom = '', OptOutSplit = null;
                if (tmpSplit.length > 2 && tmpSplit[2] != "") {

                    OptOutSplit = null;
                    OptId = tmpSplit[1];
                    OptOutVar = tmpSplit[2];
                    OptOutSplit = OptOutVar.split(',');

                    for (var OI = 0; OI < OptOutSplit.length; OI++) {

                        OptOutTeDom = ''; OptOutTeDom = "#Reb_QueOpt_text" + OptOutSplit[OI];
                        OptOutLblDom = ''; OptOutLblDom = "#Reb_QueOpt_Label|" + OptOutSplit[OI];
                        if ($(OptOutTeDom).length > 0) { $(OptOutTeDom).val(''); }
                        else {
                            var HdnId = "#hdn_QueOpt_Label" + OptOutSplit[OI];
                            if ($("[id*='" + OptOutLblDom + "']").length > 0) { $("[id*='" + OptOutLblDom + "']").AhsSetHtml($(HdnId).val()); }
                        }
                    }
                    OptDomId = "#Reb_QueOpt_text" + OptId;
                    if ($(OptDomId).length > 0) { OptVal = $(OptDomId).val(); }
                    else {
                        OptDomId = "#Reb_QueOpt_txt_area" + OptId;
                        if ($(OptDomId).length > 0) { OptVal = $(OptDomId).val(); }
                    }
                    if ($("[id*='RebQueOptCalendar€" + OptId + "']").attr('data-ctrltype') == 'txtoptcalendar') { OptVal = $("[id*='RebQueOptCalendar€" + OptId + "']").val(); }
                    if (OptVal != "") {
                        inputdata += OptId + "$" + OptVal + "€";
                        var questionId = AutoSave_GetQueIdFromPH("O", OptId);
                        questionIds.push(questionId);
                    }
                }
            }
        });

        if (inputdata != '') {
            inputdata = inputdata.slice(0, -1);
            var PostData = null;
            PostData = {
                DATA_KEY: "SCPT_VARIBLE_CALCULATE",
                SP_VA_VARIABLE: inputdata,
                SP_VA_SCRIPT_ID: $("#hdnScriptID").val()
            };
            ShowProgress();
            $.ajax({
                type: "POST",
                data: PostData,
                url: serviceURL,
                dataType: "html",
                cache: false,
                async: false,
                success: function (Result) {
                    var calculatedValues = $.parseJSON(Result);

                    for (var count = 0; count < calculatedValues.length; count++) {
                        var individualValues = calculatedValues[count];
                        var optionID = individualValues.OptionId;
                        var outputValue = individualValues.BmiValue;
                        outputValue = outputValue == null ? '0' : outputValue;
                        $("span[id*='Reb_QueOpt_Label|" + optionID + "']").each(function () {
                            var labelText = $("#hdn_QueOpt_Label" + optionID).val();
                            $(this)[0].innerHTML = labelText + " " + outputValue;
                            questionIds.push(AutoSave_GetQueIdFromPH("O", optionID));
                        });
                        $("[id*='Reb_QueOpt_text" + optionID + "']").each(function () {
                            $(this)[0].value = outputValue;
                            questionIds.push(AutoSave_GetQueIdFromPH("O", optionID));
                        });
                        $("[id*='Reb_QueOpt_txt_area" + optionID + "']").each(function () {
                            // $(this)[0].innerHTML = outputValue;
                            $(this).val(outputValue);
                            questionIds.push(AutoSave_GetQueIdFromPH("O", optionID));
                        });

                    }
                    HideProgress();
                    //Logic for script auto save after replacing script variables with respective values
                    //-----Sart-------
                    var uniQuestionIds = AutoSave_GetArrayUniqueValues(questionIds);
                    for (var i = 0; i < uniQuestionIds.length; i++) {
                        AutoSave_ReadQuestionData(uniQuestionIds[i], false);
                    }
                    AutoSave_AjaxPostResponses(function (RD) { });
                    //------End-------
                }
            });
        }
    }
    catch (e) {
    }
}
function ShowProgress() {
    if ($("body").find("#mbar").length > 0) { $("body").find("#mbar").remove() }
    var e = $("<div id='mbar' class='modal'></div>"); $("body").append(e);
    var t = $(".loading"); t.show(); var n = Math.max($(window).height() / 2 - $(t).height() / 2, 0);
    var r = Math.max($(window).width() / 2 - $(t).width() / 2, 0); t.css({ top: n, left: r })
}
function HideProgress() {
    var e = $(".loading"); e.hide();
    if ($("body").find("#mbar").length > 0) { $("body").find("#mbar").remove() }
}
//For Dynamic Rows In Single Page Script Start
function AddDynamicSubOptionRow(OptionId) {
    var gridId = "#dynTable_" + OptionId;
    var radioElements = $('.dynSource', gridId).find('input:radio');
    radioElements.each(function () {
        var name = $(this).attr("name");
        var count = parseInt(name.split('_')[0]) + 1;
        var optionId = name.split('_')[1];
        $(this).attr("name", count + "_" + optionId);
    });
    var sourceHtml = $('.dynSource', gridId).html();
    //Signature == START
    // var signElements = $('.dynItem', gridId).find('.dynsignature');
    var sHtml = sourceHtml; var htmlObj = $(sHtml);
    if ($(htmlObj).has('.dynsignature').length > 0) {
        sourceHtml = ''; var signHtml = '';
        htmlObj.each(function () {
            if ($(this).find('img.dynsignature').length > 0) {
                $(this).find('img.dynsignature')[0].src = "";
                var currentEle = $(this); var id = $(this).find('img.dynsignature')[0].id;
                var objfirstPartId = id.slice(0, id.indexOf('€')); signHtml = "<td style='border-right:1px solid gray;'>" + $(currentEle).html() + "</td>";
                signHtml = signHtml.replace(/RebQueSubOptSignature/g, objfirstPartId + "_" + $.now())
            }
            else {
                var currentHtml = $(this); signHtml = "<td style='border-right:1px solid gray;'>" + $(currentHtml).html() + "</td>";
            }
            sourceHtml = sourceHtml + signHtml;
        });
    }
    //Signature == END
    if (sourceHtml != undefined) {
        sourceHtml = sourceHtml.replace('display:none;', 'display:block;');
        $('.dynSource', gridId).after("<tr class='dynItem'>" + sourceHtml + "</tr>");
    }
    InitRunScriptCalendar();
    var textElements = $(gridId + ' input[type="text"],' + gridId + ' textarea');
    var radioCheckElements = $(gridId + ' input[type="checkbox"],' + gridId + ' input[type="radio"],' + gridId + ' .clasRadioOrCheck');
    var dropdownElements = $(gridId + ' select');
    var signElements = $(gridId + ' .dynsignature');
    textElements.unbind("focus blur");
    radioCheckElements.unbind("click");
    dropdownElements.unbind("change");
    signElements.unbind("click");
    textElements.on('focus blur', function () {
        AutoSave_CallQuestionInit($(this));
    });
    radioCheckElements.on('click', function () {
        AutoSave_CallQuestionInit($(this));
    });
    dropdownElements.on('change', function () {
        AutoSave_CallQuestionInit($(this));
    });
    signElements.on('click', function () {
        AutoSave_CallQuestionInit($(this));
    });
}


function RemoveDynamicSubOptionRow(imgObject, OptionId) {
    //AutoSave   Start
    AutoSave_ScriptSignatureReadData(imgObject);
    //AutoSave   End
    if ($("#dynTable_" + OptionId).find('.dynItem').length > 1) {
        $(imgObject).closest('tr').remove();
    }
    else if ($("#dynTable_" + OptionId).find('.dynItem').length == 1) {
        var dynRow = $($("#dynTable_" + OptionId).find('.dynItem')[0]);
        $('input:text , textarea , input:radio , input:checkbox, select, img.dynsignature', dynRow).each(function () {
            var tagName = ScriptForm_CtrlTag(this);
            if (tagName == "text" || tagName == "textarea") {
                if ($(this).val() != null && $(this).val() != '') { $(this).val(''); }
            }
            else if (tagName == "radio" || tagName == "checkbox") {
                if ($(this).is(":checked")) { $(this).attr("checked", false); }
            }
            else if (tagName == "select") {
                $(this).find('option').removeAttr("selected");
            }
            else if (tagName == "img") {
                $(this).attr("src", "");
            }
        });
    }
}
function GetDynamicSubOptionRow(OptionId) {
    var ObjId = "", ObjVal = "", retStr = "", tempVals = ""; IsSubOptionsSelected = true, parentId = "";
    $("#dynTable_" + OptionId).find('.dynItem').each(function (el, ind) {
        ObjId = ""; ObjVal = "", tempVals = ""; var countchk = 0; var countrd = 0;
        //if ($(this).find('.IsCheck')[0].checked) { retStr += "1"; } else { retStr += "0"; }        
        $(this).find('[class*=SubDyn_]').each(function (ind) {
            ObjId = ""; ObjVal = "", parentId = "";
            var eleType = "";
            if ($(this).get(0).tagName.toLowerCase() == "input") {
                eleType = $(this).get(0).type.toLowerCase();
            }
            else if ($(this).get(0).tagName.toLowerCase() == "img") {
                eleType = "img";
            }
            else if ($(this).get(0).tagName.toLowerCase() == "select") {
                if ($(this).get(0).multiple == true) {
                    eleType = "listbox";
                }
                else
                    eleType = "dropdownlist";
            }
            else {
                eleType = $(this).get(0).tagName.toLowerCase();
            }
            switch (eleType) {
                case "text":
                case "textarea":
                    if ($(this).attr("class").indexOf("dyncalendar") != -1)
                        ObjId = $(this).attr("class").split('_')[2].split(' ')[0];
                    else
                        ObjId = $(this).attr("class").split('_')[2];
                        
                    ObjVal = $(this).val();
                    ObjVal = ObjVal.replace(/1SI/g, "€¶¦validate€¶¦").replace(/1Si/g, "1Üî").replace(/1si/g, "1Ûî").replace(/1sI/g, "1Ûï");
                    //if ($.trim(ObjVal) != '') {
                    tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†OP_" + OptionId + "±";
                //}
                case "radio":
                    if (eleType == "radio") {
                        var Rbl = $('input[name="' + $(this).attr("name") + '"]:checked', $(this).parent()).length;
                        if (Rbl > 0) {
                            if ($(this)[0].checked == true) {
                                ObjId = $(this).attr("class").split('_')[2]; parentId = $(this).attr("id").split('_')[1];
                                ObjVal = $(this).next().html(); tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±";
                            }
                            else {
                                ObjId = $(this).attr("class").split('_')[2]; parentId = $(this).attr("id").split('_')[1];
                                ObjVal = ""; tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±";
                            }
                        }
                        else {
                            if (countrd == 0) {
                                countrd = 1; ObjId = $(this).attr("class").split('_')[2]; parentId = $(this).attr("id").split('_')[1];
                                ObjVal = ""; tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±";
                            }
                        }
                    }
                case "img":
                    if (eleType == "img") {
                        if ($(this).attr("class").indexOf("dynsignature") != -1) {
                            ObjId = $(this).attr("class").split('_')[2].split(' ')[0];
                            ObjVal = $(this).attr('src');
                            ObjVal = ObjVal.replace(/1SI/g, "€¶¦validate€¶¦").replace(/1Si/g, "1Üî").replace(/1si/g, "1Ûî").replace(/1sI/g, "1Ûï");
                            tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†OP_" + OptionId + "±";
                        }
                    }
                case "checkbox":
                    if (eleType == "checkbox") {
                        //var chk = $('input[name=' + $(this).attr("name") + ']:checked', $(this).parent()).length;
                        if ($(this).length > 0) {
                            if ($(this)[0].checked == true) {
                                ObjId = $(this).attr("class").split('_')[2]; parentId = $(this).attr("id").split('_')[1];
                                ObjVal = $(this).next().html(); tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±";
                            }
                            else {
                                ObjId = $(this).attr("class").split('_')[2]; parentId = $(this).attr("id").split('_')[1];
                                ObjVal = ""; tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±";
                            }
                        }
                        else {
                            if (countchk == 0) {
                                countchk = 1; ObjId = $(this).attr("class").split('_')[2]; parentId = $(this).attr("id").split('_')[1];
                                ObjVal = ""; tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±";
                            }
                        }
                    }
                case "listbox":
                case "dropdownlist":
                    $('option:selected', $(this)).each(function () {
                        ObjId = ""; ObjVal = "";
                        ObjVal = $(this).text();
                        if (ObjVal == "Select") {
                            var ObjNextValue = $(this).next(); ObjId = ObjNextValue.val().split('_')[2]; parentId = ObjNextValue.val().split('_')[1];
                        }
                        else { ObjId = $(this).val().split('_')[2]; parentId = $(this).val().split('_')[1]; }
                        if (ObjVal != "Select") { tempVals += "SI" + ObjId + "†" + encodeURIComponent(ObjVal) + "†SP_" + parentId + "±"; }
                        else { tempVals += "SI" + ObjId + "†" + "" + "†SP_" + parentId + "±"; }
                    });
                    break;
            }
        });
        if (tempVals != "") {
            if (retStr != "") { retStr += "‡"; }
            retStr += "1"; // To tell whether this needs to be loaded in script forms or not
            retStr += tempVals;
        }
        else {
            IsSubOptionsSelected = false;
        }
    });
    if (retStr == "") { IsSubOptionsSelected = false; }
    return retStr;
}
function PoulateDynSubOpt(optionId, subOptDynVal) {
    $("#trSubOptions_" + optionId).find('.TR_SubOpt').show();
    //subOptDynVal = (typeof subOptDynVal === 'undefined') ? subOptDynVal : subOptDynVal.replace(new RegExp('&#39;', 'g'), '\'');
    if (subOptDynVal != undefined) {
        //subOptDynVal = subOptDynVal.replace(new RegExp('&#39;', 'g'), '\'');
        subOptDynVal = subOptDynVal.replace(new RegExp('&#39;', 'g'), '\'').replace(new RegExp('&#220;', 'g'), 'Ü').replace(new RegExp('&#238;', 'g'), 'î').replace(new RegExp('&#239;', 'g'), 'ï').replace(new RegExp('&#219;', 'g'), 'Û').replace(new RegExp('&#182;', 'g'), '¶').replace(new RegExp('&#166;', 'g'), '¦');
        var dyntable = $(".dynTable_" + optionId);
        $(dyntable.find(".dynItem")).remove();
        var dynRows = subOptDynVal.split('‡');
        for (var count = 0; count < dynRows.length; count++) {
            AddDynamicSubOptionRow(optionId);
        }
        for (var count = 0; count < dynRows.length; count++) {
            var itemVal = dynRows[count];
            var items = itemVal.split('±');
            for (var icount = 0; icount < items.length; icount++) {
                var item = items[icount];
                if (item != "" && item != undefined) {
                    var subOptionId = item.split('†')[0];
                    var value = decodeURIComponent(item.split('†')[1]);
                    var cmpClass = "";
                    subOptionId = subOptionId.replace(/[SI]/g, "");
                    if (icount == 0) { cmpClass = "SubDyn_" + optionId + "_" + subOptionId.split('_')[0].substring(1, subOptionId.split('_')[0].length); }
                    else { cmpClass = "SubDyn_" + optionId + "_" + subOptionId.split('_')[0]; }

                    // Find element using a simple two-strategy approach
                    var element = $([]);
                    var dynItems = $(dyntable.find(".dynItem"))[count];

                    if (dynItems) {
                        // Strategy 1: Try class substring match using a selector-safe value (handles periods, quotes, etc.)
                        var escapedClass = $.fn.escapeSelector(cmpClass);
                        element = $(dynItems).find("[class*='" + escapedClass + "']");

                        // Strategy 2: Match by position - get the nth element with SubDyn class (works when IDs don't match)
                        if (element.length === 0) {
                            var subDynElements = $(dynItems).find('[class*="SubDyn_' + optionId + '"]');
                            if (subDynElements.length > icount) {
                                element = $(subDynElements[icount]);
                            }
                        }
                    }
                    var eleType = "";
                    if (element.length > 0) {
                        if (element.get(0).tagName.toLowerCase() == "input") {
                            eleType = element.get(0).type.toLowerCase();
                        }
                        else if (element.get(0).tagName.toLowerCase() == "select") {
                            if (element.get(0).multiple == true) {
                                eleType = "listbox";
                            }
                            else
                                eleType = "dropdownlist";
                        }
                        else {
                            eleType = element.get(0).tagName.toLowerCase();
                        }
                        switch (eleType) {
                            case "textarea":
                            case "text":
                                //element[0].value = ReplacespecialCharcs(value);
                                var txtValue = ReplacespecialCharcs(value);
                                if (eleType === "textarea") {
                                    txtValue = htmlContentAlter(txtValue, false);
                                }
                                element[0].value = txtValue.replace(/€¶¦validate€¶¦/g, "1SI").replace(/1Üî/g, "1Si").replace(/1Ûï/g, "1sI").replace(/1Ûî/g, "1si");
                                break;
                            case "img":
                                //element[0].src = ReplacespecialCharcs(value);
                                var imgSrc = ReplacespecialCharcs(value);
                                element[0].src = imgSrc.replace(/€¶¦validate€¶¦/g, "1SI").replace(/1Üî/g, "1Si").replace(/1Ûï/g, "1sI").replace(/1Ûî/g, "1si");
                                break;
                            case "radio":
                            case "checkbox":
                                if (value != "") {
                                    element[0].checked = true;
                                }
                                break;
                            case "listbox":
                            case "dropdownlist":
                                element.find("option").each(function () {
                                    var CmpValue = null;
                                    if (item.split('†').length > 2) {
                                        if (icount == 0)
                                            CmpValue = optionId + "_" + item.split('†')[2].replace('OP_', '').replace('SP_', '') + "_" + subOptionId.substring(1);
                                        else
                                            CmpValue = optionId + "_" + item.split('†')[2].replace('OP_', '').replace('SP_', '') + "_" + subOptionId;
                                        if ($(this).val() == CmpValue) {
                                            if (item.split('†')[1] != "") {
                                                $(this).attr("selected", "selected");
                                            }
                                        }
                                    }
                                });
                                break;
                        }
                    }
                }
            }
        }
    }
}
function InitRunScriptCalendar() {
    $('#CallScreenContent').find("[class*='dyncalendar']").each(function () {
        $(this).Calendar({ HasModel: false });
    });
}
function scriptSignatureSave() {
    var canvas = document.getElementById("Sign_Canvas");
    var dataURL = canvas.toDataURL("image/png");
    var image = dataURL.replace('data:image/png;base64,', '');
    var id = $('#controlIdForSignature').val();
    var idEve = $('#controlSignatureEvent').val();
    if (idEve == "Clear") { dataURL = ""; }
    if ($("#id1frame").length > 0 && $("#id1frame").contents().find('#' + id).length > 0)
        $("#id1frame").contents().find('#' + id).attr('src', dataURL);
    else if ($("#IframeDesGuideLine").length > 0 && $("#IframeDesGuideLine").contents().find('#' + id).length > 0)
        $("#IframeDesGuideLine").contents().find('#' + id).attr('src', dataURL);
    else if ($("#IframeUMRunScript").length > 0 && $("#IframeUMRunScript").contents().find('#' + id).length > 0)
        $("#IframeUMRunScript").contents().find('#' + id).attr('src', dataURL);
    CallingIframeJsFunction(id);//For AutoSave
    signatureClear();
    $('#btnSignClose').trigger('click');
    //$("#id1frame").contents().find('#' + id+"_btn").trigger('click');
}
//For Dynamic Rows In Single Page Script End
function ReplaceAll(OrginalString, FindString, ReplaceString) {
    if (OrginalString != null && OrginalString != '') { return OrginalString.replace(new RegExp(FindString, "gi"), ReplaceString); } else { return OrginalString; }
}
function VccOtherChange(Obj) {
    var VccOther = '';
    if (Obj == 'Name' || Obj == 'VN') {
        if (Obj != 'VN') { $('#txtVaccinationNameOther').val(''); }
        VccOther = $('#ddlVaccinationNames option:selected').text().toUpperCase();
        if (VccOther == "OTHER") { $('.VaccNameOther').show(); } else { $('.VaccNameOther').hide(); }
    }
    if (Obj == 'Status' || Obj == 'VN') {
        if (Obj != 'VN') { $('#txtVaccinationStatusOther').val(''); }
        VccOther = $('#ddlVaccinationStatus option:selected').text().toUpperCase();
        if (VccOther == "OTHER") { $('.VaccStatusOther').show(); } else { $('.VaccStatusOther').hide(); }
    }
}

function CheckAttestationClicked() {
    var ScriptResponseMode = $("#hdnScriptResponseMode").val();
    if (ScriptResponseMode === "1" || ScriptResponseMode === "2" || ScriptResponseMode === "0") {
        if (!$("#chkAttestation").is(':checked') && $("#chkAttestation").closest('.clsAttestation').css('display') != 'none') {
            window.top.AlertShow('Please Click On the Attestation Check Box and Continue...');
            return false;
        }
        else
            return true;
    }
    else
        return true;
}

function CheckAttestationValRequired() {
    if ($('#chkAttestation').is(':checked'))
        $('#chkAttestationOutCome').html('');
    else
        $('#chkAttestationOutCome').html('*');
}

function ReplacespecialCharcs(strText) {
    return strText.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&apos;/g, "'").replace(/&amp;/g, "&");
}



function AuthTypeToolTipTemplate(data) {
    var html = '';

    var ProcedureCodeToolTip = '';
    var DiagnosisCodeToolTip = '';

    if (data.ProcedureCodesText) {

        ProcedureCodeToolTip = "<ul>";
        ProcedureCodeToolTip = ProcedureCodeToolTip + data.ProcedureCodesText.replaceSpecialChar({ replaceChars: ["&quot;", "&#039;"], actualChars: [/"/g, /'/g] });
        ProcedureCodeToolTip = ProcedureCodeToolTip + " </ul> ";
    }
    else {
        ProcedureCodeToolTip = 'N/A';
    }

    if (data.DiagnosisCodesText) {

        DiagnosisCodeToolTip = "<ul>";
        DiagnosisCodeToolTip = DiagnosisCodeToolTip + data.DiagnosisCodesText.replaceSpecialChar({ replaceChars: ["&quot;", "&#039;"], actualChars: [/"/g, /'/g] });
        DiagnosisCodeToolTip = DiagnosisCodeToolTip + " </ul> ";
    }
    else {
        DiagnosisCodeToolTip = 'N/A';
    }

    if (data.AuthTypeName) {
        var AuthType = data.AuthTypeName.replaceSpecialChar({ replaceChars: ["&quot;", "&#039;"], actualChars: [/"/g, /'/g] });
        html = html + "<div class='hOverAuthStatusReasonNameCls' style='width:100%;height:100%;cursor:pointer;' title='<span align=center style=font-weight:bold;text-decoration:underline;>Procedure Code Details </span><div> " + ProcedureCodeToolTip + " </div> </br><span style=font-weight:bold;text-decoration:underline;>Diagnosis Code Details </span> <div> " + DiagnosisCodeToolTip + " </div> </br><span align=center style=font-weight:bold;text-decoration:underline;>Auth Type </span><div> " + $.fn.replaceAndEscapeHtmlExt(AuthType) + " </div></br>'>" + AuthType + " </div>";
    }
    return html;
}

function ProviderNameToolTipTemplate(data) {
    var html = '';
    var ProviderStatusToolTip = '';
    var ProviderNameData = '';

    if (data.ProviderName) {

        ProviderStatusToolTip = "<ul>";
        ProviderStatusToolTip = ProviderStatusToolTip + data.ProviderCapacity;
        ProviderStatusToolTip = ProviderStatusToolTip + " </ul> ";
    }
    else {
        ProviderStatusToolTip = 'N/A';
    }

    ProviderNameData = (data.ProviderName == '' || data.ProviderName == null) ? 'N/A' : data.ProviderName.replaceSpecialChar({ replaceChars: ["&quot;", "&#039;"], actualChars: [/"/g, /'/g] });
    html = html + "<div class='hOverAuthStatusReasonNameCls' style='width:100%;height:100%;cursor:pointer;' title='<span align=center style=font-weight:bold;text-decoration:underline;>Provider Status </span><div> " + ProviderStatusToolTip + " </div> </br>'>" + ProviderNameData + " </div>";

    return html;
}

function CallingIframeJsFunction(InpVal) {

    //Calling Iframe Javascript Function from Parent Start
    //var $f = $("#id1frame");
    //$f[0].contentWindow.AutoSave_ScriptSignatureSave(id);
    //$f.get(0).contentWindow.AutoSave_ScriptSignatureSave(id);
    //document.getElementById("id1frame").contentWindow.AutoSave_ScriptSignatureSave(InpVal);
    //Calling Iframe Javascript Function from Parent End

    $(document).ready(function () {
        if ($("#id1frame").contents().find("#aspnetForm").length > 0) {
            if (InpVal == null) {
                document.getElementById("id1frame").contentWindow.AutoSave_ResetGlobalData();
            } else {
                if ($("#id1frame").contents().find("#CallScreenContent").length > 0) {
                    if ($("#id1frame").contents().find('#' + InpVal) != null) {
                        document.getElementById("id1frame").contentWindow.AutoSave_ScriptSignatureSave(InpVal);
                    }
                }
            }
        }
        else if ($("#IframeDesGuideLine").length > 0) {
            if (InpVal == null) {
                document.getElementById("IframeDesGuideLine").contentWindow.AutoSave_ResetGlobalData();
            }
            if (($("#IframeDesGuideLine").contents().find("#CallScreenContent").length > 0) || ($("#IframeDesGuideLine").contents().find('#' + InpVal) != null)) {
                if ($("#IframeDesGuideLine").contents().find('#' + InpVal) != null) {
                    document.getElementById("IframeDesGuideLine").contentWindow.AutoSave_ScriptSignatureSave(InpVal);
                }
            }
        }
        else if ($("#IframeUMRunScript").length > 0) {
            if (InpVal == null) {
                document.getElementById("IframeUMRunScript").contentWindow.AutoSave_ResetGlobalData();
            }
            if (($("#IframeUMRunScript").contents().find("#CallScreenContent").length > 0) || ($("#IframeUMRunScript").contents().find('#' + InpVal) != null)) {
                if ($("#IframeUMRunScript").contents().find('#' + InpVal) != null) {
                    document.getElementById("IframeUMRunScript").contentWindow.AutoSave_ScriptSignatureSave(InpVal);
                }
            }
        }
    });
}


//Prod-871
//UHC-2648 - Gray out checkboxes in Team care plan
function ToggleRoleIsView(ChkSource, IsFrom) {
    if ($(ChkSource)[0].checked == false)
        $(ChkSource).removeAttr("checked");
    else
        $(ChkSource).attr("checked", "checked");

    if ((IsFrom != undefined && $(ChkSource)[0].checked == true) || IsFrom == undefined) {
        var CurrentValue = $(ChkSource).parent().next().attr('class');
        var NextValue = $(ChkSource).closest('tr').next().find("[id*='lblHdnActionType']").attr('class').split('>>');
        var NextValueLength = NextValue.length;
        if (CurrentValue == undefined) {
            CurrentValue = $(ChkSource).closest('tr').find("[id*='lblHdnActionType']").attr('class');
        }
        var CurrentValueSplit = CurrentValue.split('>>');
        var CurrentValueLength = CurrentValueSplit.length;

        if (CurrentValue.indexOf('>>') == -1 || (CurrentValueLength == 2 && NextValueLength == 3 && $.trim(CurrentValueSplit[1]) == $.trim(NextValue[1]))) { //If the header row view button is clicked              
            $("[class*='" + $.trim(CurrentValue) + " >>'],[class*='" + $.trim(CurrentValue) + ">>'],[class*='" + $.trim(CurrentValue) + " >'],[class*='" + $.trim(CurrentValue) + ">']").each(function (index, ele) {
                if ($(ChkSource)[0].checked == false) { //If the header row view button is unchecked then uncheck the child items and disable all of them
                    $(this).prev().find('input:checkbox').removeAttr('checked').attr('disabled', 'disabled');
                    $(this).closest('tr').find("input:checkbox").removeAttr('checked').attr('disabled', 'disabled');
                }
                else {
                    $(this).prev().find('input:checkbox').attr('checked', 'checked').removeAttr('disabled');
                    if (IsFrom == undefined) {
                        $(this).closest('tr').find("input:checkbox").attr('checked', 'checked').removeAttr('disabled');
                    }
                    else {
                        if (IsFrom == 'Add')
                            $(this).closest('tr').find("[id*='ItemChkAdd_']").attr('checked', 'checked').removeAttr('disabled');
                        else if (IsFrom == 'Edit')
                            $(this).closest('tr').find("[id*='ItemChkEdit_']").attr('checked', 'checked').removeAttr('disabled');
                        else if (IsFrom == 'Delete')
                            $(this).closest('tr').find("[id*='ItemChkDelete_']").attr('checked', 'checked').removeAttr('disabled');
                        else if (IsFrom == 'Export')
                            $(this).closest('tr').find("[id*='ItemChkExport_']").attr('checked', 'checked').removeAttr('disabled');
                        else if (IsFrom == 'Email')
                            $(this).closest('tr').find("[id*='ItemChkEmail_']").attr('checked', 'checked').removeAttr('disabled');
                        else if (IsFrom == 'Print')
                            $(this).closest('tr').find("[id*='ItemChkPrint_']").attr('checked', 'checked').removeAttr('disabled');
                    }
                }
            });
            if ($(ChkSource)[0].checked == true && IsFrom == undefined) {
                $(ChkSource).closest('tr').find("[id*='ItemChkAdd_']").attr('checked', 'checked')
                $(ChkSource).closest('tr').find("[id*='ItemChkEdit_']").attr('checked', 'checked')
                $(ChkSource).closest('tr').find("[id*='ItemChkDelete_']").attr('checked', 'checked')
                $(ChkSource).closest('tr').find("[id*='ItemChkExport_']").attr('checked', 'checked')
                $(ChkSource).closest('tr').find("[id*='ItemChkEmail_']").attr('checked', 'checked')
                $(ChkSource).closest('tr').find("[id*='ItemChkPrint_']").attr('checked', 'checked')
            }
        }
        else {
            value = CurrentValue.split('>>')[0];
            var checkedLength = 0, actualLength = 0;
            $("[class*='" + $.trim(value) + " >>'],[class*='" + $.trim(value) + ">>'],[class*='" + $.trim(value) + " >'],[class*='" + $.trim(value) + ">']").each(function (index, ele) {
                var nodeValue = $(this).attr('class').split('>>');
                var nodeValue1 = nodeValue.map(function (el) {
                    return $.trim(el);//To trim all items in the list
                });
                if (jQuery.inArray($.trim(value), nodeValue1) == 0) {//To Fix Quality Measures Link Issue.
                    actualLength++;
                    if ($(this).prev().find('input:checkbox')[0].checked == true)
                        checkedLength++;
                }
            });
            if (checkedLength == 0) {//If All the child items are unchecked then uncheck add/edit/delete/view in the header row eg: Manage Script
                $("[class*='" + $.trim(value) + "']").each(function (index, ele) {
                    var linkName = $(ele).attr('class').split('>>');
                    var linkNameTrim = linkName.map(function (el) {
                        return $.trim(el)
                    });
                    if (jQuery.inArray($.trim(value), linkNameTrim) == 0) {
                        $(ele).prev().find('input:checkbox').removeAttr('checked');
                        $(ele).closest('tr').find("[id*='ItemChkAdd_']").removeAttr('checked');
                        $(ele).closest('tr').find("[id*='ItemChkEdit_']").removeAttr('checked');
                        $(ele).closest('tr').find("[id*='ItemChkDelete_']").removeAttr('checked');
                        $(ele).closest('tr').find("[id*='ItemChkExport_']").removeAttr('checked');
                        $(ele).closest('tr').find("[id*='ItemChkEmail_']").removeAttr('checked');
                        $(ele).closest('tr').find("[id*='ItemChkPrint_']").removeAttr('checked');
                    }
                });
            }
            if (checkedLength == actualLength) {
                $("[class*='" + $.trim(value) + "']").prev().find('input:checkbox').attr('checked', 'checked');
            }
        }
    }
    else {
        if ($(ChkSource)[0].checked == false) {
            var header = $(ChkSource).closest('tr').find("[id*='lblHdnActionType']").attr('class');
            $("[class*='" + $.trim(header) + " >>'],[class*='" + $.trim(header) + ">>'],[class*='" + $.trim(header) + " >'],[class*='" + $.trim(header) + ">']").each(function (index, ele) {
                if (IsFrom == 'Add')
                    $(this).closest('tr').find("[id*='ItemChkAdd_']").removeAttr('checked').attr('disabled', 'disabled');
                if (IsFrom == 'Edit')
                    $(this).closest('tr').find("[id*='ItemChkEdit_']").removeAttr('checked').attr('disabled', 'disabled');
                if (IsFrom == 'Delete')
                    $(this).closest('tr').find("[id*='ItemChkDelete_']").removeAttr('checked').attr('disabled', 'disabled');
                if (IsFrom == 'Export')
                    $(this).closest('tr').find("[id*='ItemChkExport_']").removeAttr('checked').attr('disabled', 'disabled');
                if (IsFrom == 'Email')
                    $(this).closest('tr').find("[id*='ItemChkEmail_']").removeAttr('checked').attr('disabled', 'disabled');
                if (IsFrom == 'Print')
                    $(this).closest('tr').find("[id*='ItemChkPrint_']").removeAttr('checked').attr('disabled', 'disabled');
            });
        }
    }
}

function CheckViewDo() {
    var $CheckBoxViewsel = $(".HeadChkView").find("input:checkbox:not(:checked)");
    $($CheckBoxViewsel).attr('checked', false);
    var $CheckBoxAddsel = $(".HeadChkAdd").find("input:checkbox:checked");
    var $CheckBoxEditsel = $(".HeadChkEdit").find("input:checkbox:checked");
    var $CheckBoxDeletesel = $(".HeadChkDelete").find("input:checkbox:checked");
    var $CheckBoxExportsel = $(".HeadChkExport").find("input:checkbox:checked");
    var $CheckBoxEmailsel = $(".HeadChkEmail").find("input:checkbox:checked");
    var $CheckBoxPrintsel = $(".HeadChkPrint").find("input:checkbox:checked");
    $(".ItemChkView").find("input:checkbox:not(:checked)").each(function (index, el) {
        var addChk = "#" + $(this).attr("id").replace("ItemChkView_", "ItemChkAdd_");
        $(addChk).attr('checked', false);
    });
    $(".ItemChkView").find("input:checkbox:not(:checked)").each(function (index, el) {
        var editChk = "#" + $(this).attr("id").replace("ItemChkView_", "ItemChkEdit_");
        $(editChk).closest('tr').find(".txtEdit").css("display", "none");
        $(editChk).attr('checked', false);
    });
    $(".ItemChkView").find("input:checkbox:not(:checked)").each(function (index, el) {
        var deleteChk = "#" + $(this).attr("id").replace("ItemChkView_", "ItemChkDelete_");
        $(deleteChk).closest('tr').find(".txtDelete").css("display", "none");
        $(deleteChk).attr('checked', false);
    });
    $(".ItemChkView").find("input:checkbox:not(:checked)").each(function (index, el) {
        var exportChk = "#" + $(this).attr("id").replace("ItemChkView_", "ItemChkExport_");
        $(exportChk).attr('checked', false);
    });
    $(".ItemChkView").find("input:checkbox:not(:checked)").each(function (index, el) {
        var emailChk = "#" + $(this).attr("id").replace("ItemChkView_", "ItemChkEmail_");
        $(emailChk).attr('checked', false);
    });
    $(".ItemChkView").find("input:checkbox:not(:checked)").each(function (index, el) {
        var printChk = "#" + $(this).attr("id").replace("ItemChkView_", "ItemChkPrint_");
        $(printChk).attr('checked', false);
    });

    var $CheckBoxView1 = $(".ItemChkView").find("input:checkbox");
    var $CheckBoxView2 = $(".ItemChkView").find("input:checkbox:checked");
    if ($CheckBoxView1.length == $CheckBoxView2.length) {
        $($CheckBoxViewsel).attr('checked', true);
    }
    else {
        $($CheckBoxAddsel).attr('checked', false);
        $($CheckBoxEditsel).attr('checked', false);
        $($CheckBoxDeletesel).attr('checked', false);
        $($CheckBoxExportsel).attr('checked', false);
        $($CheckBoxEmailsel).attr('checked', false);
        $($CheckBoxPrintsel).attr('checked', false);
    }
}

function ChildCheckView(GvId, chkObj, ChkAct) {
    var CurrTr = $(chkObj).closest('tr');
    var CurrId = $(CurrTr).find("#hdnAdd").val().split("_");
    var parentTable = $(CurrTr).closest(GvId);

    var $CheckBoxAddsel = $(".HeadChkAdd").find("input:checkbox:checked");
    var $CheckBoxEditsel = $(".HeadChkEdit").find("input:checkbox:checked");
    var $CheckBoxDeletesel = $(".HeadChkDelete").find("input:checkbox:checked");
    var $CheckBoxExportsel = $(".HeadChkExport").find("input:checkbox:checked");
    var $CheckBoxEmailsel = $(".HeadChkEmail").find("input:checkbox:checked");
    var $CheckBoxPrintsel = $(".HeadChkPrint").find("input:checkbox:checked");
    if (CurrId[1] == 0) {
        $(".pnlLinksView " + GvId).find("tr").each(function (index, el) {
            if ($(this).find("#hdnAdd").length > 0) {
                var CheckVal = $(this).find("#hdnAdd").val().split("_")[0];
                if (CheckVal == CurrId[0]) {
                    $(this).find(ChkAct).find("input:checkbox").prop("checked", chkObj.checked);
                    if (chkObj.checked) { }
                    else {
                        $(this).find(".ItemChkAdd").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkEdit").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkDelete").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkExport").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkEmail").find("input:checkbox").prop("checked", false);
                        $(this).find(".ItemChkPrint").find("input:checkbox").prop("checked", false);
                        $($CheckBoxAddsel).attr('checked', false);
                        $($CheckBoxEditsel).attr('checked', false);
                        $($CheckBoxDeletesel).attr('checked', false);
                        $($CheckBoxExportsel).attr('checked', false);
                        $($CheckBoxEmailsel).attr('checked', false);
                        $($CheckBoxPrintsel).attr('checked', false);
                        var linkName = $(this).find("#lblMenuName").text();
                        linkName = linkName != null && linkName != undefined ? linkName.toLocaleLowerCase() : linkName;
                        if (linkName != null && linkName != undefined && (linkName == 'activity record >> documents' || linkName == 'activity record >> notes' || linkName == 'um authorizations >> notes' || linkName == 'um authorizations >> documents' || linkName == 'ag complaints >> notes' || linkName == 'ag complaints >> letters and documents')) {
                            if (!(linkName == 'activity record >> documents' && ChkAct == ".ItemChkEdit")) {
                                $(this).find(".txtEdit").css("display", "none");
                                $(this).find(".txtEdit").val("");
                                $(this).find(".txtDelete").css("display", "none");
                                $(this).find(".txtDelete").val("");
                            }
                        }
                    }
                }
            }
        });
    }
    else if (CurrId[1] != 0 && chkObj.checked == true) {
    }
    else {
        $(CurrTr).find(".ItemChkAdd").find("input:checkbox").prop("checked", false);
        $(CurrTr).find(".ItemChkEdit").find("input:checkbox").prop("checked", false);
        $(CurrTr).find(".ItemChkDelete").find("input:checkbox").prop("checked", false);
        $(CurrTr).find(".ItemChkExport").find("input:checkbox").prop("checked", false);
        $(CurrTr).find(".ItemChkEmail").find("input:checkbox").prop("checked", false);
        $(CurrTr).find(".ItemChkPrint").find("input:checkbox").prop("checked", false);
        $($CheckBoxAddsel).attr('checked', false);
        $($CheckBoxEditsel).attr('checked', false);
        $($CheckBoxDeletesel).attr('checked', false);
        $($CheckBoxExportsel).attr('checked', false);
        $($CheckBoxEmailsel).attr('checked', false);
        $($CheckBoxPrintsel).attr('checked', false);
        var linkName = $(CurrTr).find("#lblMenuName").text();
        linkName = linkName != null && linkName != undefined ? linkName.toLocaleLowerCase() : linkName;
        if (linkName != null && linkName != undefined && (linkName == 'activity record >> documents' || linkName == 'activity record >> notes' || linkName == 'um authorizations >> notes' || linkName == 'um authorizations >> documents' || linkName == 'ag complaints >> notes' || linkName == 'ag complaints >> letters and documents')) {
            if (!(linkName == 'activity record >> documents' && ChkAct == ".ItemChkEdit")) {
                $(CurrTr).find(".txtEdit").css("display", "none");
                $(CurrTr).find(".txtEdit").val("");
                $(CurrTr).find(".txtDelete").css("display", "none");
                $(CurrTr).find(".txtDelete").val("");
            }
        }
    }
}

function CheckUnCheckView() {
    var $CheckBoxView = $(".ItemChkView").find("input:checkbox:checked");
    var $CheckBoxViewsel = $(".HeadChkView").find("input:checkbox");
    var $CheckBoxAddsel = $(".HeadChkEdit").find("input:checkbox");
    var $CheckBoxEditsel = $(".HeadChkAdd").find("input:checkbox");
    var $CheckBoxDelsel = $(".HeadChkDelete").find("input:checkbox");
    var $CheckBoxExportsel = $(".HeadChkExport").find("input:checkbox:checked");
    var $CheckBoxEmailsel = $(".HeadChkEmail").find("input:checkbox:checked");
    var $CheckBoxPrintsel = $(".HeadChkPrint").find("input:checkbox:checked");
    var chkStatus = $($CheckBoxViewsel).is(':checked') ? true : false;
    if (chkStatus == false) {
        $($CheckBoxViewsel).attr('checked', chkStatus);
        $($CheckBoxAddsel).attr('checked', chkStatus);
        $($CheckBoxEditsel).attr('checked', chkStatus);
        $($CheckBoxDelsel).attr('checked', chkStatus);
        $($CheckBoxExportsel).attr('checked', chkStatus);
        $($CheckBoxEmailsel).attr('checked', chkStatus);
        $($CheckBoxPrintsel).attr('checked', chkStatus);
    }

    $(".ItemChkAdd").find("input:checkbox:checked").each(function (index, el) {
        var addChk = "#" + $(this).attr("id");
        $(addChk).attr('checked', chkStatus);
        //$(this)[0].checked = chkStatus;
    });
    $(".ItemChkEdit").find("input:checkbox:checked").each(function (index, el) {
        var editChk = "#" + $(this).attr("id");
        $(editChk).attr('checked', chkStatus);
        //$(this)[0].checked = chkStatus;
    });
    $(".ItemChkDelete").find("input:checkbox:checked").each(function (index, el) {
        var deleteChk = "#" + $(this).attr("id");
        $(deleteChk).attr('checked', chkStatus);
        //$(this)[0].checked = chkStatus;
    });
    $(".ItemChkExport").find("input:checkbox:checked").each(function (index, el) {
        var exportChk = "#" + $(this).attr("id");
        $(exportChk).attr('checked', chkStatus);
    });
    $(".ItemChkEmail").find("input:checkbox:checked").each(function (index, el) {
        var emailChk = "#" + $(this).attr("id");
        $(emailChk).attr('checked', chkStatus);
    });
    $(".ItemChkPrint").find("input:checkbox:checked").each(function (index, el) {
        var printChk = "#" + $(this).attr("id");
        $(printChk).attr('checked', chkStatus);
    });
}
/* Devx Letter Start */
var DEVEX_BASE_URL = "", DEVEX_EDITOR = "/LetterEditor/index", DEVEX_VIEWER = "/LettersViewer/index", DEVEX_EXPORT = "/LetterExport/Export", DEVEX_REVIEW = "/LetterReviewer/index", DEVEX_CONFERENCE = "/CaseConference/index", DEVEX_BULKVIEWER = "/BulkLetters/index";
//var DEVEX_BASE_URL = "", DEVEX_EDITOR = "LetterEditor.aspx", DEVEX_VIEWER = "LetterViewer.aspx", DEVEX_EXPORT = "LetterExport.aspx", DEVEX_REVIEW = "LetterReviewer.aspx", DEVEX_CONFERENCE = "CaseConference.aspx", DEVEX_BULKVIEWER = "BulkLetters.aspx";
var DEVEX_MVC_PAGE = '', DEVEX_MIGRATOR = "TemplateConversion.aspx";
function ChildInit() {
    if (!window['postMessage']) { CustomAlert("No CORS"); }
    else {
        if (window.addEventListener) { window.addEventListener("message", ChildReceiveMessage, false); }
        else { window.attachEvent("onmessage", ChildReceiveMessage); }
    }
}
function ChildReceiveMessage(evt) {
    var EventOrigin = evt.origin; var EventData = evt.data;
    if (EventData.Fun == "OpenViewer_Activity") { OpenViewer_Activity(EventData.FunData); }
    if (EventData.Fun == "OpenLetter_Close") { OpenLetter_Close(EventData.FunData); }
    if (EventData.Fun == "LoadGCPatientAlerts") { LoadGCPatientAlerts(EventData.FunData); }
}

function JsLetterGuid() { return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); }
function LetterGuid() {
    var TmpVal = (JsLetterGuid() + JsLetterGuid() + "-" + JsLetterGuid() + "-4" + JsLetterGuid().substr(0, 3) + "-" + JsLetterGuid() + "-" + JsLetterGuid() + JsLetterGuid() + JsLetterGuid()).toUpperCase();
    return TmpVal;
}
function BodyOverflow(val) {
    $("body").css({ "overflow": val });
    setInterval(function () { BodyOverflow(val) }, 5000);
}

function OpenLetter_DE_Init(route, parameters, isView) {
    ChildInit(); if (isView) { ShowMySchedule(false); } else { ShowMySchedule(true); }
    var LetEditHtml = "";

    $("#LetterDiv").html(""); $("#LetterClose").hide();

    $("#LetterCloseBtn").hide();

    var height = $(window).height();
    if (route === DEVEX_CONFERENCE) {
        height = height - 20;
    }
    LetEditHtml += "<iframe id='LetterFrame' class='LetterFrame' src='about:blank' frameborder='0'";

    if (isView) { LetEditHtml += " style='width: 100%;height:" + height + "px !important;display:block;'"; }

    else { LetEditHtml += " style='display:none;'"; }

    LetEditHtml += "></iframe>";

    $("#LetterDiv").html(LetEditHtml);

    $("#LetterClose").hide(); $('#LetterClose').html('');
    $("#LetterCloseBtn").hide(); $('#LetterCloseBtn').val('loading..');
    height = height + 20;
    if (isView) {
        $("#LetterDiv").css("width", "100%"); $("#LetterDiv").css("height", height);
    }
    else {
        $("#LetterDiv").css("width", "0px"); $("#LetterDiv").css("height", "0px");
    }
    $("#LetterDiv").show();

    var source = baseURL + "/GCAuthentication/LaunchDevExpress?route=" + encodeURI(route) + "&parameters=" + encodeURI(parameters);

    if (isView == false) { $("#LetterClose").hide(); $("#LetterCloseBtn").hide(); }
    $("#LetterDiv").find("#LetterFrame").attr("src", source);
    $("#LetterDiv").find("#LetterFrame").on("load", function () {
        if (isView) { $('#LetterCloseBtn').val('Cancel'); }
    });
    if (isView) { $("body").css({ "overflow": "hidden" }); }
}

function OpenLetter_Init(fileName, IsView) {
    ChildInit(); if (IsView) { ShowMySchedule(false); } else { ShowMySchedule(true); }
    var LetEditHtml = "", FinalUrl = "";
    var strBaseUrl = $("#HdnBaseUrl").val();
    $("#LetterDiv").html(""); $("#LetterClose").hide();
    $("#LetterCloseBtn").hide();
    var height = $(window).height();
    LetEditHtml += "<iframe id='LetterFrame' class='LetterFrame' src='about:blank' frameborder='0'";
    if (IsView) { LetEditHtml += " style='width: 100%;height:" + height + "px !important;display:block;'"; }
    else { LetEditHtml += " style='display:none;'"; }
    LetEditHtml += "></iframe>";
    $("#LetterDiv").html(LetEditHtml);

    $("#LetterClose").hide(); $('#LetterClose').html('');
    $("#LetterCloseBtn").hide(); $('#LetterCloseBtn').val('loading..');
    height = height + 20;
    if (IsView) {
        $("#LetterDiv").css("width", "100%"); $("#LetterDiv").css("height", height);
    }
    else {
        $("#LetterDiv").css("width", "0px"); $("#LetterDiv").css("height", "0px");
    }
    $("#LetterDiv").show();
    FinalUrl += strBaseUrl + fileName;

    if (IsView == false) { $("#LetterClose").hide(); $("#LetterCloseBtn").hide(); }
    $("#LetterDiv").find("#LetterFrame").attr("src", FinalUrl);
    $("#LetterDiv").find("#LetterFrame").on("load", function () {
        if (IsView) { $('#LetterCloseBtn').val('Cancel'); }
    });
    if (IsView) { $("body").css({ "overflow": "hidden" }); }
    //BodyOverflow("hidden");
}
function OpenLetter_Close(Obj) {
    $("#LetterFrame").attr("src", "about:blank");
    $("#LetterDiv").hide(); $("#LetterClose").hide(); $("#LetterCloseBtn").hide();
    $("body").css({ "overflow": "auto" }); ShowMySchedule(true);
    var isresultMTM = false;
    if (isMTMval.toLowerCase() == 'true') { isresultMTM = true; }
    if (DEVEX_MVC_PAGE == 'UM LETTER' || DEVEX_MVC_PAGE == 'UM DOCUMENTS' || DEVEX_MVC_PAGE == 'AG LETTER' || DEVEX_MVC_PAGE == 'AG DOCUMENTS'
        || ($('#selectPatientAccessed').val() > 0 && isresultMTM == false)) { $('#divUMActions,#divAGActions,#divAction').show(); }
    if (DEVEX_MVC_PAGE == 'MLT') { LetterTemplateFilters(1, true); }
    else if (DEVEX_MVC_PAGE == 'CM LETTER' || DEVEX_MVC_PAGE == 'CM DOCUMENTS') { if ($('#btnElectronicDocsSearch').length > 0) { $('#btnElectronicDocsSearch').trigger('click'); } }
    else if (DEVEX_MVC_PAGE == "UM DOCUMENTS" || DEVEX_MVC_PAGE == "UM LETTER") { $('.slimScrollDiv').show(); if ($('.TabbedPanelsTabSelected').attr('id') == 'AuthLeftTab_5') { AuthDocuments_Get(); } }
    else if (DEVEX_MVC_PAGE === "AG DOCUMENTS" || DEVEX_MVC_PAGE === "AG LETTER") {
        $('.slimScrollDiv').show();
        if ($('.TabbedPanelsTabSelected').attr('id') === 'AgLeftTab_6') {
            getComplaintDocuments();
        }
    }
    else if (DEVEX_MVC_PAGE == "PQ") { PrintQueueFilters(1); }
    else if (DEVEX_MVC_PAGE == "CASE CONFERENCE") { $('#ddlSelectActivityTypeAS').trigger('change'); }
    else if (DEVEX_MVC_PAGE == "PH LETTER") { $('.memchkvalPh,.clsMyMebChkMembercol').prop('checked', false); }
    else if (DEVEX_MVC_PAGE == "CASE CONFERENCE") { $('#ddlSelectActivityTypeAS').trigger('change'); }
    else if (DEVEX_MVC_PAGE == "MTM DOCUMENTS") { $("#electronicDocsMTMGrid").data("kendoGrid").dataSource.read(); }
    if (Obj != undefined) {
        var Result = Obj.split('|');
        if (Result[0] == 'MLTS') { CmnStatusMessageDisp('validationMessage', 'Template saved successfully', 'Success'); }
        else if (Result[0] == 'MLTU') { CmnStatusMessageDisp('validationMessage', 'Template updated successfully', 'Success'); }
        else if (Result[0] == 'PQ' && Result[1] == 3) { MessageBox("Message", "Letter has been sent to print queue successfully.", true, null, true); }
        else if (Result[0] == 'SPQ' && Result[1] == 3) { MessageBox("Message", "Letter has been saved and sent to print queue successfully.", true, null, true); }
        else if (Result[0] == 'PQ' && Result[1] == 5) { MessageBoxAlert("Message", "Letter has been sent to print queue successfully.", true, null, true); }
        else if (Result[0] == 'SPQ' && Result[1] == 5) { MessageBoxAlert("Message", "Letter has been saved and sent to print queue successfully.", true, null, true); }
        else if (Result[0] == 'CCSM') {
            window.top.AuditLog(1, window.top.actionTypeEnum.Email, "Activity Summary >> Case Conference", $('#selectPatientAccessed', window.parent.document).val(), window.top.memberidval, '');
            CustomAlert('Email has been sent successfully.');
        }
        else if (Result[0] == 'CCSD') { CustomAlert('Case conference meeting minutes saved successfully.'); }
        else if (Result[0] == 'PQ') { CustomAlert('Letter has been sent to print queue successfully.'); }
        else if (Result[0] == 'SPQ') { CustomAlert('Letter has been saved and sent to print queue successfully.'); }
        else if (Result[0] == 'INVALIDDATA') {
            $('#divValiDationMessage').CMNPopup({ popUpHeader: "Message", popLevel: 0, closeButton: "#btnCloseValidation" });
            //setTimeout(function () { $("#btnCloseValidation").trigger("click"); }, 5000);
        }
    }

}

function LoadGCPatientAlerts(obj) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CommonDefaultSessionState/PatientAlerts?patientId=" + obj + "&isDevExp=true",
        popUpHeader: "Alerts",
        popLevel: 2,
        modalWidth: MODAL_WIDTH.MEDIUM,
        onClose: function () {
        }
    });
}

function OpenLetter_CheckSingle(GvId, ChkItemId, NegMsgDefault, NegMsg) {
    var CurSelVal = ""; var CurVal = "";
    if (AlertOnActionSingle(GvId, ChkItemId, NegMsgDefault, NegMsg)) {
        var $CheckBoxsAll; var gridview = $("#" + GvId);
        if (gridview.length == 0) { $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]"); }
        else { $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]"); }

        var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
        $($CheckBoxsChecked).each(function () {
            if ($(this).closest("td").find(".ItemChkVal").length > 0) {
                CurVal = $($(this).closest("td").find(".ItemChkVal")[0]).text();
                if (CurVal != "") { CurSelVal = CurVal; }
            }
        });
    }
    return CurSelVal;
}
function OpenLetter_CheckMulti(GvId, ChkItemId, NegMsgDefault) {
    var CurSelVal = ""; var CurVal = "";
    if (AlertOnActionMulti(GvId, ChkItemId, NegMsgDefault)) {
        var $CheckBoxsAll; var gridview = $("#" + GvId);
        if (gridview.length == 0) { $CheckBoxsAll = $("#" + $("table." + GvId).attr('ID') + " input:checkbox[id*=" + ChkItemId + "]"); }
        else { $CheckBoxsAll = $("#" + GvId + " input:checkbox[id*=" + ChkItemId + "]"); }

        var $CheckBoxsChecked = $CheckBoxsAll.filter(":checked");
        $($CheckBoxsChecked).each(function () {
            if ($(this).closest("td").find(".ItemChkVal").length > 0) {
                CurVal = $($(this).closest("td").find(".ItemChkVal")[0]).text();
                if (CurVal != "") {
                    if (CurSelVal != "") { CurSelVal += ","; }
                    CurSelVal += CurVal;
                }
            }
        });
    }
    return CurSelVal;
}

function OpenEditor_Init(TemplateId, LetterType) {
    var strQsTemplateId = TemplateId;
    if (TemplateId == null || TemplateId == 0 || TemplateId == "0") { strQsTemplateId = LetterGuid(); }
    if (LetterType == undefined) { LetterType = 'NO'; }
    var requestParams = "Action^EDIT|TemplateIdFile^" + strQsTemplateId + "|LetterType^" + LetterType;
    OpenLetter_DE_Init(DEVEX_EDITOR, requestParams, true);
}

function OpenEditor_Open(GvId, ChkItemId, NegMsgDefault, NegMsg) {
    var CurSelVal = OpenLetter_CheckSingle(GvId, ChkItemId, NegMsgDefault, NegMsg);
    if (CurSelVal != "") { OpenEditor_Init(CurSelVal); }
}

function OpenViewerM_Init(PatientIds, ModuleId, AuthNo, ComplaintId) {
    var strQsProcessIdFile = LetterGuid(); if (AuthNo == undefined) { AuthNo = 0; } if (ComplaintId == undefined) { ComplaintId = 0; }
    var requestParameters = "Action^VIEW|PatientIds^" + PatientIds + "|LetterIdFile^" + strQsProcessIdFile + "|ModuleId^" + ModuleId + "|AuthNo^" + AuthNo + "|ComplaintId^" + ComplaintId;
    OpenLetter_DE_Init(DEVEX_BULKVIEWER, requestParameters , true);
}

function OpenViewer_Init(PatientId, ModuleId, AuthNo, ComplaintId) {
    var strQsProcessIdFile = LetterGuid(); if (AuthNo == undefined) { AuthNo = 0; } if (ComplaintId == undefined) { ComplaintId = 0; }
    var requestParameters = "Action^VIEW|PatientId^" + PatientId + "|LetterIdFile^" + strQsProcessIdFile + "|ModuleId^" + ModuleId + "|AuthNo^" + AuthNo + "|ComplaintId^" + ComplaintId + "|PatientAlertCount^" + $('.btnPatientCount').val();
    OpenLetter_DE_Init(DEVEX_VIEWER, requestParameters, true);
}

function OpenMTMViewer_Init(PatientId, ModuleId, TemplateId, SectionName, lobbenid, ClientId) {
    var strQsProcessIdFile = LetterGuid();
    var requestParameters = "Action^VIEW|PatientId^" + PatientId + "|LetterIdFile^" + strQsProcessIdFile + "|ModuleId^" + ModuleId + "|TemplateIdFile^" + TemplateId + "|Action^EDIT|SectionName^" + SectionName + "|LobBenId^" + lobbenid + "|PatientClientId^" + ClientId;
    OpenLetter_DE_Init(DEVEX_VIEWER, requestParameters, true);
}
function MigrationEditor_Init(TemplateId) {
    var requestParameters = "Action^EDIT|TemplateIdFile^" + TemplateId;
    OpenLetter_DE_Init(DEVEX_MIGRATOR, requestParameters, true);
}
function OpenViewer_Activity(Obj) {
    OpenLetter_Close(); var OpenAct = false; var docId = '', ModuleId = '';
    docId = Obj.split('|')[0]; ModuleId = Obj.split('|')[1];
    //var roleItem = window.top.getSpecRoleItem("AHS_CM_OPERATIONAL_ADD_ACTIVITY");
    //if (roleItem.length > 0) {
    //    if (roleItem[0].IsAdd == false)
    //        return;
    //}
    if (ModuleId == 1) {
        $('#hdnCmLetterDocId').val(docId);
        $('#SaveAsDraftConfirm').CMNPopup({ popUpHeader: "Confirmation", popLevel: 0, closeButton: '#btnClosePopUpSd' });
    }
    else if (ModuleId == 3) { ConfirmationUMSaveAsDraft(docId); }
    else if (ModuleId == 5) { ConfirmationAGSaveAsDraft(docId); }
    else { CustomAlert('Letter draft has been saved successfully.'); }
}

function PrintQueue_Init(AcType, PrintQueueIds, TemplateIds, LetterQueueIds, GroupId, DocumentId, ModuleId) {
    if (GroupId == undefined) { GroupId = 0; }
    if (DocumentId == undefined) { DocumentId = 0; }
    if (ModuleId == undefined) { ModuleId = 0; }
    var requestParameters = "Action^" + AcType + "|LetterIdFile^" + PrintQueueIds + "|TemplateIdFile^" + TemplateIds + "|LetterQueueIdFile^" + LetterQueueIds + "|GroupId^" + GroupId + "|DocumentIdFile^" + DocumentId + "|ModuleId^" + ModuleId;
    OpenLetter_DE_Init(DEVEX_EXPORT, requestParameters, false);
}

function OpenReviewer_Init(PatientId, DocumentIds, Review, ModuleId, AuthNo, ComplaintId, LetterType) {
    var strQsProcessIdFile = LetterGuid();
    if (AuthNo == undefined) { AuthNo = 0; }
    if (ComplaintId == undefined) { ComplaintId = 0; }
    if (LetterType == undefined) { LetterType = 'NO'; }
    var requestParameters = "Action^" + Review + "|PatientId^" + PatientId + "|LetterIdFile^" + strQsProcessIdFile + "|DocumentIdFile^" + DocumentIds + "|ModuleId^" + ModuleId + "|AuthNo^" + AuthNo + "|ComplaintId^" + ComplaintId + "|LetterType^" + LetterType + "|PatientAlertCount^" + $('.btnPatientCount').val();
    OpenLetter_DE_Init(DEVEX_REVIEW, requestParameters, true);
}
function OpenConference_Init(PatientId, GroupId) {
    DEVEX_MVC_PAGE = "CASE CONFERENCE";
    var strQsProcessIdFile = LetterGuid();
    var requestParameters = "Action^VIEW|PatientId^" + PatientId + "|LetterIdFile^" + strQsProcessIdFile + "|GroupId^" + GroupId;
    OpenLetter_DE_Init(DEVEX_CONFERENCE, requestParameters, true);
}

function ConfirmationCMSaveAsDraft() {
    $('#btnClosePopUpSd').trigger('click');
    var PatientId = $('#selectPatientAccessed').val();
    var docId = $('#hdnCmLetterDocId').val();
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/EditActivity?patientId=" + PatientId + "&documentId=" + docId,
        onLoad: function () {
            // $("#hdnPatientDocumentId").val(docId);
            onLoadEditActivity();
            $('#activityForm #btnCloseActivityForm').hide();
            $('#selectScheduledType').find('option[text="Scheduled"]').attr("selected", "selected");
            $('#selectScheduledType').attr("disabled", "disabled");
            //$('#selectActivityType').find('option[text="Letter Review"]').attr("selected", "selected");
            // $('#selectActivityType').attr("disabled", "disabled");
            var activityTypeddl = $("#selectActivityType").data("kendoDropDownList");
            activityTypeddl.enable(false);
            $('#divRecurringActivity').hide();
            $("#divGroupActivity").show();
            $("#btnSubmitActivityForm").hide();
            $("#btnCloseActivityForm").show();
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        popUpHeader: "Add Activity",
        popLevel: 1,
        modalWidth: MODAL_WIDTH.MEDIUM,
        closeButton: "#btnCloseEditActivityForm",
        onClose: function () {
            $("#hdnPatientDocumentId").val('0');
            if ($("#electronicDocsGrid").is(":visible")) {
                var grid = $("#electronicDocsGrid").data("kendoGrid");
                if (grid && grid.dataSource) {
                    grid.dataSource.page(1);
                }
            }
        }
    });


}
/* Devx Letter End */
function ConvertImageString(FileEle, Action) {
    var FileObj = $(FileEle).get(0).files[0];
    var FR = new FileReader();
    FR.onload = function (event) {
        if (Action.toUpperCase() == "ADD") { $('#hdnFileUploadAdd').val(event.target.result); }
        else if (Action.toUpperCase() == "UPDATE") { $('#hdnFileUploadUpdate').val(event.target.result); }
    };
    FR.readAsDataURL(FileObj);
}
function ClearFileData(elem) {
    var _confirmRemove = CustomConfirm('Do you want to remove the image?');
    if (_confirmRemove) {
        $(elem).parent().hide();
        $('#hdnFileUploadUpdate').val('');
        $('#hdnFileUploadAdd').val('');
    }
}
function ShowMySchedule(isShow) {
    if (isShow == false) { $('#divImgbtnMySchedule').hide(); }
    else { $('#divImgbtnMySchedule').show(); }
}

//GFID-815

function AssginActivityValue() {
    var selectedActivityValue = $('#ddlPrimaryCActivity option:selected').val();
    if (selectedActivityValue == '-1') {
        $('#hdnPrimaryCareActivity').val('');
    }
    else {
        $('#hdnPrimaryCareActivity').val(selectedActivityValue);
    }
}
function OnClientDropDownClosedHandler(sender, eventArgs) {
    $("#ddlPrimaryCActivity").html("<option value='-1'>--Select--</option>");
    var isPrimaryIncative = false;
    if (sender.get_checkedItems().length > 1) {
        sender.get_checkedItems().forEach(function (e) {
            $("#ddlPrimaryCActivity").append("<option value='" + e.get_value() + "'>" + e.get_text() + "</option>");
        });
    }
    else if (sender.get_checkedItems().length == 1) {
        $("#ddlPrimaryCActivity").html("");
        $("#ddlPrimaryCActivity").append("<option value='" + sender.get_checkedItems()[0].get_value() + "'>" + sender.get_checkedItems()[0].get_text() + "</option>");
    }

    if (sender.get_checkedItems().length > 0) {
        if ($('#ddlPrimaryCActivity').find('option[value="' + $("#hdnPrimaryCareActivity").val() + '"]').length > 0) {
            $("#ddlPrimaryCActivity").val($("#hdnPrimaryCareActivity").val());
        }
    }
    //if ($('#hdnScriptID').val() != "0" && $('#hdnIsFrom').val() == "") {
    //    validateAdminScriptPage();
    //}
}


function validateAdminScriptPage(value) {
    $("#addEditScAdminScript .validationMessage").hide();
    var returnMsg = true;
    if (value == 'Save') {
        if ($("#ddlPrimaryCActivity").val() == "-1") {
            returnMsg = false;
            $("#ddlPrimaryCActivity").parent().find(".validationMessage").show();
        }
        else {
            $("#hdnPrimaryCareActivity").val($("#ddlPrimaryCActivity").val());
        }
        if ($("#txtScriptName").val() == "") {
            returnMsg = false;
            $("#txtScriptName").parent().find(".validationMessage").show();
        }
        if ($("#ddlScriptRunType").val() == "-1") {
            returnMsg = false;
            $("#ddlScriptRunType").parent().find(".validationMessage").show();
        }
        if ($("#ddlCActivity_Input").val() == "Select") {
            returnMsg = false;
            $("#ddlCActivity").parent().find(".validationMessage").show();
        }
        if ($("#ddlLOB_Input").val() == "Select") {
            returnMsg = false;
            $("#ddlLOB").parent().find(".validationMessage").show();
        }
        if ($("#ddlForms").val() == "-1") {
            returnMsg = false;
            $("#ddlForms").parent().find(".validationMessage").show();
        }
        if ($("#chkAttachOGIs").length > 0 && $("#chkAttachOGIs").is(":checked")) {// If control Exists i.e, Only for Update
            if ($("#ddlOGILOB_Input").val() == "Select") {
                returnMsg = false;
                $("#ddlOGILOB").parent().find(".validationMessage").show();
            }
            if (HdnScriptOgiLobId.value == "" && HdnOtherCareStaffOgiLobId.value == "" && $("#ddlOGILOB_Input").val() != "Select") {
                returnMsg = false;
                CustomAlert("OGIs cannot be copied as there are no OGIs configured for this Script");
            }
        }
        if ($("#chkIsAttestReq").length > 0 && $("#chkIsAttestReq").is(":checked")) {// If control Exists i.e, Only for Update
            if ($.trim($("#txtAttestText").val()) == "") {
                returnMsg = false;
                $("#txtAttestText").parent().find(".validationMessage").show();
            }
        }
        if ($('#tdStartDate').find('.riTextBox').val() == "") {
            returnMsg = false;
            $('#tdStartDate').find('.validationMessage').show();
        }

        if (returnMsg) {
            returnMsg = ScriptVersionDateValidations();
        }
        return returnMsg;
    }

}
function ScriptVersionDateValidations() {
    var startDate = '', endDate = '', todaysDate = '';
    var returnMsg = true;
    startDate = new Date($('#tdStartDate').find('.riTextBox').val());
    if (ScriptIsDateValidation(startDate, 'SD')) {
        todaysDate = new Date($('#hdnCurrentUserDateTime').val());
        //todaysDate = new Date();       
        //todaysDate.setSeconds(0,0);        
        if (($('#hdnScriptID').val() == "0" || $('#hdnIsFrom').val() != "") && startDate < todaysDate) {
            returnMsg = false;
            CustomAlert("Start Date cannot be past date than current date.");
        }
        if (returnMsg == true && $('#tdEndDate').find('.riTextBox').val() != "") {
            endDate = new Date($('#tdEndDate').find('.riTextBox').val());
            if (ScriptIsDateValidation(endDate, 'ED')) {
                if (endDate < todaysDate) {
                    returnMsg = false;
                    CustomAlert("End Date cannot be past date than current date.");
                }
                else if (endDate < startDate) {
                    returnMsg = false;
                    CustomAlert("Start Date should be past date than the End Date.");
                }
            }
            else {
                $('#tdEndDate').find('.riTextBox').val('');
                returnMsg = false;
            }
        }
    }
    else {
        $('#tdStartDate').find('.riTextBox').val('');
        returnMsg = false;
    }
    return returnMsg;
}
function ScriptIsDateValidation(dateVal, obj) {
    var retval = true; var msg = '';
    var conVal = new Date(dateVal);
    if (conVal == 'Invalid Date') { retval = false; }
    if (retval == false) {
        if (obj == 'SD') {
            msg = "Invalid date format! Please correct start date."
        }
        else if (obj == 'ED') {
            msg = "Invalid date format! Please correct end date."
        }
        if (msg != "") {
            CustomAlert(msg);
        }
    }
    return retval;
}
//GFID-815
//Begin Export Import Script UHC-39
function AssginActivityValueForImportScript() {
    var selectedActivityValue = $('#ddlPrimaryCareActivityImport option:selected').val();
    if (selectedActivityValue == '-1') {
        $('#hdnPrimaryCareActivityImport').val('');
    }
    else {
        $('#hdnPrimaryCareActivityImport').val(selectedActivityValue);
    }
}

function OnClientDropDownClosedHandlerForImportScript(sender, eventArgs) {
    $("#ddlPrimaryCareActivityImport").html("<option value='-1'>--Select--</option>");
    $(".dynamicRequirementImport").removeClass("validationMessage");
    var isPrimaryIncative = false;
    if (sender.get_checkedItems().length > 1) {
        sender.get_checkedItems().forEach(function (e) {
            $("#ddlPrimaryCActivity_Import").append("<option value='" + e.get_value() + "'>" + e.get_text() + "</option>");
        });
    }
    else if (sender.get_checkedItems().length == 1) {
        $("#ddlPrimaryCActivity_Import").html("");
        $("#ddlPrimaryCActivity_Import").append("<option value='" + sender.get_checkedItems()[0].get_value() + "'>" + sender.get_checkedItems()[0].get_text() + "</option>");
    }

    if (sender.get_checkedItems().length > 0) {
        if ($('#ddlPrimaryCActivity_Import').find('option[value="' + $("#hdnPrimaryCareActivity_Import").val() + '"]').length > 0) {
            $("#ddlPrimaryCActivity_Import").val($("#hdnPrimaryCareActivity_Import").val());
        }
        $(".dynamicRequirementImport").addClass("validationMessageImptScript");
    }
    //validateAdminScriptImportPage();
}

function validateAdminScriptImportPage() {
    $("#ScAdminImportScript .validationMessageImptScript").hide();
    var returnMsg = true;
    if ($("#ddlPrimaryCareActivityImport").val() == "-1") {
        returnMsg = false;
        $("#ddlPrimaryCareActivityImport").parent().find(".validationMessageImptScript").show();
    }
    else {
        $("#hdnPrimaryCareActivity_Import").val($("#ddlPrimaryCareActivityImport").val());
    }
    if ($("#txtScriptNameImport").val() == "") {
        returnMsg = false;
        $("#txtScriptNameImport").parent().find(".validationMessageImptScript").show();
    }
    if ($("#ddlScriptRunTypeImport").val() == "-1") {
        returnMsg = false;
        $("#ddlScriptRunTypeImport").parent().find(".validationMessageImptScript").show();
    }
    if ($("#ddlCareActivitymport").val() == "Select") {
        returnMsg = false;
        $("#ddlCareActivitymport").parent().find(".validationMessageImptScript").show();
    }
    if ($('#loadScriptEligibilityLevels').children().length > 0) {
        if (!getSelHierarchyLevelValues().RecordSelected || getSelHierarchyLevelValues().LobBenIds == null) {
            returnMsg = false;
            CmnStatusMessageDisp('ImportScriptTemplateRequiredValidator', 'Please select the eligibility level', 'Error');
        }
    }
    if (($('#hdnScriptFileUpload').val() === undefined) || ($('#hdnScriptFileUpload').val() === '')) {
        returnMsg = false;
        CmnStatusMessageDisp('lblImportMsg', 'Please upload excel file.', 'Error');
    }
    return returnMsg;
}
//End
//G8CAL-83

//Intervention Alias name dynamic row adding
function AddRowIntervention(ele) {
    var $aliasNameTr = $(ele).parent().parent();
    $aliasNameTr.find('span.required').remove();
    var aliasCount = parseInt($aliasNameTr.attr("id").split("_")[1]);
    var $ddlLanguage = $("#aliasNameTr_" + aliasCount).find("select").val();
    var $txtAlias = $("#aliasNameTr_" + aliasCount).find("textarea").val();
    if ($txtAlias != "" && $ddlLanguage != "Language") {
        $("#aliasNameTr_" + aliasCount).next()
            .after("<tr style='height:35px;' class='intAlias' id='aliasNameTr_" + (aliasCount + 1) + "'>" +
                $aliasNameTr.html() + "</tr><tr>" + $("#aliasNameTr_" + aliasCount).next().html() + "</tr>");

        $("#aliasNameTr_" + (aliasCount + 1)).find("#hdnMappingId").val("0");
        $("#aliasNameTr_" + (aliasCount + 1)).find(".required").hide();
    }
    else if (($txtAlias == "" && $ddlLanguage != "Language")) {
        $aliasNameTr.find("#txtInterventionLangAlias").after('<span class="required" style="color:red">*</span>');
    }
    else if ($txtAlias != "" && $ddlLanguage == "Language") {
        $aliasNameTr.find("#ddlAliasLanguage").after('<span class="required" style="color:red">*</span>')
    }
}

//to display status message
function CmnStatusMessageDisplay(CtrlID, Msg, MsgType, className,TimeOutValue) {
    if (CtrlID != null && Msg != null && MsgType != null) {
        var TimeOut = TimeOutValue || 30000;
        var $CtrlEle = $(('#' + CtrlID));
        var isproviderUser = ToValue(isProviderUser, null);
        if (CtrlID === 'lblMsg' && isproviderUser === true) {
            $CtrlEle = $('#DisplayView #lblMsg');
        }
        $CtrlEle.html(Msg);
        if (MsgType == 'Error') {
            $CtrlEle.attr('class', className !== undefined ? className : 'popMsgError');
        }
        else if (MsgType == 'Success') {
            $CtrlEle.attr('class', className !== undefined ? className : 'popMsgSuccess');
        }
        else if (MsgType == 'Warning') {
            $CtrlEle.attr('class', className !== undefined ? className : 'popMsgWarning');
        }
        $CtrlEle.show();
        setTimeout(function () { $CtrlEle.hide('slow'); $CtrlEle.html(''); }, TimeOut);
    }
}

function RemoveRowIntervention(ele, divId) {
    $("#msgBox").hide();
    divId = $.fn.setValueOnUndefinedOrNull(divId, 'msgBox');
    var $trToRemove = $(ele).parent().parent();
    $trToRemove.find('span.requiredfields').remove();
    if ($trToRemove.find("textarea").val() != "" && $trToRemove.find("#ddlAliasLanguage").val() != "Language") {
        if (CustomConfirm("Are you sure that you want to delete " + $trToRemove.find("select option:selected").html() + " Alias for this intervention")) {

            CmnStatusMessageDisp(divId, 'The ' + $trToRemove.find("select option:selected").html() + ' alias has been deleted successfully', 'Success');
            if ($(".intAlias").length <= 1) {
                $trToRemove.find("textarea").val('');
                $trToRemove.find("#ddlAliasLanguage").val($trToRemove.find("#ddlAliasLanguage option:first").val());
            }
            else {
                $trToRemove.next().remove();
                $trToRemove.remove();
            }
        }
    }
    else {
        if ($(".intAlias").length > 1) {
            $trToRemove.next().remove();
            $trToRemove.remove();
        }
        else if ($(".intAlias").length == 1) {
            $trToRemove.find("textarea").val('');
            $trToRemove.find("#ddlAliasLanguage").val($trToRemove.find("#ddlAliasLanguage option:first").val());
        }
    }
}

function getAliasNameAsJson() {
    var aliasNameInput = trimSpacesForInput($('#txtInterventionAlias')); // to validate empty spaces-prod-5147
    var interventionNameInput = trimSpacesForInput($("#txtInterventionName"));
    $("#msgBox").hide();
    $(".intAlias").find('span.required').remove();
    var data = [], jsonVal, emptyText = false;
    if (interventionNameInput == "") {
        $("#ReqtxtInterventionName").show();
        emptyText = true;
    }
    else {
        $("#ReqtxtInterventionName").hide();
    }
    if (aliasNameInput == "") { $("#ReqFVInterventionAlias").show(); emptyText = true; }
    else {
        $("#ReqFVInterventionAlias").hide();
        data.push({
            langId: $("#hdnEngLangId").val(),
            aliasName: $("#txtInterventionAlias").val().trim(),
            mappingId: ($("#btnSave").val() == "Update") ? $("#hdnEngMappingId").val() : 0,
        });
    }
    $.each($(".intAlias"), function () {
        var $ddlLanguage = $(this).find("select option:selected").val();
        var $txtAlias = $(this).find("textarea").val();

        if ($txtAlias == "" && $ddlLanguage != "Language") {
            emptyText = true;
            $(this).find("textarea").after('<span class="required" style="color:red">*</span>');
            return;
        }
        else if ($txtAlias != "" && $ddlLanguage == "Language") {
            emptyText = true;
            $(this).find("select").after('<span class="required" style="color:red">*</span>')
            return;
        }
        if ($ddlLanguage != "Language" && $txtAlias != "") {
            data.push({
                langId: $ddlLanguage,
                aliasName: $txtAlias,
                mappingId: ($("#btnSave").val() == "Update") ? $(this).find("#hdnMappingId").val() : 0,
            });
        }
    });
    var isDuplicate = false;
    if (data.length > 1) {
        var sortedArray = [];
        sortedArray = data.sort(function (a, b) { return (a.langId > b.langId) ? 1 : ((b.langId > a.langId) ? -1 : 0); });
        for (i = sortedArray.length - 1; i > 0; i--)
            if (sortedArray[i].langId == sortedArray[i - 1].langId) {
                isDuplicate = true;
            }
    }
    if (isDuplicate)
        CmnStatusMessageDisplay('msgBox', 'Duplicate alias language', 'Error');
    if (emptyText || isDuplicate)
        return false;
    else {
        jsonVal = JSON.stringify(data);
        $("#hdnAliasData").val(jsonVal);
        return true;
    }
}

function trimSpacesForInput(input) {
    return input.val().replace(/(^\s+|\s+$)/g, '');
}

function getAlias() {
    parser = new DOMParser();
    var xmlString = $("#hdnAliasData").val();
    xmlDoc = parser.parseFromString(xmlString, "text/xml");
    var language_id = "", alias_text = "", mapping_id = "";
    var totalNodes = 0;
    var parentNode = xmlDoc.documentElement.childNodes;
    totalNodes = xmlDoc.documentElement.childElementCount;
    //get the language and respective alias for 1st record
    language_id = parentNode[0].childNodes[0].textContent;
    alias_text = parentNode[0].childNodes[1].textContent;
    mapping_id = parentNode[0].childNodes[2].textContent;
    var $aliasNameTr = $(".intAlias").last();
    //popluate 1st alias name and language
    $aliasNameTr.find("textarea").val(alias_text);
    if ($("#ddlAliasLanguage option[value='" + language_id + "']").length > 0) {
        $aliasNameTr.find("select").val(language_id);
    }
    $aliasNameTr.find("#hdnMappingId").val(mapping_id);
    for (i = 1; i < parentNode.length; i++) {
        $aliasNameTr = $(".intAlias").last();
        language_id = parentNode[i].childNodes[0].textContent;
        alias_text = parentNode[i].childNodes[1].textContent;
        mapping_id = parentNode[i].childNodes[2].textContent;
        $("#aliasNameTr_" + (i - 1)).next()
            .after("<tr style='height:35px;' class='intAlias' id='aliasNameTr_" + (i) + "'>" +
                $aliasNameTr.html() + "</tr><tr>" + $("#aliasNameTr_" + (i - 1)).next().html() + "</tr>");
        $("#aliasNameTr_" + i).find("textarea").val(alias_text);
        if ($("#ddlAliasLanguage option[value='" + language_id + "']").length > 0) {
            $("#aliasNameTr_" + i).find("select").val(language_id);
        }
        $("#aliasNameTr_" + i).find("#hdnMappingId").val(mapping_id);
    }
}
//

//Used for validating search criteria in config section
function ValidateSearchCriteria(textBoxId, dropDownId, IsFromMvc) {
    if ($('#logoSeachText').is(":visible")) {
        var searchText = $.trim($("#" + textBoxId).val()), searchField = $("#" + dropDownId).val(), Result = true;
        searchText = searchText.replace('Search Text', ''); searchField = searchField.replace('Select', '-1');
        $("#" + dropDownId).next().hide(); $("#" + textBoxId).next().hide();
        if (searchField == "-1" || searchText == '') {
            if (searchField == "-1" && searchText != '') { $("#" + dropDownId).next().show(); Result = false; }
            else if (searchField != "-1" && searchText == '') { $("#" + textBoxId).next().show(); Result = false; }
        }
        if (searchText == '' && IsFromMvc == undefined) { $("#" + textBoxId).val('Search Text'); }
        else if (searchText == '' && IsFromMvc == 1) { $("#" + textBoxId).attr('placeholder', 'Search Text'); }
        return Result;
    }
    return true;
}

function validateMDB() {
    var isValid = true;
    var grids = $("#pnlMDBInner").find('.GridStyle1');
    grids.each(function (ind) {
        var arrayValues = [];
        var ddlRank = $(this).find("select");
        var mm = ddlRank.length;
        ddlRank.each(function (ind) {
            if (arrayValues.length == 0 || $.inArray($(this).val(), arrayValues) == -1) {
                arrayValues.push($(this).val());
                //$(this).removeAttr("style");
                $(this).css("border", "").css("width", "70px");
            }
            else {
                $(this).focus().css("border", "2px solid #e02020");
                CustomAlert('You cannot have duplicate display order under one section');
                return isValid = false;
            }
        });
        if (isValid == false)
            return false;
    });
    return isValid;
}

function ReviewRSCarePlan(isActivity) {
    $('span.isMandate').hide();
    var isActivityOutComeValid = false;
    var isActualDurationValid = false;
    var isValid = false;
    var isContactTypeValid = true;
    var isCustomFieldValid = true;
    var isCustomPhoneFieldValid = true;
    var customPhoneFieldValidCount = 0;
    var PhoneandFaxformat = /^\d{3}-\d{3}-\d{4}$/;
    isValid = Page_ClientValidate('abc');
    if (!isValid) { return false; }
    var calendarValid = true;
    $('.cstcalendar:visible').each(function () {
        var inputId = $(this).attr('id');
        if (inputId) {
            var valid = A11yForms.validateFormField(inputId, null, [A11yForms.VALIDATIONS.CALENDARDATE]);
            if (!valid) {
                calendarValid = false;
            }
        }
    });
    if (!calendarValid) {
        return false;
    }
    $('span.validationMessage').hide();
    var ddlActivityOutCome = $find('ddlActivityOutCome');
    var ddlActivityOutComeType = $find('ddlActivityOutComeType');
    var OutComeId = ddlActivityOutCome.get_value();
    var OutComeTypeId = ddlActivityOutComeType.get_selectedItem().get_value();
    var IsActivityOutcomeMandatory = $('#hdnIsActivityOutcomeMandatory').val();
    var contactTypeCon = $find('ddlRSContactType'); //KP@UHG-2932
    var contactType = contactTypeCon.get_value();
    var isMemPortalProvReview = document.getElementById('chkMemberPortalReview') ? document.getElementById('chkMemberPortalReview').checked : false;
    if (contactType == "") {
        $("#spnRSContactType").show();
        isContactTypeValid = false;
    }
    var IsActualDurationMandatory = $('#hdnIsActualDurationMandatory').val();

    var hrsValue = document.getElementById('txtHours').value;
    var minsValue = document.getElementById('txtMinutes').value;

    if (IsActivityOutcomeMandatory == "True" || (IsActivityOutcomeMandatory == "False" && OutComeId != "" && OutComeTypeId != "")) {
        isActivityOutComeValid = true;
    }
    else {
        if (OutComeId == "")
            $("#ddlActivityOutComeval").show();
        if (OutComeTypeId == "")
            $("#ddlActivityOutComeTypeval").show();
        $find("behReviewCarePlanWorkflow").show();
    }
    if (IsActualDurationMandatory == "False" || (IsActualDurationMandatory == "True" && (hrsValue != "" || minsValue != ""))) {
        isActualDurationValid = true;
    }
    else {
        $("#actualDurationValidation").show();
        $find("behReviewCarePlanWorkflow").show();
    }

    if ($("#ActivityOutcomeCustomFieldUnique .requriedCustfield").length > 0) {
        var requiredFieldsCount = $("#ActivityOutcomeCustomFieldUnique .requriedCustfield").length;
        $("#ActivityOutcomeCustomFieldUnique .requriedCustfield").each(function () {
            var durHrs = '#durHrs_' + $(this).attr("id");
            var durMins = '#durMins_' + $(this).attr("id");

            // if radio button
            if ($(this).find('.chkradiocustfield').length > 0) {
                var isRadioChecked = false;
                $(this).find('.chkradiocustfield').each(function (index, obj) {
                    if (this.checked === true) {
                        isRadioChecked = true;
                    }

                });

                if (isRadioChecked == false) {
                    if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                        $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                        isCustomFieldValid = false;
                    }
                }
                else {
                    requiredFieldsCount = requiredFieldsCount - 1
                }
            }

            //if check box 
            else if ($(this).find('.chkcheckcustfield').length > 0) {
                var isCheckBoxChecked = false;
                $(this).find('.chkcheckcustfield').each(function (index, obj) {
                    if (this.checked === true) {
                        isCheckBoxChecked = true;
                    }
                });


                if (isCheckBoxChecked == false) {
                    if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                        $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                        isCustomFieldValid = false;
                    }
                }
                else {
                    requiredFieldsCount = requiredFieldsCount - 1
                }
            }
            else if ($(this).find('.cstcalendar').length > 0) {

                requiredFieldsCount = requiredFieldsCount - 1

            }

            else if ($(this).find(durHrs).length > 0 || $(this).find(durMins).length > 0) {
                if (($(this).find(durHrs).val() !== undefined && $(this).find(durHrs).val() !== "" && $(this).find(durHrs).val() !== null) ||
                    ($(this).find(durMins).val() !== undefined && $(this).find(durMins).val() !== "" && $(this).find(durMins).val() !== null)) {
                    requiredFieldsCount = requiredFieldsCount - 1
                }
                else {
                    if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                        $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                        isCustomFieldValid = false;
                    }

                }

            }

            else {
                //rest of single field controls
                if ($(this).val() != undefined && $(this).val() != "" && $(this).val() != null) {
                    requiredFieldsCount = requiredFieldsCount - 1
                }
                else {
                    if (this.className == "dateInside cstfield cstcalendar requriedCustfield k-input") {
                        if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                            $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                            isCustomFieldValid = false;
                        }
                    }
                    else {
                        $(this).css('border-color', 'red');
                        isCustomFieldValid = false;
                    }
                }
            }
        });
        $('.cstfield.phone').each(function (index, obj) {
            if ($(this).val() != "" && !$(this).val().match(PhoneandFaxformat)) {
                $('#txtLabelPhone_' + $(this).data('id')).append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
                customPhoneFieldValidCount = + 1;
                isCustomPhoneFieldValid = false;
            }
        });

        if (requiredFieldsCount == 0) {
            isCustomFieldValid = true;
        }
        else {
            isCustomFieldValid = false;
        }

        if (customPhoneFieldValidCount == 0) {
            isCustomPhoneFieldValid = true;
        }
    }


    if (isActivityOutComeValid && isActualDurationValid && isContactTypeValid && isCustomFieldValid && isCustomPhoneFieldValid) {
        $("#btnSaveAndProceed").prop('disabled', true);
        var OutComeNotes = $('#txtOutComeNotes').val();
        var FollowUpId = $('#hdnPatientFollowUpId', '.clsWorkFlowScript').val();
        $('#hdnPatientFollowUpId').val('');
        var actualHrs = parseInt($('#txtHours').val());
        var actualMins = parseInt($('#txtMinutes').val());
        var actualDuration = window.top.DurationFormat(actualHrs) + ':' + window.top.DurationFormat(actualMins) + ':00';
        var placeOfServiceCon = $find('ddlPlaceOfService');
        var ctrlHCPCCode = $find('ddlHCPCCode');
        var HCPCCodeId = ctrlHCPCCode.get_value();
        var placeOfServiceId = placeOfServiceCon.get_value();

        //PROD-23778--- Live Rule changes
        var scriptName = activityOutcomeName = activityOutcomeType = "";
        if ($('#hdnIsSaveEnd').val() != undefined && $('#hdnIsSaveEnd').val() == "True") {
            scriptName = $('#lblActivityOutComeScriptName').html();
            activityOutcomeName = ddlActivityOutCome.get_selectedItem().get_text();
            activityOutcomeType = ddlActivityOutComeType.get_selectedItem().get_text();
        }
        $('#hdnIsSaveEnd').val("");

        if ($('#chkReviewCarePlan').attr('checked') == 'checked') {
            window.top.clickfireNopat(true, OutComeId, OutComeNotes, FollowUpId, actualDuration, placeOfServiceId, '0', contactType, HCPCCodeId, isActivity, scriptName, activityOutcomeName, activityOutcomeType, isMemPortalProvReview);
        }
        else {
            window.top.clickfireNopat(false, OutComeId, OutComeNotes, FollowUpId, actualDuration, placeOfServiceId, '0', contactType, HCPCCodeId, isActivity, scriptName, activityOutcomeName, activityOutcomeType, isMemPortalProvReview);
        }
        $find("behReviewCarePlanWorkflow").hide();
        var patId = $('#selectPatientAccessed', window.parent.document).val();
        return true;
    }
    else {
        return false;
    }
}



function USDateFormat() {
    $(document).off('keyup', '#ActivityOutcomeCustomFieldUnique .phone').on('keyup', '#ActivityOutcomeCustomFieldUnique .phone', function () {
        var val = this.value.replace(/\D/g, '');
        var newVal = '';
        for (i = 0; i < 2; i++) {
            if (val.length > 3) {
                newVal += val.substr(0, 3) + '-';
                val = val.substr(3);
            }
        }
        newVal += val;
        this.value = newVal;
    });
}


function ValidateDurationHrs(inputText) {
    if ($(inputText).val() > 23) {
        CustomAlert('Please enter correct format duration');
        $(inputText).val('');
    }
}
function ValidateDurationMins(inputText) {
    if ($(inputText).val() > 59) {
        CustomAlert('Please enter correct format duration');
        $(inputText).val('');
    }
}

function ReviewSSCarePlan(validationGroup, isActivity) {
    $('span.isMandate').hide();
    var isValid = false;
    var isActivityOutComeValid = false;
    var isActualDurationValid = false;
    var isContactTypeValid = true;
    var isCustomFieldValid = true;
    var isCustomPhoneFieldValid = true;
    var customPhoneFieldValidCount = 0;
    var PhoneandFaxformat = /^\d{3}-\d{3}-\d{4}$/;
    isValid = Page_ClientValidate(validationGroup);
    if (isValid) {
        var calendarValid = true;
        $('.cstcalendar:visible').each(function () {
            var inputId = $(this).attr('id');
            if (inputId) {
                var valid = A11yForms.validateFormField(inputId, null, [A11yForms.VALIDATIONS.CALENDARDATE]);
                if (!valid) {
                    calendarValid = false;
                }
            }
        });
        if (!calendarValid) {
            return false;
        }
        $('span.validationMessage').hide();
        var ddlActivityOutCome = $find('ddlActivityOutCome');
        var ddlActivityOutComeType = $find('ddlActivityOutComeType');
        var OutComeId = ddlActivityOutCome.get_value();
        var contactTypeCon = $find('ddlSSContactType'); //KP@UHG-2931
        var contactType = contactTypeCon.get_value();
        var IsActivityOutcomeMandatory = $('#hdnIsActivityOutcomeMandatory').val();
        var OutComeTypeId = ddlActivityOutComeType.get_selectedItem().get_value();
        var IsActualDurationMandatory = $('#hdnIsActualDurationMandatory').val();
        var hrsValue = document.getElementById('txtHours').value;
        var minsValue = document.getElementById('txtMinutes').value;
        var isMemPortalProvReview = document.getElementById('chkMemberPortalReview') ? document.getElementById('chkMemberPortalReview').checked : false;
        if (IsActivityOutcomeMandatory == "True" || (IsActivityOutcomeMandatory == "False" && OutComeId != "" && OutComeTypeId != "")) {
            isActivityOutComeValid = true;
        }
        else {
            if (OutComeId == "")
                $("#ddlActivityOutComeval").show();
            if (OutComeTypeId == "")
                $("#ddlActivityOutComeTypeval").show();
            $find("behReviewCarePlanSPS").show();
        }
        if (IsActualDurationMandatory == "False" || (IsActualDurationMandatory == "True" && (hrsValue != "" || minsValue != ""))) {
            isActualDurationValid = true;
        }
        else {
            $("#actualDurationValidation").show();
            $find("behReviewCarePlanSPS").show();
        }
        if (contactType == "") {
            $("#spnSSContactType").show();
            isContactTypeValid = false;
        }

        if ($("#ActivityOutcomeCustomFieldUnique .requriedCustfield").length > 0) {
            var requiredFieldsCount = $("#ActivityOutcomeCustomFieldUnique .requriedCustfield").length;
            $("#ActivityOutcomeCustomFieldUnique .requriedCustfield").each(function () {
                var durHrs = '#durHrs_' + $(this).attr("id");
                var durMins = '#durMins_' + $(this).attr("id");

                // if radio button
                if ($(this).find('.chkradiocustfield').length > 0) {
                    var isRadioChecked = false;
                    $(this).find('.chkradiocustfield').each(function (index, obj) {
                        if (this.checked === true) {
                            isRadioChecked = true;
                        }

                    });

                    if (isRadioChecked == false) {
                        if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                            $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                            isCustomFieldValid = false;
                        }
                    }
                    else {
                        requiredFieldsCount = requiredFieldsCount - 1
                    }
                }

                //if check box 
                else if ($(this).find('.chkcheckcustfield').length > 0) {
                    var isCheckBoxChecked = false;
                    $(this).find('.chkcheckcustfield').each(function (index, obj) {
                        if (this.checked === true) {
                            isCheckBoxChecked = true;
                        }
                    });


                    if (isCheckBoxChecked == false) {
                        if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                            $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                            isCustomFieldValid = false;
                        }
                    }
                    else {
                        requiredFieldsCount = requiredFieldsCount - 1
                    }
                }
                else if ($(this).find('.cstcalendar').length > 0) {

                    requiredFieldsCount = requiredFieldsCount - 1

                }
                else if ($(this).find(durHrs).length > 0 || $(this).find(durMins).length > 0) {
                    if (($(this).find(durHrs).val() !== undefined && $(this).find(durHrs).val() !== "" && $(this).find(durHrs).val() !== null) ||
                        ($(this).find(durMins).val() !== undefined && $(this).find(durMins).val() !== "" && $(this).find(durMins).val() !== null)) {
                        requiredFieldsCount = requiredFieldsCount - 1
                    }
                    else {
                        if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                            $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                            isCustomFieldValid = false;
                        }

                    }

                }


                else {
                    //rest of single field controls
                    if ($(this).val() != undefined && $(this).val() != "" && $(this).val() != null) {
                        requiredFieldsCount = requiredFieldsCount - 1
                    }
                    else {
                        if (this.className == "dateInside cstfield cstcalendar requriedCustfield k-input") {
                            if ($(this).closest('.float-left.width33P.ItemPB5').length > 0) {
                                $(this).closest('.float-left.width33P.ItemPB5').addClass("asteriskValidationRequired");
                                isCustomFieldValid = false;
                            }
                        }
                        else {
                            $(this).css('border-color', 'red');
                            isCustomFieldValid = false;
                        }
                    }
                }
            });
            $('.cstfield.phone').each(function (index, obj) {
                if ($(this).val() != "" && !$(this).val().match(PhoneandFaxformat)) {
                    $('#txtLabelPhone_' + $(this).data('id')).append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
                    customPhoneFieldValidCount = + 1;
                    isCustomPhoneFieldValid = false;
                }
            });

            if (requiredFieldsCount == 0) {
                isCustomFieldValid = true;
            }
            else {
                isCustomFieldValid = false;
            }

            if (customPhoneFieldValidCount == 0) {
                isCustomPhoneFieldValid = true;
            }
        }



        if (isActivityOutComeValid && isActualDurationValid && isContactTypeValid && isCustomFieldValid && isCustomPhoneFieldValid) {
            $("#btnSaveAndProceed").prop('disabled', true);
            var OutComeNotes = $('#txtOutComeNotes').val();
            var FollowUpId = $('#hdnPatientFollowUpId', '.clsSingleScreenScript').val();
            var PHPatientId = $('#hdnPHPatientId', '.clsSingleScreenScript').val();
            $('#hdnPatientFollowUpId').val('');
            $('#hdnPHPatientId').val('');
            var actualHrs = parseInt($('#txtHours').val());
            var actualMins = parseInt($('#txtMinutes').val());
            var actualDuration = window.top.DurationFormat(actualHrs) + ':' + window.top.DurationFormat(actualMins) + ':00';
            var placeOfServiceCon = $find('ddlPlaceOfService');
            var placeOfServiceId = placeOfServiceCon.get_value();
            var ctrlHCPCCode = $find('ddlHCPCCode');
            var HCPCCodeId = ctrlHCPCCode.get_value();

            //PROD-23778--- Live Rule changes          
            var scriptName = activityOutcomeName = activityOutcomeType = "";
            if ($('#hdnIsSaveEnd').val() != undefined && $('#hdnIsSaveEnd').val() == "True") {
                scriptName = $('#lblActivityOutComeScriptName').html();
                activityOutcomeName = ddlActivityOutCome.get_selectedItem().get_text();
                activityOutcomeType = ddlActivityOutComeType.get_selectedItem().get_text();
            }
            $('#hdnIsSaveEnd').val("");

            if ($('#chkReviewCarePlan').attr('checked') == 'checked') {
                window.top.clickfireNopat(true, OutComeId, OutComeNotes, FollowUpId, actualDuration, placeOfServiceId, PHPatientId, contactType, HCPCCodeId, isActivity, scriptName, activityOutcomeName, activityOutcomeType, isMemPortalProvReview);
            }
            else {
                window.top.clickfireNopat(false, OutComeId, OutComeNotes, FollowUpId, actualDuration, placeOfServiceId, PHPatientId, contactType, HCPCCodeId, isActivity, scriptName, activityOutcomeName, activityOutcomeType, isMemPortalProvReview);
            }
            $find("behReviewCarePlanSPS").hide();
            var patId = $('#selectPatientAccessed', window.parent.document).val();
            //  window.top.ficoRuleAjax(patId);
            return true;
        }
        else {
            return false;
        }
    }
    else { return isValid; }

}

function BulkAllocateIndicators(btnControl, confirmMsg) {
    var btnId = document.getElementById(btnControl.id);
    var isChecked = $(btnId).next().find("input[type=checkbox]").prop('checked');
    if (isChecked) {
        if (CustomConfirm('Are you sure, you want to ' + confirmMsg + ' the records in bulk?')) {

            //__doPostBack(btnControl.id, 'OnClick');
            return true;

        }

        else {
            $(btnId).next().find("input[type=checkbox]").prop('checked', false);
            $('#ddlAccessPermissionsAllocateAll').val("Read/Write");
            $('#ddlAccessPermissionsUnAllocateAll').val("Read/Write");
            $('#ddlAccessPermissionsAllocateAll').attr("style", "display:none");
            $('#ddlAccessPermissionsUnAllocateAll').attr("style", "display:none");
            return false;

        }
    }
    else {
        return true;
    }
}

function refreshToDoListTab() {
    var tabId = $('#HiddenToDoListTabId').val();
    var tab = $('#tabToDoList_' + tabId);
    tab.trigger('click');
}

function RestrictCPCToAutoComplete(cntrl, hdncntrl) {
    var keyCodes = [8, 32, 46, 67, 88, 86];
    $('#' + cntrl).bind({
        keydown: function (e) {
            var evt = (e) ? e : window.event;
            try {
                var selectedKeyCode = (evt.which) ? evt.which : evt.keyCode
                //For space/backspace/
                if ((!evt.ctrlKey) && (keyCodes.indexOf(selectedKeyCode) > -1)) {
                    $("#" + hdncntrl).val('-1');
                }
                else if ((evt.ctrlKey) && (keyCodes.indexOf(selectedKeyCode) > -1)) { // [x] == 88; [c] == 67; [v] == 86;                    
                    // cross-browser compatibility for copy cut paste.
                    evt.preventDefault();
                }
            } catch (e) {
                console.log(e);
                evt.preventDefault();
            }
        },
        contextmenu: function (e) {
            //disabled right click
            e.preventDefault();
        }
    });
}

//Manage Activity
function AllowOnlyNumerics(e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
    }
    return true;
}
function ManageActivityDurationControl(obj) {
    var durationType = $(obj).closest('td').find('.clsManageActivityUnitType').val();
    var durationError = $(obj).closest('td').find('.durationError');
    durationError.text('');
    if (durationType == 'Days') {
        if ($(obj).val() > 7) {
            $(obj).val('');
            durationError.text('Duration cannot be more than 7 days.');
        }
    }
    else if (durationType == 'Hours') {
        if ($(obj).val() > 24) {
            $(obj).val('');
            durationError.text('Duration cannot be more than 24 hours.');
        }
    }
    else if (durationType == 'Minutes') {
        if ($(obj).val() > 60) {
            $(obj).val('');
            durationError.text('Duration cannot be more than 60 minutes.');
        }
    }
}

function OnddlManageBlurHandler(sender, eventArgs) {
    if (sender && sender.get_text() != "" && sender._originalText.toLowerCase() != sender.get_text().toLowerCase()) {
        var item = findItemByText(sender, sender.get_text());
        if (!item)
            sender.set_text("");
        else
            item.select();
    }
}

function findItemByText(sender, text) {
    var items = sender.get_items();
    var itemsCount = items.get_count();
    for (var i = 0; i < itemsCount; i++) {
        var item = items.getItem(i);
        if (item.get_text().toLowerCase() == text.toLowerCase()) {
            return item;
        }
    }
    return null;
}
//Manage Activity
//To limit characters to maxlength defined
function TextCounter(obj, maxLength) {
    var divlength = $(obj).val().length;
    if (divlength > maxLength) {
        var trimmedtext = $(obj).val().substring(0, maxLength);
        $(obj).val(trimmedtext);
    }
}

// *** OBSOLETE!!! - do not use this function anymore, instead use one of the "create" functions within the A11yAlerts.js *** //
function CustomAlert(msg, triggerBtnId) {   // NOSONAR (rename to follow naming convention - too many usages)
    // "atleast" should be "at least", but it is passed in from so many different places, it's easier to just fix it in this one place
    if (msg === 'Please select atleast one record to edit') {
        msg = 'Please select at least one record to edit';
    }

    if ($("#CMModalPopupDivMessage").length > 0) {
        legacyModalAlert("Message", msg, true, null, true, null, triggerBtnId);
    } else {
        alert(msg);
    }
}

function CustomConfirm(msg) {
    var retVal = confirm(msg);
    return retVal;
}
$(document).keydown(function (e) {
    if (e.keyCode == 67 && e.altKey) {
        focusFieldNextEmpty($(e.target))
    }
    else if (e.keyCode == 78 && e.altKey) {
        focusFieldNextAcc($(e.target), false);
    }
    else if (e.keyCode == 80 && e.altKey) {
        focusFieldNextAcc($(e.target), true);
    }
});
function focusFieldNextEmpty(Obj) {
    ArrObj = $(Obj).closest('.Accordion').find('input:not([type=hidden]),select,textarea');
    for (i = 1; i < ArrObj.length - (ArrObj.index(Obj) + 1); i++) {
        var fld = $(ArrObj[(ArrObj.index(Obj) + i)]);
        if (highlightField(fld))
            return;
    }
}
function highlightField(fld) {
    if (!fld.attr('readonly') || !fld.attr('disabled')) {
        if (fld.is('input[type="text"]') && fld.val() == "") {
            fld.focus(); return true;
        }
        else if (fld.is(':checkbox') && (!fld.prop('checked'))) {
            fld.select(); return true;
        }
        else if (fld.is(':radio') && (!fld.prop('checked'))) {
            fld.select(); return true;
        }
        else if (fld.is('select') && (fld.val() == "" || fld.val() == "00" || fld.val() == "0" || fld.val() == 0)) {
            fld.focus(); return true;
        }
        else if (fld.is('textarea') && (fld.text() == "")) {
            fld.focus(); return true;
        }
    }
}
function focusFieldNextAcc(Obj, isPrev) {
    var Acc = null;
    if (isPrev)
        Acc = $(Obj).closest('.Accordion').prev('.Accordion');
    else
        Acc = $(Obj).closest('.Accordion').next('.Accordion');
    var ArrObj = $(Acc).find('input:not([type=hidden]),select,textarea');
    for (i = 0; i < ArrObj.length; i++) {
        var fld = $(ArrObj[i]);
        if (highlightField(fld))
            return;
    }
}

function AuditLogHealthArticle(obj) {
    var moduleID = 1, patientID = '', authID = '', complaintID = '';
    if (window.top.$(".InAuthPage").is(":visible")) {
        moduleID = 3;
        var PI = window.top.UmPatient_AuthInfo("", "");
        patientID = PI.PatientId;
        authID = PI.AuthNo;
    }
    window.top.AuditLog(moduleID, window.top.actionTypeEnum.Download, "Health Article", patientID, window.top.memberidval, $(obj).data('filename'), authID, complaintID, '');
}



$(document).on('keyup change', ".clsshareofcost", function (e) {
    var inputText = $(this).val();
    $(this).val(inputText.replace(/[A-Za-z`~!@#%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/g, ""));
    $(this).val($.trim($(this).val()));
    if (inputText.length > 12) {
        $(this).val($(this).val().substr(0, 12));
    }
});

(function ($) {
    $.fn.getCursorPosition = function () {
        var pos = 0;
        var el = $(this).get(0);
        // IE Support
        if (document.selection) {
            el.focus();
            var Sel = document.selection.createRange();
            var SelLength = document.selection.createRange().text.length;
            Sel.moveStart('character', -el.value.length);
            pos = Sel.text.length - SelLength;
        }
        // Firefox support
        else if (el.selectionStart || el.selectionStart == '0')
            pos = el.selectionStart;
        return pos;
    }
})(jQuery);

//validating share of cost input
$(document).on('keypress', ".clsshareofcost", function (e) {
    var key = evt.keyCode || evt.charCode;
    var inputVal = $(this).val();
    var specialKeys = [8, 33, 35, 36, 37, 38, 40, 41, 42, 94, 95, 64, 126];
    var index = $(this).val().indexOf('.');
    var ret = (specialKeys.indexOf(key) != -1); //allow special symbol alert(ret); 
    if (((evt.which != 46 || (evt.which == 46 && $(this).val() == '')) || index != -1) && (!ret) && (evt.which < 48 || evt.which > 57)) { evt.preventDefault(); }
    var noofdecimal = 2;
    // it decides how many number to be printed after decimal point.
    var temp1 = inputVal.split('.');
    if (temp1.length == 2) {
        var currentPos = $(this).getCursorPosition();
        var decimalPos = inputVal.lastIndexOf(".");
        if (temp1[1].length >= noofdecimal && currentPos > decimalPos && key != 8)// it determines that after decimal user has entered values 
            evt.preventDefault();
    }

    if (inputVal.length >= 12 && key != 8) {
        evt.preventDefault();
    }
});


/*Smart Comm Start*/

var attachmentInputFromDraft = [];

var attachmentArrayObj = [];

var numberOfDocuments = 0;

function OpenConfirmBoxByModule(moduleId, docId) {
    var module = gtModNm(moduleId);//jQuery.grep(allModules_Data, function (a) { return a.Id == moduleId; })[0].Name;
    if (module == "CM") {
        $('#hdnCmLetterDocId').val(docId);
        $('#SaveAsDraftConfirm').CMNPopup({ popUpHeader: "Confirmation", popLevel: 0, closeButton: '#btnClosePopUpSd' });
    }
    else if (module == "UM") { ConfirmationUMSaveAsDraft(docId); }
    else if (module == "AG") { ConfirmationAGSaveAsDraft(docId); }
    else { CustomAlert('Letter draft has been saved successfully.'); }
}

function LoadDraftLetterCaseConf(patientId, groupId) {
    loader(1);
    $('#LetterDiv').show();
    var url = baseURL + '/Letter/CaseConferenceLetter?moduleId=' + gtModId("CM");
    $('#LetterDiv').load(url, function () {
        $('#hdnCtrlGroupId').val(groupId);
        BindPartcipants(groupId, patientId);
        $('#hdnCtrlGroupId').val(groupId);
        GetTemplatesCaseConf();
        LoadDraftEditor();
        loader(0);
    });
}

function BindPartcipants(groupId, patientId) {
    var HtmlData = '';
    var prtcid = $('#HdnCtrlPartcipantID').val(); var DisplayName = ''; var HiddenName = '';
    AjaxCallInit({
        url: baseURL + '/Letter/BindParticipants',
        PostData: {
            groupId: groupId,
            participantIds: prtcid,
            patientId: patientId
        }
    }, function (AR) {
        var RowData = AR.ToJson();
        for (var RI = 0; RI < RowData.length; RI++) {
            if (!$.fn.isNullOrEmpty(RowData[RI]["Email"])) {
                DisplayName = (RowData[RI]["FullName"] !== null ? RowData[RI]["FullName"] : "") + '-' + RowData[RI]["RoleName"] + ' (' + RowData[RI]["Email"] + ')';
            }
            else {
                DisplayName = RowData[RI]["FullName"] + RowData[RI]["RoleName"];
            }
            HiddenName = RowData[RI]["Email"] + '|' + RowData[RI]["PhysicainId"] + '|' + RowData[RI]["FullName"] + '|' + RowData[RI]["RoleName"] + '|' + RowData[RI]["IsInvited"] + '|' + RowData[RI]["IsParticipated"] + '|' + RowData[RI]["IsDisplay"];
            if (RowData[RI]["Flag"]) { HtmlData += '<input class="clsCaseConfComplete"  checked="checked" type="checkbox" id="caseConfCareTeam|' + HiddenName + ' "/>' + DisplayName + '<br/>'; }
            else { HtmlData += '<input class="clsCaseConfComplete"   type="checkbox" id="caseConfCareTeam|' + HiddenName + ' "/>' + DisplayName + '<br/>'; }
        }
        $('.ListBox').AhsAppend(HtmlData);
    });
}

function LoadDraftLetter(moduleId, authNo, complaintId, docId, Review, templateId, lobId, clientId, patientId, reviewDetails) {
    loader(1);
    $('#LetterDiv').show();
    var moduleName = gtModNm(moduleId);
    if (Review) {
        var url = baseURL + '/Letter/ReviewLetter?moduleId=' + moduleId + '&docId=' + docId;
    }
    else {
        var url = baseURL + '/Letter/AddLetter?moduleId=' + moduleId + '&moduleName=' + moduleName;
    }
    $('#LetterDiv').load(url, function () {
        $('body').css('overflow', 'hidden');
        $('html,body').animate({ scrollTop: 0 }, 0);
        $('#hdnAddLetterAuthNo').val(authNo);
        $('#hdnAddLetterComplaintId').val(complaintId);
        $('#hdnAddLetterModuleId').val(moduleId);
        if (Review) {
            $('#hdnIsReviewLetter').val(1);
        }
        if (templateId && templateId > 0) {
            $('#hdnIsLetterFromMTM').val(1);
        }
        if (Review && Review == "VIEW0") {
            afterReviewButtons(3);
            getPrintQueueFieldLabelValue();
        }
        else if (Review && Review == "VIEW1") {
            afterReviewButtons(1);
            getPrintQueueFieldLabelValue();
        }
        else if (Review && Review == "VIEW2") {
            afterReviewButtons(2);
        }
        else {
            if (reviewDetails) {
                $('#hdnLetterReviewNbr').val(reviewDetails.reviewNo);
                $('#hdnLetterReviewLookupId').val(reviewDetails.lookupId);
            }
            LoadLetterMetaDropDowns(moduleId, templateId, lobId, clientId, patientId);
            if (!isAttachmentModule(moduleId)) {
                $('.TemplateFields #ddlModule').val(moduleId).prop('disabled', true);
            }
            else {
                $('.draftLetterClass #moduleDescriptionOne').text(gtModNm(moduleId));
                $('.draftLetterClass #moduleDescriptionTwo').text(gtModDesc(moduleId));
            }
        }
        getPatPreferWrittenLanguages();
        loader(0);
    });
}

function LoadLetterMetaDropDowns(moduleId, templateId, lobId, clientId, patientId) {
    if (!isAttachmentModule(moduleId)) {
        var parDiv = $('#divSCLetterContainer');
        LoadDraftEditor();
        loadDropDownSync(baseURL + '/Letter/BindModules/', 'ddlModule', moduleId);
        loadDropDownSync(baseURL + '/Letter/BindClients/', 'ddlClient', clientId);
        loadDropDownSync(baseURL + '/Letter/BindGroups/', 'ddlGroup');
        loadDropDownSync(baseURL + '/Letter/BindLetterTypes/', 'ddlLetterType');
        bindLobsOld(moduleId, templateId, lobId, patientId);
        var Module = $("#ddlModule option:selected", parDiv).text();
        if (Module === "MTM") {
            $('.TemplateFields #ddlGroup').prop('disabled', true);
            $('.TemplateFields #ddlLetterType').prop('disabled', true);
            $('.TemplateFields #ddlLOB').prop('disabled', true);
            $('.TemplateFields #ddlLanguage').prop('disabled', true);
            $('.TemplateFields #ddlTemplateId').prop('disabled', true);
        }
    }
    else {
        LoadDraftEditor();
        loadDropDownSync(baseURL + '/Letter/BindClients/', 'ddlClient', clientId);
        loadDropDownSync(baseURL + '/Letter/BindLetterTypes/', 'ddlLetterType');
        BindLobs(moduleId, templateId, lobId, patientId);
        var Module = gtModNm(moduleId);
        if (Module === "MTM") {
            $(".draftLetterClass input[name=RadioGroup]").prop('disabled', true);
            $('.draftLetterClass #ddlLetterType').prop('disabled', true);
            $('.draftLetterClass #ddlLanguage').prop('disabled', true);
            $('.draftLetterClass #ddlTemplateId').prop('disabled', true);
        }
    }
}

function bindLanguages(moduleId, templateId, patientId) {
    var ddlModuleId = '';
    if (!isAttachmentModule(moduleId)) {
        var parDiv = $('#divSCLetterContainer');
        ddlModuleId = $("#ddlModule", parDiv).val();
        bindCmnLanguages(moduleId, templateId, ddlModuleId, patientId);
    }
    else {
        var parDiv = $('#divScLetterVerticalContainer');
        var Module = $("#moduleDescriptionOne", parDiv).text();
        ddlModuleId = gtModId(Module);
        bindCmnLanguages(moduleId, templateId, ddlModuleId, patientId);
    }
}

function bindCmnLanguages(moduleId, templateId, ddlModuleId, patientId)
{
    var lobBenId = '';
    if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
        lobBenId = getSelMemEligFromMini('divAddScLetterCLob').LobBenId;
        $("#HdnCtrlLOB").val(lobBenId);
    }
    loadDropDownSync(baseURL + '/Letter/BindLanguages?ModuleId=' + ddlModuleId + '&LobBenId=' + lobBenId + '&PatientId=' + patientId, 'ddlLanguage');
    GetTemplates(moduleId, templateId);
    LobDateValidation();
}
function BindLobs(moduleId, templateId, lobId, patientId) {
    if (!isAttachmentModule(moduleId)) {
        bindLobsOld(moduleId, templateId, lobId, patientId);
    }
    else {
        var isActive = false, LobBenId = "";
        var Module = gtModNm(moduleId);
        var datastring = { authNo: $("#hdnAddLetterAuthNo").val(), complaintId: $('#hdnAddLetterComplaintId').val() };
        if (Module == "AG" || Module == "UM") {
            $.ajax({
                type: "GET",
                url: baseURL + '/Letter/GetAuthComplaintLobAutoPop',
                data: datastring,
                dataType: "json",
                async: false,
                success: function (data) {
                    var resp = data;
                    LobBenId = resp.result[0].LobBenId;
                    if (resp.result[0].Status == 1) { isActive = true; }
                    if (patientId == "" || patientId == undefined) {
                        patientId = $('#HdnPatientId').val();
                    }
                    LoadMemberEligibilityMiniView('divAddScLetterCLob', 0, 0, true, 'Full', patientId, LobBenId, 0, true, function () {
                        $("#divAddScLetterCLob .clsRdoMemEligMini").attr("onclick", "bindLanguages(" + moduleId + ")");
                        if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
                            bindLanguages(moduleId, null, patientId);
                        }
                    });
                }
            });
        }
        else {
            patientId = $('#selectPatientAccessed').val();
            LoadMemberEligibilityMiniView('divAddScLetterCLob', 0, getMemberId().MemberId, true, 'Full', patientId, 0, 0, true, function () {
                $("#divAddScLetterCLob .clsRdoMemEligMini").attr("onclick", "bindLanguages(" + moduleId + ")");
                if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
                    bindLanguages(moduleId, templateId, patientId);
                }
            });
        }
    }
}

function bindLobsOld(moduleIdVal, templateId, lobId, patientId) {
    var parDiv = $('#divSCLetterContainer'); var isActive = false, LobBenId = "";
    var Module = $("#ddlModule option:selected", parDiv).text();
    var ModuleId = $("#ddlModule", parDiv).val();
    var datastring = { authNo: $("#hdnAddLetterAuthNo").val(), complaintId: $('#hdnAddLetterComplaintId').val() };
    if (Module == "AG" || Module == "UM") {
        $.ajax({
            type: "GET",
            url: baseURL + '/Letter/GetAuthComplaintLobAutoPop',
            data: datastring,
            dataType: "json",
            async: false,
            success: function (data) {
                var resp = data;
                LobBenId = resp.result[0].LobBenId;
                if (resp.result[0].Status == 1) { isActive = true; }
                if (patientId == "" || patientId == undefined) {
                    patientId = $('#HdnPatientId').val();
                }
                LoadMemberEligibilityMiniView('divAddScLetterCLob', 0, 0, true, 'Full', patientId, LobBenId, 0, true, function () {
                    $("#divAddScLetterCLob .clsRdoMemEligMini").attr("onclick", "bindLanguages(" + moduleIdVal + ")");
                    if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
                        bindLanguages(moduleIdVal);
                    }
                });
            }
        });
    }
    else {
        LoadMemberEligibilityMiniView('divAddScLetterCLob', 0, getMemberId().MemberId, true, 'Full', $('#selectPatientAccessed').val(), 0, 0, true, function () {
            $("#divAddScLetterCLob .clsRdoMemEligMini").attr("onclick", "bindLanguages(" + moduleIdVal + ")");
            if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
                bindLanguages(moduleIdVal, templateId);
            }
        });
    }
}

function GetTemplates(moduleId, templateId, fromPhBulkLetter = false) {
    if (!isAttachmentModule(moduleId)) {
        var parDiv = $('#divSCLetterContainer');
        var ModuleId = '', ClientId = '', LobBenId = '', LanguageId = '', GroupId = '', LetterTypeId = '', SPName = '';
        ModuleId = $("#ddlModule", parDiv).val(); LanguageId = $("#ddlLanguage", parDiv).val(); ClientId = $("#ddlClient", parDiv).val();
        var Module = $("#ddlModule option:selected", parDiv).text();
        if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
            LobBenId = getSelMemEligFromMini('divAddScLetterCLob').LobBenId;
        }
        GroupId = $("#ddlGroup", parDiv).val();
        LetterTypeId = $("#ddlLetterType", parDiv).val();
        loadDropDownSync(baseURL + '/Letter/BindTemplates?ModuleID=' + ModuleId + '&ClientId=' + ClientId + '&LobBenId=' + LobBenId + '&LanguageId=' + LanguageId + '&GroupId=' + GroupId + '&LetterTypeId=' + LetterTypeId + '&templateId=' + (templateId ? templateId : 0) + '&fromPhBulkLetter=' + fromPhBulkLetter, 'ddlTemplateId');
    }
    else {
        var parDiv = $('#divScLetterVerticalContainer');
        var ModuleId = '', ClientId = '', LobBenId = '', LanguageId = '', GroupId = '', LetterTypeId = '', SPName = '';
        LanguageId = $("#ddlLanguage", parDiv).val();
        ClientId = $("#ddlClient", parDiv).val();
        var Module = $("#moduleDescriptionOne", parDiv).text();
        ModuleId = gtModId(Module);

        if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
            LobBenId = getSelMemEligFromMini('divAddScLetterCLob').LobBenId;
        }
        GroupId = $("input[name=RadioGroup]:checked").val();
        LetterTypeId = $("#ddlLetterType", parDiv).val();
        loadDropDownSync(baseURL + '/Letter/BindTemplates?ModuleID=' + ModuleId + '&ClientId=' + ClientId + '&LobBenId=' + LobBenId + '&LanguageId=' + LanguageId + '&GroupId=' + GroupId + '&LetterTypeId=' + LetterTypeId + '&templateId=' + (templateId ? templateId : 0), 'ddlTemplateId');
    }
}

function GetTemplatesCaseConf() {
    loadDropDownSync(baseURL + '/Letter/BindTemplates?ModuleID=' + gtModId("CM") + '&isEmail=' + true, 'ddlTemplateId');
    //if (templateId > 0) setTimeout(function () { GetTemplate() },3000);
}

function GetTemplate(moduleId, isPHBulkLetter) {
    var parDiv, ModuleId = '';
    if (isAttachmentModule(moduleId)) {
        parDiv = $('#divScLetterVerticalContainer');
        var module = $("#moduleDescriptionOne", parDiv).text();
        ModuleId = gtModId(module);
    }
    else {
        parDiv = $('#divSCLetterContainer');
        ModuleId = moduleId;
    }
    if ($('#ddlTemplateId', parDiv).val() != "-1") {
        getTemplateDescription(ModuleId);
        if (isPHBulkLetter != true) {
            loadDraft(ModuleId);
        }
        showHideButtonsLetter(true);
        getPrintQueueFieldLabelValue();
    }
    else {
        $('#txtTemplateDesc').val('');
    }
}
function getSpeedyDispatch() {
    var $templateId = $('#ddlTemplateId');
    var $docId = $('#DocumentId');
    var $moduleId = $('#ModuleId');
    var $SpeedyDispatch = $('#SpeedyDispatch');
    var strUrl;
    if ($templateId.val() && $templateId.val() !== '-1') {
        strUrl = baseURL + '/Letter/GetSpeedyDispatch?templateId=' + $templateId.val();
    } else if ($docId.val() && $moduleId.val()) {
        strUrl = baseURL + '/Letter/GetSpeedyDispatch?docId=' + $docId.val() + '&moduleId=' + $moduleId.val();
    }
    else {
        $SpeedyDispatch.hide();
    }
    if (strUrl) {
        $.ajax({
            type: 'GET',
            url: strUrl,
            success: function (response) {
                if (response && response.Result) {
                    $SpeedyDispatch.css('display', 'inline-block');
                }
                else {
                    $SpeedyDispatch.hide();
                }
            },
            error: function () {
                $SpeedyDispatch.hide();
            }
        });
    }
}

function saveDocsPageDetails(result) {
    var stringObj = JSON.stringify(result);
    $('#hdnDocsPageDetails').val(stringObj);
}

function getDocsPageDetails() {
    var jsonObj = JSON.parse($('#hdnDocsPageDetails').val());
    return jsonObj;
};

function isValidLetterDocument(DocumentName, DocumentExtension, DocumentGuid) {
    var isValid = false;
    if (!DocumentGuid && !DocumentExtension) {
        return isValid;
    }
    DocumentName = DocumentName.trim().toUpperCase();
    var validExtensions = [".PDF", ".DOC", ".DOCX"];
    var extension = DocumentName.substring(DocumentName.lastIndexOf('.'), DocumentName.length) || DocumentName;
    if (validExtensions.indexOf(extension) >= 0) {
        return true;
    }
    else {
        DocumentExtension = DocumentExtension.trim().toUpperCase();
        return validExtensions.indexOf(DocumentExtension) >= 0 ? true : false;
    }
}

function validateDocToDisplay(data) {
    var docName = (letterModuleName === "CM") ? data.OriginalName : data.DocumentName,
        docPath = data.DocumentExtension,
        docGuid = data.DocumentGuid;
    if (isValidLetterDocument(docName, docPath, docGuid)) {
        return true;
    } else {
        return false;
    }
}

function getDocsArrayToDisplay(data) {
    var docDataSet = [];
    $.each(data, function (key, value) {
        if (validateDocToDisplay(value)) {
            let dataDetail = value;
            var docType = letterModuleName === "AG" || letterModuleName === "CM" ? dataDetail.DocumentType : dataDetail.DocumentTypeName;
            var isperceptiveOrLetterDoc = (docType).trim().toLowerCase() === 'perceptive document' || (docType).trim().toLowerCase() === 'letter document';
            if (letterModuleName === "AG" && !isperceptiveOrLetterDoc) {
                dataDetail.DocumentDesc = ToValue(dataDetail.DocumentDesc, '') !== '' ? (xssSafeString(dataDetail.DocumentDesc.replace(/<\/?br\s*\/?>/gi, '\n'))).replaceAll('\n', '<br>') : '';
                dataDetail.DocumentType = xssSafeString(dataDetail.DocumentType);
            }
            if (letterModuleName === "UM" && !isperceptiveOrLetterDoc) {
                dataDetail.DocumentDesc = ToValue(dataDetail.DocumentDesc, '') !== '' ? (xssSafeString(dataDetail.DocumentDesc.replace(/<\/?br\s*\/?>/gi, '\n'))).replaceAll('\n', '<br>') : '';
                dataDetail.DocumentTypeName = xssSafeString(dataDetail.DocumentTypeName);
            }
            if (letterModuleName === "CM" && !isperceptiveOrLetterDoc) {
                dataDetail.Description = ToValue(dataDetail.Description, '') !== '' ? (xssSafeString(dataDetail.Description.replace(/<\/?br\s*\/?>/gi, '\n'))).replaceAll('\n', '<br>') : '';
                dataDetail.DocumentType = xssSafeString(dataDetail.DocumentType);
            }
            docDataSet.push(value);
        }
    });
    return docDataSet;
}

function loadNextPageDocsWhenNoScroll() {
    var numOfLoadedDocs = $("#listViewChildDiv").data("kendoListView").dataSource.total();
    if (numOfLoadedDocs < 15 && nextPageNumber > 0) {
        loadNextDocsPacketsForLetter(nextPageNumber, nextPageSize);
    }
}
function enableDocUploadOnEditLetter() {
    const docModuleObj = attachmentInputFromDraft.find(item => item.Module !== 3);
    if (docModuleObj) {
        document.querySelectorAll('.letterDocCheckBox').forEach(checkbox => {
            var referenceId = parseInt((checkbox.id).split("_")[1]);
            var itemDocExists = $.inArray(referenceId, checkedDocumentsList);
            if (itemDocExists === -1 && docModuleObj.Reference.includes(referenceId)) {
                checkbox.checked = true;
                checkedDocumentsList.push(referenceId);
            }
        });
    }
}
function enablePacketUploadOnEditLetter() {
    const packateModuleObj = attachmentInputFromDraft.find(item => item.Module === 3);
    if (packateModuleObj) {
        document.querySelectorAll('.letterPacketCheckbox').forEach(checkbox => {
            var referenceId = parseInt((checkbox.id).split("_")[1]);
            var itemPacketExists = $.inArray(referenceId, checkedPacketsList);
            if (itemPacketExists === -1 && packateModuleObj.Reference.includes(referenceId)) {
                checkbox.checked = true;
                checkedPacketsList.push(referenceId);
            }
        });
    }
}
function loadDocsPacketsForLetter() {
    loader(1);
    var pageNo = 1;
    var pageSize = 100;
    var datastring = {};
    var requestUrl = "";
    numberOfDocuments = 0;

    if (letterModuleName === "CM") {
        requestUrl = baseURL + "/Document/GetElectronicDocuments";
        $.ajax({
            type: "Get",
            url: requestUrl,
            dataType: "json",
            data: {
                patientId: parseInt($('#selectPatientAccessed').val()),
                includeExternalDocument: false,
                TimeDictionaryobj: timeZone,
                carestaffId: parseInt(memberidval),
                page: pageNo,
                pageSize: pageSize
            },
            async: false,
            success: function (response) {
                if (response && response.Data) {
                    if (response.Data.length > 0) {
                        numberOfDocuments = numberOfDocuments + response.Data.length;
                        var totalRecordCount = response.Total;
                        var docsData = getDocsArrayToDisplay(response.Data);
                        var dataSource = new kendo.data.DataSource({
                            data: docsData,
                            serverFiltering: true,
                        });
                        $("#listViewChildDiv").kendoListView({
                            dataSource: dataSource,
                            template: kendo.template($("#templateScriptListView").html())
                        });
                        enableDocUploadOnEditLetter();
                        if (totalRecordCount > numberOfDocuments) {
                            nextPageNumber = pageNo + 1;
                            nextPageSize = pageSize;
                        }
                        if (totalRecordCount < pageSize && docsData.length === 0) {
                            $("#hiddenLabelDocModule").css('display', 'block');
                            $('#hiddenLabelDocModule').text("No Documents available.");
                            return;
                        }
                        loadNextPageDocsWhenNoScroll();
                        $("#hdnDocsScrollCheck").val(1);
                        loader(0);
                    } else {
                        $("#hiddenLabelDocModule").css('display', 'block');
                        $('#hiddenLabelDocModule').text("No Documents available.");
                    }
                    loader(0);
                }
                else {
                    CustomAlert('Error occurred while fetching the documents, Please try again');
                    loader(0);
                }
            },
            error: function (error) {
                CustomAlert('Error occurred, Please try again');
                loader(0);
            }
        });
    }

    if (letterModuleName === "UM") {
        var PI = UmPatient_AuthInfo('');
        AjaxRequest(baseApiURL + '/UMCommon/GetAllAuthDocuments', { SP_VA_AUTH_NO: PI.AuthNo, COLUMN_CARE_STAFF: "CARE_STAFF_ID", SP_VA_PAGE_NUMBER: pageNo, SP_VA_PAGE_SIZE: pageSize }, function (umDocsResponse) {
            var authDocuments = umDocsResponse.ToJson();
            if (authDocuments.length > 0) {
                var docsData = getDocsArrayToDisplay(authDocuments);
                nextPageNumber = pageNo + 1;
                nextPageSize = pageSize;
                var dataSource = new kendo.data.DataSource({
                    data: docsData,
                    serverFiltering: true,
                });
                $("#listViewChildDiv").kendoListView({
                    dataSource: dataSource,
                    template: kendo.template($("#templateScriptListView").html())
                });
                enableDocUploadOnEditLetter();
                loadNextPageDocsWhenNoScroll();
                $("#hdnDocsScrollCheck").val(1);
                loader(0);
            } else if (authDocuments.length === 0) {
                $("#hiddenLabelDocModule").css('display', 'block');
                $('#hiddenLabelDocModule').text("No Documents available.");
                loader(0);
            } else {
                CustomAlert('Error occurred while fetching the documents, Please try again');
                loader(0);
            }
        });
    }

    if (letterModuleName === "AG") {
        var PI = AgPatient_ComplaintInfo("", "");
        AjaxRequest(baseApiURL + '/Route/GetAGResult', { DATA_KEY: "GET_COMPLAINT_DOCUMENT", SP_VA_COMPLAINT_RECORD_ID: PI.ComplaintNo, COLUMN_CARE_STAFF: "CARE_STAFF_ID", SP_VA_PAGE_NUMBER: pageNo, SP_VA_PAGE_SIZE: pageSize, SP_VA_IS_SMARTCOMM: IsSmartCommEnabled }, function (agDocsResponse) {
            var complaintDocuments = agDocsResponse.ToJson();
            if (complaintDocuments.length > 0) {
                var docsData = getDocsArrayToDisplay(complaintDocuments);
                nextPageNumber = pageNo + 1;
                nextPageSize = pageSize;
                var dataSource = new kendo.data.DataSource({
                    data: docsData,
                    serverFiltering: true,
                });
                $("#listViewChildDiv").kendoListView({
                    dataSource: dataSource,
                    template: kendo.template($("#templateScriptListView").html())
                });
                enableDocUploadOnEditLetter();
                loadNextPageDocsWhenNoScroll();
                $("#hdnDocsScrollCheck").val(1);
                loader(0);
            } else if (complaintDocuments.length === 0) {
                $("#hiddenLabelDocModule").css('display', 'block');
                $('#hiddenLabelDocModule').text("No Documents available.");
                loader(0);
            } else {
                CustomAlert('Error occurred while fetching the documents, Please try again');
                loader(0);
            }
        });
    }

    if (letterModuleName === "AG_PACKET") {
        var PI = AgPatient_ComplaintInfo("", "");
        requestUrl = baseURL + 'api/AgPacket/GetPacketLogData';
        $.ajax({
            type: "Get",
            url: requestUrl,
            dataType: "json",
            data: datastring,
            data: {
                patientId: PI.PatientId,
                TimeDictionaryobj: timeZone,
                carestaffid: parseInt(memberidval),
                page: pageNo,
                pageSize: pageSize
            },
            async: false,
            success: function (data) {
                if (data && data.Data) {
                    if (data.Data.length > 0) {
                        var docsData = data.Data.filter(x => x.Status.toLowerCase() !== "failed");
                        nextPageNumber = pageNo + 1;
                        nextPageSize = pageSize;
                        var dataSource = new kendo.data.DataSource({
                            data: docsData,
                            serverFiltering: true,
                        });
                        $("#listViewPacketDiv").kendoListView({
                            dataSource: dataSource,
                            template: kendo.template($("#templateScriptAGListView").html())
                        });
                        enablePacketUploadOnEditLetter();
                        $("#hdnDocsScrollCheck").val(1);
                        loader(0);
                    } else {
                        $("#hiddenLabelPacketModule").css('display', 'block');
                        $('#hiddenLabelPacketModule').text("No Packets available.");
                        loader(0);
                    }
                } else {
                    CustomAlert('Error occurred while fetching the documents, Please try again');
                    loader(0);
                }
            },
            error: function (error) {
                CustomAlert('Error occurred, Please try again');
                loader(0);
            }
        });
    }

    loader(0);
}

function loadNextDocsPacketsForLetter(pageNextNo, pageNextSize) {
    loader(1);
    if (letterModuleName === "CM") {
        var requestUrl = baseURL + "/Document/GetElectronicDocuments";
        $.ajax({
            type: "Get",
            url: requestUrl,
            dataType: "json",
            data: {
                patientId: parseInt($('#selectPatientAccessed').val()),
                TimeDictionaryobj: timeZone,
                carestaffId: parseInt(memberidval),
                page: pageNextNo,
                pageSize: pageNextSize
            },
            async: false,
            success: function (response) {
                if (response && response.Data) {
                    if (response.Data.length > 0) {
                        var totalRecordCount = response.Total;
                        var docsData = getDocsArrayToDisplay(response.Data);
                        for (var i = 0; i < docsData.length; i++) {
                            $('#listViewChildDiv').data('kendoListView').dataSource.add(docsData[i]);
                        }
                        enableDocUploadOnEditLetter();
                        var numOfLoadedDocs = $("#listViewChildDiv").data("kendoListView").dataSource.total();
                        if (totalRecordCount < (numberOfDocuments + pageNextSize) && numOfLoadedDocs === 0) {
                            $("#hiddenLabelDocModule").css('display', 'block');
                            $('#hiddenLabelDocModule').text("No Documents available.");
                        }
                        numberOfDocuments = numberOfDocuments + response.Data.length;
                        if (totalRecordCount > numberOfDocuments) {
                            nextPageNumber = pageNextNo + 1;
                            nextPageSize = pageNextSize;
                        } else {
                            nextPageNumber = 0;
                            nextPageSize = 0;
                        }
                        loadNextPageDocsWhenNoScroll();
                        $("#hdnDocsScrollCheck").val(1);
                        if (checkedDocumentsList.length > 0) {
                            for (var i = 0; i < checkedDocumentsList.length; i++) {
                                $('#cbxDocDiv_' + checkedDocumentsList[i]).prop('checked', true);
                            }
                        }
                    }
                    loader(0);
                }
                else {
                    loader(0);
                }
            },
            error: function (error) {
                CustomAlert('Error occurred, Please try again');
                loader(0);
            }
        });
    }

    if (letterModuleName === "UM") {
        var PI = UmPatient_AuthInfo('');
        AjaxRequest(baseApiURL + '/UMCommon/GetAllAuthDocuments', { SP_VA_AUTH_NO: PI.AuthNo, COLUMN_CARE_STAFF: "CARE_STAFF_ID", SP_VA_PAGE_NUMBER: pageNextNo, SP_VA_PAGE_SIZE: pageNextSize }, function (umDocsResponse) {
            var AuthDocuments = umDocsResponse.ToJson();
            if (AuthDocuments.length > 0) {
                var docsData = getDocsArrayToDisplay(AuthDocuments);
                nextPageNumber = pageNextNo + 1;
                nextPageSize = pageNextSize;
                for (var i = 0; i < docsData.length; i++) {
                    $('#listViewChildDiv').data('kendoListView').dataSource.add(docsData[i]);
                }
                enableDocUploadOnEditLetter();
                loadNextPageDocsWhenNoScroll();
                if (checkedDocumentsList.length > 0) {
                    for (var i = 0; i < checkedDocumentsList.length; i++) {
                        $('#cbxDocDiv_' + checkedDocumentsList[i]).prop('checked', true);
                    }
                }
                $("#hdnDocsScrollCheck").val(1);
                loader(0);
            } else {
                var numOfLoadedUMDocs = $("#listViewChildDiv").data("kendoListView").dataSource.total();
                if (!numOfLoadedUMDocs) {
                    $("#hiddenLabelDocModule").css('display', 'block');
                    $('#hiddenLabelDocModule').text("No Documents available.");
                }
                if (nextPageNumber > 1) {
                    return;
                } else {
                    CustomAlert('Error occurred while fetching the documents, Please try again');
                }
                loader(0);
            }
        });
    }

    if (letterModuleName === "AG") {
        var PI = AgPatient_ComplaintInfo("", "");
        AjaxRequest(baseApiURL + '/Route/GetAGResult', { DATA_KEY: "GET_COMPLAINT_DOCUMENT", SP_VA_COMPLAINT_RECORD_ID: PI.ComplaintNo, COLUMN_CARE_STAFF: "CARE_STAFF_ID", SP_VA_PAGE_NUMBER: pageNextNo, SP_VA_PAGE_SIZE: pageNextSize, SP_VA_IS_SMARTCOMM: IsSmartCommEnabled }, function (agDocsResponse) {
            var complaintDocuments = agDocsResponse.ToJson();
            if (complaintDocuments.length > 0) {
                var docsData = getDocsArrayToDisplay(complaintDocuments);
                nextPageNumber = pageNextNo + 1;
                nextPageSize = pageNextSize;
                for (var i = 0; i < docsData.length; i++) {
                    $('#listViewChildDiv').data('kendoListView').dataSource.add(docsData[i]);
                }
                enableDocUploadOnEditLetter();
                loadNextPageDocsWhenNoScroll();
                if (checkedDocumentsList.length > 0) {
                    for (var i = 0; i < checkedDocumentsList.length; i++) {
                        $('#cbxDocDiv_' + checkedDocumentsList[i]).prop('checked', true);
                    }
                }
                $("#hdnDocsScrollCheck").val(1);
                loader(0);
            }
            else {
                var numOfLoadedUMDocs = $("#listViewChildDiv").data("kendoListView").dataSource.total();
                if (!numOfLoadedUMDocs) {
                    $("#hiddenLabelDocModule").css('display', 'block');
                    $('#hiddenLabelDocModule').text("No Documents available.");
                }
                if (nextPageNumber > 1) {
                    return;
                } else {
                    CustomAlert('Error occurred while fetching the documents, Please try again');
                }
                loader(0);
            }
        });
    }

    if (letterModuleName === "AG_PACKET") {
        var PI = AgPatient_ComplaintInfo("", "");
        requestUrl = baseURL + 'api/AgPacket/GetPacketLogData';
        $.ajax({
            type: "Get",
            url: requestUrl,
            dataType: "json",
            data: {
                patientId: PI.PatientId,
                TimeDictionaryobj: timeZone,
                carestaffid: parseInt(memberidval),
                page: pageNextNo,
                pageSize: pageNextSize
            },
            async: false,
            success: function (data) {
                if (data && data.Data) {
                    if (data.Data.length > 0) {
                        nextPageNumber = pageNextNo + 1;
                        nextPageSize = pageNextSize;
                        var docsData = data.Data.filter(x => x.Status.toLowerCase() !== "failed");
                        for (var i = 0; i < docsData.length; i++) {
                            $('#listViewPacketDiv').data('kendoListView').dataSource.add(docsData[i]);
                        }
                        enablePacketUploadOnEditLetter();
                        if (checkedPacketsList.length > 0) {
                            for (var i = 0; i < checkedPacketsList.length; i++) {
                                $('#cbxPacketCheck_' + checkedPacketsList[i]).prop('checked', true);
                            }
                        }
                        $("#hdnDocsScrollCheck").val(1);
                        loader(0);
                    }
                }
                else {
                    if (nextPageNumber > 1) {
                        return;
                    } else {
                        CustomAlert('Error occurred while fetching the documents, Please try again');
                    }
                    loader(0);
                }
            },
            error: function (error) {
                CustomAlert('Error occurred, Please try again');
                loader(0);
            }
        });
    }

    loader(0);
}

function GetCaseConfTemplate() {
    loader(1);
    AjaxCallInit({
        url: baseURL + '/Letter/LoadCaseConfDraft',
        PostData: {
            extTemplateId: $('#ddlTemplateId').val(), moduleId: gtModId("CM"), keyValues: 'groupId=' + $('#hdnCtrlGroupId').val() + '§participants=' + $('#hdnPaticipantIds').val()
        }
    }, function (data) {
        draft = data.ToJson();
        if (draft && draft.DraftData != "") {
            loadDraftFromString(draft.DraftData);
            loader(0);
        }
    });
}

function LobDateValidation() {
    var LobBenId = "";
    if (getSelMemEligFromMini('divAddScLetterCLob').RecordSelected) {
        LobBenId = getSelMemEligFromMini('divAddScLetterCLob').LobBenId;
    }
    if (LobBenId !== "") {
        AjaxCallInit({
            url: baseURL + '/Letter/LobDateValidation',
            PostData: { lobBenId: LobBenId }
        }, function (RowData) {
            RD = RowData.ToJson();
            if (RD) {
                $('#hdnAddLetterLobStatus').val(RD.Status); $('#hdnAddLetterLobActiveDate').val(RD.ActiveDate);
            }
        });
    }
}

function LobConfirmation() {
    if (!isLetterReview()) {
        var Status = $('#hdnAddLetterLobStatus').val();
        var ActiveDate = $('#hdnAddLetterLobActiveDate').val();
        if (Status == 0 || Status == 2) {
            var message = "Please make note that LOB eligibility date for this member has been exhausted on " + ActiveDate + ". Do you want to proceed anyway? ";
            if (Status == 2) { message = "Please make note that LOB eligibility for this member will be active from " + ActiveDate + " onwards. Do you want to proceed anyway? "; }
            if (confirm(message)) { return true; }
            else { return false; }
        }
        else { return true; }
    }
    else { return true; }
}

function LoadDraftEditor() {
    var extUrl = '/';
    $('#loadLetterDrafEditor').load(baseURL + '/Letter/LetterDraftEditor' + extUrl);
    $('#BtnSaveDraft').hide();
}

function AjaxCallInit(Opt, AjaxCallBack) {
    $.ajax({
        type: "POST", data: Opt.PostData, url: Opt.url, dataType: "html", success: function (Result) {
            if (AjaxCallBack && typeof (AjaxCallBack) === "function") { AjaxCallBack(Result); }
        }
    }).fail(AjaxFailed);
}

function AjaxFailed(jqXHR, TextStatus, ErrorThrown) {
    loader(0);
}

function CloseLetterPopup() {
    afterReviewUMDocRefresh();
    afterReviewCMDocRefresh();
    afterReviewAGDocRefresh();
    afterReviewMTMDocRefresh();
    $('body').css('overflow', 'auto');
    $('#LetterDiv').html('').hide();
    $('#divUMActions').show();
    $('#divAction').show();
    isFromSmartCOMMAddLetter = false;
    attachmentInputFromDraft = [];
    attachmentArrayObj = [];
}

function getModuleForLetterDocsPackets() {
    var moduleName = (letterModuleName === "CM" ? "PATIENT_DOCUMENT" : (letterModuleName === "UM" ? "AUTH_DOCUMENT" :
        (letterModuleName === "AG" || letterModuleName === "AG_PACKET" ? "COMPLAINT_DOCUMENT" : "")));
    attachmentArrayObj = [];
    if (!isFromSmartCOMMAddLetter) {
        if (attachmentInputFromDraft.length > 0) {
            attachmentArrayObj = attachmentInputFromDraft;
        }
    } else {
        if (checkedDocumentsList.length > 0) {
            var attachedDocObj = {
                Module: moduleName,
                Reference: checkedDocumentsList
            };
            attachmentArrayObj.push(attachedDocObj);
        }
        if (checkedPacketsList.length > 0) {
            var attachedPacketObj = {
                Module: "COMPLAINT_PACKET",
                Reference: checkedPacketsList
            };
            attachmentArrayObj.push(attachedPacketObj);
        }
    }
}

function LetterPrintQueue(moduleId, isPHBulkLetter) {
    $("#BtnPrintQueue").prop('disabled', true);
    if (isPHBulkLetter == true) {
        loader(1);
        var filterPatientIds = $('#hdnPHPatientIds').val(), moduleId = $('#hdnPHModuleId').val();
        var nameFieldValue = $('#ddlTemplateId').val();
        if (filterPatientIds != null && nameFieldValue != null && nameFieldValue > 0) {
            AjaxCallInit({
                url: baseURL + '/Letter/GenerateCMAndPHBulkLetters',
                PostData: {
                    patientIds: filterPatientIds,
                    templateId: 0,
                    extTemplateId: $('#ddlTemplateId').val(),
                    languageId: $('#ddlLanguage').val(),
                    moduleId: moduleId,
                    saveType: 1,
                    templateName: $('#ddlTemplateId option:selected').text(),
                    lobbenId: $('.clsRdoMemEligMini:checked').data('lobbenid') ? $('.clsRdoMemEligMini:checked').data('lobbenid') : 0,
                    loggedInUserName: loggedInUserName
                }
            },
                function (data) {
                    var dataRow = data.ToJson()
                    if (dataRow.Success) {
                        var finalMsg = "Letter(s) have been sent to print queue successfully";
                        $('#memchkvalPh').prop('checked', false);
                        $('.memchkvalPh').prop('checked', false);
                        loader(0);
                        $("#btnCancel").trigger('click');
                        CmnStatusMessageDisp('validationMessagePHBulkLetter', finalMsg, 'Success');
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                    } else {
                        loader(0);
                        $("#BtnPrintQueue").prop('disabled', false);
                        $("#btnCancel").trigger('click');
                        CmnStatusMessageDisp('validationMessagePHBulkLetter', 'Error occured', 'Error');
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                    }
                });
        }
        else {
            loader(0);
            $("#BtnPrintQueue").prop('disabled', false);
            CustomAlert("Please select the required fields."); return;
        }

    } else {
        var ModuleId = validateModuleId(moduleId);
        if (LobConfirmation()) {
            var data;
            editor.getString(function (success, data) {
                //CNT-2427 - To escape \ in the draft content
                //var draft = data.replace(/"/g, '\\"');
                var draft = data.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                if (draft.indexOf('[ERROR]') <= -1) {
                    loader(1);
                    if (isLetterReview()) {
                        data = {
                            documentId: $('#DocumentId').val(),
                            moduleId: $('#ModuleId').val(),
                            draftContent: draft,
                            authNo: $('#hdnAddLetterAuthNo').val(),
                            complaintId: $('#hdnAddLetterComplaintId').val(),
                            lobbenId: getSelMemEligFromMini('divAddScLetterCLob').LobBenId ? getSelMemEligFromMini('divAddScLetterCLob').LobBenId : 0,
                            attachmentInputArray: attachmentArrayObj,
                            speedyDispatch: $('#ChkSpeedyDispatch').is(':checked')
                        }
                    } else {
                        data = {
                            extTemplateId: $('#ddlTemplateId').val(),
                            moduleId: ModuleId,
                            draftContent: draft,
                            languageId: $('#ddlLanguage').val(),
                            authNo: $('#hdnAddLetterAuthNo').val(),
                            complaintId: $('#hdnAddLetterComplaintId').val(),
                            lobbenId: getSelMemEligFromMini('divAddScLetterCLob').LobBenId ? getSelMemEligFromMini('divAddScLetterCLob').LobBenId : 0,
                            attachmentInputArray: attachmentArrayObj,
                            speedyDispatch: $('#ChkSpeedyDispatch').is(':checked')
                        };
                    }
                    var modName = (ModuleId == 1) ? "CM" : (ModuleId == 3 ? "UM" : (ModuleId == 5 ? "AG" : ""));
                    var ruleEventSource = "PRINTQUEUE";
                    var ficoPreLetterPQ = { eventSource: ruleEventSource, parentConrolId: "", moduleName: modName, eventType: "PRE", languageName: $("#ddlLanguage option:selected").text(), letterTemplateName: $("#ddlTemplateId option:selected").text() };
                    var ficoPreLetterPQResponse = ficoRealTimeValidation(ficoPreLetterPQ);
                    var isRuleHardValidation = CheckValidationMessages(ficoPreLetterPQResponse);
                    if (isRuleHardValidation) {
                        loader(0);
                        $("#BtnPrintQueue").prop('disabled', false);
                        return;
                    }
                    AjaxCallInit({
                        url: baseURL + '/Letter/PrintQueue',
                        PostData: data
                    },
                        function (RowData) {
                            RD = RowData.ToJson();
                            if (isAttachmentModule(ModuleId)) {
                                if (RD && RD.result) {
                                    checkMergedStatus(RD.result);
                                    $("#BtnPrintQueue").prop('disabled', false);
                                }
                            }
                            if (RD && RD.LetterQueueId > 0) {
                                LetterMessageBox("Message",
                                    "Letter has been sent to print queue successfully.",
                                    true,
                                    null,
                                    true);
                                CloseLetterPopup();
                                loader(0);
                            }
                            loader(0);
                        });
                }
            });
        }
        $("#BtnPrintQueue").prop('disabled', false);
    }
    $("#BtnPrintQueue").prop('disabled', false);
}

function LetterExportPdf(moduleId, isPHBulkLetter) {
    if (isPHBulkLetter) {
        loader(1);
        var filterPatientIds = $('#hdnPHPatientIds').val(), moduleId = $('#hdnPHModuleId').val();
        var nameFieldValue = $('#ddlTemplateId').val();
        if (filterPatientIds != null && nameFieldValue != null && nameFieldValue > 0) {
            AjaxCallInit({
                url: baseURL + '/Letter/GenerateCMAndPHBulkLetters',
                PostData: {
                    patientIds: filterPatientIds,
                    templateId: 0,
                    extTemplateId: $('#ddlTemplateId').val(),
                    languageId: $('#ddlLanguage').val(),
                    moduleId: moduleId,
                    saveType: 0,
                    templateName: $('#ddlTemplateId option:selected').text(),
                    lobbenId: $('.clsRdoMemEligMini:checked').data('lobbenid') ? $('.clsRdoMemEligMini:checked').data('lobbenid') : 0,
                    loggedInUserName: loggedInUserName
                }
            },
                function (data) {
                    var dataRow = data.ToJson()
                    if (dataRow.Success) {
                        window.location.href =
                            baseURL +
                        '/Letter/DownloadPHZipFile?isZip=' + dataRow.isZip + '&gc-fd-token=' + dataRow.Result;

                        //var finalMsg = "Dowloaded successfully";
                        //$('#memchkvalPh').prop('checked', false);
                        //$('.memchkvalPh').prop('checked', false);
                        loader(0);
                        //$("#btnCancel").trigger('click');
                        //CmnStatusMessageDisp('validationMessagePHBulkLetter', finalMsg, 'Success');
                    } else {
                        loader(0);
                        $("#btnCancel").trigger('click');
                        CmnStatusMessageDisp('validationMessagePHBulkLetter', 'Error occured', 'Error');
                    }
                });
        }
        else {
            loader(0);
            CustomAlert("Please select the required fields."); return;
        }
    } else {
        var ModuleId = validateModuleId(moduleId);
        if (LobConfirmation()) {
            var data;
            editor.getString(function (success, data) {

                //CNT-2427 - To escape \ in the draft content
                //var draft = data.replace(/"/g, '\\"');
                var draft = data.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                if (draft.indexOf('[ERROR]') <= -1) {
                    loader(1);
                    if (isLetterReview()) {
                        data = {
                            documentId: $('#DocumentId').val(),
                            draftContent: draft,
                            moduleId: $('#ModuleId').val(),
                            attachmentInputArray: attachmentArrayObj
                        }
                    } else {
                        data = {
                            extTemplateId: $('#ddlTemplateId').val(),
                            moduleId: ModuleId,
                            draftContent: draft,
                            languageId: $('#ddlLanguage').val(),
                            authNo: $('#hdnAddLetterAuthNo').val(),
                            complaintId: $('#hdnAddLetterComplaintId').val(),
                            attachmentInputArray: attachmentArrayObj
                        };
                    }

                    AjaxCallInit({
                        url: baseURL + '/Letter/ExportPdf',
                        PostData: data
                    },
                        function (RowData) {
                            RD = RowData.ToJson();
                            if (isAttachmentModule(ModuleId)) {
                                if (RD && RD.DraftData) {
                                    checkMergedStatus(RD.DraftData)
                                }
                            }
                            if (RD && RD.DraftData.IsSaved) {
                                SecureBrowserFileDownload.DownloadFile(baseURL, null, "LetterExportPdfSC", RD.Token, null);
                                loader(0);
                            }
                            loader(0);
                        });
                }
            });
        }
    }
}

function LetterSaveAsDraft(moduleId) {
    $("#BtnSaveDraft").prop('disabled', true);
    var ModuleId = validateModuleId(moduleId);
    if (LobConfirmation()) {
        editor.getString(function (success, data) {
            //CNT-2427 - To escape \ in the draft content
            //var draft = data.replace(/"/g, '\\"');
            var draft = data.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
            if (draft.indexOf('[ERROR]') <= -1) {
                loader(1);
                var ruleModuleName = (ModuleId == 1) ? "CM" : (ModuleId == 3 ? "UM" : (ModuleId == 5 ? "AG" : ""));
                var ruleEventSource = "SAVEASDRAFT";
                var ficoPreLetterDraft = { eventSource: ruleEventSource, parentConrolId: "", moduleName: ruleModuleName, eventType: "PRE", languageName: $("#ddlLanguage option:selected").text(), letterTemplateName: $("#ddlTemplateId option:selected").text() };
                var ficoPreLetterDraftResponse = ficoRealTimeValidation(ficoPreLetterDraft);
                var isRuleHardValidation = CheckValidationMessages(ficoPreLetterDraftResponse);
                if (isRuleHardValidation) {
                    loader(0);
                    $("#BtnSaveDraft").prop('disabled', false);
                    return;
                }
                AjaxCallInit({
                    url: baseURL + '/Letter/SaveAsDraft',
                    PostData: {
                        documentId: $('#DocumentId').val(),
                        extTemplateId: $('#ddlTemplateId').val(),
                        moduleId: ModuleId,
                        draftContent: draft,
                        languageId: $('#ddlLanguage').val(),
                        authNo: $('#hdnAddLetterAuthNo').val(),
                        complaintId: $('#hdnAddLetterComplaintId').val(),
                        attachmentInputArray: attachmentArrayObj,
                        reviewNumber: $('#hdnLetterReviewNbr').val(),
                        reviewTypeLookupId: $('#hdnLetterReviewLookupId').val(),
                        lobbenId: $('.clsRdoMemEligMini:checked').data('lobbenid') ? $('.clsRdoMemEligMini:checked').data('lobbenid') : 0
                    }
                },
                    function (RowData) {
                        RD = RowData.ToJson();
                        if (isAttachmentModule(ModuleId)) {
                            if (RD && RD.result) {
                                checkMergedStatus(RD.result);
                                $("#BtnSaveDraft").prop('disabled', false);
                            }
                        }
                        if (RD && RD.DocumentId > 0) {
                            CloseLetterPopup();
                            OpenConfirmBoxByModule(RD.ModuleId, RD.DocumentId);
                            loader(0);
                        } else {
                            loader(0);
                            $("#BtnSaveDraft").prop('disabled', false);
                        }
                    });
            }
        });
    }
    $("#BtnSaveDraft").prop('disabled', false);
}

function LetterSaveCaseConference(flag) {
    var Emails = '', PIDS = '', PNAME = '', TEAM_INFO = '', TEAM_INFO_DATA = '';
    $(".ListBox").find('.clsCaseConfComplete').each(function (index, el) {
        var CCEmail = $(this).attr("id").split('|')[1];
        if ($(this).is(':checked')) {
            Emails = Emails + CCEmail + ',';
        }
    });
    Emails = Emails.substring(0, Emails.length - 1);

    retFlag = true;
    if (Emails == "" || Emails == "0") {
        $('.Participants').show();
        retFlag = false;
    } else {
        $('.Participants').hide();
    }
    if ($('#ddlTemplateId').val() == "" || $('#ddlTemplateId').val() == "-1" || $('#ddlTemplateId').val() == "0") {
        $('.Template').show();
        retFlag = false;
    } else {
        $('.Template').hide();
    }
    if (!retFlag) {
        return;
    }

    loader(1);
    editor.getString(function (success, data) {
        var draft = data.replace(/"/g, '\\"');
        AjaxCallInit({
            url: baseURL + '/Letter/SaveCaseConference',
            PostData: {
                extTemplateId: $('#ddlTemplateId').val(),
                moduleId: gtModId("CM"),
                draftContent: draft,
                keyValues: 'EMailIds=' +
                    Emails +
                    '§AdditionalEMailIds=' +
                    $('#txtAdditionalEmails').val() +
                    '§GroupId=' +
                    $('#hdnCtrlGroupId').val() +
                    '§IsSendMail=' +
                    flag
            }
        },
            function (RowData) {
                RD = RowData.ToJson();
                if (RD) {
                    CloseLetterPopup();
                    legacyModalAlert("Message",
                        (flag
                            ? "Email has been sent successfully."
                            : "Case conference meeting minutes saved successfully."),
                        true,
                        null,
                        true);
                    if ($('#caseConferenceGrid').is(":visible")) {
                        $("#caseConferenceGrid").data("kendoGrid").dataSource.read();
                    }
                }
                loader(0);
            });
    });

    loader(0);
}

function validateModuleId(moduleId) {
    var ModuleId = '';
    if (isAttachmentModule(moduleId)) {
        var parDiv = $('#divScLetterVerticalContainer');
        var module = $("#moduleDescriptionOne", parDiv).text();
        ModuleId = gtModId(module);
        getModuleForLetterDocsPackets();
    }
    else {
        if (moduleId) {
            ModuleId = moduleId;
        }
        else {
            ModuleId = $('#ddlModule').val();
        }
    }
    return ModuleId;
}

function LetterSaveAndPrintQueue(moduleId, isPHBulkLetter) {
    $("#BtnSavePrintQueue").prop('disabled', true);
    if (isPHBulkLetter == true) {
        loader(1);
        var filterPatientIds = $('#hdnPHPatientIds').val(), moduleId = $('#hdnPHModuleId').val();
        var nameFieldValue = $('#ddlTemplateId').val();
        if (filterPatientIds != null && nameFieldValue != null && nameFieldValue > 0) {
            AjaxCallInit({
                url: baseURL + '/Letter/GenerateCMAndPHBulkLetters',
                PostData: {
                    patientIds: filterPatientIds,
                    templateId: 0,
                    extTemplateId: $('#ddlTemplateId').val(),
                    languageId: $('#ddlLanguage').val(),
                    moduleId: moduleId,
                    saveType: 2,
                    templateName: $('#ddlTemplateId option:selected').text(),
                    lobbenId: $('.clsRdoMemEligMini:checked').data('lobbenid') ? $('.clsRdoMemEligMini:checked').data('lobbenid') : 0,
                    loggedInUserName: loggedInUserName
                }
            },
                function (data) {
                    var dataRow = data.ToJson()
                    if (dataRow.Success) {
                        var finalMsg = "Letter(s) have been saved and sent to print queue successfully";
                        $('#memchkvalPh').prop('checked', false);
                        $('.memchkvalPh').prop('checked', false);
                        loader(0);
                        $("#btnCancel").trigger('click');
                        CmnStatusMessageDisp('validationMessagePHBulkLetter', finalMsg, 'Success');
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                    } else {
                        loader(0);
                        $("#BtnSavePrintQueue").prop('disabled', false);
                        $("#btnCancel").trigger('click');
                        CmnStatusMessageDisp('validationMessagePHBulkLetter', 'Error occured', 'Error');
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                    }
                });
        }
        else {
            loader(0);
            $("#BtnSavePrintQueue").prop('disabled', false);
            CustomAlert("Please select the required fields."); return;
        }
    } else {
        var ModuleId = validateModuleId(moduleId);
        if (LobConfirmation()) {
            var data;
            editor.getString(function (success, data) {
                data = data.replace(/\\/g, '\\\\');
                var draft = data.replace(/"/g, '\\"');
                if (draft.indexOf('[ERROR]') <= -1) {
                    loader(1);
                    if (isLetterReview()) {
                        data = {
                            documentId: $('#DocumentId').val(),
                            draftContent: draft,
                            moduleId: $('#ModuleId').val(),
                            authNo: $('#hdnAddLetterAuthNo').val(),
                            complaintId: $('#hdnAddLetterComplaintId').val(),
                            lobbenId: $('.clsRdoMemEligMini:checked').data('lobbenid') ? $('.clsRdoMemEligMini:checked').data('lobbenid') : 0,
                            attachmentInputArray: attachmentArrayObj,
                            speedyDispatch: $('#ChkSpeedyDispatch').is(':checked')
                        }
                    } else {
                        data = {
                            extTemplateId: $('#ddlTemplateId').val(),
                            draftContent: draft,
                            moduleId: ModuleId,
                            languageId: $('#ddlLanguage').val(),
                            authNo: $('#hdnAddLetterAuthNo').val(),
                            complaintId: $('#hdnAddLetterComplaintId').val(),
                            lobbenId: $('.clsRdoMemEligMini:checked').data('lobbenid') ? $('.clsRdoMemEligMini:checked').data('lobbenid') : 0,
                            attachmentInputArray: attachmentArrayObj,
                            reviewNumber: $('#hdnLetterReviewNbr').val(),
                            reviewTypeLookupId: $('#hdnLetterReviewLookupId').val(),
                            speedyDispatch: $('#ChkSpeedyDispatch').is(':checked')
                        };
                    }
                    var modName = (ModuleId == 1) ? "CM" : (ModuleId == 3 ? "UM" : (ModuleId == 5 ? "AG" : ""));
                    var ruleEventSource = "SAVEANDPRINTQUEUE";
                    var ficoPreLetterSavePQ = { eventSource: ruleEventSource, parentConrolId: "", moduleName: modName, eventType: "PRE", languageName: $("#ddlLanguage option:selected").text(), letterTemplateName: $("#ddlTemplateId option:selected").text() };
                    var ficoPreLetterSavePQResponse = ficoRealTimeValidation(ficoPreLetterSavePQ);
                    var isRuleHardValidation = CheckValidationMessages(ficoPreLetterSavePQResponse);
                    if (isRuleHardValidation) {
                        loader(0);
                        $("#BtnSavePrintQueue").prop('disabled', false);
                        return;
                    }
                    AjaxCallInit({
                        url: baseURL + '/Letter/SaveAndPrintQueue',
                        PostData: data
                    },
                        function (RowData) {
                            RD = RowData.ToJson();
                            if (isAttachmentModule(ModuleId)) {
                                if (RD && RD.result) {
                                    checkMergedStatus(RD.result);
                                    $("#BtnSavePrintQueue").prop('disabled', false);
                                }
                            }
                            if (RD && RD.LetterQueueId > 0) {
                                LetterMessageBox("Message",
                                    "Letter has been saved and sent to print queue successfully.",
                                    true,
                                    null,
                                    true);
                                var PI;                                
                                if (modName === "AG") {
                                    PI = AgData.complaintInfo();
                                }
                                else if (modName === "UM") {
                                    PI = UmPatient_AuthInfo("", "");
                                }
                                else {
                                    PI = "";
                                }
                                var ficoPostObject = { eventSource: ruleEventSource, parentConrolId: PI, moduleName: modName, eventType: "POST", isAsync: true };
                                var ficoPostResponse = ficoRealTimeValidation(ficoPostObject);
                                CheckValidationMessages(ficoPostResponse);
                                CloseLetterPopup();
                                loader(0);
                            }
                            loader(0);
                        });
                }
            });

        }
        $("#BtnSavePrintQueue").prop('disabled', false);
    }
    $("#BtnSavePrintQueue").prop('disabled', false);
}

function LetterCompleteReview() {
    editor.getString(function (success, data) {
        //var draft = '<review-case createdate=\"13/Jul/2018 12:57:14\" system=\"\" batchid=\"0\" transactionno=\"1\" batchname=\"\" version=\"6.0\"><change-sessions><session id=\"0\" tag=\"vguduri@SC-AHS-SBX.guidingcare.com\"/></change-sessions><transaction><objects><object class=\"Th_158355078_6_DocumentSet\" name=\"DocumentSet\"><property name=\"Document\" index=\"0\"><object class=\"Th_158355078_6_Document\" name=\"Document\"><property name=\"UMDocument\"><object class=\"Th_158355078_6_UMDocument\" name=\"UMDocument\"><property name=\"TemplateId\" value=\"154361934\"/><property name=\"RecipientData\"><object class=\"Th_158355078_6_Recipient\" name=\"RecipientData\"><property name=\"Type\" value=\"type1\"/><property name=\"FaxNumber\" value=\"+1-111-222-3333\"/><property name=\"EmailAddress\" value=\"a@b.com\"/><property name=\"RecipientAddress\"><object class=\"Th_158355078_6_RecipientAddress\" name=\"RecipientAddress\"><property name=\"Addressee\" value=\"Addressee1\"/><property name=\"AddressLine1\" value=\"AddLine1\"/><property name=\"AddressLine2\" value=\"AddLine2\"/><property name=\"AddressLine3\" value=\"AddLine3\"/><property name=\"City\" value=\"city1\"/><property name=\"State\" value=\"state1\"/><property name=\"PostalCode\" value=\"12312\"/><property name=\"Country\" value=\"country1\"/></object></property></object></property><property name=\"DocumentLanguage\" value=\"English\"/><property name=\"Client\" value=\"client1\"/><property name=\"LineOfBusiness\" value=\"lob1\"/><property name=\"Plan\" value=\"plan1\"/><property name=\"Group\" value=\"group1\"/><property name=\"Module\" value=\"module1\"/><property name=\"UMDataModel\"><object class=\"Th_158355078_6_XMLSchema_xsd_UMDataModel\" name=\"UMDataModel\"><property name=\"Patient\"><object class=\"Th_158355078_6_patient_2\" name=\"Patient\"><property name=\"AlternateEmail\" value=\"saindleni@altruistahealth.com\"/><property name=\"AlternatePhone\" value=\"888-888-8888\"/><property name=\"PrimaryBehavioralDescription\" value=\"Asa\"/><property name=\"CellPhone\" value=\"111-111-1111\"/><property name=\"Fax\" value=\"888-777-6666\"/><property name=\"FirstName\" value=\"Test MTM\"/><property name=\"Gender\" value=\"F\"/><property name=\"HomePhone\" value=\"123-456-7891\"/><property name=\"InsurancePolicyNo\" value=\"d\"/><property name=\"LastName\" value=\"Member 12\"/><property name=\"MaritalStatus\" value=\"Divorced\"/><property name=\"PrimaryMedicalDescription\" value=\"dsfds\"/><property name=\"MiddleName\" value=\"updating\"/><property name=\"NamePrefix\" value=\"\"/><property name=\"Name\" value=\"Test MTM updating Member 12\"/><property name=\"PrefTimeofCall\" value=\"Tuesday:Morning\"/><property name=\"PrimaryEmai\" value=\"jsingampalli1@altruistahealth.com\"/><property name=\"PrimaryLanguage\" value=\"American Sign Language\"/><property name=\"RelationType\" value=\"U\"/><property name=\"ResidentStatus\" value=\"Living with Friend or Relative\"/><property name=\"SecInsurancePolicyNo\" value=\"d\"/><property name=\"SecInsuranceType\" value=\"CC\"/><property name=\"Suffix\" value=\"\"/></object></property><property name=\"Auth\"><object class=\"Th_158355078_6_auth\" name=\"Auth\"><property name=\"ActualOwnerName\" value=\"QA Coach1  QA LN1\"/><property name=\"Admission\"><object class=\"Th_158355078_6_admission\" name=\"Admission\"/></property><property name=\"CurrentOwnerName\" value=\"QA Coach1  QA LN1\"/><property name=\"Planname\" value=\"\"/><property name=\"Status\" value=\"Open\"/><property name=\"Type\" value=\"InPatient-1\"/><property name=\"LOBName\" value=\"Medicaid\"/><property name=\"Proc\" index=\"0\"><object class=\"Th_158355078_6_procedureCode\" name=\"Proc\"><property name=\"ApprovedCode\" value=\"N/A\"/><property name=\"ApprovedDesc\" value=\"N/A\"/><property name=\"Code\" value=\"E0145\"/><property name=\"Desc\" value=\"WALKER WHEELED W/SEAT &amp; CRUTCH ATTA\"/><property name=\"CodeStatus\" value=\"Pending\"/></object></property><property name=\"Proc\" index=\"1\"><object class=\"Th_158355078_6_procedureCode\" name=\"Proc\"><property name=\"ApprovedCode\" value=\"N/A\"/><property name=\"ApprovedDesc\" value=\"N/A\"/><property name=\"Code\" value=\"84565\"/><property name=\"Desc\" value=\"UROBILIN, URINE; QUALITATIVE\"/><property name=\"CodeStatus\" value=\"Pending\"/></object></property><property name=\"Diagnosis\" index=\"0\"><object class=\"Th_158355078_6_diagnosis\" name=\"Diagnosis\"><property name=\"Code\" value=\"Y35.123A\"/><property name=\"Description\" value=\"Legal intervnt w injury by explosv shell, suspect inj, init\"/></object></property></object></property></object></property></object></property></object></property></object></objects></transaction><review-document docdef-resid=\"154361601\" docdef-resverid=\"158355178\" bo-class=\"\" bo-name=\"\" styleset-resid=\"154361597\" styleset-resverid=\"158356596\" language=\"-1\" jurisdiction=\"-1\" idiom=\"-1\" device=\"\" brand=\"-1\" effective-date=\"13/Jul/2018 12:57:14\"><userkeys/><review-channel channel=\"2\" destination=\"-5\" layout-resid=\"154361598\" layout-resverid=\"154403792\"><properties><property name=\"op-disk.exclude\" value=\"true\"/><property name=\"op-jms.exclude\" value=\"true\"/><property name=\"op-custom.exclude\" value=\"true\"/><property name=\"op-smtp.exclude\" value=\"true\"/><property name=\"op-bin.exclude\" value=\"true\"/><property name=\"preview.exclude\" value=\"true\"/></properties><content><region name=\"Body\"><section id=\"2\" name=\"Body\" edit-groups=\"*\" fragresid=\"154361601\" fragresverid=\"158355178\"><frag id=\"25299346\" name=\"new text fragment\" type=\"text\" fragresid=\"154361601\" fragresverid=\"158355178\"><lcij id=\"1252641537\" name=\"new text fragment\"><p xml:space=\"preserve\"/><p xml:space=\"preserve\"/><p xml:space=\"preserve\"><var name=\"Current_Document_index\" type=\"int\" format=\"0\">1</var>: <var name=\"currentTemplateName\" type=\"any\">TestUMTemplate</var></p></lcij></frag><enclosure enclosureid=\"1\" channelid=\"2\" resid=\"154361934\" resverid=\"158355054\"/></section></region></content><enclosures><review-document docdef-resid=\"154361934\" docdef-resverid=\"158355054\" bo-class=\"\" bo-name=\"\" styleset-resid=\"154361597\" styleset-resverid=\"158356596\" language=\"-1\" jurisdiction=\"-1\" idiom=\"-1\" device=\"\" brand=\"-1\" effective-date=\"13/Jul/2018 12:57:14\" enclosureid=\"1\"><userkeys/><review-channel channel=\"2\" destination=\"3\" layout-resid=\"154361598\" layout-resverid=\"154403792\"><properties/><content><region name=\"Body\"><section id=\"2\" name=\"Body\" edit-groups=\"*\" fragresid=\"154361934\" fragresverid=\"158355054\"><frag id=\"8\" edit-groups=\"*\" fragresid=\"154361934\" fragresverid=\"158355054\"><lcij id=\"9\"><p xml:space=\"preserve\">Template Resource ID: <var name=\"UMDocument.TemplateId\" type=\"long\" format=\"0\">154361934</var></p></lcij></frag><frag id=\"20\" edit-groups=\"*\" fragresid=\"154361934\" fragresverid=\"158355054\"><lcij id=\"21\"><p xml:space=\"preserve\">Document Language: <var name=\"UMDocument.DocumentLanguage\" type=\"string\">English</var></p></lcij></frag><frag id=\"22\" name=\"Frag 4\" edit-groups=\"*\" type=\"text\" fragresid=\"154361934\" fragresverid=\"158355054\"><lcij id=\"23\" name=\"Edition 6\"><p xml:space=\"preserve\"/><p xml:space=\"preserve\"><var name=\"UMDocument.RecipientData.RecipientAddress.Addressee\" type=\"string\" edit-groups=\"*\">Addressee1</var></p><p xml:space=\"preserve\"><var name=\"UMDocument.RecipientData.RecipientAddress.AddressLine1\" type=\"string\" edit-groups=\"*\">AddLine1</var></p><p xml:space=\"preserve\"><var name=\"UMDocument.RecipientData.RecipientAddress.City\" type=\"string\" edit-groups=\"*\">city1</var>, <var name=\"UMDocument.RecipientData.RecipientAddress.State\" type=\"string\" edit-groups=\"*\">state1</var> <var name=\"UMDocument.RecipientData.RecipientAddress.PostalCode\" type=\"string\" edit-groups=\"*\">12312</var></p><p xml:space=\"preserve\"/><p xml:space=\"preserve\"/><p xml:space=\"preserve\"/></lcij></frag><frag id=\"32\" edit-groups=\"*\" fragresid=\"154361934\" fragresverid=\"158355054\"><lcij id=\"33\"><p xml:space=\"preserve\">Dear <var name=\"UMDocument.UMDataModel.Patient.FirstName\" type=\"string\" edit-groups=\"*\">Test MTM</var>,</p><p xml:space=\"preserve\" style=\"English_Body\"/></lcij></frag><frag id=\"34\" edit-groups=\"*\" fragresid=\"154361934\" fragresverid=\"158355054\"><lcij id=\"35\"><p xml:space=\"preserve\" style=\"English_Body\"><var name=\"userData1\" type=\"any\" edit-groups=\"*\">Provide a letter body here.</var></p></lcij></frag></section></region></content></review-channel></review-document></enclosures></review-channel></review-document></review-case>';
        //CNT-2653 - To escape \ in the draft content
        var draft = data.replace(/\\(?!")/g, '\\\\').replace(/"/g, '\\"');
        AjaxCallInit({
            url: baseURL + '/Letter/CompleteReview',
            PostData: {
                docId: $('#DocumentId').val(), draftContent: draft, moduleId: $('#ModuleId').val()
            }
        },
            function (RowData) {
                RD = RowData.ToJson();
                if (RD.success.IsSaved) {
                    $("#divLetterScContainer").css('display', 'none');
                    afterReviewButtons(1);
                    getPrintQueueFieldLabelValue();
                }
            });
    });
}

function loadDraft(moduleId) {
    loader(1);
    var ModuleId = validateModuleId(moduleId);
    var LobBenId = getSelMemEligFromMini('divAddScLetterCLob').LobBenId;
    AjaxCallInit({
        url: baseURL + '/Letter/LoadDraft',
        PostData: { extTemplateId: $('#ddlTemplateId').val(), moduleId: ModuleId, languageId: $('#ddlLanguage').val(), authNo: $('#hdnAddLetterAuthNo').val(), complaintId: $('#hdnAddLetterComplaintId').val(), lobBenId: LobBenId, clientId: $('#ddlClient').val(), uniqueEligibilityId: getSelMemEligFromMini('divAddScLetterCLob').UniqueEligibilityId, startDate: getSelMemEligFromMini('divAddScLetterCLob').StartDate }
    }, function (data) {
        draft = data.ToJson();
        if (draft && draft.DraftData != "") {
            loadDraftLetterData(ReplaceAll(draft.DraftData, "&amp;#39;", "'"));
            loader(0);
        }
        else {
            loader(0);
            CustomAlert("No data available for the selected template"); return;
        }
    });
}

function loadSavedDraft() {
    $('#expand_menu').attr('id', 'expand_menu_edit');
    var moduleId = $('#ModuleId').val();
    AjaxCallInit({
        url: baseURL + '/Letter/LoadSavedDraft',
        PostData: { docId: $('#DocumentId').val(), moduleId: moduleId }
    }, function (data) {
        draft = data.ToJson();
        if (draft && draft.DraftData !== "") {
            loadDraftFromString(draft.DraftData.DraftContent);
            if (draft.DraftData.IsReviewed) {
                $("#divLetterScContainer").css('display', 'none');
            }
            $('.draftLetterClass #moduleDescriptionOne').text(gtModNm(moduleId));
            $('.draftLetterClass #moduleDescriptionTwo').text(gtModDesc(moduleId));
            if (draft.DraftData.AttachmentInput) {
                attachmentInputFromDraft = [];
                for (i = 0; i < draft.DraftData.AttachmentInput.length; i++) {
                    attachmentInputFromDraft.push(draft.DraftData.AttachmentInput[i])
                }
            }
        }
        else {
            loader(0);
            CustomAlert("No data available for the selected template"); return;
        }
    });
}

function checkSelectedAttachments(attachmentInput) {
    attachmentInput.forEach(function (e) {
        var attachedList = e.Reference;
        var moduleName = e.Module;
        if (moduleName !== 3) {
            attachedList.forEach(function (e) {
                $('#cbxDocDiv_' + e).prop('checked', true);
            });
        } else {
            attachedList.forEach(function (e) {
                $('#cbxPacketCheck_' + e).prop('checked', true);
            });
        }
    });
}

function GenerateBatchDocs(modId, authNo, decisionId, decisionGroupId, AccId, complaintId, msg, patientId, reviewNumber, reviewTypeLookupId, faxMsgFlag) {
    AjaxCallInit({
        url: baseURL + '/Letter/BatchDocuments',
        PostData: { moduleId: modId, languageId: 0, authNo: authNo ? authNo : 0, decisionId: decisionId ? decisionId : 0, decisionGroupId: decisionGroupId ? decisionGroupId : 0, complaintId: complaintId ? complaintId : 0, patientId: patientId ? patientId : 0,
                    reviewNumber: reviewNumber ? reviewNumber : null, reviewTypeLookupId: reviewTypeLookupId ? reviewTypeLookupId : null }
    }, function (data) {
        if (AccId)
            if (modId == 3) {
                CmnStatusMessageDisp(AccId + ' #lblDecisionStatus', msg, 'Success', 'UM');
            }
            else if (modId == 5 && !faxMsgFlag) {
                $(AccId).MessageBox({ Message: msg,Type: "Success", IsSliding: true });
            }
    });
}

function showHideButtonsLetter(flag) {
    var roleLevelConfigs = $.greproleext(roleConfig, function (ele, _ind) {
        return ele.UniqueName === "AHS_CM_ACTION_LETTER";
    });
    if (roleLevelConfigs !== null && roleLevelConfigs.length > 0 && roleLevelConfigs[0].IsPrint) {
        $('#BtnPrintQueue').show();
        $('#BtnSavePrintQueue').show();
        getSpeedyDispatch();
    }
    else {
        $('#BtnPrintQueue').hide();
        $('#BtnSavePrintQueue').hide();
        $('#SpeedyDispatch').hide();
    }
    if (roleLevelConfigs !== null && roleLevelConfigs.length > 0 && roleLevelConfigs[0].IsExport) {
        $('#BtnPdf').show();
    }
    else {
        $('#BtnPdf').hide();
    }
    if (flag) {
        $('#BtnSaveDraft').show();
        $('#BtnPHPrintQueue').show();
        $('#BtnPHSavePrintQueue').show();
        $('#BtnPHPdf').show();
    }
    else {
        $('#BtnSaveDraft').hide();
    }
}

function afterReviewButtons(flag) {
    if (flag == 1) {
        $('#BtnPrintQueue').show();
        $('#BtnSavePrintQueue').show();
        getSpeedyDispatch();
        $('#BtnPdf').show();
        $('#BtnCompleteReview').hide();
        $('#BtnSaveDraft').hide();
    }
    else if (flag == 2) {
        $('#BtnPrintQueue').hide();
        $('#BtnSavePrintQueue').hide();
        $('#SpeedyDispatch').hide();
        $('#BtnPdf').hide();
        $('#BtnCompleteReview').show();
        $('#BtnSaveDraft').show();
    }
    else {
        $('#BtnPrintQueue').hide();
        $('#BtnSavePrintQueue').hide();
        $('#SpeedyDispatch').hide();
        $('#BtnPdf').hide();
        $('#BtnCompleteReview').hide();
    }
}

function afterReviewUMDocRefresh() {
    if ($('#MainAuth #Accordion_Group_5').is(":visible")) {
        AuthDocuments_Get();
    }
}

function afterReviewAGDocRefresh() {
    if ($('#MainComplaint #AgLeftTab_6').hasClass('TabbedPanelsTabSelected')) {
        getComplaintDocuments();
    }
}

function afterReviewMTMDocRefresh() {
    if ($('#electronicDocsMTMGrid').is(":visible")) {
        $("#electronicDocsMTMGrid").data("kendoGrid").dataSource.read();
    }
}

function isLetterReview() {
    var isRev = $('#hdnIsReviewLetter').val();
    return isRev && isRev == "2";
}

function getTemplateDescription(moduleId) {
    $('#txtTemplateDesc').text("");
    AjaxCallInit({
        url: baseURL + '/Letter/GetTemplateDescription',
        PostData: { extTemplateId: $('#ddlTemplateId').val() }
    }, function (data) {
        result = data.ToJson()
        if (result.Result != "") {
            var strText = result.Result;
            if (!isAttachmentModule(moduleId)) {
                if ((strText).length > 20) {
                    strText = strText.substring(0, 20)
                    strText = strText + '...';
                }
                $('#txtTemplateDesc').val(strText);
                $('#txtTemplateDesc').prop('title', result.Result);
            }
            else
            {
                $('#txtTemplateDesc').val(strText);
            }
        }
        else {
            $('#txtTemplateDesc').val("N/A");
        }
    });
}

function LetterMessageBox(title, msg, isClose, callBack, IsAutoClose) {
    var Module = getModuleWithContainer();
    Module = (Module == "" || Module == undefined || Module == null) ? "CM" : Module;
    if (Module != "CM" || Module != "MTM") {
        legacyModalAlert(title, msg, isClose, callBack, IsAutoClose);
    }
    else {
        MessageBox(title, msg, isClose, callBack, IsAutoClose);
    }
}

function LetterDataMessageBox(title, msg, isClose, callBack, IsAutoClose) {
    var Module = getModuleWithContainer();
    Module = (Module == "" || Module == undefined || Module == null) ? "CM" : Module;
    if (Module != "CM" || Module != "MTM") {
        smartCommMessageBoxAlert(title, msg, isClose, callBack, IsAutoClose);
    }
    else {
        MessageBox(title, msg, isClose, callBack, IsAutoClose);
    }
}

function getModuleWithContainer() {
    var moduleName;
    try {
        var parDiv = $('#divScLetterVerticalContainer');
        moduleName = $("#moduleDescriptionOne", parDiv).text();

    } catch (e) {
        moduleName = $("#ddlModule option:selected", $('#divSCLetterContainer')).text();
    }
    return moduleName;
}

function afterReviewCMDocRefresh() {
    if ($('#electronicDocsGrid').is(":visible")) {
        $("#electronicDocsGrid").data("kendoGrid").dataSource.read();
    }
}

function downLoadDraftLetter(documentId, moduleId, fileName) {
    var module = gtModNm(moduleId)
    letterModuleName = module;

    loader(1); var fileExtention = fileName.substring(fileName.lastIndexOf('.')); var fileNameDwnld = fileName;
    AjaxCallInit({
        url: baseURL + '/Letter/LoadSavedDraft',
        PostData: { docId: documentId, moduleId: moduleId }
    }, function (data) {
        draft = data.ToJson();
        if (draft && draft.DraftData) {
            if (draft.DraftData.AttachmentInput) {
                attachmentInputFromDraft = [];
                for (i = 0; i < draft.DraftData.AttachmentInput.length; i++) {
                    attachmentInputFromDraft.push(draft.DraftData.AttachmentInput[i])
                }
                getModuleForLetterDocsPackets();
            }
            var draftContent = (draft.DraftData.DraftContent != null ? String(draft.DraftData.DraftContent) : "").replace(/\\/g, "\\\\").replace(/"/g, '\\"');
            var data1 = {
                extTemplateId: draft.DraftData.LetterTemplateId,
                moduleId: draft.DraftData.ModuleId,
                draftContent: draftContent,
                documentId: draft.DraftData.DocumentId,
                attachmentInputArray: attachmentArrayObj
            };
            AjaxCallInit({
                url: baseURL + '/Letter/ExportPdf',
                PostData: data1
            },
                function (RowData) {
                    RD = RowData.ToJson();
                    if (RD) {
                        SecureBrowserFileDownload.DownloadFile(baseURL, { isDeleteFromPatientDoc: 1 }, "DraftLetterSC", RD.Token, null);
                        fileNameDwnld = RD.DraftData.FileName;
                        loader(0);
                    }
                });
        }
    });
    loader(0);
    AuditLog(1, actionTypeEnum.Download, 'Documents', $("#selectPatientAccessed").val(), memberidval, fileNameDwnld);
    $('body').css('overflow', 'scroll')
}

function downLoadDraftLetterOld(documentId, moduleId, fileName) {
    loader(1); var fileExtention = fileName.substring(fileName.lastIndexOf('.')); var fileNameDwnld = fileName;
    AjaxCallInit({
        url: baseURL + '/Letter/LoadSavedDraft',
        PostData: { docId: documentId, moduleId: moduleId }
    }, function (data) {
        draft = data.ToJson()
        if (draft && draft.DraftData !== "") {
            var data1 = {
                extTemplateId: draft.DraftData.LetterTemplateId, moduleId: draft.DraftData.ModuleId, draftContent: draft.DraftData.DraftContent, documentId: draft.DraftData.DocumentId
            };
            //CNT-2729 - To escape \ in the draft content
            data1.draftContent = $.trim(data1.draftContent).replace(/\\(?!")/g, '\\\\');
            AjaxCallInit({
                url: baseURL + '/Letter/ExportPdf',
                PostData: data1
            },
                function (RowData) {
                    RD = RowData.ToJson();
                    if (RD) {
                        SecureBrowserFileDownload.DownloadFile(baseURL, { isDeleteFromPatientDoc: 1 }, "DraftLetterSC", RD.Token, null);
                        fileNameDwnld = RD.DraftData.FileName;
                        loader(0);
                    }
                });
        }
    });
    loader(0);
    AuditLog(1, actionTypeEnum.Download, 'Documents', $("#selectPatientAccessed").val(), memberidval, fileNameDwnld);
    $('body').css('overflow', 'scroll')
}

function checkMergedStatus(data) {
    var isMerged = true,
        appendErrorListHtml = "",
        getDocValidationDiv = "";

    if (data && data.MergeStatus && (data.MergeStatus === 3 || data.MergeStatus === 4 || data.MergeStatus === 5)) {
        isMerged = false;
    }
    if (!isMerged) {
        var errorMsgList = data.ErrorMessageList;
        if (errorMsgList && errorMsgList.length > 0) {
            for (var i = 0; i < errorMsgList.length; i++) {
                appendErrorListHtml += "<div class='clear userList alignValidMsgDivSc'><span class='ItemPR10'>" + errorMsgList[i] + "</span></div>";
            }
            appendErrorListHtml += "<div id='docErrorMsgTextFooter' class='float-left ItemP10 ItemMT5 width90P' style='padding:15px 60px !important;font-size:18px;'>Please Remove these document(s) from your selection to proceed.</div>";
            if (appendErrorListHtml != "") { $(".userListContainer").html(appendErrorListHtml); }
        } else {
            $("#docErrorMsgTextHeader").text("");
            $("#docErrorMsgTextHeader").text("Document could not be created, please try again.");
        }
        getDocValidationDiv = document.getElementById("smartCommErrorMsgTemp").innerHTML;
        $("#popUpDialog3").html(getDocValidationDiv);
        $('#popUpDialog3').CMNPopup({ popUpHeader: "", popLevel: 1 });
    }
}

function isAttachmentModule(moduleId) {
    return moduleId && (gtModNm(moduleId) === 'CM' || gtModNm(moduleId) === 'AG' || gtModNm(moduleId) === 'UM') ? true : false;
}

/*Smart Comm End*/


function AllowOnlyNaturalNumerics(e, ctrl) {
    if (e.shiftKey || e.ctrlKey || e.altKey) {
        e.preventDefault();
    } else {
        var key = e.keyCode;
        if (!((key == 8) || (key == 46) || (key >= 35 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105))) {
            e.preventDefault();
        }
    }
}

function ClearValuesOnKeyUp(e, ctrl) {
    var charCode = (event.which) ? event.which : event.keyCode

    if (charCode == 8 || charCode == 46) {
        if ($(ctrl).val() == 0) {
            $(ctrl).val('');
            e.preventDefault();
        }
    }
}

function ReplaceDynRowSpecialChars(data) {
    var result = data.replace(/1SI/g, "€¶¦validate€¶¦").replace(/1Si/g, "1Üî").replace(/1si/g, "1Ûî").replace(/1sI/g, "1Ûï").replace(/%/g, '[:Ä:]');
    return result;
}

function ReplaceDynSpecToNormalChars(objdata) {
    var replacedData = objdata.replace(/€¶¦validate€¶¦/g, "1SI").replace(/1Üî/g, "1Si").replace(/1Ûï/g, "1sI").replace(/1Ûî/g, "1si").replace(/\[:Ä:]/g, '%');
    return replacedData;
}
function AllModules() {
    $.ajax({
        type: "GET",
        async: true,
        url: baseURL + '/Common/AllModules',
        dataType: "json",
        success: function (data) {
            allModules_Data = data;
        }
    });
}
function gtModNm(modId) {
    return jQuery.grep(allModules_Data, function (a) {
        return a.Id == modId;
    })[0].Name;
}
function gtModId(modNm) {
    return jQuery.grep(allModules_Data, function (a) {
        return a.Name == modNm;
    })[0].Id;
}
function gtModDesc(modId) {
    return $.grep(allModules_Data, function (element, index) {
        return element.Id == modId;
    })[0].Description;
}
function DownLoadPdfSC(filePath, fileName, documentGuid) {
    var ext = fileName.indexOf('.pdf') >= 0 ? "" : ".pdf";
    var Url = 'download.ashx?IMMUNIZATIONS=' + filePath + '&FileName=' + fileName + ext + '&DOCUMENTGUID=' + documentGuid;
    window.open(Url, (window.browserPopUpName || window.top.browserPopUpName));
}
function funChkBothMgrProvChkd(mgrChkId, providerChkId, obj) {
    var objId = obj.attributes.id;
    if (objId.textContent == mgrChkId) {
        if ($(obj, mgrChkId).is(":checked"))
            $('#' + providerChkId).prop('checked', false);
        else {
            $('#' + mgrChkId).prop('checked', false);
            $('#' + providerChkId).prop('checked', false);
        }
    }
    else {
        if ($('#' + providerChkId).is(":checked"))
            $('#' + mgrChkId).prop('checked', false);
        else {
            $('#' + mgrChkId).prop('checked', false);
            $('#' + providerChkId).prop('checked', false);
        }
    }
}
function getPrintQueueFieldLabelValue() {
    if (PrintQueueBtnConfiguration === -1) {
        AjaxCallInit({
            url: baseURL + '/Letter/GetPrintQueueFieldLabelValue',
            PostData: { key: "DISPLAY PRINT QUEUE BUTTON" }
        }, function (data) {
            PrintQueueBtnConfiguration = parseInt(JSON.parse(data).result,10);
            hidePrintQueue();
        });
    } else {
        hidePrintQueue();
    }
}

function hidePrintQueue() {
    if (PrintQueueBtnConfiguration === 0) {
        $("#BtnPrintQueue").hide();
    }
}
function getPatPreferWrittenLanguages() {
    AjaxCallInit({
        url: baseURL + '/Letter/GetPatientPreferWrittenLanguages'
    }, function (data) {
        result = data.ToJson()
        if (result.Result == "")
            var prefWritLangs = "Not Available";
        else
            prefWritLangs = result.Result;
        var html = "<span style=font-weight:bold;text-decoration:underline;>Preferred Written Language(s) : </span><br /><br /><span style=font-weight:bold;>" + prefWritLangs + "</span>";
        $('#divWrittenLanguages').attr('title', html).aToolTip({});
    });
}

function validateDuplicateRisks() {
    var isValid = true;
    var grids = $("#divEditLobRanking").find('.GridStyle1');
    grids.each(function (ind) {
        var arrayValues = [];
        var ddlRank = $(this).find("select");
        var mm = ddlRank.length;
        ddlRank.each(function (ind) {
            if (arrayValues.length == 0 || $.inArray($(this).val(), arrayValues) == -1) {
                arrayValues.push($(this).val());
                $(this).removeAttr("style");
            }
            else {
                $(this).focus().css("border", "2px solid #e02020");
                CustomAlert('You cannot have duplicate rank value for ' + window.top.RiskLevel + 's');
                return isValid = false;
            }
        });
        if (isValid == false)
            return false;
    });
    return isValid;
}

function DateDiff(Val1, Val2) {

    var D1 = new Date(Val1); var D2 = new Date(Val2);
    var nextDate = new Date(D1);
    var DiffDays = 0, i;
    //We adding dates comparsion check 'D2 < D1 ? -1 : 1', since the condition check was ignored it causing issues.
    //Sample case1: 'if date2 is less than date1 the below loop getting infinte iterations.
    var polarityValue = D2 < D1 ? -1 : 1;
    for (i = 0; i < DiffDays + 1; i++) {
        if (new Date(D2).toDateString() === new Date(nextDate).toDateString())
            break;
        nextDate.setDate(nextDate.getDate() + (polarityValue));
        DiffDays++;
    }
    return DiffDays * (polarityValue);
}

function resetHoursData(curRow, isFrom) {
    if (isFrom == 'UM') {
        if ($("#UmDdUnitType", curRow).length > 0) {
            var unitType = $("#UmDdUnitType option:selected", curRow).text().toLowerCase();
            CreateDropCheckForAuth(0, curRow);
            if (unitType == "days") {
                if ($('#IsFromIAR').val() == "true" && $("#TextFromDate", curRow).val() != '' && $("#TextToDate", curRow).val() != '') {
                    $("#TextWeeks,#TextReq", curRow).val("");
                    $("#TextToDate", curRow).trigger('blur');
                } else {
                    $("#TextWeeks,#TextFromDate,#TextToDate,#TextReq", curRow).val("").trigger('change');
                }
                $("#TextAdlDays,#ddlDaysval,#TextHrs,#TextWeeks,#TxtWeeklyHours", curRow).val('').trigger('change');
                $("#TextAdlDays,#ddlDaysval,#TextHrs,#TextWeeks,#TxtWeeklyHours", curRow).attr('disabled', 'disabled');
                $("#UmLblScheduleForm", curRow).css("pointer-events", "none");

            }
            else {
                $("#UmLblScheduleForm", curRow).css("pointer-events", "");
                $("#TextAdlDays,#ddlDaysval,#TextHrs,#TextWeeks,#TxtWeeklyHours", curRow).removeAttr('disabled', 'disabled');
            }
            ResetMaxHrsValueLimit(curRow);

        }
    }
    else if (isFrom == 'CM') {
        if ($('.clsddlCrPlAddSrPlMembNewUnitType', curRow).val() == 1) {
            $("#txtSrPlADays,#ddlDaysval,#txtSrPlHours,#txtSrPlWeeks,#txtSrPlWHours", curRow).val('');
            $("#txtSrPlADays,#ddlDaysval,#txtSrPlHours,#txtSrPlWeeks,#txtSrPlWHours", curRow).attr('disabled', 'disabled');
            $('#ddlDayshdn,#ddlDayNameshdn', curRow).val('');
            $('.chkDays', curRow).attr('checked', false);
            $('#ddlDayschk', curRow).hide();
        }
        else {
            if ($(curRow).find('#ddlDayschk').find('input[type="checkbox"]:checked').val() != 'Weekly')
                $("#txtSrPlADays,#ddlDaysval,#txtSrPlHours,#txtSrPlWeeks,#txtSrPlWHours", curRow).removeAttr('disabled', 'disabled');
        }
        $("#txtSrPlHours,#txtCrPlAddSrPlMembGNewRUnits,#txtSrPlWHours,#txtSrPlADays,#txtSrPlWeeks", curRow).val("");
        $('#txtSrPlWHours', curRow).attr('disabled', 'disabled');
    }
}

function ResetMaxHrsValueLimit(curRow) {
    if ($("#TextHrs", curRow).is("visible") && $("#TextHrs", curRow).val().length > 0) {
        var unitType = $("#UmDdUnitType option:selected", curRow).text().toLowerCase();
        var hrs = $.trim($("#TextHrs", curRow).val());
        var daysName = $('#ddlDaysval', curRow).val();
        var valLimit = 24;
        if (unitType == "units" && daysName == 'W') { valLimit = 168; }
        else if (unitType == "15 minutes") {
            if (daysName == 'W') { valLimit = 672; }
            else { valLimit = 96; }
        }
        if (!(hrs <= valLimit)) {
            $("#TextHrs,#TxtWeeklyHours,#TextReq", curRow).val('');
        }
    }
}

function GetTotalWeeks(fromDate, toDate) {
    var noOfWeeks = 0;
    var weekDays = 6;
    var dayIndex = fromDate.getDay();
    var dateDiff = DateDiff(fromDate, toDate);
    var diffIndex = weekDays - dayIndex;
    if (dateDiff > diffIndex) {
        var remainingDays = dateDiff - diffIndex;
        if (remainingDays > 0) {
            noOfWeeks = 1;
            var tempWeeks = parseInt(remainingDays / 7) + ((remainingDays % 7) > 0 ? 1 : 0);
            if (tempWeeks > 0) {
                noOfWeeks = noOfWeeks + tempWeeks;
            }
        }
    }
    else {
        noOfWeeks = 1;
    }

    return noOfWeeks;
}
/*function to clear the local storage variables*/
function ClearFaxLinkValues() {
    if (localStorage.getItem("LINK_FAX_NEW_AUTH") != null) { localStorage.removeItem("LINK_FAX_NEW_AUTH"); }
    if (localStorage.getItem("MESSAGE_ID_NEW_AUTH") != null) { localStorage.removeItem("MESSAGE_ID_NEW_AUTH"); }
    if (ToValue($("#HdnLinkFaxNewComplaint").val(), '') !== '') {
        $("#HdnLinkFaxNewComplaint").val('');
    }
    $('#hdnFaxForAuth').val('false');
}

/*function to show confirm messgae to user when navigating from auth entry page*/
function ConfirmUserNavigationOnFaxLinking() {
    if (localStorage.getItem("LINK_FAX_NEW_AUTH") != null || ToValue($("#HdnLinkFaxNewComplaint").val(), '') !== '') {
        var flag = CustomConfirm("Navigating to other section will not link the Fax document. Are you sure you want to proceed?");
        if (flag) {
            ClearFaxLinkValues();
            //if (!$.fn.isNullOrEmpty(faxOCRData)) {
            //    clearFaxOCRDataCache();
            //}
            if ($('#divFaxPreview').is(':visible')) {
                $('#divFaxPreview').hide();
            }
            $('#divFaxIcon').remove();
            clearFaxOCRData();
            faxReceivedDate = null;
        }
        return flag;
    }
    return true;
}

/*Validate time in HH:MM:SS format*/
function validateTimeIn24HourFormat(ctrl, hoursLimit) {
    if ($(ctrl).attr('id') === 'txtDateHours' && $(ctrl).val() > hoursLimit) {
        $(ctrl).val('');
    }
    if ($(ctrl).attr('id') === 'txtDateMinutes' || $(ctrl).attr('id') === 'txtDateSeconds') {
        validateHoursAndMinutes(ctrl);
    }
}
/*END Validate time in HH:MM:SS format*/

/*Validate time in HH:MM:SS tt format*/
function validateTimeIn12HourFormat(ctrl, hoursLimit) {
    if ($(ctrl).attr('id') === 'txtDateHours' &&
        ($(ctrl).val() > hoursLimit || ($(ctrl).val() < 1 && $(ctrl).val().length === 2))) {
        $(ctrl).val('');
    }
    if ($(ctrl).attr('id') === 'txtDateMinutes' || $(ctrl).attr('id') === 'txtDateSeconds') {
        validateHoursAndMinutes(ctrl);
    }
}
/*END Validate time in HH:MM:SS format*/

function validateHoursAndMinutes(ctrl) {
    if ($(ctrl).val() > 59) {
        $(ctrl).val('');
    }
}

/*Validate time in meridian format*/
function ValidateMeridianFormat(ctrl) {
    $(ctrl).val($(ctrl).val().trim().toUpperCase());
    if ($(ctrl).val().length == 1 && ($(ctrl).val() == "A" || $(ctrl).val() == "P")) {
        $(ctrl).val($(ctrl).val());
    }
    else if ($(ctrl).val().length == 2 && ($(ctrl).val()[0] == "A" || $(ctrl).val()[0] == "P")) {
        if ($(ctrl).val()[0] == "A" && $(ctrl).val()[1] == "M") {
            $(ctrl).val($(ctrl).val());
        }
        else if ($(ctrl).val()[0] == "P" && $(ctrl).val()[1] == "M") {
            $(ctrl).val($(ctrl).val());
        }
        else {
            $(ctrl).val($(ctrl).val()[0]);
        }
    }
    else {
        $(ctrl).val('');
    }
}
/*END Validate time in Meridian format*/

/*Validate Datetime field in AG Activities section*/
function IsDateTime24Format(TxtDate) {
    var timeRegEx = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]:[0-5][0-9]$/;
    var dateRegEx = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    var dateTxt = TxtDate.split(' ')[0];
    if (!dateRegEx.test(dateTxt)) {
        return false;
    } else if (!timeRegEx.test(TxtDate.split(' ')[1])) {
        return false;
    }
    return true;
}

function fnloadddlCstm() {
    loader(1);
    $.getJSON(baseURL + "api/ScriptConfigApi/GetActCustomFieldsMaster/").done(function (resdata, respo) {
        if (respo == 'success') {
            $.each(resdata.objSection, function (key, value) {
                $("#ddlScreen").append($("<option></option>").val(value.SectionId).html(value.SectionName));
            });
            $("#ddlScreen").val($("#ddlScreen").data('sectionid'));
            $.each(resdata.objActMode, function (key, value) {
                $("#ddlActMode").append($("<option></option>").val(value.ActModeId).html(value.ActModeName));
            });
            $("#ddlActMode").val($("#ddlActMode").data('actmodeid'));
            $.each(resdata.objCustFields, function (key, value) {
                $("#ddlCustmOptionType").append($("<option></option>").val(value.CustFieldDataTypeId).html(value.CustFieldDataTypeName));
            });
            $("#ddlCustmOptionType").val($("#ddlCustmOptionType").data('custdatatypevalueid'));

            if ($('#ddlCustmOptionType option:selected').text() == 'Radio Button List' || $('#ddlCustmOptionType option:selected').text() == 'Checkbox List') {
                $('#divgvcstmdatavalue').show();
                $('#divCntrlstate').show();
                $("#gvcstmdatavalue").data("kendoGrid").dataSource.read();
                $('#gvcstmdatavalue .chkActCustomFieldOptionValues').prop('checked', false);
            }
            loader(0);
        } else {
            loader(0);
        }
    });

}
function fnHealthGridParameters() {
    return {
        Search: "",
        HealthType: 0,
        HealthCategory: "",
        HealthSubCategory: ""
    }
}
function onManageDataBoundFunction() {

}


//ManageActCustomFieldsGet(1);
function ManageActCustomFieldsGet(reset) {
    if (reset == 1) {
        $("#ddlActCustomFiledsStatus").val("1");
    }
    $("#ActCustomFieldsGrid").data("kendoGrid").dataSource.page(1);
    //Global Check Box
    $('#ActCustomFieldsGrid .clsItemChkActCustomFieldsHead').prop('checked', false);
    //Inside grid Check Box
    $('#ActCustomFieldsGrid .clsItemChkActCustomFields').prop('checked', false);
    ChkShowHideAuthCustomFieldsButtons();

}

function fnCstmDataValueParameters() {
    return {
        CustFieldId: $('#hidCustomFieldid').val(),
        isActive: true
    }
}
function isFourDigitNumberKey(obj, evt, isReqUnitsCheckRequired) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    var len = $(obj).val().length;
    var isNotValidKey = charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57);

    if (isNotValidKey || len >= 4) {
        //the function name is wrong. It should have been renamed as "isNotFourDigitNumberKey" because the logic is inconsistent with the name of the setting.
        if (isReqUnitsCheckRequired && len >= 4) {
            if (isNotValidKey) {
                return false;
            }
            else {
                var eleRow = $(obj).closest('.DiagProcCode').length > 0 ? $(obj).closest('.DiagProcCode') : $(obj).closest("table tr .DecisionSelect");
                if (len >= 7) {
                    return false;
                }
                return $("#UmDdUnitType option:selected", eleRow).text().toLowerCase() === 'days' ? false : true;
            }
        }
        else {
            return false;
        }
    }
    return true;
}

function isFourDigitNumberPaste(obj, isReqUnitsCheckRequired) {
    var len = $(obj).val().length;
    var Num0to9 = /^[1-9][0-9\s]*$/;
    var eventdata = obj.value.trim();
    isValid = Num0to9.test(eventdata);
    if (isValid) {
        if (len > 4) {
            if (isReqUnitsCheckRequired) {
                var unitTypeDays = 9999;
                unitTypeDays = reQUnitLimit > unitTypeDays ? unitTypeDays : reQUnitLimit;
                if ($("#UmDdUnitType option:selected", ($(obj).closest('.DiagProcCode').length > 0 ? $(obj).closest('.DiagProcCode') : $(obj).closest("table tr .DecisionSelect"))).text().toLowerCase() === 'days') {
                    $(obj).val(unitTypeDays);
                }
                else {
                    if (len > 7) {
                        $(obj).val(eventdata.substr(0, 7));
                    }
                }
            }
            else {
                $(obj).val(eventdata.substr(0, 4));
            }
            return true;
        }
        return true;
    }
    else {
        $(obj).val('');
        return false;
    }
}

function allowFourdigitsWithZero(obj) {
    var len = $(obj).val().length;
    var Num0to9 = /^[0-9\s]*$/;
    var eventdata = obj.value.trim();
    isValid = Num0to9.test(eventdata);
    if (isValid) {
        if (len > 4) {
            $(obj).val(eventdata.substr(0, 4));
            return true;
        }
        return true;
    }
    else {
        $(obj).val('');
        return false;
    }
}

function dropDownDataCallBack(arg, dataContext) {
    if (typeof dataContext.elementId === 'object')
        var $select = dataContext.elementId;
    else
        var $select = $('#' + dataContext.elementId);
    $select.load(baseURL + "/Common/LoadMultiLevelDropdown", { modelData: arg, placeHolderVal: dataContext.placeHolder }, function () {
        loader(0);
        if (dataContext.callBackFunction != undefined && dataContext.callBackFunction != '' && dataContext.callBackFunction != null) {
            setTimeout(function () {
                dataContext.callBackFunction();
            }, 200);
        }
    });
}
//#region Controller Events for Loading Multi Level Dropdown with Multi-option selection 
function loadMultiLevelDropDown(remoteUrl, elementId, placeHolder, slideMenuTitle, callBackFunction, SDOHTypeCode) {
    var findCommunityProviderDataContext = {
        remoteUrl: remoteUrl,
        elementId: elementId,
        placeHolder: placeHolder,
        slideMenuTitle: slideMenuTitle,
        callBackFunction: callBackFunction
    };
    loadMultiLevelSDOHDropDown(findCommunityProviderDataContext, dropDownDataCallBack, SDOHTypeCode);
}

function LoadMultiLevelDropValues(responseModel) {
    var multilevelValArr = []
    if (responseModel != null) {
        $.each(responseModel, function (key1, val1) {
            if (val1.values != null && val1.values.length != 0 && val1.values[0] != null) {
                if (val1.key != null) {
                    multilevelValArr.push({ "Text": val1.value, "key": val1.key });
                }
                $.each(val1.values, function (key2, val2) {
                    if (val2.values != null && val2.values.length != 0 && val2.values[0] != null) {
                        if (val2.key != null) {
                            multilevelValArr.push({ "Text": val2.value, "key": val2.key });
                        }
                        $.each(val2.values, function (key3, val3) {
                            if (val3.values != null && val3.values.length != 0 && val3.values[0] != null) {
                                if (val3.key != null) {
                                    multilevelValArr.push({ "Text": val3.value, "key": val3.key });
                                }
                                $.each(val3.values, function (key4, val4) {
                                    if (val4.values != null && val4.values.length != 0 && val4.values[0] != null) {
                                        if (val4.key != null) {
                                            multilevelValArr.push({ "Text": val4.value, "key": val4.key });
                                        }
                                        $.each(val4.values, function (key5, val5) {
                                            if (val5.values != null && val5.values.length != 0 && val5.values[key5] != null) {
                                                if (val5.key != null) {
                                                    multilevelValArr.push({ "Text": val5.value, "key": val5.key });
                                                }
                                                $.each(val5.values, function (key6, val6) {
                                                    if (val6.values != null && val6.values.length != 0 && val6.values[key6] != null) {
                                                        if (val6.key != null) {
                                                            multilevelValArr.push({ "Text": val6.value, "key": val6.key });
                                                        }
                                                        $.each(key6.values, function (key7, val7) {
                                                            if (val7.values != null && val7.values.length != 0 && val7.values[key7] != null) {
                                                                if (val7.key != null) {
                                                                    multilevelValArr.push({ "Text": val7.value, "key": val7.key });
                                                                }
                                                                $.each(val7.values, function (key8, val8) {
                                                                    if (val8.values != null && val8.values.length != 0 && val8.values[key8] != null) {
                                                                        if (val8.key != null) {
                                                                            multilevelValArr.push({ "Text": val8.value, "key": val8.key });
                                                                        }
                                                                        $.each(val8.values, function (key9, val9) {
                                                                            if (val9.values != null && val9.values.length != 0 && val9.values[key9] != null) {
                                                                                if (val9.key != null) {
                                                                                    multilevelValArr.push({ "Text": val9.value, "key": val9.key });
                                                                                }
                                                                                $.each(val9.values, function (key10, val10) {
                                                                                    multilevelValArr.push({ "Text": val10.value, "key": val10.key });
                                                                                })
                                                                            }
                                                                            else if (val9.key != null) {
                                                                                multilevelValArr.push({ "Text": val9.value, "key": val9.key });
                                                                            }
                                                                        })
                                                                    }
                                                                    else if (val8.key != null) {
                                                                        multilevelValArr.push({ "Text": val8.value, "key": val8.key });
                                                                    }
                                                                })
                                                            }
                                                            else if (val1.key7 != null) {
                                                                multilevelValArr.push({ "Text": val7.value, "key": val7.key });
                                                            }
                                                        })
                                                    }
                                                    else if (val6.key != null) {
                                                        multilevelValArr.push({ "Text": val6.value, "key": val6.key });
                                                    }
                                                })
                                            }
                                            else if (val5.key != null) {
                                                multilevelValArr.push({ "Text": val5.value, "key": val5.key });
                                            }
                                        })
                                    }
                                    else if (val4.key != null) {
                                        multilevelValArr.push({ "Text": val4.value, "key": val4.key });
                                    }
                                })
                            }
                            else if (val3.key != null) {
                                multilevelValArr.push({ "Text": val3.value, "key": val3.key });
                            }
                        })
                    }
                    else if (val2.key != null) {
                        multilevelValArr.push({ "Text": val2.value, "key": val2.key });
                    }
                })
            }
            else if (val1.key != null) {
                multilevelValArr.push({ "Text": val1.value, "key": val1.key });
            }
        })
    }
    $("#multiSelecKendo").data('kendoMultiSelect').dataSource.data(multilevelValArr);
    loader(0);
};

function AddMultiSelectValue(key, value) {
    var multiselect = $("#multiSelecKendo").data("kendoMultiSelect");
    serSelcArr = [];
    arrVal = []
    serSelcArr.push({ "Text": value, "key": key });
    //multiselect.dataSource.data().remove(serSelcArr)
    if (multiselect.value().length != 0) {
        var selcValArr = multiselect.value();
        $.each(selcValArr, function (key, value) {
            arrVal.push(value);
        });
    }
    multiselect.value('');
    arrVal.push(key);
    multiselect.open();
    multiselect.value(arrVal);
    multiselect.close();
    $('#lnkCumProvServ_' + key).hide();
    $("#multiSelecKendo").data("kendoMultiSelect").trigger('change');
};

function multiSelecKendoOnOpen(e) {
    $('#CPSlideMenu').slideUp(300);
    $('#btnFindCumProvDwn').show();
    $('#btnFindCumProvUp').hide();
};

function multiSelecKendoOnClose(e) {
    $('#btnMultiLevelUpArr').hide();
    $('#btnMultiLevelDwnArr').show();
};

function multiSelecKendoOnChange(e) {
    var multiselect = $("#multiSelecKendo").data("kendoMultiSelect");
    var dataSourceValues = multiselect.dataSource.data();
    var isFreeTextSelected = false;
    var selMultiItems = multiselect.value();
    $.each(selMultiItems, function (key, value) {
        if (value == 'ml-ms-ft-id') {
            isFreeTextSelected = true;
        }
    });

    if (multiselect.value().length == 0 || !isFreeTextSelected) {
        $.each(dataSourceValues, function (key, value) {
            if (value.key == 'ml-ms-ft-id') {
                remvItmArr = [];
                remvItmArr.push({ "Text": value.Text, "Key": value.key });
                multiselect.dataSource.remove(dataSourceValues[key]);
            }
        })
    }

    $('.CPslider  a').show();
    if (multiselect.value().length != 0) {
        var selcValArr = multiselect.value();
        $.each(selcValArr, function (key, value) {
            $('#lnkCumProvServ_' + value).hide();
        });
    }
    $("#multiSelecKendo").data("kendoMultiSelect").trigger('Close');
};

function multiSelecKendoOnSelect(e) {
};

//#endregion

//Export Pdf Code for Attach Document
function ExportLetterToPDF(QueueIds) {
    var scExt = "";
    var IsArchive = true;
    if (IsSmartCommEnabled === "1") { scExt = ".pdf"; IsArchive = false; }
    $.ajax({
        type: "GET",
        async: false,
        url: baseURL + "/Home/GetLetterPath?letterQueueId=" + QueueIds + "&IsArchive=" + IsArchive,
        success: function (data) {
            if (data.success) {
                var pathSplit = data.Path.split('.');
                scExt = "." + pathSplit[pathSplit.length - 1];
                var Url = 'download.ashx?IMMUNIZATIONS=' + data.Path + '&FileName=' + data.Name + scExt + '&DocumentGuId=' + data.DocumentGuId;
                window.open(Url, (window.browserPopUpName || window.top.browserPopUpName));
            }
        },
        error: function () {
        }
    });
}
function exportPhLetterToPdf(QueueIds, patientId, obj) {
    var IsArchive = true;
    if (IsSmartCommEnabled === "1") {
        IsArchive = false;
    }
    if (IsArchive) {
        $.ajax({
            type: "GET",
            async: false,
            url: baseURL + "/Home/Archive?letterQueueId=" + QueueIds + "&patientId=" + patientId,
            success: function () {
            },
            error: function () {
            }
        });
    }
    if (QueueIds !== null && QueueIds !== '' && QueueIds !== 0 && IsSmartCommEnabled !== "1") {
        var ActionType = 'EXPPDF';
        PrintQueue_Init(ActionType, 0, 0, QueueIds);
    }
    else {
        downloadDocumentFileHandler(QueueIds, 0, obj);
    }
}

function htmlContentAlter(content, toHtml) {
    var dictionary = {};
    content = content || "";
    if (content !== "" && content !== undefined) {
        if (toHtml) {
            dictionary = {
                "\n": "<br/>",
                "\r": "",
                "\t": "&ensp;"
            };
        }
        else {
            dictionary = {
                "<br/>": "\n",
                "&ensp;": "\t",
                "&lt;br/&gt;": "<br/>",
                "&amp;ensp;": "&ensp;"
            };
        }
        var re = new RegExp(Object.keys(dictionary).join("|"), "ig");
        return content.replace(re, function (key) {
            return dictionary[key];
        });
    }
    else {
        return "";
    }
}
// Ahs Set Html Extention function
$.fn.AhsSetHtml = function (value, callback) {
    value = value || '';
    callback = (callback && typeof (callback) === "function") ? callback : undefined;
    $(this).html(ahsSerialize(value, { unsafescripttag: true, unsafe: true }), callback);

    return this;
};
function ahsSerialize(obj, options) {
    options || (options = {});

    // Backwards-compatibility for `space` as the second argument.
    if (typeof options === 'number' || typeof options === 'string') {
        options = { space: options };
    }

    var functions = [];
    var regexps = [];
    var dates = [];

    // Returns placeholders for functions and regexps (identified by index)
    // which are later replaced by their string representation.
    function replacer(key, value) {
        if (!value) {
            return value;
        }

        // If the value is an object w/ a toJSON method, toJSON is called before
        // the replacer runs, so we use this[key] to get the non-toJSONed value.
        var origValue = this[key];
        var type = typeof origValue;

        if (type === 'object') {
            if (origValue instanceof RegExp) {
                return '@@__R-' + uniqueId + '-' + (regexps.push(origValue) - 1) + '__@@';
            }

            if (origValue instanceof Date) {
                return '@@__D-' + uniqueId + '-' + (dates.push(origValue) - 1) + '__@@';
            }
        }

        if (type === 'function') {
            return '@@__F-' + uniqueId + '-' + (functions.push(origValue) - 1) + '__@@';
        }

        return value;
    }

    var str;
    // Creates a JSON string representation of the value.
    // NOTE: Node 0.12 goes into slow mode with extra JSON.stringify() args.
    if (options.isJSON && !options.space) {
        str = JSON.stringify(obj);
    } else {
        str = obj;
    }

    // Protects against `JSON.stringify()` returning `undefined`, by serializing
    // to the literal string: "undefined".
    if (typeof str !== 'string') {
        return String(str);
    }

    // Replace unsafe HTML and invalid JavaScript line terminator chars with
    // their safe Unicode char counterpart. This _must_ happen before the
    // regexps and functions are serialized and added back to the string.
    if (options.unsafe === false) {
        str = str.replace(unsafeCharsRegExp, escapeUnsafeChars);
    }

    if (options.unsafescripttag === false) {
        str = str.replace(unsafeCharsRegExp1, escapeUnsafeScriptTag);
    }

    if (functions.length === 0 && regexps.length === 0 && dates.length === 0) {
        return str;
    }

    // Replaces all occurrences of function, regexp and date placeholders in the
    // JSON string with their string representations. If the original value can
    // not be found, then `undefined` is used.
    return str.replace(placeHolderRegex, function (match, type, valueIndex) {
        if (type === 'D') {
            return "new Date(\"" + dates[valueIndex].toISOString() + "\")";
        }

        if (type === 'R') {
            return regexps[valueIndex].toString();
        }

        var fn = functions[valueIndex];
        var serializedFn = fn.toString();

        if (isNativeCodeRegExp.test(serializedFn)) {
            throw new TypeError('Serializing native function: ' + fn.name);
        }

        return serializedFn;
    });
};

function validateQuickFieldsScriptForms(uniqueFieldName, messageDivId, currentUserDate, impCat) {
    if ((uniqueFieldName === "COMMUNICATION_IMPAIRMENT" || uniqueFieldName === "ADVANCED_DIRECTIVE") && (impCat.length === 0)) {
        messageDivId.html('Select at least one option');
        messageDivId.css("color", 'Red');
        return false;
    }
    return validateScriptCommonFields(uniqueFieldName, messageDivId, currentUserDate);
}

function validateScriptCommonFields(fieldUniqueName, lblMessage, currentUserDate) {
    var filter = /^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/;
    lblMessage.css("color", 'Red');
    if (fieldUniqueName === "DATE_OF_BIRTH") {
        var dob = $("#txtQuickUpdateDOB").val();
        if (IsDate(dob) === false) {
            lblMessage.html('Enter a valid date');
            return false;
        }
        else {
            if (!ValidateDate('01/01/1900', dob)) {
                lblMessage.html('Please enter a valid year');
                return false;
            }
            if (new Date(dob).ToDateWithoutTime() > new Date(currentUserDate).ToDateWithoutTime()) {
                lblMessage.html('Date of Birth should not be greater than the current date');
                return false;
            }
        }
    }
    if (fieldUniqueName === "NEW_PHONE_NUMBER" || fieldUniqueName === "UPDATE_ALTERNATE_PHONE") {
        var phone = fieldUniqueName === "NEW_PHONE_NUMBER" ? $("#txtQuickUpdatePhoneNumber").val() : $("#txtQuickUpdateAlternatePhone").val();
        if (!filter.test(phone)) {
            lblMessage.html('Enter a valid phone number');
            return false;
        }
    }
    if (fieldUniqueName === "NEW_EMAIL" || fieldUniqueName === "UPDATE_ALTERNATE_EMAIL") {
        var email = fieldUniqueName === "NEW_EMAIL" ? $("#txtQuickUpdateEmail").val() : $("#txtQuickUpdateAlternateEmail").val();
        var regexEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!regexEmail.test(email)) {
            lblMessage.html('Enter a valid email');
            return false;
        }
    }
    if (fieldUniqueName === "PRIMARY_CARE_GIVER_NAME_AND_PHONE_NUMBER") {
        var firstname = $("#txtQuickUpdateFirstName").val();
        if (firstname.trim() === "") {
            lblMessage.html('Enter First name');
            return false;
        }
        var lastname = $("#txtQuickUpdateLastName").val();
        if (lastname.trim() === "") {
            lblMessage.html('Enter Last name');
            return false;
        }
        var careGiverPhone = $("#txtQuickUpdateCareGiverPhone").val();
        if (!filter.test(careGiverPhone)) {
            lblMessage.html('Enter a valid phone number');
            return false;
        }
    }
    if (fieldUniqueName === "NEXT_DOCTORS_APPOINTMENT_DATE_AND_REASON") {
        var appointmentDate = $("#txtQuickUpdateNextAppDate").val();
        if (IsDate(appointmentDate) === false) {
            lblMessage.html('Enter a valid date');
            return false;
        }
        var appointmentReason = $("#txtQuickUpdateAppointmentReason").val();
        if (appointmentReason.trim() === '') {
            lblMessage.html('Enter Appointment reason');
            return false;
        }
    }
    if (fieldUniqueName === "ANY_NEW_DRUG_SENSITIVITY_OR_REACTION") {

        var sensitivity = $("#txtQuickUpdateDrugSensitivity").val();
        if (sensitivity.trim() === '') {
            lblMessage.html('Enter Allergy / Sensitivity');
            return false;
        }

        var desc = $("#txtQuickUpdateDrugSensitivityDescription").val();
        if (desc.trim() === '') {
            lblMessage.html('Enter description');
            return false;
        }
    }
    if (fieldUniqueName === "LAST_IMMUNIZATION_DATE_AND_TYPE") {
        var VccName = $('#ddlVaccinationNames').val();
        var VccNameOther = $('#txtVaccinationNameOther').val();
        var VccDt = $('#txtQuickUpdateVaccinationDate').val();
        var VccStatus = $('#ddlVaccinationStatus').val();
        var VccStatusOther = $('#txtVaccinationStatusOther').val();

        var VccNameOtherText = $('#ddlVaccinationNames option:selected').text().toUpperCase();
        var VccStatusOtherText = $('#ddlVaccinationStatus option:selected').text().toUpperCase();

        if (VccName === '' || VccName === '-1') {
            lblMessage.html('Select Name');
            return false;
        }
        if (VccNameOtherText === 'OTHER' && $.trim(VccNameOther) === '') {
            lblMessage.html('Enter Name Other Value');
            return false;
        }

        if (IsDate(VccDt) === false) {
            lblMessage.html('Enter Valid Date');
            return false;
        }

        if (VccStatus === '' || VccStatus === '-1') {
            lblMessage.html('Select Status');
            return false;
        }
        if (VccStatusOtherText === 'OTHER' && $.trim(VccStatusOther) === '') {
            lblMessage.html('Enter Status Other Value');
            return false;
        }
        if (new Date(VccDt).ToDateWithoutTime() > new Date(currentUserDate).ToDateWithoutTime()) {
            lblMessage.html('Vaccination with future date is not allowed');
            return false;
        }
    }
    if (fieldUniqueName === "LAST_PREVENTIVE_SCREENING_DATE_AND_TYPE") {

        var screeningDate = $("#txtQuickUpdateScreeningDate").val();
        if (IsDate(screeningDate) === false) {
            lblMessage.html('Enter a valid date');
            return false;
        }
        var screeningType = $("#txtQuickUpdateScreeningType").val();
        if (screeningType.trim() === '') {
            lblMessage.html('Enter Screening Type');
            return false;
        }
    }

    if (fieldUniqueName === "PREFERRED_TIME_OF_CALL") {
        var days = $('.classDdlDays').val();
        var time = $('.classDdlTime').val();
        var preferredTimeCall = (days === 'Do Not Call' ? days : (days + ' : ' + time));
        window.top.$('#membsummaryPTC').html(preferredTimeCall);
    }
    lblMessage.css("color", 'Green');
    return true;
}

//if ifTrue is null/undefined then returns element value(lVal) by default;
//if ifFalse is null/undefined then returns empty value by default;
function fnGetConditionBasedValue(lVal, rVal, con, retReq, ifTrue, ifFalse) {
    var res = eval("'" + lVal + "'" + con + "'" + rVal + "'");
    ifTrue = ifTrue || lVal;
    ifFalse = ifFalse || '';

    if (retReq) {
        return res ? ifTrue : ifFalse;
    }
    else { return res; }
}

$(document).on('propertychange change', '.clsIntEndDate,.clsIntStartDate', function () {
    var dateregex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    var Dateval = $(this).val();
    $('.validationMessages', $(this).closest('div')).remove();
    $(this).removeClass('.invalidDate');
    if (Dateval !== "" && Dateval !== undefined && !dateregex.test(Dateval)) {
        $(this).closest('div').append('<div class="validationMessages red ItemPB5"><span>Please enter valid date in MM/DD/YYYY format</span></div>');
        $(this).addClass('.invalidDate');
        return false;
    }
    return true;
});
function invokeFicoRules(ficoObject) {
    if (ficoObject != null) {
        window.top.ficoRealTimeValidation(ficoObject);
    }
}
